import * as N from "react";
import A, { createContext as Kt, useMemo as Ne, createElement as y, useContext as ct, useCallback as K, forwardRef as R, Children as Zt, isValidElement as Lr, cloneElement as Ja, Fragment as xt, useRef as O, useEffect as Z, useState as J, useLayoutEffect as ao, useReducer as el, Component as j1 } from "react";
import * as z1 from "react-dom";
import H1, { flushSync as tl, createPortal as nl } from "react-dom";
var Ie = "colors", Ue = "sizes", q = "space", X1 = { gap: q, gridGap: q, columnGap: q, gridColumnGap: q, rowGap: q, gridRowGap: q, inset: q, insetBlock: q, insetBlockEnd: q, insetBlockStart: q, insetInline: q, insetInlineEnd: q, insetInlineStart: q, margin: q, marginTop: q, marginRight: q, marginBottom: q, marginLeft: q, marginBlock: q, marginBlockEnd: q, marginBlockStart: q, marginInline: q, marginInlineEnd: q, marginInlineStart: q, padding: q, paddingTop: q, paddingRight: q, paddingBottom: q, paddingLeft: q, paddingBlock: q, paddingBlockEnd: q, paddingBlockStart: q, paddingInline: q, paddingInlineEnd: q, paddingInlineStart: q, top: q, right: q, bottom: q, left: q, scrollMargin: q, scrollMarginTop: q, scrollMarginRight: q, scrollMarginBottom: q, scrollMarginLeft: q, scrollMarginX: q, scrollMarginY: q, scrollMarginBlock: q, scrollMarginBlockEnd: q, scrollMarginBlockStart: q, scrollMarginInline: q, scrollMarginInlineEnd: q, scrollMarginInlineStart: q, scrollPadding: q, scrollPaddingTop: q, scrollPaddingRight: q, scrollPaddingBottom: q, scrollPaddingLeft: q, scrollPaddingX: q, scrollPaddingY: q, scrollPaddingBlock: q, scrollPaddingBlockEnd: q, scrollPaddingBlockStart: q, scrollPaddingInline: q, scrollPaddingInlineEnd: q, scrollPaddingInlineStart: q, fontSize: "fontSizes", background: Ie, backgroundColor: Ie, backgroundImage: Ie, borderImage: Ie, border: Ie, borderBlock: Ie, borderBlockEnd: Ie, borderBlockStart: Ie, borderBottom: Ie, borderBottomColor: Ie, borderColor: Ie, borderInline: Ie, borderInlineEnd: Ie, borderInlineStart: Ie, borderLeft: Ie, borderLeftColor: Ie, borderRight: Ie, borderRightColor: Ie, borderTop: Ie, borderTopColor: Ie, caretColor: Ie, color: Ie, columnRuleColor: Ie, fill: Ie, outline: Ie, outlineColor: Ie, stroke: Ie, textDecorationColor: Ie, fontFamily: "fonts", fontWeight: "fontWeights", lineHeight: "lineHeights", letterSpacing: "letterSpacings", blockSize: Ue, minBlockSize: Ue, maxBlockSize: Ue, inlineSize: Ue, minInlineSize: Ue, maxInlineSize: Ue, width: Ue, minWidth: Ue, maxWidth: Ue, height: Ue, minHeight: Ue, maxHeight: Ue, flexBasis: Ue, gridTemplateColumns: Ue, gridTemplateRows: Ue, borderWidth: "borderWidths", borderTopWidth: "borderWidths", borderRightWidth: "borderWidths", borderBottomWidth: "borderWidths", borderLeftWidth: "borderWidths", borderStyle: "borderStyles", borderTopStyle: "borderStyles", borderRightStyle: "borderStyles", borderBottomStyle: "borderStyles", borderLeftStyle: "borderStyles", borderRadius: "radii", borderTopLeftRadius: "radii", borderTopRightRadius: "radii", borderBottomRightRadius: "radii", borderBottomLeftRadius: "radii", boxShadow: "shadows", textShadow: "shadows", transition: "transitions", zIndex: "zIndices" }, Z1 = (e, t) => typeof t == "function" ? { "()": Function.prototype.toString.call(t) } : t, In = () => {
  const e = /* @__PURE__ */ Object.create(null);
  return (t, n, ...r) => {
    const o = ((a) => JSON.stringify(a, Z1))(t);
    return o in e ? e[o] : e[o] = n(t, ...r);
  };
}, Yt = Symbol.for("sxs.internal"), Qa = (e, t) => Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)), hs = (e) => {
  for (const t in e)
    return !0;
  return !1;
}, { hasOwnProperty: Y1 } = Object.prototype, ga = (e) => e.includes("-") ? e : e.replace(/[A-Z]/g, (t) => "-" + t.toLowerCase()), U1 = /\s+(?![^()]*\))/, dn = (e) => (t) => e(...typeof t == "string" ? String(t).split(U1) : [t]), vs = { appearance: (e) => ({ WebkitAppearance: e, appearance: e }), backfaceVisibility: (e) => ({ WebkitBackfaceVisibility: e, backfaceVisibility: e }), backdropFilter: (e) => ({ WebkitBackdropFilter: e, backdropFilter: e }), backgroundClip: (e) => ({ WebkitBackgroundClip: e, backgroundClip: e }), boxDecorationBreak: (e) => ({ WebkitBoxDecorationBreak: e, boxDecorationBreak: e }), clipPath: (e) => ({ WebkitClipPath: e, clipPath: e }), content: (e) => ({ content: e.includes('"') || e.includes("'") || /^([A-Za-z]+\([^]*|[^]*-quote|inherit|initial|none|normal|revert|unset)$/.test(e) ? e : `"${e}"` }), hyphens: (e) => ({ WebkitHyphens: e, hyphens: e }), maskImage: (e) => ({ WebkitMaskImage: e, maskImage: e }), maskSize: (e) => ({ WebkitMaskSize: e, maskSize: e }), textSizeAdjust: (e) => ({ WebkitTextSizeAdjust: e, textSizeAdjust: e }), userSelect: (e) => ({ WebkitUserSelect: e, userSelect: e }), marginBlock: dn((e, t) => ({ marginBlockStart: e, marginBlockEnd: t || e })), marginInline: dn((e, t) => ({ marginInlineStart: e, marginInlineEnd: t || e })), maxSize: dn((e, t) => ({ maxBlockSize: e, maxInlineSize: t || e })), minSize: dn((e, t) => ({ minBlockSize: e, minInlineSize: t || e })), paddingBlock: dn((e, t) => ({ paddingBlockStart: e, paddingBlockEnd: t || e })), paddingInline: dn((e, t) => ({ paddingInlineStart: e, paddingInlineEnd: t || e })) }, Xo = /([\d.]+)([^]*)/, J1 = (e, t) => e.length ? e.reduce((n, r) => (n.push(...t.map((o) => o.includes("&") ? o.replace(/&/g, /[ +>|~]/.test(r) && /&.*&/.test(o) ? `:is(${r})` : r) : r + " " + o)), n), []) : t, Q1 = (e, t) => e in K1 && typeof t == "string" ? t.replace(/^((?:[^]*[^\w-])?)(fit-content|stretch)((?:[^\w-][^]*)?)$/, (n, r, o, a) => r + (o === "stretch" ? `-moz-available${a};${ga(e)}:${r}-webkit-fill-available` : `-moz-fit-content${a};${ga(e)}:${r}fit-content`) + a) : String(t), K1 = { blockSize: 1, height: 1, inlineSize: 1, maxBlockSize: 1, maxHeight: 1, maxInlineSize: 1, maxWidth: 1, minBlockSize: 1, minHeight: 1, minInlineSize: 1, minWidth: 1, width: 1 }, St = (e) => e ? e + "-" : "", rl = (e, t, n) => e.replace(/([+-])?((?:\d+(?:\.\d*)?|\.\d+)(?:[Ee][+-]?\d+)?)?(\$|--)([$\w-]+)/g, (r, o, a, i, s) => i == "$" == !!a ? r : (o || i == "--" ? "calc(" : "") + "var(--" + (i === "$" ? St(t) + (s.includes("$") ? "" : St(n)) + s.replace(/\$/g, "-") : s) + ")" + (o || i == "--" ? "*" + (o || "") + (a || "1") + ")" : "")), q1 = /\s*,\s*(?![^()]*\))/, e0 = Object.prototype.toString, vn = (e, t, n, r, o) => {
  let a, i, s;
  const c = (l, d, u) => {
    let f, p;
    const g = (b) => {
      for (f in b) {
        const $ = f.charCodeAt(0) === 64, x = $ && Array.isArray(b[f]) ? b[f] : [b[f]];
        for (p of x) {
          const w = /[A-Z]/.test(v = f) ? v : v.replace(/-[^]/g, (P) => P[1].toUpperCase()), C = typeof p == "object" && p && p.toString === e0 && (!r.utils[w] || !d.length);
          if (w in r.utils && !C) {
            const P = r.utils[w];
            if (P !== i) {
              i = P, g(P(p)), i = null;
              continue;
            }
          } else if (w in vs) {
            const P = vs[w];
            if (P !== s) {
              s = P, g(P(p)), s = null;
              continue;
            }
          }
          if ($ && (m = f.slice(1) in r.media ? "@media " + r.media[f.slice(1)] : f, f = m.replace(/\(\s*([\w-]+)\s*(=|<|<=|>|>=)\s*([\w-]+)\s*(?:(<|<=|>|>=)\s*([\w-]+)\s*)?\)/g, (P, E, T, F, V, _) => {
            const W = Xo.test(E), H = 0.0625 * (W ? -1 : 1), [D, M] = W ? [F, E] : [E, F];
            return "(" + (T[0] === "=" ? "" : T[0] === ">" === W ? "max-" : "min-") + D + ":" + (T[0] !== "=" && T.length === 1 ? M.replace(Xo, (j, U, ee) => Number(U) + H * (T === ">" ? 1 : -1) + ee) : M) + (V ? ") and (" + (V[0] === ">" ? "min-" : "max-") + D + ":" + (V.length === 1 ? _.replace(Xo, (j, U, ee) => Number(U) + H * (V === ">" ? -1 : 1) + ee) : _) : "") + ")";
          })), C) {
            const P = $ ? u.concat(f) : [...u], E = $ ? [...d] : J1(d, f.split(q1));
            a !== void 0 && o($s(...a)), a = void 0, c(p, E, P);
          } else
            a === void 0 && (a = [[], d, u]), f = $ || f.charCodeAt(0) !== 36 ? f : `--${St(r.prefix)}${f.slice(1).replace(/\$/g, "-")}`, p = C ? p : typeof p == "number" ? p && !(w in t0) && f.charCodeAt(0) !== 45 ? String(p) + "px" : String(p) : rl(Q1(w, p ?? ""), r.prefix, r.themeMap[w]), a[0].push(`${$ ? `${f} ` : `${ga(f)}:`}${p}`);
        }
      }
      var m, v;
    };
    g(l), a !== void 0 && o($s(...a)), a = void 0;
  };
  c(e, t, n);
}, $s = (e, t, n) => `${n.map((r) => `${r}{`).join("")}${t.length ? `${t.join(",")}{` : ""}${e.join(";")}${t.length ? "}" : ""}${Array(n.length ? n.length + 1 : 0).join("}")}`, t0 = { animationIterationCount: 1, borderImageOutset: 1, borderImageSlice: 1, borderImageWidth: 1, boxFlex: 1, boxFlexGroup: 1, boxOrdinalGroup: 1, columnCount: 1, columns: 1, flex: 1, flexGrow: 1, flexPositive: 1, flexShrink: 1, flexNegative: 1, flexOrder: 1, gridRow: 1, gridRowEnd: 1, gridRowSpan: 1, gridRowStart: 1, gridColumn: 1, gridColumnEnd: 1, gridColumnSpan: 1, gridColumnStart: 1, msGridRow: 1, msGridRowSpan: 1, msGridColumn: 1, msGridColumnSpan: 1, fontWeight: 1, lineHeight: 1, opacity: 1, order: 1, orphans: 1, tabSize: 1, widows: 1, zIndex: 1, zoom: 1, WebkitLineClamp: 1, fillOpacity: 1, floodOpacity: 1, stopOpacity: 1, strokeDasharray: 1, strokeDashoffset: 1, strokeMiterlimit: 1, strokeOpacity: 1, strokeWidth: 1 }, xs = (e) => String.fromCharCode(e + (e > 25 ? 39 : 97)), Ut = (e) => ((t) => {
  let n, r = "";
  for (n = Math.abs(t); n > 52; n = n / 52 | 0)
    r = xs(n % 52) + r;
  return xs(n % 52) + r;
})(((t, n) => {
  let r = n.length;
  for (; r; )
    t = 33 * t ^ n.charCodeAt(--r);
  return t;
})(5381, JSON.stringify(e)) >>> 0), Vn = ["themed", "global", "styled", "onevar", "resonevar", "allvar", "inline"], n0 = (e) => {
  if (e.href && !e.href.startsWith(location.origin))
    return !1;
  try {
    return !!e.cssRules;
  } catch {
    return !1;
  }
}, r0 = (e) => {
  let t;
  const n = () => {
    const { cssRules: o } = t.sheet;
    return [].map.call(o, (a, i) => {
      const { cssText: s } = a;
      let c = "";
      if (s.startsWith("--sxs"))
        return "";
      if (o[i - 1] && (c = o[i - 1].cssText).startsWith("--sxs")) {
        if (!a.cssRules.length)
          return "";
        for (const l in t.rules)
          if (t.rules[l].group === a)
            return `--sxs{--sxs:${[...t.rules[l].cache].join(" ")}}${s}`;
        return a.cssRules.length ? `${c}${s}` : "";
      }
      return s;
    }).join("");
  }, r = () => {
    if (t) {
      const { rules: s, sheet: c } = t;
      if (!c.deleteRule) {
        for (; Object(Object(c.cssRules)[0]).type === 3; )
          c.cssRules.splice(0, 1);
        c.cssRules = [];
      }
      for (const l in s)
        delete s[l];
    }
    const o = Object(e).styleSheets || [];
    for (const s of o)
      if (n0(s)) {
        for (let c = 0, l = s.cssRules; l[c]; ++c) {
          const d = Object(l[c]);
          if (d.type !== 1)
            continue;
          const u = Object(l[c + 1]);
          if (u.type !== 4)
            continue;
          ++c;
          const { cssText: f } = d;
          if (!f.startsWith("--sxs"))
            continue;
          const p = f.slice(14, -3).trim().split(/\s+/), g = Vn[p[0]];
          g && (t || (t = { sheet: s, reset: r, rules: {}, toString: n }), t.rules[g] = { group: u, index: c, cache: new Set(p) });
        }
        if (t)
          break;
      }
    if (!t) {
      const s = (c, l) => ({ type: l, cssRules: [], insertRule(d, u) {
        this.cssRules.splice(u, 0, s(d, { import: 3, undefined: 1 }[(d.toLowerCase().match(/^@([a-z]+)/) || [])[1]] || 4));
      }, get cssText() {
        return c === "@media{}" ? `@media{${[].map.call(this.cssRules, (d) => d.cssText).join("")}}` : c;
      } });
      t = { sheet: (() => {
        if (!e)
          return s("", "text/css");
        const c = document.createElement("style"), l = window.__webpack_nonce__ !== void 0 ? window.__webpack_nonce__ : window.nonce !== void 0 ? window.nonce : null;
        return l && c.setAttribute("nonce", l), (e.head || e).appendChild(c).sheet;
      })(), rules: {}, reset: r, toString: n };
    }
    const { sheet: a, rules: i } = t;
    for (let s = Vn.length - 1; s >= 0; --s) {
      const c = Vn[s];
      if (!i[c]) {
        const l = Vn[s + 1], d = i[l] ? i[l].index : a.cssRules.length;
        a.insertRule("@media{}", d), a.insertRule(`--sxs{--sxs:${s}}`, d), i[c] = { group: a.cssRules[d + 1], index: d, cache: /* @__PURE__ */ new Set([s]) };
      }
      o0(i[c]);
    }
  };
  return r(), t;
}, o0 = (e) => {
  const t = e.group;
  let n = t.cssRules.length;
  e.apply = (r) => {
    try {
      t.insertRule(r, n), ++n;
    } catch {
    }
  };
}, Rn = Symbol(), a0 = In(), ys = (e, t) => a0(e, () => {
  const n = (o, a = {}) => {
    let i = { type: null, composers: /* @__PURE__ */ new Set() };
    for (const s of o)
      if (s != null)
        if (s[Yt]) {
          i.type == null && (i.type = s[Yt].type);
          for (const c of s[Yt].composers)
            i.composers.add(c);
        } else
          s.constructor !== Object || s.$$typeof ? i.type == null && (i.type = s) : i.composers.add(i0(s, e, a));
    return i.type == null && (i.type = "span"), i.composers.size || i.composers.add(["PJLV", {}, [], [], {}, []]), s0(e, i, t, a);
  }, r = (...o) => n(o);
  return r.withConfig = (o) => (...a) => n(a, o), r;
}), i0 = ({ variants: e, compoundVariants: t, defaultVariants: n, ...r }, o, { componentId: a, displayName: i }) => {
  const s = a || Ut(r), c = i ? "c-" + i : "c", l = `${St(o.prefix)}${c}-${s}`, d = [], u = [], f = /* @__PURE__ */ Object.create(null), p = [];
  for (const m in n)
    f[m] = String(n[m]);
  if (typeof e == "object" && e)
    for (const m in e) {
      g = f, b = m, Y1.call(g, b) || (f[m] = "undefined");
      const v = e[m];
      for (const $ in v) {
        const x = { [m]: String($) };
        String($) === "undefined" && p.push(m);
        const w = v[$], C = [x, w, !hs(w)];
        d.push(C);
      }
    }
  var g, b;
  if (typeof t == "object" && t)
    for (const m of t) {
      let { css: v, ...$ } = m;
      v = typeof v == "object" && v || {};
      for (const w in $)
        $[w] = String($[w]);
      const x = [$, v, !hs(v)];
      u.push(x);
    }
  return [l, r, d, u, f, p];
}, s0 = (e, t, n, { shouldForwardStitchesProp: r }) => {
  const [o, a, i, s] = c0(t.composers), c = typeof t.type == "function" || t.type.$$typeof ? ((f) => {
    function p() {
      for (let g = 0; g < p[Rn].length; g++) {
        const [b, m] = p[Rn][g];
        f.rules[b].apply(m);
      }
      return p[Rn] = [], null;
    }
    return p[Rn] = [], p.rules = {}, Vn.forEach((g) => p.rules[g] = { apply: (b) => p[Rn].push([g, b]) }), p;
  })(n) : null, l = (c || n).rules, d = `.${o}${a.length > 1 ? `:where(.${a.slice(1).join(".")})` : ""}`, u = (f) => {
    f = typeof f == "object" && f || l0;
    const { ...p } = f, g = {};
    for (const $ in i)
      if ($ in f) {
        r != null && r($) || delete p[$];
        let x = f[$];
        typeof x == "object" && x ? g[$] = { "@initial": i[$], ...x } : (x = String(x), g[$] = x !== "undefined" || s.has($) ? x : i[$]);
      } else
        g[$] = i[$];
    const b = /* @__PURE__ */ new Set([...a]);
    for (const [$, x, w, C] of t.composers) {
      n.rules.styled.cache.has($) || (n.rules.styled.cache.add($), vn(x, [`.${$}`], [], e, (T) => {
        l.styled.apply(T);
      }));
      const P = Cs(w, g, e.media), E = Cs(C, g, e.media, !0);
      for (const T of P)
        if (T !== void 0)
          for (const [F, V, _] of T) {
            const W = `${$}-${Ut(V)}-${F}`;
            b.add(W);
            const H = (_ ? n.rules.resonevar : n.rules.onevar).cache, D = _ ? l.resonevar : l.onevar;
            H.has(W) || (H.add(W), vn(V, [`.${W}`], [], e, (M) => {
              D.apply(M);
            }));
          }
      for (const T of E)
        if (T !== void 0)
          for (const [F, V] of T) {
            const _ = `${$}-${Ut(V)}-${F}`;
            b.add(_), n.rules.allvar.cache.has(_) || (n.rules.allvar.cache.add(_), vn(V, [`.${_}`], [], e, (W) => {
              l.allvar.apply(W);
            }));
          }
    }
    const m = p.css;
    if (typeof m == "object" && m) {
      r != null && r("css") || delete p.css;
      const $ = `${o}-i${Ut(m)}-css`;
      b.add($), n.rules.inline.cache.has($) || (n.rules.inline.cache.add($), vn(m, [`.${$}`], [], e, (x) => {
        l.inline.apply(x);
      }));
    }
    for (const $ of String(f.className || "").trim().split(/\s+/))
      $ && b.add($);
    const v = p.className = [...b].join(" ");
    return { type: t.type, className: v, selector: d, props: p, toString: () => v, deferredInjector: c };
  };
  return Qa(u, { className: o, selector: d, [Yt]: t, toString: () => (n.rules.styled.cache.has(o) || u(), o) });
}, c0 = (e) => {
  let t = "";
  const n = [], r = {}, o = [];
  for (const [a, , , , i, s] of e) {
    t === "" && (t = a), n.push(a), o.push(...s);
    for (const c in i) {
      const l = i[c];
      (r[c] === void 0 || l !== "undefined" || s.includes(l)) && (r[c] = l);
    }
  }
  return [t, n, r, new Set(o)];
}, Cs = (e, t, n, r) => {
  const o = [];
  e:
    for (let [a, i, s] of e) {
      if (s)
        continue;
      let c, l = 0, d = !1;
      for (c in a) {
        const u = a[c];
        let f = t[c];
        if (f !== u) {
          if (typeof f != "object" || !f)
            continue e;
          {
            let p, g, b = 0;
            for (const m in f) {
              if (u === String(f[m])) {
                if (m !== "@initial") {
                  const v = m.slice(1);
                  (g = g || []).push(v in n ? n[v] : m.replace(/^@media ?/, "")), d = !0;
                }
                l += b, p = !0;
              }
              ++b;
            }
            if (g && g.length && (i = { ["@media " + g.join(", ")]: i }), !p)
              continue e;
          }
        }
      }
      (o[l] = o[l] || []).push([r ? "cv" : `${c}-${a[c]}`, i, d]);
    }
  return o;
}, l0 = {}, u0 = In(), d0 = (e, t) => u0(e, () => (...n) => {
  const r = () => {
    for (let o of n) {
      o = typeof o == "object" && o || {};
      let a = Ut(o);
      if (!t.rules.global.cache.has(a)) {
        if (t.rules.global.cache.add(a), "@import" in o) {
          let i = [].indexOf.call(t.sheet.cssRules, t.rules.themed.group) - 1;
          for (let s of [].concat(o["@import"]))
            s = s.includes('"') || s.includes("'") ? s : `"${s}"`, t.sheet.insertRule(`@import ${s};`, i++);
          delete o["@import"];
        }
        vn(o, [], [], e, (i) => {
          t.rules.global.apply(i);
        });
      }
    }
    return "";
  };
  return Qa(r, { toString: r });
}), f0 = In(), p0 = (e, t) => f0(e, () => (n) => {
  const r = `${St(e.prefix)}k-${Ut(n)}`, o = () => {
    if (!t.rules.global.cache.has(r)) {
      t.rules.global.cache.add(r);
      const a = [];
      vn(n, [], [], e, (s) => a.push(s));
      const i = `@keyframes ${r}{${a.join("")}}`;
      t.rules.global.apply(i);
    }
    return r;
  };
  return Qa(o, { get name() {
    return o();
  }, toString: o });
}), b0 = class {
  constructor(t, n, r, o) {
    this.token = t == null ? "" : String(t), this.value = n == null ? "" : String(n), this.scale = r == null ? "" : String(r), this.prefix = o == null ? "" : String(o);
  }
  get computedValue() {
    return "var(" + this.variable + ")";
  }
  get variable() {
    return "--" + St(this.prefix) + St(this.scale) + this.token;
  }
  toString() {
    return this.computedValue;
  }
}, g0 = In(), m0 = (e, t) => g0(e, () => (n, r) => {
  r = typeof n == "object" && n || Object(r);
  const o = `.${n = (n = typeof n == "string" ? n : "") || `${St(e.prefix)}t-${Ut(r)}`}`, a = {}, i = [];
  for (const c in r) {
    a[c] = {};
    for (const l in r[c]) {
      const d = `--${St(e.prefix)}${c}-${l}`, u = rl(String(r[c][l]), e.prefix, c);
      a[c][l] = new b0(l, u, c, e.prefix), i.push(`${d}:${u}`);
    }
  }
  const s = () => {
    if (i.length && !t.rules.themed.cache.has(n)) {
      t.rules.themed.cache.add(n);
      const c = `${r === e.theme ? ":root," : ""}.${n}{${i.join(";")}}`;
      t.rules.themed.apply(c);
    }
    return n;
  };
  return { ...a, get className() {
    return s();
  }, selector: o, toString: s };
}), h0 = In(), v0 = In(), $0 = (e) => {
  const t = ((n) => {
    let r = !1;
    const o = h0(n, (a) => {
      r = !0;
      const i = "prefix" in (a = typeof a == "object" && a || {}) ? String(a.prefix) : "", s = typeof a.media == "object" && a.media || {}, c = typeof a.root == "object" ? a.root || null : globalThis.document || null, l = typeof a.theme == "object" && a.theme || {}, d = { prefix: i, media: s, theme: l, themeMap: typeof a.themeMap == "object" && a.themeMap || { ...X1 }, utils: typeof a.utils == "object" && a.utils || {} }, u = r0(c), f = { css: ys(d, u), globalCss: d0(d, u), keyframes: p0(d, u), createTheme: m0(d, u), reset() {
        u.reset(), f.theme.toString();
      }, theme: {}, sheet: u, config: d, prefix: i, getCssText: u.toString, toString: u.toString };
      return String(f.theme = f.createTheme(l)), f;
    });
    return r || o.reset(), o;
  })(e);
  return t.styled = (({ config: n, sheet: r }) => v0(n, () => {
    const o = ys(n, r), a = (s, c = o, { displayName: l, shouldForwardStitchesProp: d } = {}) => {
      const u = c(...s), f = u[Yt].type, p = d == null ? void 0 : d("as"), g = A.forwardRef((b, m) => {
        const v = b != null && b.as && !p ? b == null ? void 0 : b.as : f, { props: $, deferredInjector: x } = u(b);
        return p || delete $.as, $.ref = m, x ? A.createElement(A.Fragment, null, A.createElement(v, $), A.createElement(x, null)) : A.createElement(v, $);
      });
      return g.className = u.className, g.displayName = l || `Styled.${f.displayName || f.name || f}`, g.selector = u.selector, g.toString = () => u.selector, g[Yt] = u[Yt], g;
    }, i = (...s) => a(s);
    return i.withConfig = (s) => (...c) => {
      const l = o.withConfig(s);
      return a(c, l, s);
    }, i;
  }))(t), t;
};
const Br = {
  Main: "rgba(255, 255, 255, 0.87)",
  70: "rgba(255, 255, 255, 0.70)",
  50: "rgba(255, 255, 255, 0.50)",
  30: "rgba(255, 255, 255, 0.30)",
  25: "rgba(255, 255, 255, 0.25)",
  16: "rgba(255, 255, 255, 0.16)",
  10: "rgba(255, 255, 255, 0.10)"
}, Vr = {
  Main: "rgba(0, 0, 0, 0.87)",
  70: "rgba(0, 0, 0, 0.70)",
  50: "rgba(0, 0, 0, 0.50)",
  30: "rgba(0, 0, 0, 0.30)",
  25: "rgba(0, 0, 0, 0.25)",
  16: "rgba(0, 0, 0, 0.16)",
  10: "rgba(0, 0, 0, 0.10)"
};
function Ot(e, t) {
  return Object.entries(t).reduce((n, [r, o]) => {
    const a = e === "Inverted" ? `textPrimary${r}${e}` : `text${e}${r}`;
    return {
      ...n,
      [a]: o
    };
  }, {});
}
const x0 = {
  brandPrimaryMain: "#5684FD",
  brandPrimary75: "rgba(86, 132, 253, 0.75)",
  brandPrimary50: "rgba(86, 132, 253, 0.50)",
  brandPrimary25: "rgba(86, 132, 253, 0.25)",
  brandPrimary16: "rgba(86, 132, 253, 0.16)",
  ...Ot("Primary", Vr),
  ...Ot("Inverted", Br),
  ...Ot("AlwaysDark", Vr),
  ...Ot("AlwaysLight", Br),
  textLink: "#5684FD",
  textSuccess: "#25C270",
  textError: "#F53656",
  textAttention: "#F98215",
  uiPrimaryMain: "#5684FD",
  uiPrimary75: "rgba(86, 132, 253, 0.75)",
  uiPrimary50: "rgba(86, 132, 253, 0.50)",
  uiPrimary25: "rgba(86, 132, 253, 0.25)",
  uiPrimary16: "#d5e1ff",
  uiPrimary16A: "rgba(86, 132, 253, 0.16)",
  uiSecondary: "#ffffff",
  uiTertiary: "#f7f7f7",
  uiQuaternary: "#F3F6FF",
  uiSuccessMain: "#46DC8E",
  uiSuccess75: "rgba(70, 220, 142, 0.75)",
  uiSuccess50: "rgba(70, 220, 142, 0.50)",
  uiSuccess25: "rgba(70, 220, 142, 0.25)",
  uiSuccess16: "#DBF3E6",
  uiSuccess16A: "rgba(70, 220, 142, 0.16)",
  uiErrorMain: "#F53656",
  uiError75: "rgba(245, 54, 86, 0.75)",
  uiError50: "rgba(245, 54, 86, 0.50)",
  uiError25: "rgba(245, 54, 86, 0.25)",
  uiError16: "#F7D8DD",
  uiError16A: "rgba(245, 54, 86, 0.16)",
  uiAttentionMain: "#F98215",
  uiAttention75: "rgba(249, 130, 21, 0.75)",
  uiAttention50: "rgba(249, 130, 21, 0.50)",
  uiAttention25: "rgba(249, 130, 21, 0.25)",
  uiAttention16: "#F7E4D3",
  uiAttention16A: "rgba(249, 130, 21, 0.16)",
  uiDisabledMain: "rgba(102, 102, 102, 1)",
  uiDisabled75: "rgba(102, 102, 102, 0.75)",
  uiDisabled50: "rgba(102, 102, 102, 0.50)",
  uiDisabled25: "rgba(102, 102, 102, 0.25)",
  uiDisabled16: "rgba(102, 102, 102, 0.16)",
  uiMonochromeMain: "rgba(0, 0, 0, 1)",
  uiMonochrome75: "rgba(0, 0, 0, 0.75)",
  uiMonochrome50: "rgba(0, 0, 0, 0.50)",
  uiMonochrome30: "rgba(0, 0, 0, 0.30)",
  uiMonochrome25: "rgba(0, 0, 0, 0.25)",
  uiMonochrome20: "rgba(0, 0, 0, 0.20)",
  divider: "rgba(0, 0, 0, 0.1)",
  twitchPurple: "#9146FF",
  youtubeRed: "#ff0000",
  trovoGreen: "#32C27C",
  facebookBlue: "#1678F2",
  kickGreen: "#53FC18",
  xBlack: "#191919"
}, y0 = {
  ...Ot("Primary", Br),
  ...Ot("Inverted", Vr),
  uiSecondary: "#232428",
  uiTertiary: "#131315",
  uiQuaternary: "#35363C",
  uiPrimary16: "#0e1528",
  uiSuccess16: "#204533",
  uiAttention16: "#4D2F15",
  uiError16: "#4C1C25",
  uiMonochromeMain: "rgba(255, 255, 255, 1)",
  uiMonochrome75: "rgba(255, 255, 255, 0.75)",
  uiMonochrome50: "rgba(255, 255, 255, 0.50)",
  uiMonochrome30: "rgba(255, 255, 255, 0.30)",
  uiMonochrome25: "rgba(255, 255, 255, 0.25)",
  uiMonochrome20: "rgba(255, 255, 255, 0.20)",
  divider: "rgba(255, 255, 255, 0.1)"
}, C0 = {
  ...Ot("Primary", Br),
  ...Ot("Inverted", Vr),
  uiSecondary: "#1C233D",
  uiTertiary: "#020923",
  uiQuaternary: "#2C3450",
  uiPrimary16: "#0e1528",
  uiSuccess16: "#204533",
  uiAttention16: "#4D2F15",
  uiError16: "#4C1C25",
  uiMonochromeMain: "rgba(255, 255, 255, 1)",
  uiMonochrome75: "rgba(255, 255, 255, 0.75)",
  uiMonochrome50: "rgba(255, 255, 255, 0.50)",
  uiMonochrome30: "rgba(255, 255, 255, 0.30)",
  uiMonochrome25: "rgba(255, 255, 255, 0.25)",
  uiMonochrome20: "rgba(255, 255, 255, 0.20)",
  divider: "rgba(255, 255, 255, 0.1)"
}, w0 = {
  1: "0px 4px 10px rgba(0, 0, 0, 0.05)",
  2: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  3: "0px 8px 16px rgba(0, 0, 0, 0.1);",
  4: "0px 4px 10px rgba(0, 0, 0, 0.03), 0px 16px 32px rgba(0, 0, 0, 0.15)"
}, ol = {
  1: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  2: "0px 4px 10px rgba(0, 0, 0, 0.5)",
  3: "0px 8px 16px rgba(0, 0, 0, 0.5)",
  4: "0px 4px 4px rgba(0, 0, 0, 0.25)"
}, I0 = {
  heading1: "3.625rem",
  heading2: "2.875rem",
  heading3: "2rem",
  heading4: "1.75rem",
  heading5: "1.5rem",
  heading6: "1.25rem",
  subtitle: "1rem",
  bodyText: "0.875rem",
  caption: "0.75rem"
}, S0 = {
  regular: "400",
  bold: "700",
  black: "900"
}, A0 = {
  tight1: "-0.5px",
  tight2: "-0.25px",
  tight3: "-0.15px",
  tight: "-0.1px",
  base: "0.1px",
  loose: "0.25px",
  loose1: "0.5px"
}, E0 = {
  base: '"Nunito Sans", sans-serif',
  heading: '"Nunito Sans", sans-serif',
  button: '"Nunito Sans", sans-serif',
  dropdownTrigger: '"Nunito Sans", sans-serif',
  dropdownItem: '"Nunito Sans", sans-serif',
  dropdownSubTrigger: '"Nunito Sans", sans-serif'
}, P0 = $0({
  prefix: "se-ds",
  theme: {
    colors: x0,
    fontSizes: I0,
    fontWeights: S0,
    letterSpacings: A0,
    fonts: E0,
    shadows: w0,
    radii: {
      xs: "2px",
      sm: "4px",
      base: "8px",
      md: "12px",
      lg: "14px",
      xl: "16px",
      2: "2px",
      4: "4px",
      8: "8px",
      12: "12px",
      14: "14px",
      16: "16px",
      24: "24px",
      32: "32px"
    },
    space: {
      base: "8px",
      4: "4px",
      8: "8px",
      10: "8px",
      12: "12px",
      16: "16px",
      24: "24px",
      32: "32px",
      40: "40px",
      48: "48px",
      56: "56px"
    },
    transitions: {
      1: "cubic-bezier(0.0, 0, 0.2, 1)"
    }
  },
  media: {
    min480: "(min-width: 480px)",
    max480: "(max-width: 480px)",
    min768: "(min-width: 768px)",
    max768: "(max-width: 768px)",
    min1024: "(min-width: 1024px)",
    max1024: "(max-width: 1024px)",
    min1336: "(min-width: 1336px)",
    max1336: "(max-width: 1336px)",
    minFullHD: "(min-width: 1920px)",
    maxFullHD: "(max-width: 1920px)",
    min1440: "(min-width: 1440px)",
    max1440: "(max-width: 1440px)",
    minQHD: "(min-width: 2560px)",
    maxQHD: "(max-width: 2560px)",
    min4K: "(min-width: 3840px)",
    max4K: "(max-width: 3840px)"
  },
  utils: {
    m: (e) => ({ margin: e }),
    mt: (e) => ({ marginTop: e }),
    mr: (e) => ({ marginRight: e }),
    mb: (e) => ({ marginBottom: e }),
    ml: (e) => ({ marginLeft: e }),
    my: (e) => ({ marginTop: e, marginBottom: e }),
    mx: (e) => ({ marginLeft: e, marginRight: e }),
    br: (e) => ({
      borderRadius: e
    }),
    borderTopRadius: (e) => ({
      borderTopLeftRadius: e,
      borderTopRightRadius: e
    }),
    borderBottomRadius: (e) => ({
      borderBottomLeftRadius: e,
      borderBottomRightRadius: e
    }),
    btr: (e) => ({
      borderTopLeftRadius: e,
      borderTopRightRadius: e
    }),
    bbr: (e) => ({
      borderBottomLeftRadius: e,
      borderBottomRightRadius: e
    }),
    borderLeftRadius: (e) => ({
      borderBottomLeftRadius: e,
      borderTopLeftRadius: e
    }),
    borderRightRadius: (e) => ({
      borderBottomRightRadius: e,
      borderTopRightRadius: e
    }),
    blr: (e) => ({
      borderBottomLeftRadius: e,
      borderTopLeftRadius: e
    }),
    brr: (e) => ({
      borderBottomRightRadius: e,
      borderTopRightRadius: e
    }),
    py: (e) => ({
      paddingTop: e,
      paddingBottom: e
    }),
    px: (e) => ({
      paddingLeft: e,
      paddingRight: e
    }),
    pt: (e) => ({
      paddingTop: e
    }),
    pb: (e) => ({
      paddingBottom: e
    }),
    pl: (e) => ({
      paddingLeft: e
    }),
    pr: (e) => ({
      paddingRight: e
    }),
    bgc: (e) => ({
      backgroundColor: e
    }),
    size: (e) => ({
      width: e,
      height: e
    })
  }
}), { styled: k, theme: $I, createTheme: al, keyframes: Lt, globalCss: xI, css: tn, getCssText: yI, config: T0 } = P0, { media: CI } = T0, il = al("dark-theme", {
  colors: y0,
  shadows: ol
}), sl = al("transitional-dark-theme", {
  colors: C0,
  shadows: ol
});
function S() {
  return S = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, S.apply(this, arguments);
}
function _e(e, t = []) {
  let n = [];
  function r(a, i) {
    const s = /* @__PURE__ */ Kt(i), c = n.length;
    n = [
      ...n,
      i
    ];
    function l(u) {
      const { scope: f, children: p, ...g } = u, b = (f == null ? void 0 : f[e][c]) || s, m = Ne(
        () => g,
        Object.values(g)
      );
      return /* @__PURE__ */ y(b.Provider, {
        value: m
      }, p);
    }
    function d(u, f) {
      const p = (f == null ? void 0 : f[e][c]) || s, g = ct(p);
      if (g)
        return g;
      if (i !== void 0)
        return i;
      throw new Error(`\`${u}\` must be used within \`${a}\``);
    }
    return l.displayName = a + "Provider", [
      l,
      d
    ];
  }
  const o = () => {
    const a = n.map((i) => /* @__PURE__ */ Kt(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || a;
      return Ne(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: c
          }
        }),
        [
          s,
          c
        ]
      );
    };
  };
  return o.scopeName = e, [
    r,
    R0(o, ...t)
  ];
}
function R0(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(a) {
      const i = r.reduce((s, { useScope: c, scopeName: l }) => {
        const u = c(a)[`__scope${l}`];
        return {
          ...s,
          ...u
        };
      }, {});
      return Ne(
        () => ({
          [`__scope${t.scopeName}`]: i
        }),
        [
          i
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
function M0(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function io(...e) {
  return (t) => e.forEach(
    (n) => M0(n, t)
  );
}
function se(...e) {
  return K(io(...e), e);
}
const je = /* @__PURE__ */ R((e, t) => {
  const { children: n, ...r } = e, o = Zt.toArray(n), a = o.find(D0);
  if (a) {
    const i = a.props.children, s = o.map((c) => c === a ? Zt.count(i) > 1 ? Zt.only(null) : /* @__PURE__ */ Lr(i) ? i.props.children : null : c);
    return /* @__PURE__ */ y(ma, S({}, r, {
      ref: t
    }), /* @__PURE__ */ Lr(i) ? /* @__PURE__ */ Ja(i, void 0, s) : null);
  }
  return /* @__PURE__ */ y(ma, S({}, r, {
    ref: t
  }), n);
});
je.displayName = "Slot";
const ma = /* @__PURE__ */ R((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ Lr(n) ? /* @__PURE__ */ Ja(n, {
    ...O0(r, n.props),
    ref: t ? io(t, n.ref) : n.ref
  }) : Zt.count(n) > 1 ? Zt.only(null) : null;
});
ma.displayName = "SlotClone";
const cl = ({ children: e }) => /* @__PURE__ */ y(xt, null, e);
function D0(e) {
  return /* @__PURE__ */ Lr(e) && e.type === cl;
}
function O0(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...s) => {
      a(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...a
    } : r === "className" && (n[r] = [
      o,
      a
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const wI = je;
function tr(e) {
  const t = e + "CollectionProvider", [n, r] = _e(t), [o, a] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), i = (p) => {
    const { scope: g, children: b } = p, m = A.useRef(null), v = A.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ A.createElement(o, {
      scope: g,
      itemMap: v,
      collectionRef: m
    }, b);
  }, s = e + "CollectionSlot", c = /* @__PURE__ */ A.forwardRef((p, g) => {
    const { scope: b, children: m } = p, v = a(s, b), $ = se(g, v.collectionRef);
    return /* @__PURE__ */ A.createElement(je, {
      ref: $
    }, m);
  }), l = e + "CollectionItemSlot", d = "data-radix-collection-item", u = /* @__PURE__ */ A.forwardRef((p, g) => {
    const { scope: b, children: m, ...v } = p, $ = A.useRef(null), x = se(g, $), w = a(l, b);
    return A.useEffect(() => (w.itemMap.set($, {
      ref: $,
      ...v
    }), () => void w.itemMap.delete($))), /* @__PURE__ */ A.createElement(je, {
      [d]: "",
      ref: x
    }, m);
  });
  function f(p) {
    const g = a(e + "CollectionConsumer", p);
    return A.useCallback(() => {
      const m = g.collectionRef.current;
      if (!m)
        return [];
      const v = Array.from(m.querySelectorAll(`[${d}]`));
      return Array.from(g.itemMap.values()).sort(
        (w, C) => v.indexOf(w.ref.current) - v.indexOf(C.ref.current)
      );
    }, [
      g.collectionRef,
      g.itemMap
    ]);
  }
  return [
    {
      Provider: i,
      Slot: c,
      ItemSlot: u
    },
    f,
    r
  ];
}
function G(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function Ee(e) {
  const t = O(e);
  return Z(() => {
    t.current = e;
  }), Ne(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function Te({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = F0({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, i = a ? e : r, s = Ee(n), c = K((l) => {
    if (a) {
      const u = typeof l == "function" ? l(e) : l;
      u !== e && s(u);
    } else
      o(l);
  }, [
    a,
    e,
    o,
    s
  ]);
  return [
    i,
    c
  ];
}
function F0({ defaultProp: e, onChange: t }) {
  const n = J(e), [r] = n, o = O(r), a = Ee(t);
  return Z(() => {
    o.current !== r && (a(r), o.current = r);
  }, [
    r,
    o,
    a
  ]), n;
}
const k0 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], te = k0.reduce((e, t) => {
  const n = /* @__PURE__ */ R((r, o) => {
    const { asChild: a, ...i } = r, s = a ? je : t;
    return Z(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ y(s, S({}, i, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function Ka(e, t) {
  e && tl(
    () => e.dispatchEvent(t)
  );
}
const ft = globalThis != null && globalThis.document ? ao : () => {
};
function N0(e, t) {
  return el((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const Oe = (e) => {
  const { present: t, children: n } = e, r = _0(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : Zt.only(n), a = se(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ Ja(o, {
    ref: a
  }) : null;
};
Oe.displayName = "Presence";
function _0(e) {
  const [t, n] = J(), r = O({}), o = O(e), a = O("none"), i = e ? "mounted" : "unmounted", [s, c] = N0(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Z(() => {
    const l = mr(r.current);
    a.current = s === "mounted" ? l : "none";
  }, [
    s
  ]), ft(() => {
    const l = r.current, d = o.current;
    if (d !== e) {
      const f = a.current, p = mr(l);
      e ? c("MOUNT") : p === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(d && f !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    c
  ]), ft(() => {
    if (t) {
      const l = (u) => {
        const p = mr(r.current).includes(u.animationName);
        u.target === t && p && tl(
          () => c("ANIMATION_END")
        );
      }, d = (u) => {
        u.target === t && (a.current = mr(r.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", l), t.addEventListener("animationend", l), () => {
        t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", l), t.removeEventListener("animationend", l);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: K((l) => {
      l && (r.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function mr(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
const L0 = N["useId".toString()] || (() => {
});
let B0 = 0;
function nt(e) {
  const [t, n] = N.useState(L0());
  return ft(() => {
    e || n(
      (r) => r ?? String(B0++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
const ll = "Collapsible", [V0, ul] = _e(ll), [G0, qa] = V0(ll), W0 = /* @__PURE__ */ R((e, t) => {
  const { __scopeCollapsible: n, open: r, defaultOpen: o, disabled: a, onOpenChange: i, ...s } = e, [c = !1, l] = Te({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ y(G0, {
    scope: n,
    disabled: a,
    contentId: nt(),
    open: c,
    onOpenToggle: K(
      () => l(
        (d) => !d
      ),
      [
        l
      ]
    )
  }, /* @__PURE__ */ y(te.div, S({
    "data-state": ei(c),
    "data-disabled": a ? "" : void 0
  }, s, {
    ref: t
  })));
}), j0 = "CollapsibleTrigger", z0 = /* @__PURE__ */ R((e, t) => {
  const { __scopeCollapsible: n, ...r } = e, o = qa(j0, n);
  return /* @__PURE__ */ y(te.button, S({
    type: "button",
    "aria-controls": o.contentId,
    "aria-expanded": o.open || !1,
    "data-state": ei(o.open),
    "data-disabled": o.disabled ? "" : void 0,
    disabled: o.disabled
  }, r, {
    ref: t,
    onClick: G(e.onClick, o.onOpenToggle)
  }));
}), dl = "CollapsibleContent", H0 = /* @__PURE__ */ R((e, t) => {
  const { forceMount: n, ...r } = e, o = qa(dl, e.__scopeCollapsible);
  return /* @__PURE__ */ y(
    Oe,
    {
      present: n || o.open
    },
    ({ present: a }) => /* @__PURE__ */ y(X0, S({}, r, {
      ref: t,
      present: a
    }))
  );
}), X0 = /* @__PURE__ */ R((e, t) => {
  const { __scopeCollapsible: n, present: r, children: o, ...a } = e, i = qa(dl, n), [s, c] = J(r), l = O(null), d = se(t, l), u = O(0), f = u.current, p = O(0), g = p.current, b = i.open || s, m = O(b), v = O();
  return Z(() => {
    const $ = requestAnimationFrame(
      () => m.current = !1
    );
    return () => cancelAnimationFrame($);
  }, []), ft(() => {
    const $ = l.current;
    if ($) {
      v.current = v.current || {
        transitionDuration: $.style.transitionDuration,
        animationName: $.style.animationName
      }, $.style.transitionDuration = "0s", $.style.animationName = "none";
      const x = $.getBoundingClientRect();
      u.current = x.height, p.current = x.width, m.current || ($.style.transitionDuration = v.current.transitionDuration, $.style.animationName = v.current.animationName), c(r);
    }
  }, [
    i.open,
    r
  ]), /* @__PURE__ */ y(te.div, S({
    "data-state": ei(i.open),
    "data-disabled": i.disabled ? "" : void 0,
    id: i.contentId,
    hidden: !b
  }, a, {
    ref: d,
    style: {
      ["--radix-collapsible-content-height"]: f ? `${f}px` : void 0,
      ["--radix-collapsible-content-width"]: g ? `${g}px` : void 0,
      ...e.style
    }
  }), b && o);
});
function ei(e) {
  return e ? "open" : "closed";
}
const Z0 = W0, Y0 = z0, U0 = H0, J0 = /* @__PURE__ */ Kt(void 0);
function Bt(e) {
  const t = ct(J0);
  return e || t || "ltr";
}
const Vt = "Accordion", Q0 = [
  "Home",
  "End",
  "ArrowDown",
  "ArrowUp",
  "ArrowLeft",
  "ArrowRight"
], [ti, K0, q0] = tr(Vt), [so, II] = _e(Vt, [
  q0,
  ul
]), ni = ul(), fl = /* @__PURE__ */ A.forwardRef((e, t) => {
  const { type: n, ...r } = e, o = r, a = r;
  return /* @__PURE__ */ A.createElement(ti.Provider, {
    scope: e.__scopeAccordion
  }, n === "multiple" ? /* @__PURE__ */ A.createElement(rp, S({}, a, {
    ref: t
  })) : /* @__PURE__ */ A.createElement(np, S({}, o, {
    ref: t
  })));
});
fl.propTypes = {
  type(e) {
    const t = e.value || e.defaultValue;
    return e.type && ![
      "single",
      "multiple"
    ].includes(e.type) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected one of `single | multiple`.") : e.type === "multiple" && typeof t == "string" ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `single` when `defaultValue` or `value` is type `string`.") : e.type === "single" && Array.isArray(t) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `multiple` when `defaultValue` or `value` is type `string[]`.") : null;
  }
};
const [pl, ep] = so(Vt), [bl, tp] = so(Vt, {
  collapsible: !1
}), np = /* @__PURE__ */ A.forwardRef((e, t) => {
  const { value: n, defaultValue: r, onValueChange: o = () => {
  }, collapsible: a = !1, ...i } = e, [s, c] = Te({
    prop: n,
    defaultProp: r,
    onChange: o
  });
  return /* @__PURE__ */ A.createElement(pl, {
    scope: e.__scopeAccordion,
    value: s ? [
      s
    ] : [],
    onItemOpen: c,
    onItemClose: A.useCallback(
      () => a && c(""),
      [
        a,
        c
      ]
    )
  }, /* @__PURE__ */ A.createElement(bl, {
    scope: e.__scopeAccordion,
    collapsible: a
  }, /* @__PURE__ */ A.createElement(gl, S({}, i, {
    ref: t
  }))));
}), rp = /* @__PURE__ */ A.forwardRef((e, t) => {
  const { value: n, defaultValue: r, onValueChange: o = () => {
  }, ...a } = e, [i = [], s] = Te({
    prop: n,
    defaultProp: r,
    onChange: o
  }), c = A.useCallback(
    (d) => s(
      (u = []) => [
        ...u,
        d
      ]
    ),
    [
      s
    ]
  ), l = A.useCallback(
    (d) => s(
      (u = []) => u.filter(
        (f) => f !== d
      )
    ),
    [
      s
    ]
  );
  return /* @__PURE__ */ A.createElement(pl, {
    scope: e.__scopeAccordion,
    value: i,
    onItemOpen: c,
    onItemClose: l
  }, /* @__PURE__ */ A.createElement(bl, {
    scope: e.__scopeAccordion,
    collapsible: !0
  }, /* @__PURE__ */ A.createElement(gl, S({}, a, {
    ref: t
  }))));
}), [op, co] = so(Vt), gl = /* @__PURE__ */ A.forwardRef((e, t) => {
  const { __scopeAccordion: n, disabled: r, dir: o, orientation: a = "vertical", ...i } = e, s = A.useRef(null), c = se(s, t), l = K0(n), u = Bt(o) === "ltr", f = G(e.onKeyDown, (p) => {
    var g;
    if (!Q0.includes(p.key))
      return;
    const b = p.target, m = l().filter((F) => {
      var V;
      return !((V = F.ref.current) !== null && V !== void 0 && V.disabled);
    }), v = m.findIndex(
      (F) => F.ref.current === b
    ), $ = m.length;
    if (v === -1)
      return;
    p.preventDefault();
    let x = v;
    const w = 0, C = $ - 1, P = () => {
      x = v + 1, x > C && (x = w);
    }, E = () => {
      x = v - 1, x < w && (x = C);
    };
    switch (p.key) {
      case "Home":
        x = w;
        break;
      case "End":
        x = C;
        break;
      case "ArrowRight":
        a === "horizontal" && (u ? P() : E());
        break;
      case "ArrowDown":
        a === "vertical" && P();
        break;
      case "ArrowLeft":
        a === "horizontal" && (u ? E() : P());
        break;
      case "ArrowUp":
        a === "vertical" && E();
        break;
    }
    const T = x % $;
    (g = m[T].ref.current) === null || g === void 0 || g.focus();
  });
  return /* @__PURE__ */ A.createElement(op, {
    scope: n,
    disabled: r,
    direction: o,
    orientation: a
  }, /* @__PURE__ */ A.createElement(ti.Slot, {
    scope: n
  }, /* @__PURE__ */ A.createElement(te.div, S({}, i, {
    "data-orientation": a,
    ref: c,
    onKeyDown: r ? void 0 : f
  }))));
}), ha = "AccordionItem", [ap, ri] = so(ha), ip = /* @__PURE__ */ A.forwardRef((e, t) => {
  const { __scopeAccordion: n, value: r, ...o } = e, a = co(ha, n), i = ep(ha, n), s = ni(n), c = nt(), l = r && i.value.includes(r) || !1, d = a.disabled || e.disabled;
  return /* @__PURE__ */ A.createElement(ap, {
    scope: n,
    open: l,
    disabled: d,
    triggerId: c
  }, /* @__PURE__ */ A.createElement(Z0, S({
    "data-orientation": a.orientation,
    "data-state": ml(l)
  }, s, o, {
    ref: t,
    disabled: d,
    open: l,
    onOpenChange: (u) => {
      u ? i.onItemOpen(r) : i.onItemClose(r);
    }
  })));
}), sp = "AccordionHeader", cp = /* @__PURE__ */ A.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...r } = e, o = co(Vt, n), a = ri(sp, n);
  return /* @__PURE__ */ A.createElement(te.h3, S({
    "data-orientation": o.orientation,
    "data-state": ml(a.open),
    "data-disabled": a.disabled ? "" : void 0
  }, r, {
    ref: t
  }));
}), ws = "AccordionTrigger", lp = /* @__PURE__ */ A.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...r } = e, o = co(Vt, n), a = ri(ws, n), i = tp(ws, n), s = ni(n);
  return /* @__PURE__ */ A.createElement(ti.ItemSlot, {
    scope: n
  }, /* @__PURE__ */ A.createElement(Y0, S({
    "aria-disabled": a.open && !i.collapsible || void 0,
    "data-orientation": o.orientation,
    id: a.triggerId
  }, s, r, {
    ref: t
  })));
}), up = "AccordionContent", dp = /* @__PURE__ */ A.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...r } = e, o = co(Vt, n), a = ri(up, n), i = ni(n);
  return /* @__PURE__ */ A.createElement(U0, S({
    role: "region",
    "aria-labelledby": a.triggerId,
    "data-orientation": o.orientation
  }, i, r, {
    ref: t,
    style: {
      ["--radix-accordion-content-height"]: "var(--radix-collapsible-content-height)",
      ["--radix-accordion-content-width"]: "var(--radix-collapsible-content-width)",
      ...e.style
    }
  }));
});
function ml(e) {
  return e ? "open" : "closed";
}
const fp = fl, pp = ip, bp = cp, gp = lp, mp = dp;
var va = { exports: {} }, Mn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Is;
function hp() {
  if (Is)
    return Mn;
  Is = 1;
  var e = A, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(s, c, l) {
    var d, u = {}, f = null, p = null;
    l !== void 0 && (f = "" + l), c.key !== void 0 && (f = "" + c.key), c.ref !== void 0 && (p = c.ref);
    for (d in c)
      r.call(c, d) && !a.hasOwnProperty(d) && (u[d] = c[d]);
    if (s && s.defaultProps)
      for (d in c = s.defaultProps, c)
        u[d] === void 0 && (u[d] = c[d]);
    return { $$typeof: t, type: s, key: f, ref: p, props: u, _owner: o.current };
  }
  return Mn.Fragment = n, Mn.jsx = i, Mn.jsxs = i, Mn;
}
var Dn = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ss;
function vp() {
  return Ss || (Ss = 1, process.env.NODE_ENV !== "production" && function() {
    var e = A, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), g = Symbol.iterator, b = "@@iterator";
    function m(I) {
      if (I === null || typeof I != "object")
        return null;
      var L = g && I[g] || I[b];
      return typeof L == "function" ? L : null;
    }
    var v = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function $(I) {
      {
        for (var L = arguments.length, Y = new Array(L > 1 ? L - 1 : 0), ae = 1; ae < L; ae++)
          Y[ae - 1] = arguments[ae];
        x("error", I, Y);
      }
    }
    function x(I, L, Y) {
      {
        var ae = v.ReactDebugCurrentFrame, ge = ae.getStackAddendum();
        ge !== "" && (L += "%s", Y = Y.concat([ge]));
        var Se = Y.map(function(pe) {
          return String(pe);
        });
        Se.unshift("Warning: " + L), Function.prototype.apply.call(console[I], console, Se);
      }
    }
    var w = !1, C = !1, P = !1, E = !1, T = !1, F;
    F = Symbol.for("react.module.reference");
    function V(I) {
      return !!(typeof I == "string" || typeof I == "function" || I === r || I === a || T || I === o || I === l || I === d || E || I === p || w || C || P || typeof I == "object" && I !== null && (I.$$typeof === f || I.$$typeof === u || I.$$typeof === i || I.$$typeof === s || I.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      I.$$typeof === F || I.getModuleId !== void 0));
    }
    function _(I, L, Y) {
      var ae = I.displayName;
      if (ae)
        return ae;
      var ge = L.displayName || L.name || "";
      return ge !== "" ? Y + "(" + ge + ")" : Y;
    }
    function W(I) {
      return I.displayName || "Context";
    }
    function H(I) {
      if (I == null)
        return null;
      if (typeof I.tag == "number" && $("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof I == "function")
        return I.displayName || I.name || null;
      if (typeof I == "string")
        return I;
      switch (I) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case a:
          return "Profiler";
        case o:
          return "StrictMode";
        case l:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof I == "object")
        switch (I.$$typeof) {
          case s:
            var L = I;
            return W(L) + ".Consumer";
          case i:
            var Y = I;
            return W(Y._context) + ".Provider";
          case c:
            return _(I, I.render, "ForwardRef");
          case u:
            var ae = I.displayName || null;
            return ae !== null ? ae : H(I.type) || "Memo";
          case f: {
            var ge = I, Se = ge._payload, pe = ge._init;
            try {
              return H(pe(Se));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var D = Object.assign, M = 0, j, U, ee, z, oe, le, ie;
    function fe() {
    }
    fe.__reactDisabledLog = !0;
    function Ae() {
      {
        if (M === 0) {
          j = console.log, U = console.info, ee = console.warn, z = console.error, oe = console.group, le = console.groupCollapsed, ie = console.groupEnd;
          var I = {
            configurable: !0,
            enumerable: !0,
            value: fe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: I,
            log: I,
            warn: I,
            error: I,
            group: I,
            groupCollapsed: I,
            groupEnd: I
          });
        }
        M++;
      }
    }
    function Re() {
      {
        if (M--, M === 0) {
          var I = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: D({}, I, {
              value: j
            }),
            info: D({}, I, {
              value: U
            }),
            warn: D({}, I, {
              value: ee
            }),
            error: D({}, I, {
              value: z
            }),
            group: D({}, I, {
              value: oe
            }),
            groupCollapsed: D({}, I, {
              value: le
            }),
            groupEnd: D({}, I, {
              value: ie
            })
          });
        }
        M < 0 && $("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var B = v.ReactCurrentDispatcher, ue;
    function we(I, L, Y) {
      {
        if (ue === void 0)
          try {
            throw Error();
          } catch (ge) {
            var ae = ge.stack.trim().match(/\n( *(at )?)/);
            ue = ae && ae[1] || "";
          }
        return `
` + ue + I;
      }
    }
    var ce = !1, Le;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Le = new Je();
    }
    function X(I, L) {
      if (!I || ce)
        return "";
      {
        var Y = Le.get(I);
        if (Y !== void 0)
          return Y;
      }
      var ae;
      ce = !0;
      var ge = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Se;
      Se = B.current, B.current = null, Ae();
      try {
        if (L) {
          var pe = function() {
            throw Error();
          };
          if (Object.defineProperty(pe.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(pe, []);
            } catch (Qe) {
              ae = Qe;
            }
            Reflect.construct(I, [], pe);
          } else {
            try {
              pe.call();
            } catch (Qe) {
              ae = Qe;
            }
            I.call(pe.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Qe) {
            ae = Qe;
          }
          I();
        }
      } catch (Qe) {
        if (Qe && ae && typeof Qe.stack == "string") {
          for (var de = Qe.stack.split(`
`), Ye = ae.stack.split(`
`), De = de.length - 1, Fe = Ye.length - 1; De >= 1 && Fe >= 0 && de[De] !== Ye[Fe]; )
            Fe--;
          for (; De >= 1 && Fe >= 0; De--, Fe--)
            if (de[De] !== Ye[Fe]) {
              if (De !== 1 || Fe !== 1)
                do
                  if (De--, Fe--, Fe < 0 || de[De] !== Ye[Fe]) {
                    var ot = `
` + de[De].replace(" at new ", " at ");
                    return I.displayName && ot.includes("<anonymous>") && (ot = ot.replace("<anonymous>", I.displayName)), typeof I == "function" && Le.set(I, ot), ot;
                  }
                while (De >= 1 && Fe >= 0);
              break;
            }
        }
      } finally {
        ce = !1, B.current = Se, Re(), Error.prepareStackTrace = ge;
      }
      var un = I ? I.displayName || I.name : "", Ht = un ? we(un) : "";
      return typeof I == "function" && Le.set(I, Ht), Ht;
    }
    function Ve(I, L, Y) {
      return X(I, !1);
    }
    function Ze(I) {
      var L = I.prototype;
      return !!(L && L.isReactComponent);
    }
    function Pe(I, L, Y) {
      if (I == null)
        return "";
      if (typeof I == "function")
        return X(I, Ze(I));
      if (typeof I == "string")
        return we(I);
      switch (I) {
        case l:
          return we("Suspense");
        case d:
          return we("SuspenseList");
      }
      if (typeof I == "object")
        switch (I.$$typeof) {
          case c:
            return Ve(I.render);
          case u:
            return Pe(I.type, L, Y);
          case f: {
            var ae = I, ge = ae._payload, Se = ae._init;
            try {
              return Pe(Se(ge), L, Y);
            } catch {
            }
          }
        }
      return "";
    }
    var gt = Object.prototype.hasOwnProperty, br = {}, gr = v.ReactDebugCurrentFrame;
    function sn(I) {
      if (I) {
        var L = I._owner, Y = Pe(I.type, I._source, L ? L.type : null);
        gr.setExtraStackFrame(Y);
      } else
        gr.setExtraStackFrame(null);
    }
    function Bo(I, L, Y, ae, ge) {
      {
        var Se = Function.call.bind(gt);
        for (var pe in I)
          if (Se(I, pe)) {
            var de = void 0;
            try {
              if (typeof I[pe] != "function") {
                var Ye = Error((ae || "React class") + ": " + Y + " type `" + pe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof I[pe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ye.name = "Invariant Violation", Ye;
              }
              de = I[pe](L, pe, ae, Y, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (De) {
              de = De;
            }
            de && !(de instanceof Error) && (sn(ge), $("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ae || "React class", Y, pe, typeof de), sn(null)), de instanceof Error && !(de.message in br) && (br[de.message] = !0, sn(ge), $("Failed %s type: %s", Y, de.message), sn(null));
          }
      }
    }
    var cn = Array.isArray;
    function Vo(I) {
      return cn(I);
    }
    function w1(I) {
      {
        var L = typeof Symbol == "function" && Symbol.toStringTag, Y = L && I[Symbol.toStringTag] || I.constructor.name || "Object";
        return Y;
      }
    }
    function I1(I) {
      try {
        return is(I), !1;
      } catch {
        return !0;
      }
    }
    function is(I) {
      return "" + I;
    }
    function ss(I) {
      if (I1(I))
        return $("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", w1(I)), is(I);
    }
    var Tn = v.ReactCurrentOwner, S1 = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, cs, ls, Go;
    Go = {};
    function A1(I) {
      if (gt.call(I, "ref")) {
        var L = Object.getOwnPropertyDescriptor(I, "ref").get;
        if (L && L.isReactWarning)
          return !1;
      }
      return I.ref !== void 0;
    }
    function E1(I) {
      if (gt.call(I, "key")) {
        var L = Object.getOwnPropertyDescriptor(I, "key").get;
        if (L && L.isReactWarning)
          return !1;
      }
      return I.key !== void 0;
    }
    function P1(I, L) {
      if (typeof I.ref == "string" && Tn.current && L && Tn.current.stateNode !== L) {
        var Y = H(Tn.current.type);
        Go[Y] || ($('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', H(Tn.current.type), I.ref), Go[Y] = !0);
      }
    }
    function T1(I, L) {
      {
        var Y = function() {
          cs || (cs = !0, $("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", L));
        };
        Y.isReactWarning = !0, Object.defineProperty(I, "key", {
          get: Y,
          configurable: !0
        });
      }
    }
    function R1(I, L) {
      {
        var Y = function() {
          ls || (ls = !0, $("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", L));
        };
        Y.isReactWarning = !0, Object.defineProperty(I, "ref", {
          get: Y,
          configurable: !0
        });
      }
    }
    var M1 = function(I, L, Y, ae, ge, Se, pe) {
      var de = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: I,
        key: L,
        ref: Y,
        props: pe,
        // Record the component responsible for creating this element.
        _owner: Se
      };
      return de._store = {}, Object.defineProperty(de._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(de, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ae
      }), Object.defineProperty(de, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ge
      }), Object.freeze && (Object.freeze(de.props), Object.freeze(de)), de;
    };
    function D1(I, L, Y, ae, ge) {
      {
        var Se, pe = {}, de = null, Ye = null;
        Y !== void 0 && (ss(Y), de = "" + Y), E1(L) && (ss(L.key), de = "" + L.key), A1(L) && (Ye = L.ref, P1(L, ge));
        for (Se in L)
          gt.call(L, Se) && !S1.hasOwnProperty(Se) && (pe[Se] = L[Se]);
        if (I && I.defaultProps) {
          var De = I.defaultProps;
          for (Se in De)
            pe[Se] === void 0 && (pe[Se] = De[Se]);
        }
        if (de || Ye) {
          var Fe = typeof I == "function" ? I.displayName || I.name || "Unknown" : I;
          de && T1(pe, Fe), Ye && R1(pe, Fe);
        }
        return M1(I, de, Ye, ge, ae, Tn.current, pe);
      }
    }
    var Wo = v.ReactCurrentOwner, us = v.ReactDebugCurrentFrame;
    function ln(I) {
      if (I) {
        var L = I._owner, Y = Pe(I.type, I._source, L ? L.type : null);
        us.setExtraStackFrame(Y);
      } else
        us.setExtraStackFrame(null);
    }
    var jo;
    jo = !1;
    function zo(I) {
      return typeof I == "object" && I !== null && I.$$typeof === t;
    }
    function ds() {
      {
        if (Wo.current) {
          var I = H(Wo.current.type);
          if (I)
            return `

Check the render method of \`` + I + "`.";
        }
        return "";
      }
    }
    function O1(I) {
      {
        if (I !== void 0) {
          var L = I.fileName.replace(/^.*[\\\/]/, ""), Y = I.lineNumber;
          return `

Check your code at ` + L + ":" + Y + ".";
        }
        return "";
      }
    }
    var fs = {};
    function F1(I) {
      {
        var L = ds();
        if (!L) {
          var Y = typeof I == "string" ? I : I.displayName || I.name;
          Y && (L = `

Check the top-level render call using <` + Y + ">.");
        }
        return L;
      }
    }
    function ps(I, L) {
      {
        if (!I._store || I._store.validated || I.key != null)
          return;
        I._store.validated = !0;
        var Y = F1(L);
        if (fs[Y])
          return;
        fs[Y] = !0;
        var ae = "";
        I && I._owner && I._owner !== Wo.current && (ae = " It was passed a child from " + H(I._owner.type) + "."), ln(I), $('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Y, ae), ln(null);
      }
    }
    function bs(I, L) {
      {
        if (typeof I != "object")
          return;
        if (Vo(I))
          for (var Y = 0; Y < I.length; Y++) {
            var ae = I[Y];
            zo(ae) && ps(ae, L);
          }
        else if (zo(I))
          I._store && (I._store.validated = !0);
        else if (I) {
          var ge = m(I);
          if (typeof ge == "function" && ge !== I.entries)
            for (var Se = ge.call(I), pe; !(pe = Se.next()).done; )
              zo(pe.value) && ps(pe.value, L);
        }
      }
    }
    function k1(I) {
      {
        var L = I.type;
        if (L == null || typeof L == "string")
          return;
        var Y;
        if (typeof L == "function")
          Y = L.propTypes;
        else if (typeof L == "object" && (L.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        L.$$typeof === u))
          Y = L.propTypes;
        else
          return;
        if (Y) {
          var ae = H(L);
          Bo(Y, I.props, "prop", ae, I);
        } else if (L.PropTypes !== void 0 && !jo) {
          jo = !0;
          var ge = H(L);
          $("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ge || "Unknown");
        }
        typeof L.getDefaultProps == "function" && !L.getDefaultProps.isReactClassApproved && $("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function N1(I) {
      {
        for (var L = Object.keys(I.props), Y = 0; Y < L.length; Y++) {
          var ae = L[Y];
          if (ae !== "children" && ae !== "key") {
            ln(I), $("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ae), ln(null);
            break;
          }
        }
        I.ref !== null && (ln(I), $("Invalid attribute `ref` supplied to `React.Fragment`."), ln(null));
      }
    }
    var gs = {};
    function ms(I, L, Y, ae, ge, Se) {
      {
        var pe = V(I);
        if (!pe) {
          var de = "";
          (I === void 0 || typeof I == "object" && I !== null && Object.keys(I).length === 0) && (de += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ye = O1(ge);
          Ye ? de += Ye : de += ds();
          var De;
          I === null ? De = "null" : Vo(I) ? De = "array" : I !== void 0 && I.$$typeof === t ? (De = "<" + (H(I.type) || "Unknown") + " />", de = " Did you accidentally export a JSX literal instead of a component?") : De = typeof I, $("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", De, de);
        }
        var Fe = D1(I, L, Y, ge, Se);
        if (Fe == null)
          return Fe;
        if (pe) {
          var ot = L.children;
          if (ot !== void 0)
            if (ae)
              if (Vo(ot)) {
                for (var un = 0; un < ot.length; un++)
                  bs(ot[un], I);
                Object.freeze && Object.freeze(ot);
              } else
                $("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              bs(ot, I);
        }
        if (gt.call(L, "key")) {
          var Ht = H(I), Qe = Object.keys(L).filter(function(W1) {
            return W1 !== "key";
          }), Ho = Qe.length > 0 ? "{key: someKey, " + Qe.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!gs[Ht + Ho]) {
            var G1 = Qe.length > 0 ? "{" + Qe.join(": ..., ") + ": ...}" : "{}";
            $(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ho, Ht, G1, Ht), gs[Ht + Ho] = !0;
          }
        }
        return I === r ? N1(Fe) : k1(Fe), Fe;
      }
    }
    function _1(I, L, Y) {
      return ms(I, L, Y, !0);
    }
    function L1(I, L, Y) {
      return ms(I, L, Y, !1);
    }
    var B1 = L1, V1 = _1;
    Dn.Fragment = r, Dn.jsx = B1, Dn.jsxs = V1;
  }()), Dn;
}
process.env.NODE_ENV === "production" ? va.exports = hp() : va.exports = vp();
var h = va.exports;
const $p = k(bp, {
  margin: 0
}), xp = A.forwardRef(
  function(t, n) {
    return /* @__PURE__ */ h.jsx($p, { ...t, ref: n });
  }
), hl = Lt({
  from: { maxHeight: 0 },
  to: { maxHeight: "var(--radix-accordion-content-height)" }
}), vl = Lt({
  from: { maxHeight: "var(--radix-accordion-content-height)" },
  to: { maxHeight: 0 }
}), yp = k(mp, {
  overflow: "hidden",
  '&[data-state="open"]': {
    animation: `${hl} 0.2s $transitions$1`
  },
  '&[data-state="closed"]': {
    animation: `${vl} 0.2s $transitions$1`
  }
}), Cp = fp, wp = pp, Ip = gp, SI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccordionSlideDownKeyframes: hl,
  AccordionSlideUpKeyframes: vl,
  Content: yp,
  Header: xp,
  Item: wp,
  Root: Cp,
  Trigger: Ip
}, Symbol.toStringTag, { value: "Module" })), $l = "Avatar", [Sp, AI] = _e($l), [Ap, xl] = Sp($l), Ep = /* @__PURE__ */ R((e, t) => {
  const { __scopeAvatar: n, ...r } = e, [o, a] = J("idle");
  return /* @__PURE__ */ y(Ap, {
    scope: n,
    imageLoadingStatus: o,
    onImageLoadingStatusChange: a
  }, /* @__PURE__ */ y(te.span, S({}, r, {
    ref: t
  })));
}), Pp = "AvatarImage", Tp = /* @__PURE__ */ R((e, t) => {
  const { __scopeAvatar: n, src: r, onLoadingStatusChange: o = () => {
  }, ...a } = e, i = xl(Pp, n), s = Dp(r), c = Ee((l) => {
    o(l), i.onImageLoadingStatusChange(l);
  });
  return ft(() => {
    s !== "idle" && c(s);
  }, [
    s,
    c
  ]), s === "loaded" ? /* @__PURE__ */ y(te.img, S({}, a, {
    ref: t,
    src: r
  })) : null;
}), Rp = "AvatarFallback", Mp = /* @__PURE__ */ R((e, t) => {
  const { __scopeAvatar: n, delayMs: r, ...o } = e, a = xl(Rp, n), [i, s] = J(r === void 0);
  return Z(() => {
    if (r !== void 0) {
      const c = window.setTimeout(
        () => s(!0),
        r
      );
      return () => window.clearTimeout(c);
    }
  }, [
    r
  ]), i && a.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ y(te.span, S({}, o, {
    ref: t
  })) : null;
});
function Dp(e) {
  const [t, n] = J("idle");
  return ft(() => {
    if (!e) {
      n("error");
      return;
    }
    let r = !0;
    const o = new window.Image(), a = (i) => () => {
      r && n(i);
    };
    return n("loading"), o.onload = a("loaded"), o.onerror = a("error"), o.src = e, () => {
      r = !1;
    };
  }, [
    e
  ]), t;
}
const Op = Tp, Fp = Mp, kp = k(Ep, {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  verticalAlign: "middle",
  overflow: "hidden",
  userSelect: "none",
  borderRadius: "50%",
  variants: {
    /** Sets the size of the element */
    size: {
      xxs: {
        width: 18,
        height: 18
      },
      xs: {
        width: 24,
        height: 24
      },
      sm: {
        width: 32,
        height: 32
      },
      md: {
        width: 48,
        height: 48
      },
      lg: {
        width: 64,
        height: 64
      },
      xl: {
        width: 80,
        height: 80
      },
      xxl: {
        width: 96,
        height: 96
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
}), Np = k(Op, {
  width: "100%",
  height: "100%",
  objectFit: "cover"
}), _p = k(Fp, {
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  bgc: "transparent"
});
function EI({
  size: e = "md",
  src: t,
  srcSet: n,
  fallback: r,
  onClick: o,
  css: a,
  ...i
}) {
  return /* @__PURE__ */ h.jsxs(kp, { size: e, onClick: o, css: a, ...i, children: [
    /* @__PURE__ */ h.jsx(Np, { src: t, srcSet: n, alt: "User avatar" }),
    /* @__PURE__ */ h.jsx(_p, { children: r })
  ] });
}
const Lp = "span", Bp = [
  "Primary",
  "Success",
  "Attention",
  "Error"
].map((e) => ({
  appearance: "translucent",
  color: e.toLowerCase(),
  css: {
    $$colorBackground: `$colors$ui${e}25`,
    $$colorText: e === "Primary" ? "$colors$uiPrimaryMain" : `$colors$text${e}`
  }
})), Vp = k(Lp, {
  // Reset
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  appearance: "none",
  borderWidth: "0",
  boxSizing: "border-box",
  flexShrink: 0,
  fontFamily: "$base",
  lineHeight: 1.2,
  py: "calc($base / 4)",
  borderRadius: "$base",
  fontSize: "0.5625rem",
  letterSpacing: "$loose1",
  fontWeight: "$bold",
  textDecoration: "none",
  textTransform: "uppercase",
  userSelect: "none",
  color: "$$colorText",
  bgc: "$$colorBackground",
  boxShadow: "0 0 0 1px $colors$uiSecondary",
  variants: {
    /** The background color of the badge */
    color: {
      primary: {
        $$colorBackground: "$colors$uiPrimaryMain"
      },
      success: {
        $$colorBackground: "$colors$uiSuccessMain"
      },
      attention: {
        $$colorBackground: "$colors$uiAttentionMain"
      },
      error: {
        $$colorBackground: "$colors$uiErrorMain"
      },
      // TODO: Maybe map to a theme color when designers define it
      neutral: {
        $$colorBackground: "#999999"
      },
      // TODO: Come up with a better name and theme color once designers define it
      purple: {
        $$colorBackground: "#7B3EFE32"
      }
    },
    /** The background color of the badge */
    appearance: {
      opaque: {
        color: "$textAlwaysLightMain"
      },
      translucent: {
        color: "$$colorText"
      }
    },
    /**
     - ``default`` Default Tag
     - ``compact`` Badge numeric values
     - ``comfortable`` Badge text values
     */
    density: {
      default: {
        px: "$base"
      },
      compact: {
        px: "0.1875rem"
      },
      comfortable: {
        px: "0.375rem"
      }
    }
  },
  compoundVariants: [
    ...Bp,
    {
      color: "neutral",
      appearance: "translucent",
      css: {
        $$colorBackground: "#999999",
        $$colorText: "#444444"
      }
    },
    {
      color: "purple",
      appearance: "translucent",
      css: {
        $$colorBackground: "#7B3EFE32",
        $$colorText: "#7B3EFE"
      }
    }
  ],
  defaultVariants: {
    color: "neutral",
    appearance: "opaque",
    density: "default"
  }
});
Vp.displayName = "Badge";
const nn = k("div", {}), Gp = k("button", {
  textTransform: "uppercase",
  fontFamily: "$button",
  fontSize: "$bodyText",
  letterSpacing: "1.25px",
  textAlign: "center",
  fontWeight: "$bold",
  appearance: "none",
  border: "none",
  background: "none",
  margin: 0,
  textDecoration: "none",
  userSelect: "none",
  WebkitTapHighlightColor: "rgba(0,0,0,0)",
  fontVariantNumeric: "tabular-nums",
  boxSizing: "border-box",
  display: "inline-flex",
  gridAutoFlow: "column",
  columnGap: "$base",
  placeItems: "center",
  justifyContent: "center",
  lineHeight: "1em",
  flexShrink: 0,
  br: "1.25rem",
  $$outlineShadowColor: "transparent",
  $$hoverShadow: "$shadows$1",
  $$outlineShadowPrimary: "0 0 0 1px $$outlineShadowColor",
  $$shadow: "$$outlineShadowPrimary, $$hoverShadow",
  transition: "box-shadow 0.4s ease, background 0.4s ease, outline 0.4s $1",
  cursor: "pointer",
  verticalAlign: "middle",
  outline: "none",
  "&:disabled": {
    pointerEvents: "none"
  },
  "&:hover, &:focus": {
    boxShadow: "$$hoverShadow"
  },
  /** Provide a better keyboard nav visibility */
  "&:focus-visible": {
    outline: "2px $colors$uiPrimaryMain solid"
  },
  variants: {
    /** The appearance of the button. */
    variant: {
      contained: {
        background: "linear-gradient(0deg, $$backgroundIdle, $$backgroundIdle), $$backgroundIdle",
        color: "$$textIdle",
        "&:hover": {
          boxShadow: "$$shadow",
          background: "linear-gradient(0deg, $$backgroundHover, $$backgroundHover)"
        },
        "&:focus": {
          background: "linear-gradient(0deg, $$backgroundIdle, $$backgroundIdle)",
          boxShadow: "$$shadow"
        },
        "&:focus-visible": {
          outlineOffset: "2px"
        },
        "&:active": {
          background: "linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), $$backgroundIdle"
        },
        "&:disabled": {
          background: "$uiDisabledMain",
          $$textIdle: "$colors$textPrimary50",
          opacity: 0.3
        }
      },
      outlined: {
        background: "transparent",
        color: "$$textIdle",
        $$outlineShadowColor: "$$textIdle",
        boxShadow: "$$outlineShadowPrimary",
        "&:hover": {
          background: "$$backgroundHover",
          boxShadow: "$$shadow"
        },
        "&:focus": {
          boxShadow: "$$shadow"
        },
        "&:focus-visible": {
          outlineColor: "$$textIdle"
        },
        "&:active": {
          boxShadow: "$$outlineShadowPrimary",
          background: "$$backgroundHover"
        },
        "&:disabled": {
          $$outlineShadowColor: "$colors$uiDisabledMain",
          $$textIdle: "$colors$uiDisabledMain",
          opacity: 0.3
        }
      },
      ghost: {
        background: "transparent",
        color: "$$textIdle",
        "&:hover": {
          boxShadow: "$$shadow"
        },
        "&:focus": {
          $$outlineShadowColor: "$$borderIdle",
          boxShadow: "$$shadow"
        },
        "&:active": {
          boxShadow: "none",
          background: "$$backgroundHover"
        },
        "&:disabled": {
          boxShadow: "none",
          background: "$transparent",
          color: "$uiDisabledMain",
          opacity: 0.3
        }
      }
    },
    /** Renders a button in different color than default. */
    color: {
      primary: {},
      success: {},
      attention: {},
      error: {},
      neutral: {}
    },
    /** If true, it will render a button container with fixed width and height. */
    iconButton: {
      true: {
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        size: "1.5rem",
        br: "$sm",
        "&:before": {
          // hitbox
          content: '""',
          display: "block",
          size: "2rem",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)"
        }
      },
      false: {}
    },
    /** Different padding settings for the button */
    density: {
      compact: {
        py: "0.125rem",
        px: "calc($base * 2)",
        minHeight: "2rem"
      },
      default: {
        px: "1.75rem",
        py: "0.5rem",
        minHeight: "2.5rem"
      },
      comfortable: {
        borderRadius: "2rem",
        px: "2rem",
        py: "1.125rem",
        minHeight: "2.5rem"
      }
    }
  },
  compoundVariants: [
    {
      variant: "contained",
      color: "primary",
      css: {
        $$backgroundIdle: "$colors$uiPrimaryMain",
        $$backgroundHover: "$colors$uiPrimary75",
        $$textIdle: "$colors$textAlwaysLightMain"
      }
    },
    {
      variant: "outlined",
      color: "primary",
      css: {
        $$backgroundHover: "$colors$uiPrimary16A",
        $$textIdle: "$colors$uiPrimaryMain"
      }
    },
    {
      variant: "ghost",
      color: "primary",
      css: {
        $$backgroundHover: "$colors$uiPrimary16A",
        $$textIdle: "$colors$uiPrimaryMain",
        $$borderIdle: "$colors$uiPrimary25"
      }
    },
    {
      variant: "contained",
      color: "success",
      css: {
        $$backgroundIdle: "$colors$uiSuccessMain",
        $$backgroundHover: "$colors$uiSuccess75",
        $$textIdle: "$colors$textAlwaysLightMain"
      }
    },
    {
      variant: "outlined",
      color: "success",
      css: {
        $$backgroundHover: "$colors$uiSuccess16A",
        $$textIdle: "$colors$uiSuccessMain"
      }
    },
    {
      variant: "ghost",
      color: "success",
      css: {
        $$backgroundHover: "$colors$uiSuccess16A",
        $$textIdle: "$colors$uiSuccessMain",
        $$borderIdle: "$colors$uiSuccess25"
      }
    },
    {
      variant: "contained",
      color: "attention",
      css: {
        $$backgroundIdle: "$colors$uiAttentionMain",
        $$backgroundHover: "$colors$uiAttention75",
        $$textIdle: "$colors$textAlwaysLightMain"
      }
    },
    {
      variant: "outlined",
      color: "attention",
      css: {
        $$backgroundHover: "$colors$uiAttention16A",
        $$textIdle: "$colors$uiAttentionMain"
      }
    },
    {
      variant: "ghost",
      color: "attention",
      css: {
        $$backgroundHover: "$colors$uiAttention16A",
        $$textIdle: "$colors$uiAttentionMain",
        $$borderIdle: "$colors$uiAttention25"
      }
    },
    {
      variant: "contained",
      color: "error",
      css: {
        $$backgroundIdle: "$colors$uiErrorMain",
        $$backgroundHover: "$colors$uiError75",
        $$textIdle: "$colors$textAlwaysLightMain"
      }
    },
    {
      variant: "outlined",
      color: "error",
      css: {
        $$backgroundHover: "$colors$uiError16A",
        $$textIdle: "$colors$uiErrorMain"
      }
    },
    {
      variant: "ghost",
      color: "error",
      css: {
        $$backgroundHover: "$colors$uiError16A",
        $$textIdle: "$colors$uiErrorMain",
        $$borderIdle: "$colors$uiError25"
      }
    },
    {
      variant: "contained",
      color: "neutral",
      css: {
        $$backgroundIdle: "$colors$textPrimaryMain",
        $$backgroundHover: "$colors$textPrimary70",
        $$textIdle: "$colors$textPrimaryMainInverted"
      }
    },
    {
      variant: "outlined",
      color: "neutral",
      css: {
        $$backgroundHover: "$colors$textPrimary16",
        $$textIdle: "$colors$textPrimaryMain"
      }
    },
    {
      variant: "ghost",
      color: "neutral",
      css: {
        $$backgroundHover: "$colors$textPrimary16",
        $$textIdle: "$colors$textPrimaryMain",
        $$borderIdle: "$colors$textPrimary30"
      }
    },
    {
      iconButton: !0,
      color: "neutral",
      variant: "ghost",
      css: {
        $$textIdle: "$colors$textPrimary50"
      }
    },
    {
      iconButton: "true",
      density: "default",
      css: {
        padding: 0,
        minHeight: "1.5rem"
      }
    },
    {
      iconButton: "true",
      density: "compact",
      css: {
        padding: 0,
        minHeight: "1.5rem"
      }
    },
    {
      iconButton: !0,
      density: "comfortable",
      css: {
        size: "2.5rem",
        padding: 0
      }
    }
  ],
  defaultVariants: {
    variant: "contained",
    color: "primary",
    density: "default",
    iconButton: !1
  }
}), rn = R(function({ children: t, asChild: n, type: r = "button", ...o }, a) {
  if (n && !A.isValidElement(t))
    throw new Error("Button: asChild prop is set to true but no child element is provided");
  return /* @__PURE__ */ h.jsx(
    Gp,
    {
      ...o,
      type: n ? void 0 : r,
      as: n ? je : "button",
      ref: a,
      children: t
    }
  );
});
function lo(e) {
  const t = O({
    value: e,
    previous: e
  });
  return Ne(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [
    e
  ]);
}
function nr(e) {
  const [t, n] = J(void 0);
  return ft(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const a = o[0];
        let i, s;
        if ("borderBoxSize" in a) {
          const c = a.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          i = l.inlineSize, s = l.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        n({
          width: i,
          height: s
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const yl = "Checkbox", [Wp, PI] = _e(yl), [jp, zp] = Wp(yl), Hp = /* @__PURE__ */ R((e, t) => {
  const { __scopeCheckbox: n, name: r, checked: o, defaultChecked: a, required: i, disabled: s, value: c = "on", onCheckedChange: l, ...d } = e, [u, f] = J(null), p = se(
    t,
    (x) => f(x)
  ), g = O(!1), b = u ? !!u.closest("form") : !0, [m = !1, v] = Te({
    prop: o,
    defaultProp: a,
    onChange: l
  }), $ = O(m);
  return Z(() => {
    const x = u == null ? void 0 : u.form;
    if (x) {
      const w = () => v($.current);
      return x.addEventListener("reset", w), () => x.removeEventListener("reset", w);
    }
  }, [
    u,
    v
  ]), /* @__PURE__ */ y(jp, {
    scope: n,
    state: m,
    disabled: s
  }, /* @__PURE__ */ y(te.button, S({
    type: "button",
    role: "checkbox",
    "aria-checked": Jt(m) ? "mixed" : m,
    "aria-required": i,
    "data-state": Cl(m),
    "data-disabled": s ? "" : void 0,
    disabled: s,
    value: c
  }, d, {
    ref: p,
    onKeyDown: G(e.onKeyDown, (x) => {
      x.key === "Enter" && x.preventDefault();
    }),
    onClick: G(e.onClick, (x) => {
      v(
        (w) => Jt(w) ? !0 : !w
      ), b && (g.current = x.isPropagationStopped(), g.current || x.stopPropagation());
    })
  })), b && /* @__PURE__ */ y(Yp, {
    control: u,
    bubbles: !g.current,
    name: r,
    value: c,
    checked: m,
    required: i,
    disabled: s,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), Xp = "CheckboxIndicator", Zp = /* @__PURE__ */ R((e, t) => {
  const { __scopeCheckbox: n, forceMount: r, ...o } = e, a = zp(Xp, n);
  return /* @__PURE__ */ y(Oe, {
    present: r || Jt(a.state) || a.state === !0
  }, /* @__PURE__ */ y(te.span, S({
    "data-state": Cl(a.state),
    "data-disabled": a.disabled ? "" : void 0
  }, o, {
    ref: t,
    style: {
      pointerEvents: "none",
      ...e.style
    }
  })));
}), Yp = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...o } = e, a = O(null), i = lo(n), s = nr(t);
  return Z(() => {
    const c = a.current, l = window.HTMLInputElement.prototype, u = Object.getOwnPropertyDescriptor(l, "checked").set;
    if (i !== n && u) {
      const f = new Event("click", {
        bubbles: r
      });
      c.indeterminate = Jt(n), u.call(c, Jt(n) ? !1 : n), c.dispatchEvent(f);
    }
  }, [
    i,
    n,
    r
  ]), /* @__PURE__ */ y("input", S({
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: Jt(n) ? !1 : n
  }, o, {
    tabIndex: -1,
    ref: a,
    style: {
      ...e.style,
      ...s,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function Jt(e) {
  return e === "indeterminate";
}
function Cl(e) {
  return Jt(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const Up = Hp, Jp = Zp, Qp = k(Up, {
  appearance: "none",
  border: "none",
  fontSize: "$bodyText",
  width: "1em",
  height: "1em",
  br: "$xs",
  padding: 0,
  position: "relative",
  cursor: "pointer",
  verticalAlign: "middle",
  // Increase the hit-box with this for accessibility purposes
  "&::before": {
    content: '""',
    width: "2.5rem",
    height: "2.5rem",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  },
  $$bgFill: "$colors$uiSecondary",
  $$borderColor: "$colors$uiMonochrome30",
  $$fillShadowColor: "$colors$textAlwaysDark25",
  $$borderShadow: "inset 0 0 1px 1px $$borderColor",
  $$fillShadow: "inset 0px 2px 4px $$fillShadowColor",
  $$shadow: "$$fillShadow, $$borderShadow",
  background: "$$bgFill",
  boxShadow: "$$shadow",
  [`.${il} &, .${sl} &`]: {
    $$fillShadowColor: "$colors$textAlwaysDark50"
  },
  "&:hover, &.state--hover": {
    $$borderColor: "$colors$uiPrimaryMain"
  },
  '&[data-state="checked"], &[data-state="indeterminate"]': {
    $$shadow: "none",
    $$borderColor: "transparent",
    $$bgFill: "$colors$uiPrimaryMain",
    "&:hover, &.state--hover": {
      $$shadow: "$$fillShadow"
    }
  },
  "&[data-disabled]": {
    pointerEvents: "none",
    $$bgFill: "$colors$uiMonochrome30",
    boxShadow: "$$borderShadow",
    opacity: 0.25
  }
}), wl = k("svg", {
  width: "1.125rem",
  height: "1.125rem",
  margin: -2,
  fill: "#fff",
  pointerEvents: "none",
  "&[data-disabled]": {
    $$bgFill: "$colors$textAlwaysLight30",
    boxShadow: "none"
  }
}), Kp = A.forwardRef(
  function(t, n) {
    return /* @__PURE__ */ h.jsx(wl, { ...t, ref: n, children: /* @__PURE__ */ h.jsx("path", { d: "M6.568 12.665l-2.257-2.323a1.139 1.139 0 010-1.564 1.068 1.068 0 011.537 0l1.484 1.53 4.82-4.981a1.068 1.068 0 011.537 0 1.139 1.139 0 010 1.563l-5.594 5.775a1.037 1.037 0 01-1.527 0z" }) });
  }
), qp = A.forwardRef(
  function(t, n) {
    return /* @__PURE__ */ h.jsx(wl, { ...t, ref: n, children: /* @__PURE__ */ h.jsx("path", { d: "M4 9a1 1 0 011-1h8a1 1 0 110 2H5a1 1 0 01-1-1z" }) });
  }
), eb = A.forwardRef(function(t, n) {
  const [r, o] = Te({
    defaultProp: t.defaultChecked,
    prop: t.checked,
    onChange: t.onCheckedChange
  });
  return /* @__PURE__ */ h.jsx(Qp, { ...t, ref: n, onCheckedChange: o, children: /* @__PURE__ */ h.jsxs(Jp, { children: [
    r === "indeterminate" && /* @__PURE__ */ h.jsx(qp, {}),
    r === !0 && /* @__PURE__ */ h.jsx(Kp, {})
  ] }) });
});
eb.displayName = "Checkbox";
(function(e, t) {
  t === void 0 && (t = {});
  var n = t.insertAt;
  if (e && typeof document < "u") {
    var r = document.head || document.getElementsByTagName("head")[0], o = document.createElement("style");
    o.type = "text/css", n === "top" && r.firstChild ? r.insertBefore(o, r.firstChild) : r.appendChild(o), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e));
  }
})(`.SvgIcon-root {
  fill: currentColor;
  width: 1em;
  height: 1em;
  display: inline-block;
  font-size: 1.5rem;
  flex-shrink: 0;
  user-select: none;
}
`);
const Q = R(function(e, t) {
  const { children: n, className: r, viewBox: o = "0 0 24 24", titleAccess: a, ...i } = e;
  return h.jsxs("svg", { className: ["SvgIcon-root", r].join(" "), focusable: "false", viewBox: o, ref: t, ...i, children: [n, a ? h.jsx("title", { children: a }) : null] });
}), tb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M19.828 5.794l-1.274-1.54A1.33 1.33 0 0017.5 3.75h-11c-.43 0-.807.192-1.063.504l-1.265 1.54a1.795 1.795 0 00-.422 1.164v11.459c0 1.008.825 1.833 1.833 1.833h12.834a1.839 1.839 0 001.833-1.833V6.958c0-.44-.156-.852-.422-1.164zM11.68 16.721L6.96 12h3.208v-1.833h3.666V12h3.209l-4.721 4.72a.46.46 0 01-.642 0zM5.693 5.583l.743-.916h11l.861.916H5.694z" }) }));
tb.displayName = "ArchiveRounded";
const nb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M15.297 12.883l-2.59-2.59a.996.996 0 00-1.41 0l-2.59 2.59c-.63.63-.18 1.71.71 1.71h5.18c.89 0 1.33-1.08.7-1.71z" }) }));
nb.displayName = "ArrowDropDownRoundedUp";
const rb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M19.845 10.385H6.942l5.637-5.467c.45-.436.45-1.153 0-1.59a1.176 1.176 0 00-1.629 0L3.338 10.71a1.092 1.092 0 000 1.58l7.612 7.382c.45.437 1.179.437 1.629 0 .45-.437.45-1.142 0-1.58l-5.637-5.466h12.903c.635 0 1.155-.504 1.155-1.12 0-.617-.52-1.12-1.155-1.12z" }) }));
rb.displayName = "ArrowBackRounded";
const ob = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M10.944 6.75v8.377l-3.66-3.66a.756.756 0 00-1.065 0 .747.747 0 000 1.058l4.943 4.943a.747.747 0 001.057 0l4.943-4.943a.747.747 0 10-1.058-1.058l-3.66 3.66V6.75a.752.752 0 00-.75-.75.752.752 0 00-.75.75z" }) }));
ob.displayName = "ArrowDownRounded";
const ab = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M19.8 13.6H19c0-3.096-2.504-5.6-5.6-5.6h-.8V6.984a1.6 1.6 0 10-1.6 0V8h-.8a5.596 5.596 0 00-5.6 5.6h-.8c-.44 0-.8.36-.8.8v2.4c0 .44.36.8.8.8h.8v.8c0 .888.72 1.6 1.6 1.6h11.2c.888 0 1.6-.712 1.6-1.6v-.8h.8c.44 0 .8-.36.8-.8v-2.4c0-.44-.36-.8-.8-.8zm-9.84 1.16l-.584.584L8.2 16.52l-1.76-1.76a.82.82 0 010-1.16.812.812 0 011.176 0l.584.576.584-.576a.812.812 0 011.176 0 .82.82 0 010 1.16zm7.2 0l-.584.584L15.4 16.52l-1.76-1.76a.82.82 0 010-1.16.812.812 0 011.176 0l.584.576.584-.576a.812.812 0 011.176 0 .82.82 0 010 1.16z" }) }));
ab.displayName = "BotRounded";
const ib = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M4.652 13.617H3.527a.527.527 0 00-.527.527v6.329c0 .291.236.527.527.527h1.125c.873 0 1.582-.71 1.582-1.582v-4.219c0-.872-.71-1.582-1.582-1.582zM20.842 14.64a.966.966 0 00-.243-.264c-.388-.34-1.042-.307-1.424.106l-2.394 2.763-.074.085a1.556 1.556 0 01-1.16.506h-4.092a.522.522 0 01-.527-.527c0-.296.232-.528.527-.528h3.217c.58 0 1.055-.474 1.055-1.054v-.011a1.056 1.056 0 00-1.055-1.044h-1.91c-.315 0-.654-.116-.927-.348a3.696 3.696 0 00-4.546-.243v6.486c1.044.285 2.12.433 3.206.433H15.2c1.16 0 2.257-.549 2.953-1.477l2.532-3.375c.369-.484.397-1.15.158-1.508zM17.14 4.02A3.016 3.016 0 0014.857 3c-.99 0-1.849.468-2.483 1.354a4.219 4.219 0 00-.133.199 4.203 4.203 0 00-.134-.199C11.473 3.468 10.615 3 9.624 3c-.887 0-1.698.362-2.283 1.02-.555.623-.86 1.457-.86 2.348 0 .967.375 1.86 1.181 2.81.704.828 1.712 1.68 2.88 2.666.433.364.879.741 1.353 1.152a.526.526 0 00.691 0c.474-.41.92-.788 1.352-1.152.75-.633 1.399-1.18 1.961-1.71 1.092-1.03 2.102-2.2 2.102-3.766 0-.89-.306-1.725-.86-2.349z" }) }));
ib.displayName = "GiveBackRounded";
const sb = A.forwardRef((e, t) => h.jsxs(Q, { ...e, ref: t, children: [h.jsx("path", { d: "M19.364 9.09c-1.187 0-1.85 1.18-1.58 2.055l-2.904 2.912a1.665 1.665 0 00-.85 0l-2.087-2.086c.278-.876-.385-2.062-1.58-2.062-1.186 0-1.857 1.178-1.578 2.062l-3.731 3.723C4.178 15.424 3 16.086 3 17.273c0 .9.736 1.636 1.636 1.636 1.187 0 1.85-1.178 1.58-2.054l3.722-3.73c.246.073.606.073.851 0l2.087 2.086c-.279.875.384 2.062 1.579 2.062 1.186 0 1.857-1.178 1.579-2.062l2.912-2.905c.876.27 2.054-.392 2.054-1.579 0-.9-.736-1.636-1.636-1.636z" }), h.jsx("path", { d: "M14.454 9.91l.77-1.695 1.685-.76-1.685-.761L14.454 5l-.752 1.694-1.702.76 1.702.761.752 1.694zM5.045 11.545l.41-1.636L7.09 9.5l-1.636-.41-.41-1.635-.409 1.636L3 9.5l1.636.41.41 1.635z" })] }));
sb.displayName = "InsightsRounded";
const cb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M12 3c-4.968 0-9 4.032-9 9s4.032 9 9 9 9-4.032 9-9-4.032-9-9-9zm1.269 14.481v.522c0 .657-.54 1.197-1.197 1.197h-.009c-.657 0-1.197-.54-1.197-1.197v-.54c-1.197-.252-2.259-.909-2.709-2.016-.207-.495.18-1.044.72-1.044h.216c.333 0 .603.225.729.54.261.675.945 1.143 2.259 1.143 1.764 0 2.16-.882 2.16-1.431 0-.747-.396-1.449-2.403-1.926-2.232-.54-3.762-1.458-3.762-3.303 0-1.548 1.251-2.556 2.799-2.889v-.54c0-.657.54-1.197 1.197-1.197h.009c.657 0 1.197.54 1.197 1.197v.558c1.242.306 2.025 1.08 2.367 2.034.18.495-.198 1.017-.729 1.017h-.234c-.333 0-.603-.234-.693-.558-.207-.684-.774-1.125-1.908-1.125-1.35 0-2.16.612-2.16 1.476 0 .756.585 1.251 2.403 1.719 1.818.468 3.762 1.251 3.762 3.519-.018 1.647-1.251 2.547-2.817 2.844z" }) }));
cb.displayName = "MonetizationOnRounded";
const lb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" }) }));
lb.displayName = "MoreHoriz";
const ub = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M14 6c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm0 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm0-6c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2z" }) }));
ub.displayName = "MoreVert";
const db = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6.99 15c-.7 0-1.26-.56-1.26-1.26 0-.71.56-1.25 1.26-1.25.71 0 1.25.54 1.25 1.25-.01.69-.54 1.26-1.25 1.26zm3.01-7.4c-.76 1.11-1.48 1.46-1.87 2.17-.1.18-.16.32-.19.63-.05.45-.45.78-.9.78H12c-.52 0-.93-.44-.88-.96.03-.34.11-.69.3-1.03.49-.87 1.42-1.39 1.96-2.16.57-.81.25-2.33-1.37-2.33-.71 0-1.18.36-1.47.79-.25.36-.69.53-1.1.36a.872.872 0 01-.4-1.31C9.65 6.65 10.67 6 11.99 6c1.48 0 2.49.67 3.01 1.52.44.72.7 2.07.02 3.08z" }) }));
db.displayName = "HelpCentreRounded";
const fb = A.forwardRef((e, t) => h.jsxs(Q, { ...e, ref: t, children: [h.jsx("path", { d: "M19.607 3.413a1.32 1.32 0 00-1.892 0l-5.208 5.288L7.285 3.4a1.32 1.32 0 00-1.892 0 1.378 1.378 0 000 1.926l6.16 6.271a1.32 1.32 0 001.893 0l6.161-6.271c.524-.52.524-1.38 0-1.913z" }), h.jsx("path", { d: "M19.605 12.417a1.322 1.322 0 00-1.894 0L12.5 17.704l-5.212-5.301a1.322 1.322 0 00-1.894 0 1.377 1.377 0 000 1.926l6.166 6.271c.524.533 1.37.533 1.894 0l6.166-6.27c.51-.52.51-1.38-.014-1.913z" })] }));
fb.displayName = "KeyboardDoubleArrowDownRounded";
const pb = A.forwardRef((e, t) => h.jsxs(Q, { ...e, ref: t, children: [h.jsx("path", { d: "M5.393 20.587a1.32 1.32 0 001.892 0l5.208-5.288 5.222 5.301a1.32 1.32 0 001.892 0 1.378 1.378 0 000-1.926l-6.16-6.271a1.32 1.32 0 00-1.893 0l-6.161 6.271a1.361 1.361 0 000 1.913z" }), h.jsx("path", { d: "M5.395 11.583c.524.533 1.37.533 1.894 0L12.5 6.296l5.212 5.301c.524.533 1.37.533 1.894 0a1.377 1.377 0 000-1.926L13.441 3.4a1.322 1.322 0 00-1.894 0L5.381 9.67c-.51.52-.51 1.38.014 1.913z" })] }));
pb.displayName = "KeyboardDoubleArrowUpRounded";
const oi = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M8.12 9.29L12 13.17l3.88-3.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-4.59 4.59c-.39.39-1.02.39-1.41 0L6.7 10.7a.9959.9959 0 010-1.41c.39-.38 1.03-.39 1.42 0z" }) }));
oi.displayName = "KeyboardArrowDownRounded";
const Il = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M14.71 15.88L10.83 12l3.88-3.88c.39-.39.39-1.02 0-1.41a.9959.9959 0 00-1.41 0L8.71 11.3c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .38-.39.39-1.03 0-1.42z" }) }));
Il.displayName = "KeyboardArrowLeftRounded";
const Sl = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M8.12 14.71L12 10.83l3.88 3.88c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L12.7 8.71a.9959.9959 0 00-1.41 0L6.7 13.3c-.39.39-.39 1.02 0 1.41.39.38 1.03.39 1.42 0z" }) }));
Sl.displayName = "KeyboardArrowUpRounded";
const Al = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M9.29 15.88L13.17 12 9.29 8.12a.9959.9959 0 010-1.41c.39-.39 1.02-.39 1.41 0l4.59 4.59c.39.39.39 1.02 0 1.41L10.7 17.3c-.39.39-1.02.39-1.41 0-.38-.39-.39-1.03 0-1.42z" }) }));
Al.displayName = "KeyboardArrowRightRounded";
const bb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsxs("g", { children: [h.jsx("path", { d: "M19,3h-6c-0.55,0-1,0.45-1,1v0c0,0.55,0.45,1,1,1h6v14h-6c-0.55,0-1,0.45-1,1v0c0,0.55,0.45,1,1,1h6c1.1,0,2-0.9,2-2V5 C21,3.9,20.1,3,19,3z" }), h.jsx("path", { d: "M11,9.21V11H4c-0.55,0-1,0.45-1,1v0c0,0.55,0.45,1,1,1h7v1.79c0,0.45,0.54,0.67,0.85,0.35l2.79-2.79 c0.2-0.2,0.2-0.51,0-0.71l-2.79-2.79C11.54,8.54,11,8.76,11,9.21z" })] }) }));
bb.displayName = "LoginRounded";
const El = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M12 0C5.376 0 0 5.376 0 12s5.376 12 12 12 12-5.376 12-12S18.624 0 12 0zm1.2 18h-2.4v-2.4h2.4V18zm0-4.8h-2.4V6h2.4v7.2z" }) }));
El.displayName = "ErrorRounded";
const gb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M12 0C6.545 0 1.887 3.317 0 8c1.887 4.683 6.545 8 12 8 5.454 0 10.113-3.317 12-8-1.887-4.683-6.546-8-12-8zm0 13.333c-3.01 0-5.455-2.389-5.455-5.333 0-2.944 2.444-5.333 5.455-5.333 3.01 0 5.454 2.389 5.454 5.333 0 2.944-2.443 5.333-5.454 5.333zM12 4.8c-1.81 0-3.273 1.43-3.273 3.2 0 1.77 1.462 3.2 3.273 3.2 1.81 0 3.273-1.43 3.273-3.2 0-1.77-1.462-3.2-3.273-3.2z" }) }));
gb.displayName = "VisibilityRounded";
const mb = A.forwardRef((e, t) => h.jsx(Q, { viewBox: "0 2 24 20", ...e, ref: t, children: h.jsx("path", { d: "M12 4.465a5.458 5.458 0 015.454 5.457c0 .556-.108 1.091-.261 1.593l3.338 3.34A12.88 12.88 0 0024 9.91c-1.887-4.78-6.546-8.175-12-8.175-1.386 0-2.716.218-3.97.622l2.366 2.368c.513-.152 1.048-.261 1.604-.261zM1.865.819a1.087 1.087 0 000 1.54l2.15 2.15A12.978 12.978 0 000 9.921c1.887 4.79 6.545 8.185 12 8.185 1.658 0 3.24-.327 4.702-.895l2.967 2.969a1.087 1.087 0 101.538-1.539L3.415.819a1.1 1.1 0 00-1.55 0zM12 15.38a5.458 5.458 0 01-5.455-5.457c0-.84.197-1.638.535-2.336l1.713 1.713a3.75 3.75 0 00-.066.623A3.27 3.27 0 0012 13.196c.218 0 .415-.033.622-.077l1.713 1.714a5.248 5.248 0 01-2.335.546zm3.24-5.818a3.24 3.24 0 00-2.88-2.88l2.88 2.88z" }) }));
mb.displayName = "VisibilityOffRounded";
const hb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M12 3c-4.968 0-9 4.032-9 9s4.032 9 9 9 9-4.032 9-9-4.032-9-9-9zM9.561 15.861L6.33 12.63a.896.896 0 111.269-1.269l2.601 2.592 6.192-6.192a.896.896 0 111.269 1.269l-6.831 6.831a.894.894 0 01-1.269 0z" }) }));
hb.displayName = "CheckRounded";
const vb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M8.398 17.4c-.99 0-1.79.81-1.79 1.8s.8 1.8 1.79 1.8 1.8-.81 1.8-1.8-.81-1.8-1.8-1.8zM3 3.9c0 .495.405.9.9.9h.9l3.238 6.831-1.214 2.196c-.657 1.206.207 2.673 1.574 2.673h9.896c.495 0 .9-.405.9-.9s-.405-.9-.9-.9H8.398l.99-1.8h6.702a1.79 1.79 0 001.575-.927l3.22-5.841a.896.896 0 00-.782-1.332H6.788l-.603-1.287A.893.893 0 005.375 3H3.9c-.495 0-.9.405-.9.9zm14.395 13.5c-.99 0-1.79.81-1.79 1.8s.8 1.8 1.79 1.8 1.799-.81 1.799-1.8-.81-1.8-1.8-1.8z", fill: "#000" }) }));
vb.displayName = "CartRounded";
const $b = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M11.586 21.5c1.1 0 2-.9 2-2h-4a2 2 0 002 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-2.87.68-4.5 3.24-4.5 6.32v5l-1.29 1.29c-.63.63-.19 1.71.7 1.71h13.17c.89 0 1.34-1.08.71-1.71l-1.29-1.29z" }) }));
$b.displayName = "NotificationRounded";
const xb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.24.06-.47.15-.69.23L18 13.1V11zM5.41 3.35 4 4.76l2.81 2.81C6.29 8.57 6 9.73 6 11v5l-1.29 1.29c-.63.63-.19 1.71.7 1.71h12.83l1.74 1.74 1.41-1.41L5.41 3.35z" }) }));
xb.displayName = "NotificationsOffRounded";
const Pl = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M12 3c-4.977 0-9 4.023-9 9s4.023 9 9 9 9-4.023 9-9-4.023-9-9-9zm3.87 12.87a.895.895 0 01-1.269 0L12 13.269 9.399 15.87a.898.898 0 01-1.269-1.269L10.731 12 8.13 9.399A.897.897 0 119.399 8.13L12 10.731l2.601-2.601a.897.897 0 111.269 1.269L13.269 12l2.601 2.601a.913.913 0 010 1.269z" }) }));
Pl.displayName = "CloseCircleRounded";
const uo = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M18.3 5.71a.9959.9959 0 00-1.41 0L12 10.59 7.11 5.7a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z" }) }));
uo.displayName = "CloseRounded";
const yb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M4 18h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-5h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 7c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z" }) }));
yb.displayName = "MenuRounded";
const Cb = A.forwardRef((e, t) => h.jsxs(Q, { ...e, ref: t, children: [h.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 6.214L7.333 3H20v9l-6 5.786h-2.667L8 21v-3.214H4V6.214zm14.667 5.143V4.286H8v9.643h3v2.25l2.333-2.25H16l2.667-2.572z" }), h.jsx("path", { d: "M16.667 6.698h-1.334v4.033h1.334V6.698zM13 6.698h-1.333v4.033H13V6.698z" })] }));
Cb.displayName = "Twitch";
const wb = A.forwardRef((e, t) => {
  const n = A.useMemo(() => ["SvgIcon-Trovo", e.className].filter(Boolean).join(" "), [e.className]);
  return h.jsx(Q, { ...e, className: n, ref: t, children: h.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M 17.2 2.793 C 17.5 2.793 17.7 2.993 17.7 3.293 L 17.7 3.393 L 17 6.593 C 17 6.693 17.1 6.893 17.2 6.893 C 17.2 6.893 17.2 6.893 17.3 6.893 L 23.7 6.893 C 24 6.893 24.292 7.093 24.2 7.493 L 22.7 13.794 C 22.6 14.094 22.4 14.194 22.1 14.194 L 18.6 13.994 C 17.5 13.994 16.3 14.294 15.4 15.294 C 14.2 16.494 14.1 18.294 14.6 19.594 C 15.1 20.894 16.5 21.594 17.9 21.294 C 19 21.094 19.6 19.994 19.5 19.094 C 19.4 18.094 19 17.794 18.4 17.794 C 17.8 17.794 17.6 18.094 17.6 18.394 C 17.6 18.694 17.7 18.894 17.9 19.094 C 18.2 19.394 17.6 20.294 16.8 19.794 C 16.3 19.494 16 18.894 16.1 17.994 C 16.2 16.894 17.1 15.894 18.7 15.894 C 20.3 15.894 21.5 16.894 21.8 18.394 C 22.3 20.294 21.3 22.594 19 23.794 C 16.2 25.294 11.5 25.194 8.9 22.394 C 7.4 20.794 6.9 18.694 7 16.794 C 7 16.194 7.1 15.494 7.3 14.894 C 7.3 14.694 7.2 14.494 7 14.394 L 6.9 14.394 L 2.5 14.394 C 2.2 14.394 2 14.094 2 13.794 L 2 13.694 L 3.4 7.593 C 3.5 7.193 3.8 6.993 4.2 6.993 L 8.5 6.993 C 8.7 6.893 8.9 6.793 9 6.493 L 9.7 3.393 C 9.8 2.993 10.2 2.793 10.5 2.793 L 17.2 2.793 Z" }) });
});
wb.displayName = "Trovo";
const Ib = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("g", { id: "surface1", children: h.jsx("path", { d: "M 22.539062 6.671875 C 22.289062 5.71875 21.542969 4.96875 20.59375 4.710938 C 18.878906 4.25 12 4.25 12 4.25 C 12 4.25 5.121094 4.25 3.40625 4.710938 C 2.457031 4.96875 1.710938 5.71875 1.460938 6.671875 C 1 8.398438 1 12 1 12 C 1 12 1 15.601562 1.460938 17.328125 C 1.710938 18.28125 2.457031 19.03125 3.40625 19.289062 C 5.121094 19.75 12 19.75 12 19.75 C 12 19.75 18.878906 19.75 20.59375 19.289062 C 21.542969 19.03125 22.289062 18.28125 22.539062 17.328125 C 23 15.601562 23 12 23 12 C 23 12 23 8.398438 22.539062 6.671875 Z M 9.75 15.269531 L 9.75 8.730469 L 15.5 12 Z M 9.75 15.269531 " }) }) }));
Ib.displayName = "YouTube";
const Sb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M16 3v3.6h-1.8c-.621 0-.9.729-.9 1.35v2.25H16v3.6h-2.7V21H9.7v-7.2H7v-3.6h2.7V6.6A3.6 3.6 0 0113.3 3H16z" }) }));
Sb.displayName = "Facebook";
const Ab = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "m5.58 16.89 5.77-4.07c.56-.4.56-1.24 0-1.63L5.58 7.11C4.91 6.65 4 7.12 4 7.93v8.14c0 .81.91 1.28 1.58.82zM13 7.93v8.14c0 .81.91 1.28 1.58.82l5.77-4.07c.56-.4.56-1.24 0-1.63l-5.77-4.07c-.67-.47-1.58 0-1.58.81z" }) }));
Ab.displayName = "FastForwardRounded";
const Eb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M10.59 9.17 6.12 4.7a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41l4.46 4.46 1.42-1.4zm4.76-4.32 1.19 1.19L4.7 17.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L17.96 7.46l1.19 1.19c.31.31.85.09.85-.36V4.5c0-.28-.22-.5-.5-.5h-3.79c-.45 0-.67.54-.36.85zm-.52 8.56-1.41 1.41 3.13 3.13-1.2 1.2c-.31.31-.09.85.36.85h3.79c.28 0 .5-.22.5-.5v-3.79c0-.45-.54-.67-.85-.35l-1.19 1.19-3.13-3.14z" }) }));
Eb.displayName = "ShuffleRounded";
A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M19.688 9h-1.875c-.724 0-1.313.589-1.313 1.313v9.374c0 .724.589 1.313 1.313 1.313h1.875C20.41 21 21 20.411 21 19.687v-9.375C21 9.59 20.411 9 19.687 9zM4.313 21h9.375c.72 0 1.312-.593 1.312-1.313v-9.375C15 9.592 14.408 9 13.687 9H4.313C3.593 9 3 9.592 3 10.313v9.374C3 20.407 3.592 21 4.313 21zm2.437-4.313v-4.125c0-.194.098-.374.27-.48a.568.568 0 01.548-.022l4.125 2.063a.57.57 0 01.307.502.57.57 0 01-.307.502L7.568 17.19a.633.633 0 01-.255.06.574.574 0 01-.293-.082.556.556 0 01-.27-.48zM19.688 3H4.313C3.588 3 3 3.589 3 4.313v1.875C3 6.91 3.589 7.5 4.313 7.5h15.375C20.41 7.5 21 6.911 21 6.187V4.313C21 3.59 20.411 3 19.687 3z" }) }));
const Pb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm7.46 7.12l-2.78 1.15a4.982 4.982 0 00-2.95-2.94l1.15-2.78c2.1.8 3.77 2.47 4.58 4.57zM12 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zM9.13 4.54l1.17 2.78a5 5 0 00-2.98 2.97L4.54 9.13a7.984 7.984 0 014.59-4.59zM4.54 14.87l2.78-1.15a4.968 4.968 0 002.97 2.96l-1.17 2.78a7.996 7.996 0 01-4.58-4.59zm10.34 4.59l-1.15-2.78a4.978 4.978 0 002.95-2.97l2.78 1.17a8.007 8.007 0 01-4.58 4.58z" }) }));
Pb.displayName = "SupportRounded";
const Tb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M15.5 4H19v2H5V4h3.5l1-1h5l1 1zM8 21c-1.1 0-2-.9-2-2V7h12v12c0 1.1-.9 2-2 2H8z" }) }));
Tb.displayName = "TrashRounded";
const Rb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M14.71 14h.79l4.24 4.26c.41.41.41 1.08 0 1.49-.41.41-1.08.41-1.49 0L14 15.5v-.79l-.27-.28a6.5 6.5 0 01-5.34 1.48c-2.78-.47-5-2.79-5.34-5.59a6.505 6.505 0 017.27-7.27c2.8.34 5.12 2.56 5.59 5.34a6.5 6.5 0 01-1.48 5.34l.28.27zM5 9.5C5 11.99 7.01 14 9.5 14S14 11.99 14 9.5 11.99 5 9.5 5 5 7.01 5 9.5z" }) }));
Rb.displayName = "SearchRounded";
const Mb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" }) }));
Mb.displayName = "SettingsRounded";
const Db = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M17 7h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c1.65 0 3 1.35 3 3s-1.35 3-3 3h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-9 5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1H9c-.55 0-1 .45-1 1zm2 3H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h3c.55 0 1-.45 1-1s-.45-1-1-1H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h3c.55 0 1-.45 1-1s-.45-1-1-1z" }) }));
Db.displayName = "LinkRounded";
const Ob = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M4 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm4 4h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zm0 4h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zM7 8c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1zm-3 5c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm4 4h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zm0 4h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zM7 8c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1z" }) }));
Ob.displayName = "ListRounded";
const Fb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M3 18c0 .55.45 1 1 1h5v-2H4c-.55 0-1 .45-1 1zM3 6c0 .55.45 1 1 1h9V5H4c-.55 0-1 .45-1 1zm10 14v-1h7c.55 0 1-.45 1-1s-.45-1-1-1h-7v-1c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1zM7 10v1H4c-.55 0-1 .45-1 1s.45 1 1 1h3v1c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55-.45-1-1-1s-1 .45-1 1zm14 2c0-.55-.45-1-1-1h-9v2h9c.55 0 1-.45 1-1zm-5-3c.55 0 1-.45 1-1V7h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V4c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1z" }) }));
Fb.displayName = "FilterRounded";
const kb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M4.25 5.61C6.57 8.59 10 13 10 13v5c0 1.1.9 2 2 2s2-.9 2-2v-5s3.43-4.41 5.75-7.39c.51-.66.04-1.61-.8-1.61H5.04c-.83 0-1.3.95-.79 1.61z" }) }));
kb.displayName = "FunnelRounded";
const Nb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM8 19h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zm0-6h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zM7 6c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1z" }) }));
Nb.displayName = "FormatListBulletedRounded";
const _b = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M20.954 9.6c-.305-1.145-2.11-1.744-4.607-1.725A5.964 5.964 0 0012 6a5.999 5.999 0 00-5.83 4.604v-.002C4 11.834 2.74 13.255 3.046 14.398c.307 1.146 2.112 1.747 4.61 1.726A5.965 5.965 0 0012 18a6 6 0 005.83-4.603c2.17-1.231 3.431-2.652 3.124-3.796zM12.5 13.867C8.38 14.969 4.815 15.03 4.538 14c-.124-.465.444-1.07 1.478-1.697 0-.002.005-.005.005-.007.024.442.084.873.197 1.286.182.015.397.028.665.028 1.414 0 3.355-.303 5.325-.831 2.806-.752 4.69-1.677 5.59-2.298a5.98 5.98 0 00-.471-1.219c.002.003.006.006.007.009 1.209.025 2.004.266 2.128.73.277 1.03-2.841 2.761-6.962 3.865z" }) }));
_b.displayName = "ObsliveRounded";
const Lb = A.forwardRef((e, t) => h.jsxs(Q, { ...e, ref: t, children: [h.jsx("path", { d: "M17 14.883v-2.33-.019L16.786 8.9c-.058-1-.61-1.148-.934-1.148-.226 0-.45.066-.64.184l-.236-1.772c-.116-.868-.656-1.109-1.083-1.052-.459.061-.91.454-1.115.998l-.356-1.193c-.194-.646-.608-.834-.838-.889-.388-.092-.82.053-1.127.379-.367.389-.486.953-.318 1.51l.995 3.31c-.575-.123-1.08.147-1.675.629-.657.532-1.717 1.09-1.965 1.21-.259.125-.394.41-.352.741.025.202.12.426.286.608a1.091 1.091 0 00-.294.289c-.169.252-.179.536-.026.76.044.065.095.129.149.196.173.217.411.515.644 1.137.332.885.902 1.283 1.36 1.603.437.304.745.52.828 1.047a.312.312 0 00-.26.307v1.934c0 .173.14.313.312.313h6.286c.172 0 .312-.14.312-.313v-1.934a.312.312 0 00-.264-.308c.04-.337.138-.681.24-1.04.14-.492.285-1 .285-1.522zm-.886 4.492h-5.66v-1.31h1.424a.312.312 0 100-.624h-1.159c-.099-.857-.607-1.211-1.1-1.555-.427-.298-.869-.606-1.132-1.31a4.3 4.3 0 00-.742-1.307c-.048-.06-.089-.111-.12-.156.002-.016.02-.073.102-.144a.7.7 0 01.593-.145c.454.095.587.275.787.548.182.247.409.555.9.811.348.182.64.314.971.225.313-.083.585-.35.948-.78.288-.34.326-.73.11-1.127-.167-.305-.464-.59-.807-.906-.556-.513-1.151-.157-1.63.13-.439.263-.893.534-1.443.422a.509.509 0 01-.368-.318c-.041-.108-.028-.184-.018-.204.326-.158 1.393-.727 2.082-1.284.785-.636 1.103-.63 1.602-.292.143.096.27.138.373.172a.85.85 0 01.396.234.313.313 0 00.434-.449 1.458 1.458 0 00-.634-.378 1.37 1.37 0 01-.13-.048l-1.156-3.845c-.147-.49.073-.793.175-.9.154-.164.356-.24.528-.2.218.052.329.28.383.46l1.26 4.222c.077.276.222.466.349.634.171.226.32.422.361.856a.313.313 0 00.622-.059c-.058-.61-.295-.924-.485-1.175-.112-.147-.2-.264-.245-.425 0-.002 0-.005-.002-.007l-.157-.527-.23-1.713c-.084-.638.353-1.127.68-1.17.253-.034.346.261.38.515l.74 5.542a.313.313 0 00.62-.082l-.384-2.875a.33.33 0 01.087-.262.586.586 0 01.433-.193c.09 0 .278 0 .31.56l.213 3.626v2.322c0 .434-.127.878-.26 1.349-.112.392-.227.795-.268 1.208H14.69a.312.312 0 100 .625h1.424v1.309zm-6.84-6.767c.237-.102.451-.23.647-.347.529-.317.699-.378.885-.207.779.718.845.93.643 1.171-.222.262-.47.536-.633.58-.103.027-.25-.035-.52-.176-.363-.19-.52-.402-.685-.627-.096-.13-.197-.268-.337-.394z" }), h.jsx("path", { d: "M13.284 17.44a.312.312 0 100 .626.312.312 0 000-.625z" })] }));
Lb.displayName = "OkHandRounded";
const Bb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M18.25 19h-12c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h5c.55 0 1-.45 1-1s-.45-1-1-1h-6a2 2 0 00-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55-.45 1-1 1zm-4-15c0 .55.45 1 1 1h2.59l-9.13 9.13a.996.996 0 101.41 1.41l9.13-9.13V9c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1h-5c-.55 0-1 .45-1 1z" }) }));
Bb.displayName = "OpenInNew";
const Vb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M10 16c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1zm2-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm2-4c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1z" }) }));
Vb.displayName = "PauseCircleRounded";
const Gb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M8 19c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2s-2 .9-2 2v10c0 1.1.9 2 2 2zm6-12v10c0 1.1.9 2 2 2s2-.9 2-2V7c0-1.1-.9-2-2-2s-2 .9-2 2z" }) }));
Gb.displayName = "PauseRounded";
const Wb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M8 6.82v10.36c0 .79.87 1.27 1.54.84l8.14-5.18a1 1 0 000-1.69L9.54 5.98A.998.998 0 008 6.82z" }) }));
Wb.displayName = "PlayRounded";
const jb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M12 5V2.21c0-.45-.54-.67-.85-.35l-3.8 3.79c-.2.2-.2.51 0 .71l3.79 3.79c.32.31.86.09.86-.36V7c3.73 0 6.68 3.42 5.86 7.29-.47 2.27-2.31 4.1-4.57 4.57-3.57.75-6.75-1.7-7.23-5.01-.07-.48-.49-.85-.98-.85-.6 0-1.08.53-1 1.13.62 4.39 4.8 7.64 9.53 6.72 3.12-.61 5.63-3.12 6.24-6.24C20.84 9.48 16.94 5 12 5z" }) }));
jb.displayName = "ReplayRounded";
const zb = A.forwardRef(function(e, t) {
  return h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" }) });
}), Hb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M18.4 4.8h-.9v-.9a.902.902 0 00-.9-.9.902.902 0 00-.9.9v.9H8.5v-.9a.902.902 0 00-.9-.9.902.902 0 00-.9.9v.9h-.9c-.998 0-1.79.81-1.79 1.8L4 19.2A1.8 1.8 0 005.8 21h12.6c.99 0 1.8-.81 1.8-1.8V6.6c0-.99-.81-1.8-1.8-1.8zm0 13.5c0 .496-.404.9-.9.9H6.7a.902.902 0 01-.9-.9v-9h12.6v9zM7.6 11.1h1.8v1.8H7.6v-1.8zm3.6 0H13v1.8h-1.8v-1.8zm3.6 0h1.8v1.8h-1.8v-1.8z" }) }));
Hb.displayName = "CalendarRounded";
const Xb = A.forwardRef((e, t) => h.jsxs(Q, { ...e, ref: t, children: [h.jsx("path", { d: "M15.941 13.948h-.643l-.227-.22a5.264 5.264 0 001.277-3.44A5.287 5.287 0 0011.06 5a5.275 5.275 0 00-5.263 4.88H7.44a3.642 3.642 0 013.62-3.253 3.655 3.655 0 013.66 3.66 3.655 3.655 0 01-3.66 3.66c-.139 0-.269-.024-.407-.04v1.643c.138.016.268.024.406.024 1.31 0 2.514-.48 3.441-1.277l.22.228v.643l4.067 4.059L20 18.015l-4.059-4.067z" }), h.jsx("path", { d: "M8.596 11.36l-2.01 2.01-2.008-2.01-.578.578 2.01 2.01L4 15.957l.578.577 2.009-2.009 2.009 2.01.577-.578-2.009-2.01 2.01-2.009-.578-.577z" })] }));
Xb.displayName = "SearchNotFoundRounded";
const Zb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M3 17.253v3.75h3.75l11.06-11.06-3.75-3.75L3 17.253zm17.71-10.21a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" }) }));
Zb.displayName = "EditRounded";
const Yb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M18.002 7c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1s1-.45 1-1V7zm-7.82 5l-3.89-3.89c-.38-.38-.38-1.02 0-1.41a.996.996 0 011.41 0l4.59 4.6c.39.39.39 1.02 0 1.41l-4.59 4.59a.996.996 0 11-1.41-1.41l3.89-3.89z" }) }));
Yb.displayName = "LastRounded";
const Ub = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M19.837 5.785l-1.274-1.54A1.383 1.383 0 0017.5 3.75h-11c-.43 0-.807.192-1.054.504L4.172 5.785a1.82 1.82 0 00-.422 1.173v11.459c0 1.008.816 1.833 1.833 1.833h12.834a1.839 1.839 0 001.833-1.833V6.958c0-.449-.156-.852-.413-1.173zm-7.516 4.244l4.72 4.721h-3.208v1.833h-3.666V14.75H6.958l4.721-4.72a.46.46 0 01.642 0zM5.693 5.583l.752-.916h11l.852.916H5.694z" }) }));
Ub.displayName = "UnarchiveRounded";
const Jb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M9.5 16.2L5.3 12l-1.4 1.4L9.5 19l12-12-1.4-1.4L9.5 16.2z" }) }));
Jb.displayName = "Check";
const Qb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92c-.5.51-.86.97-1.04 1.69-.08.32-.13.68-.13 1.14h-2v-.5a3.997 3.997 0 011.17-2.83l1.24-1.26c.46-.44.68-1.1.55-1.8a1.99 1.99 0 00-1.39-1.53c-1.11-.31-2.14.32-2.47 1.27-.12.37-.43.65-.82.65h-.3C8.4 9 8 8.44 8.16 7.88a4.008 4.008 0 013.23-2.83c1.52-.24 2.97.55 3.87 1.8 1.18 1.63.83 3.38-.19 4.4z" }) }));
Qb.displayName = "HelpRounded";
const Kb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm8 7H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1zm1-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z" }) }));
Kb.displayName = "KeyboardRounded";
const qb = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M19 8h-1.81a5.985 5.985 0 00-1.82-1.96l.93-.93a.996.996 0 10-1.41-1.41l-1.47 1.47C12.96 5.06 12.49 5 12 5s-.96.06-1.41.17L9.11 3.7A.996.996 0 107.7 5.11l.92.93C7.88 6.55 7.26 7.22 6.81 8H5c-.55 0-1 .45-1 1s.45 1 1 1h1.09c-.05.33-.09.66-.09 1v1H5c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .34.04.67.09 1H5c-.55 0-1 .45-1 1s.45 1 1 1h1.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H19c.55 0 1-.45 1-1s-.45-1-1-1h-1.09c.05-.33.09-.66.09-1v-1h1c.55 0 1-.45 1-1s-.45-1-1-1h-1v-1c0-.34-.04-.67-.09-1H19c.55 0 1-.45 1-1s-.45-1-1-1zm-6 8h-2c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1zm0-4h-2c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1z" }) }));
qb.displayName = "BugRounded";
const eg = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M16.59 9H15V4c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v5H7.41c-.89 0-1.34 1.08-.71 1.71l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59c.63-.63.19-1.71-.7-1.71zM5 19c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1z" }) }));
eg.displayName = "DownloadRounded";
const tg = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M19 11h-8v6h8v-6zm4 8V4.98C23 3.88 22.1 3 21 3H3c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H3V4.97h18v14.05z" }) }));
tg.displayName = "PictureInPictureRounded";
const ng = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3zM7.5 11.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S9.83 13 9 13s-1.5-.67-1.5-1.5zM16 17H8v-2h8v2zm-1-4c-.83 0-1.5-.67-1.5-1.5S14.17 10 15 10s1.5.67 1.5 1.5S15.83 13 15 13z" }) }));
ng.displayName = "SmartToyRounded";
const rg = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M12.95 19H20V7H4v12h7.24c.14-.98.42-2.05-.16-2.43-.89-.59-1.27 2.06-2.8 1.35-1.39-1.12 1.05-1.29.5-3.27-.22-.79-2.28.36-2.4-1.24-.08-1 1.49-.74 1.51-1.49.03-.75-1.03-1.05-.25-1.91.22-.24.71-.26.91-.19.79.27 1.55 1.82 2.51 1.19 1.03-.66-1.88-2.35 0-2.86 1.64-.44 1.31 2.08 2.65 2.44 1.94.52 2.65-4.55 4.41-2.33 1.85 2.33-3.43 2.27-2.85 4.01.34 1.01 2.15-1.2 2.76.53.64 1.83-3.09.82-3.04 1.66.06.83 2.41.55 1.64 2.12-1.14 1.86-3-1.03-3.81.09-.39.57-.09 1.49.13 2.33zM20 5c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h3.17L9 3h6l1.83 2H20zm-1.86 13.01a.86.86 0 01-.86-.86c0-.48.38-.86.86-.86.47 0 .86.38.86.86s-.38.86-.86.86z" }) }));
rg.displayName = "DirtyLensRounded";
R(function(e, t) {
  return h.jsx(Q, { ...e, className: e.className, ref: t, children: h.jsx("path", { d: "M3 2h6.675v4.444H11.9V4.222h2.225V2H20.8v6.667h-2.225v2.222H16.35v2.222h2.225v2.222H20.8V22h-6.675v-2.222H11.9v-2.223H9.675V22H3V2z", fillRule: "evenodd", clipRule: "evenodd" }) });
});
const og = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm1-8h-2V7h2v2z" }) }));
og.displayName = "InfoRounded";
A.forwardRef(function(e, t) {
  return h.jsx(Q, { ...e, ref: t, children: h.jsx("path", { d: "M17.751 3h3.067l-6.7 7.658L22 21.078h-6.172l-4.833-6.32-5.531 6.32h-3.07l7.167-8.19L2 3h6.328l4.37 5.777L17.751 3zm-1.076 16.242h1.7L7.404 4.74H5.58l11.094 14.503.001-.001z" }) });
});
const ag = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsx("g", { clipPath: "url(#clip0_5683_3199)", transform: "matrix(0.925723, 0, 0, 0.925723, -1.986876, -2.298668)", children: h.jsx("path", { d: "M23.913 6.788a20.164 20.164 0 00-5.094-1.632.076.076 0 00-.082.04c-.22.404-.463.931-.634 1.346a18.455 18.455 0 00-5.721 0c-.171-.424-.424-.942-.645-1.346a.08.08 0 00-.081-.04 20.107 20.107 0 00-5.094 1.632.074.074 0 00-.034.03c-3.244 5.005-4.133 9.888-3.697 14.71a.09.09 0 00.033.06 20.504 20.504 0 006.249 3.263.08.08 0 00.087-.03c.482-.679.91-1.395 1.279-2.147a.083.083 0 00-.044-.114 13.492 13.492 0 01-1.952-.961.084.084 0 01-.008-.138c.131-.101.263-.207.388-.313a.075.075 0 01.08-.012c4.097 1.931 8.53 1.931 12.578 0a.075.075 0 01.082.01c.125.107.256.214.388.315a.084.084 0 01-.006.138c-.624.376-1.272.694-1.954.96a.083.083 0 00-.042.115 17.32 17.32 0 001.277 2.146c.02.029.056.041.088.03a20.435 20.435 0 006.259-3.261.084.084 0 00.033-.06c.521-5.575-.874-10.417-3.7-14.71a.064.064 0 00-.033-.031zM11.09 18.592c-1.233 0-2.249-1.17-2.249-2.605 0-1.436.997-2.605 2.25-2.605 1.262 0 2.268 1.18 2.248 2.605 0 1.436-.996 2.605-2.249 2.605zm8.316 0c-1.233 0-2.25-1.17-2.25-2.605 0-1.436.997-2.605 2.25-2.605 1.263 0 2.269 1.18 2.249 2.605 0 1.436-.986 2.605-2.25 2.605z" }) }) }));
ag.displayName = "Discord";
const ig = A.forwardRef((e, t) => h.jsx(Q, { ...e, ref: t, children: h.jsxs("g", { clipPath: "url(#clip0_5683_3194)", transform: "matrix(0.954548, 0, 0, 0.867817, -3.082062, -0.871597)", children: [h.jsx("path", { d: "M15.939 5.782c3.007 0 3.363.012 4.55.066 1.098.05 1.695.233 2.092.387.49.18.933.469 1.296.843.375.364.663.807.843 1.296.154.397.337.994.388 2.092.053 1.188.065 1.543.065 4.55 0 3.008-.011 3.364-.065 4.551-.05 1.098-.234 1.695-.388 2.091a3.734 3.734 0 01-2.137 2.138c-.397.154-.994.337-2.092.387-1.187.054-1.543.066-4.55.066-3.008 0-3.364-.012-4.551-.066-1.098-.05-1.694-.233-2.091-.387a3.487 3.487 0 01-1.297-.843 3.488 3.488 0 01-.842-1.296c-.155-.397-.338-.994-.388-2.091-.054-1.188-.066-1.544-.066-4.551 0-3.008.012-3.363.066-4.551.05-1.098.233-1.694.388-2.091.18-.49.468-.933.842-1.297A3.487 3.487 0 019.3 6.234c.397-.155.993-.338 2.09-.388 1.189-.054 1.545-.066 4.552-.066l-.002.002zm.002-2.03c-3.059 0-3.443.012-4.644.067-1.2.055-2.019.247-2.734.525a5.529 5.529 0 00-1.996 1.3 5.529 5.529 0 00-1.299 1.995c-.278.715-.468 1.535-.523 2.733-.054 1.199-.068 1.584-.068 4.643 0 3.058.013 3.442.068 4.643.055 1.201.245 2.017.523 2.733a5.53 5.53 0 001.3 1.994 5.523 5.523 0 001.995 1.3c.715.278 1.535.469 2.733.523 1.199.055 1.585.068 4.644.068 3.058 0 3.442-.013 4.643-.068 1.201-.055 2.017-.245 2.732-.523a5.757 5.757 0 003.294-3.294c.278-.715.469-1.535.523-2.734.055-1.198.069-1.585.069-4.643 0-3.059-.014-3.442-.069-4.643-.055-1.202-.245-2.017-.523-2.732a5.522 5.522 0 00-1.299-1.995 5.528 5.528 0 00-1.995-1.3c-.715-.278-1.535-.468-2.734-.523-1.198-.055-1.584-.068-4.642-.068l.002-.002z" }), h.jsx("path", { d: "M15.941 9.232a5.783 5.783 0 100 11.567 5.783 5.783 0 000-11.567zm0 9.538a3.755 3.755 0 110-7.51 3.755 3.755 0 010 7.51zM21.953 10.355a1.351 1.351 0 100-2.703 1.351 1.351 0 000 2.703z" })] }) }));
ig.displayName = "Instagram";
const sg = A.forwardRef((e, t) => h.jsxs(Q, { ...e, ref: t, children: [h.jsx("path", { d: "M 12.003 0.031 C 5.386 0.031 0.034 5.391 0.034 12.006 C 0.034 18.619 5.386 23.978 12.003 23.978 C 18.617 23.978 23.981 18.619 23.981 12.006 C 23.981 5.391 18.617 0.031 12.003 0.031 Z M 20.292 7.216 L 16.761 7.216 C 16.371 5.719 15.828 4.281 15.11 2.954 C 17.312 3.708 19.144 5.234 20.292 7.216 Z M 12.009 2.469 C 13.007 3.904 13.785 5.502 14.295 7.216 L 9.721 7.216 C 10.23 5.502 11.009 3.904 12.009 2.469 Z M 2.74 14.399 C 2.542 13.632 2.429 12.832 2.429 12.006 C 2.429 11.177 2.542 10.377 2.74 9.611 L 6.779 9.611 C 6.685 10.395 6.62 11.19 6.62 12.006 C 6.62 12.82 6.685 13.614 6.787 14.399 L 2.74 14.399 Z M 3.718 16.794 L 7.249 16.794 C 7.638 18.291 8.183 19.727 8.902 21.061 C 6.698 20.308 4.865 18.775 3.718 16.794 Z M 7.249 7.216 L 3.718 7.216 C 4.865 5.234 6.698 3.702 8.902 2.948 C 8.183 4.281 7.638 5.719 7.249 7.216 Z M 12.009 21.541 C 11.015 20.105 10.237 18.507 9.721 16.794 L 14.295 16.794 C 13.78 18.507 13.001 20.105 12.009 21.541 Z M 14.81 14.399 L 9.205 14.399 C 9.091 13.614 9.015 12.82 9.015 12.006 C 9.015 11.19 9.091 10.395 9.205 9.611 L 14.81 9.611 C 14.923 10.395 15.002 11.19 15.002 12.006 C 15.002 12.82 14.923 13.614 14.81 14.399 Z M 15.117 21.056 C 15.833 19.721 16.378 18.291 16.767 16.794 L 20.3 16.794 C 19.144 18.775 17.312 20.302 15.117 21.056 Z M 17.229 14.399 C 17.325 13.614 17.395 12.82 17.395 12.006 C 17.395 11.19 17.33 10.395 17.229 9.611 L 21.269 9.611 C 21.467 10.377 21.586 11.177 21.586 12.006 C 21.586 12.832 21.473 13.632 21.269 14.399 L 17.229 14.399 Z" }), "  "] }));
sg.displayName = "LanguageRounded";
const cg = k("span", {
  display: "inline-grid",
  gridAutoFlow: "column",
  placeItems: "center",
  textAlign: "center",
  gridColumnGap: "$base",
  fontFamily: "$base",
  fontSize: "$bodyText",
  lineHeight: 1.4,
  fontWeight: "$regular",
  borderRadius: "1em",
  bgc: "$uiPrimary25",
  py: "0.25rem",
  px: "1rem",
  color: "$textPrimaryMain",
  "&:hover, &.state--hover": {
    boxShadow: "$1"
  },
  "&:active, &.state--active": {
    bgc: "$uiPrimary50"
  },
  "&[disabled]": {
    userSelect: "none",
    cursor: "default",
    bgc: "$uiMonochrome25",
    opacity: 0.3
  },
  variants: {
    /** should be used in conjunction with Chip.Remove */
    isRemovable: {
      true: {
        pr: "0.25rem"
      }
    },
    isClickable: {
      true: {
        cursor: "pointer"
      }
    },
    /** should be used in conjunction with Chip.DragIndicator */
    isDraggable: {
      true: {
        pl: "0.25rem",
        cursor: "move",
        "@supports (cursor: grab)": {
          cursor: "grab"
        }
      }
    }
  }
}), lg = k("button", {
  appearance: "none",
  padding: 0,
  margin: 0,
  display: "inline-grid",
  placeItems: "center",
  size: "1em",
  fontSize: "1.125rem",
  boxSizing: "border-box",
  border: "none",
  background: "none",
  color: "$textPrimary30",
  cursor: "pointer",
  "&:hover, &.state--hover": {
    color: "$textPrimary16"
  },
  "&[disabled]": {
    pointerEvents: "none",
    cursor: "default"
  },
  svg: {
    fontSize: "inherit",
    margin: "-1px 0 0 -1px"
  }
}), Tl = k(zb, {
  "&&": {
    fontSize: "1.125rem",
    color: "$textPrimary30"
  }
}), Rl = A.createContext({
  disabled: !1,
  isRemovable: !1,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setIsRemovable() {
  }
}), Ml = A.forwardRef(function(t, n) {
  const { isDraggable: r, disabled: o = !1, children: a, asChild: i, ...s } = t, [c, l] = A.useState(!1);
  return /* @__PURE__ */ h.jsx(Rl.Provider, { value: { isRemovable: c, setIsRemovable: l, disabled: o }, children: /* @__PURE__ */ h.jsx(
    cg,
    {
      ref: n,
      isDraggable: r,
      isRemovable: c,
      disabled: o,
      as: i ? je : "span",
      ...s,
      children: i ? a : /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
        r && /* @__PURE__ */ h.jsx(Tl, {}),
        a
      ] })
    }
  ) });
}), Dl = A.forwardRef(function(t, n) {
  const { setIsRemovable: r, disabled: o } = A.useContext(Rl);
  return A.useEffect(() => (r(!0), () => {
    r(!1);
  }), []), /* @__PURE__ */ h.jsx(lg, { ref: n, disabled: o, type: "button", ...t, children: /* @__PURE__ */ h.jsx(Pl, {}) });
}), TI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DragIndicator: Tl,
  Remove: Dl,
  Root: Ml
}, Symbol.toStringTag, { value: "Module" })), ug = k("text", {
  fontFamily: "$base",
  textAnchor: "middle",
  fill: "$uiPrimaryMain",
  userSelect: "none"
}), dg = "svg", fg = k(dg, {
  $$fill: "$colors$uiPrimaryMain",
  $$background: "transparent",
  variants: {
    /** Color variant */
    context: {
      primary: {},
      success: {
        $$fill: "$colors$$uiSuccessMain",
        $$background: "$colors$uiSuccess25"
      },
      error: {
        $$fill: "$colors$uiErrorMain",
        $$background: "$colors$uiError25"
      },
      attention: {
        $$fill: "$colors$uiAttentionMain",
        $$background: "$colors$uiAttention25"
      },
      disabled: {
        $$fill: "$colors$uiDisabledMain",
        $$background: "$colors$uiDisabled25"
      },
      monochrome: {
        $$fill: "$colors$uiMonochromeMain",
        $$background: "$colors$uiMonochrome25"
      }
    },
    variant: {
      determinate: {},
      indeterminate: {}
    }
  }
}), pg = k("circle", {
  stroke: "$$background",
  fill: "transparent",
  cx: "50%",
  cy: "50%"
}), bg = Lt({
  from: {
    transform: "rotate(0)"
  },
  to: {
    transform: "rotate(360deg)"
  }
}), gg = k("circle", {
  transition: "0.35s stroke-dashoffset",
  transform: "rotate(-90deg)",
  transformOrigin: "50% 50%",
  stroke: "$$fill",
  fill: "transparent",
  cx: "50%",
  cy: "50%",
  variants: {
    variant: {
      indeterminate: {
        animation: `${bg} 1s linear infinite`
      },
      determinate: {}
    }
  }
}), Ol = A.createContext({
  size: 0
}), Gr = A.forwardRef((e, t) => {
  const {
    children: n,
    value: r = 50,
    maxValue: o = 100,
    size: a = 120,
    strokeWidth: i = 0.055 * a,
    style: s = {},
    variant: c = "determinate",
    ...l
  } = e, d = (a - i) / 2, u = d * 2 * Math.PI, [f, p] = J(u);
  Z(() => {
    const m = c === "indeterminate" ? Math.round(0.25 * o) : r;
    p(u - m / o * u);
  }, [r, a, c, o]);
  const g = {
    strokeDashoffset: 0,
    strokeWidth: Math.max(i, 2)
  }, b = {
    strokeDasharray: `${u} ${u}`,
    strokeDashoffset: `${f}`,
    strokeLinecap: "round",
    strokeWidth: Math.max(i, 2)
  };
  return /* @__PURE__ */ h.jsxs(fg, { ...l, ref: t, style: { ...s, height: a, width: a }, children: [
    /* @__PURE__ */ h.jsx(pg, { style: g, r: d }),
    /* @__PURE__ */ h.jsx(gg, { style: b, r: d, variant: c }),
    /* @__PURE__ */ h.jsx(Ol.Provider, { value: { size: a }, children: n })
  ] });
});
Gr.displayName = "CircularProgress";
const $a = A.forwardRef(
  function(t, n) {
    const { size: r } = A.useContext(Ol);
    return /* @__PURE__ */ h.jsx(ug, { x: "50%", y: "50%", dy: ".35em", fontSize: r / 2 - 4, ...t, ref: n });
  }
), RI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CircularProgress: Gr,
  CircularProgressText: $a,
  Root: Gr,
  Text: $a
}, Symbol.toStringTag, { value: "Module" })), Fl = {
  width: "100%",
  display: "inline-block",
  border: "none",
  borderBlockEnd: "1px $divider solid",
  variants: {
    variant: {
      vertical: {
        width: 1,
        height: "100%",
        borderRight: "1px $divider solid",
        margin: 0
      }
    }
  }
}, MI = k("hr", Fl), ai = {
  regular: {
    fontWeight: "$regular"
  },
  bold: {
    fontWeight: "$bold"
  },
  black: {
    fontWeight: "$black"
  }
}, pt = k("p", {
  margin: 0,
  color: "$textPrimaryMain",
  fontFamily: "$base",
  variants: {
    variant: {
      body: {
        fontSize: "$bodyText",
        letterSpacing: "$loose",
        lineHeight: 1.4
      },
      caption: {
        fontSize: "$caption",
        letterSpacing: "$loose1",
        lineHeight: 1.4,
        display: "inline-block"
      }
    },
    weight: { ...ai }
  },
  defaultVariants: {
    variant: "body",
    weight: "regular"
  }
}), mg = k(pt, {
  display: "inline-grid",
  gridTemplateColumns: "max-content auto",
  placeItems: "center start",
  gridColumnGap: "$base",
  verticalAlign: "middle",
  cursor: "default"
}), DI = A.forwardRef(
  function({ asChild: t, children: n, ...r }, o) {
    return /* @__PURE__ */ h.jsx(mg, { as: t ? je : "label", ...r, ref: o, children: n });
  }
), hg = k("input", {
  borderRadius: "$base",
  padding: "0.625rem 1rem",
  border: "1px solid $brandPrimary25",
  backgroundColor: "transparent",
  transition: "all 0.3s ease-in",
  fontFamily: "$base",
  fontSize: "$bodyText",
  width: "100%",
  color: "$textPrimaryMain",
  borderWidth: 1,
  borderStyle: "solid",
  boxSizing: "border-box",
  '&[type="search"]::-webkit-search-decoration': {
    appearance: "none"
  },
  '&[type="search"]::-webkit-search-cancel-button': {
    appearance: "none"
  },
  '&[type="search"]::-webkit-search-results-button': {
    appearance: "none"
  },
  '&[type="search"]::-webkit-search-results-decoration': {
    appearance: "none"
  },
  "&:hover": {
    boxShadow: "$1"
  },
  "&:focus": {
    outline: "none",
    borderColor: "$brandPrimaryMain",
    boxShadow: "$1"
  },
  "&:active": {
    boxShadow: "none"
  },
  "&[disabled]": {
    borderColor: "$uiDisabledMain",
    pointerEvents: "none",
    opacity: 0.3,
    color: "$textPrimary30"
  },
  variants: {
    error: {
      true: {
        borderColor: "$uiError25",
        "&:focus": {
          borderColor: "$uiErrorMain"
        }
      },
      false: {}
    },
    hasIcon: {
      true: {
        padding: "0.625rem 2.5rem 0.625rem 1rem"
      }
    }
  }
});
hg.displayName = "Input";
const OI = k("label", {
  fontSize: "$bodyText",
  fontFamily: "$base",
  color: "$uiPrimaryMain",
  br: "$base",
  variants: {
    disabled: {
      true: {
        color: "$uiDisabled50"
      }
    },
    error: {
      true: {
        color: "$textError"
      }
    },
    raised: {
      true: {
        fontSize: "0.75rem"
      }
    }
  }
}), vg = tn({
  display: "grid",
  gridTemplateColumns: "max-content 1fr",
  columnGap: "$base"
}), $g = tn({
  display: "grid",
  gridTemplateColumns: "1fr max-content",
  columnGap: "$base"
}), xg = tn({
  display: "grid",
  gridTemplateColumns: "max-content 1fr max-content",
  columnGap: "$base"
}), FI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  stylesWithEndIcon: $g,
  stylesWithStartAndEndIcons: xg,
  stylesWithStartIcon: vg
}, Symbol.toStringTag, { value: "Module" })), yg = k("ul", {
  padding: 0,
  margin: 0,
  display: "grid",
  listStyle: "none",
  variants: {
    /** Sets the orientation of the list */
    orientation: {
      vertical: {
        rowGap: "0.25rem",
        gridAutoFlow: "row"
      },
      horizontal: {
        columnGap: "0.25rem",
        gridAutoFlow: "column"
      }
    }
  },
  defaultVariants: {
    orientation: "vertical"
  }
}), Cg = k("li", {
  // Reset
  appearance: "none",
  borderWidth: "0",
  px: "$base",
  fontWeight: "$regular",
  fontFamily: "$base",
  color: "$textPrimary70",
  cursor: "default",
  transition: "font-weight 0.2s ease, background-color 0.2s ease",
  textAlign: "start",
  background: "none",
  fontSize: "$bodyText",
  display: "inline-block",
  letterSpacing: "$loose",
  lineHeight: 20 / 14,
  // Figma line height in px / Figma font size
  '&:hover, &:focus, &[data-focused="true"]': {
    backgroundColor: "$uiPrimary16A",
    color: "$textPrimaryMain",
    outline: "none"
  },
  variants: {
    /**
     Sets styles according to the passed state.
     If you attach any logic to it, like onClick, you still need to handle the case of state === 'disabled' in the onClick handler.
     */
    state: {
      selected: {
        color: "$uiPrimaryMain",
        fontWeight: "$bold",
        bgc: "$uiPrimary25",
        '&:hover, &:focus, &[data-focused="true"]': {
          color: "$uiPrimaryMain",
          bgc: "$uiPrimary25"
        }
      },
      disabled: {
        opacity: 0.3
      }
    },
    /** Sets cursor: pointer CSS rule to the element. */
    clickable: {
      true: {
        cursor: "pointer"
      },
      false: {}
    },
    /** Sets different amount of inner padding to the element. */
    density: {
      default: {
        py: "0.625rem"
      },
      compact: {
        py: "0.375rem"
      },
      comfortable: {
        py: "0.75rem"
      }
    },
    /** Removes the corner radius when "square" */
    roundness: {
      square: {
        borderRadius: "0"
      },
      round: {
        borderRadius: "$base"
      }
    },
    twoLine: {
      true: {}
    }
  },
  compoundVariants: [
    {
      density: "default",
      twoLine: "true",
      css: {
        py: "$base"
      }
    }
  ],
  defaultVariants: {
    density: "default",
    roundness: "round"
  }
}), wg = Lt({
  "0%": { transform: "rotate(0deg)" },
  "100%": { transform: "rotate(360deg)" }
}), kI = k("div", {
  border: "2px solid rgba(0, 0, 0, 0.16)",
  borderTop: "2px solid $brandPrimaryMain",
  br: "50%",
  width: 16,
  height: 16,
  animation: `${wg} 2s linear infinite`
}), Ig = "span", Sg = k(Ig, {
  // Reset
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  appearance: "none",
  borderWidth: "0",
  boxSizing: "border-box",
  flexShrink: 0,
  fontFamily: "$base",
  lineHeight: "normal",
  padding: "calc($base / 4) $base",
  borderRadius: "$base",
  fontSize: "0.5625rem",
  letterSpacing: "$loose1",
  fontWeight: "$bold",
  textDecoration: "none",
  textTransform: "uppercase",
  userSelect: "none",
  color: "$textAlwaysLightMain",
  bgc: "$$colorBackground",
  variants: {
    /** The background color of the badge */
    color: {
      primary: {
        $$colorBackground: "$colors$uiPrimaryMain"
      },
      success: {
        $$colorBackground: "$colors$uiSuccessMain"
      },
      attention: {
        $$colorBackground: "$colors$uiAttentionMain"
      },
      error: {
        $$colorBackground: "$colors$uiErrorMain"
      },
      // TODO: Maybe map to a theme color when designers define it
      neutral: {
        $$colorBackground: "#999999"
      },
      // TODO: Come up with a better name and theme color once designers define it
      purple: {
        $$colorBackground: "#7B3EFE"
      },
      magenta: {
        // TODO: Maybe map to a theme color when designers define it
        $$colorBackground: "#FE3E83"
      }
    }
  },
  defaultVariants: {
    color: "neutral"
  }
});
Sg.displayName = "Tag";
function Gn(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function As(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function re(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? As(Object(n), !0).forEach(function(r) {
      Gn(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : As(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ag(e) {
  if (Array.isArray(e))
    return e;
}
function Eg(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], o = !0, a = !1, i, s;
    try {
      for (n = n.call(e); !(o = (i = n.next()).done) && (r.push(i.value), !(t && r.length === t)); o = !0)
        ;
    } catch (c) {
      a = !0, s = c;
    } finally {
      try {
        !o && n.return != null && n.return();
      } finally {
        if (a)
          throw s;
      }
    }
    return r;
  }
}
function xa(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function kl(e, t) {
  if (e) {
    if (typeof e == "string")
      return xa(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return xa(e, t);
  }
}
function Pg() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wt(e, t) {
  return Ag(e) || Eg(e, t) || kl(e, t) || Pg();
}
function Tg(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function Tt(e, t) {
  if (e == null)
    return {};
  var n = Tg(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      r = a[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
var Rg = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function Mg(e) {
  var t = e.defaultInputValue, n = t === void 0 ? "" : t, r = e.defaultMenuIsOpen, o = r === void 0 ? !1 : r, a = e.defaultValue, i = a === void 0 ? null : a, s = e.inputValue, c = e.menuIsOpen, l = e.onChange, d = e.onInputChange, u = e.onMenuClose, f = e.onMenuOpen, p = e.value, g = Tt(e, Rg), b = J(s !== void 0 ? s : n), m = wt(b, 2), v = m[0], $ = m[1], x = J(c !== void 0 ? c : o), w = wt(x, 2), C = w[0], P = w[1], E = J(p !== void 0 ? p : i), T = wt(E, 2), F = T[0], V = T[1], _ = K(function(ee, z) {
    typeof l == "function" && l(ee, z), V(ee);
  }, [l]), W = K(function(ee, z) {
    var oe;
    typeof d == "function" && (oe = d(ee, z)), $(oe !== void 0 ? oe : ee);
  }, [d]), H = K(function() {
    typeof f == "function" && f(), P(!0);
  }, [f]), D = K(function() {
    typeof u == "function" && u(), P(!1);
  }, [u]), M = s !== void 0 ? s : v, j = c !== void 0 ? c : C, U = p !== void 0 ? p : F;
  return re(re({}, g), {}, {
    inputValue: M,
    menuIsOpen: j,
    onChange: _,
    onInputChange: W,
    onMenuClose: D,
    onMenuOpen: H,
    value: U
  });
}
function Dg(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Es(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Og(e, t, n) {
  return t && Es(e.prototype, t), n && Es(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function ya(e, t) {
  return ya = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, ya(e, t);
}
function Fg(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && ya(e, t);
}
function Wr(e) {
  return Wr = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Wr(e);
}
function kg() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function jr(e) {
  "@babel/helpers - typeof";
  return jr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, jr(e);
}
function Ng(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _g(e, t) {
  if (t && (jr(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ng(e);
}
function Lg(e) {
  var t = kg();
  return function() {
    var r = Wr(e), o;
    if (t) {
      var a = Wr(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return _g(this, o);
  };
}
function Bg(e) {
  if (Array.isArray(e))
    return xa(e);
}
function Vg(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Gg() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ii(e) {
  return Bg(e) || Vg(e) || kl(e) || Gg();
}
function Wg(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function jg(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var zg = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(o) {
      var a;
      r.tags.length === 0 ? r.insertionPoint ? a = r.insertionPoint.nextSibling : r.prepend ? a = r.container.firstChild : a = r.before : a = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(o, a), r.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(jg(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var a = r.charCodeAt(0) === 64 && r.charCodeAt(1) === 105;
      a && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + r + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !a;
    }
    if (this.isSpeedy) {
      var i = Wg(o);
      try {
        i.insertRule(r, i.cssRules.length);
      } catch (s) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(r) && console.error('There was a problem inserting the following rule: "' + r + '"', s);
      }
    } else
      o.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      return r.parentNode && r.parentNode.removeChild(r);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), He = "-ms-", zr = "-moz-", me = "-webkit-", si = "comm", ci = "rule", li = "decl", Hg = "@import", Nl = "@keyframes", Xg = "@layer", Zg = Math.abs, fo = String.fromCharCode, Yg = Object.assign;
function Ug(e, t) {
  return ze(e, 0) ^ 45 ? (((t << 2 ^ ze(e, 0)) << 2 ^ ze(e, 1)) << 2 ^ ze(e, 2)) << 2 ^ ze(e, 3) : 0;
}
function _l(e) {
  return e.trim();
}
function Jg(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function he(e, t, n) {
  return e.replace(t, n);
}
function Ca(e, t) {
  return e.indexOf(t);
}
function ze(e, t) {
  return e.charCodeAt(t) | 0;
}
function jn(e, t, n) {
  return e.slice(t, n);
}
function mt(e) {
  return e.length;
}
function ui(e) {
  return e.length;
}
function hr(e, t) {
  return t.push(e), e;
}
function Qg(e, t) {
  return e.map(t).join("");
}
var po = 1, Cn = 1, Ll = 0, et = 0, ke = 0, Sn = "";
function bo(e, t, n, r, o, a, i) {
  return { value: e, root: t, parent: n, type: r, props: o, children: a, line: po, column: Cn, length: i, return: "" };
}
function On(e, t) {
  return Yg(bo("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function Kg() {
  return ke;
}
function qg() {
  return ke = et > 0 ? ze(Sn, --et) : 0, Cn--, ke === 10 && (Cn = 1, po--), ke;
}
function rt() {
  return ke = et < Ll ? ze(Sn, et++) : 0, Cn++, ke === 10 && (Cn = 1, po++), ke;
}
function $t() {
  return ze(Sn, et);
}
function Rr() {
  return et;
}
function rr(e, t) {
  return jn(Sn, e, t);
}
function zn(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Bl(e) {
  return po = Cn = 1, Ll = mt(Sn = e), et = 0, [];
}
function Vl(e) {
  return Sn = "", e;
}
function Mr(e) {
  return _l(rr(et - 1, wa(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function em(e) {
  for (; (ke = $t()) && ke < 33; )
    rt();
  return zn(e) > 2 || zn(ke) > 3 ? "" : " ";
}
function tm(e, t) {
  for (; --t && rt() && !(ke < 48 || ke > 102 || ke > 57 && ke < 65 || ke > 70 && ke < 97); )
    ;
  return rr(e, Rr() + (t < 6 && $t() == 32 && rt() == 32));
}
function wa(e) {
  for (; rt(); )
    switch (ke) {
      case e:
        return et;
      case 34:
      case 39:
        e !== 34 && e !== 39 && wa(ke);
        break;
      case 40:
        e === 41 && wa(e);
        break;
      case 92:
        rt();
        break;
    }
  return et;
}
function nm(e, t) {
  for (; rt() && e + ke !== 47 + 10; )
    if (e + ke === 42 + 42 && $t() === 47)
      break;
  return "/*" + rr(t, et - 1) + "*" + fo(e === 47 ? e : rt());
}
function rm(e) {
  for (; !zn($t()); )
    rt();
  return rr(e, et);
}
function om(e) {
  return Vl(Dr("", null, null, null, [""], e = Bl(e), 0, [0], e));
}
function Dr(e, t, n, r, o, a, i, s, c) {
  for (var l = 0, d = 0, u = i, f = 0, p = 0, g = 0, b = 1, m = 1, v = 1, $ = 0, x = "", w = o, C = a, P = r, E = x; m; )
    switch (g = $, $ = rt()) {
      case 40:
        if (g != 108 && ze(E, u - 1) == 58) {
          Ca(E += he(Mr($), "&", "&\f"), "&\f") != -1 && (v = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        E += Mr($);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        E += em(g);
        break;
      case 92:
        E += tm(Rr() - 1, 7);
        continue;
      case 47:
        switch ($t()) {
          case 42:
          case 47:
            hr(am(nm(rt(), Rr()), t, n), c);
            break;
          default:
            E += "/";
        }
        break;
      case 123 * b:
        s[l++] = mt(E) * v;
      case 125 * b:
      case 59:
      case 0:
        switch ($) {
          case 0:
          case 125:
            m = 0;
          case 59 + d:
            v == -1 && (E = he(E, /\f/g, "")), p > 0 && mt(E) - u && hr(p > 32 ? Ts(E + ";", r, n, u - 1) : Ts(he(E, " ", "") + ";", r, n, u - 2), c);
            break;
          case 59:
            E += ";";
          default:
            if (hr(P = Ps(E, t, n, l, d, o, s, x, w = [], C = [], u), a), $ === 123)
              if (d === 0)
                Dr(E, t, P, P, w, a, u, s, C);
              else
                switch (f === 99 && ze(E, 3) === 110 ? 100 : f) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Dr(e, P, P, r && hr(Ps(e, P, P, 0, 0, o, s, x, o, w = [], u), C), o, C, u, s, r ? w : C);
                    break;
                  default:
                    Dr(E, P, P, P, [""], C, 0, s, C);
                }
        }
        l = d = p = 0, b = v = 1, x = E = "", u = i;
        break;
      case 58:
        u = 1 + mt(E), p = g;
      default:
        if (b < 1) {
          if ($ == 123)
            --b;
          else if ($ == 125 && b++ == 0 && qg() == 125)
            continue;
        }
        switch (E += fo($), $ * b) {
          case 38:
            v = d > 0 ? 1 : (E += "\f", -1);
            break;
          case 44:
            s[l++] = (mt(E) - 1) * v, v = 1;
            break;
          case 64:
            $t() === 45 && (E += Mr(rt())), f = $t(), d = u = mt(x = E += rm(Rr())), $++;
            break;
          case 45:
            g === 45 && mt(E) == 2 && (b = 0);
        }
    }
  return a;
}
function Ps(e, t, n, r, o, a, i, s, c, l, d) {
  for (var u = o - 1, f = o === 0 ? a : [""], p = ui(f), g = 0, b = 0, m = 0; g < r; ++g)
    for (var v = 0, $ = jn(e, u + 1, u = Zg(b = i[g])), x = e; v < p; ++v)
      (x = _l(b > 0 ? f[v] + " " + $ : he($, /&\f/g, f[v]))) && (c[m++] = x);
  return bo(e, t, n, o === 0 ? ci : s, c, l, d);
}
function am(e, t, n) {
  return bo(e, t, n, si, fo(Kg()), jn(e, 2, -2), 0);
}
function Ts(e, t, n, r) {
  return bo(e, t, n, li, jn(e, 0, r), jn(e, r + 1, -1), r);
}
function xn(e, t) {
  for (var n = "", r = ui(e), o = 0; o < r; o++)
    n += t(e[o], o, e, t) || "";
  return n;
}
function im(e, t, n, r) {
  switch (e.type) {
    case Xg:
      if (e.children.length)
        break;
    case Hg:
    case li:
      return e.return = e.return || e.value;
    case si:
      return "";
    case Nl:
      return e.return = e.value + "{" + xn(e.children, r) + "}";
    case ci:
      e.value = e.props.join(",");
  }
  return mt(n = xn(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function sm(e) {
  var t = ui(e);
  return function(n, r, o, a) {
    for (var i = "", s = 0; s < t; s++)
      i += e[s](n, r, o, a) || "";
    return i;
  };
}
function cm(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function lm(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var um = function(t, n, r) {
  for (var o = 0, a = 0; o = a, a = $t(), o === 38 && a === 12 && (n[r] = 1), !zn(a); )
    rt();
  return rr(t, et);
}, dm = function(t, n) {
  var r = -1, o = 44;
  do
    switch (zn(o)) {
      case 0:
        o === 38 && $t() === 12 && (n[r] = 1), t[r] += um(et - 1, n, r);
        break;
      case 2:
        t[r] += Mr(o);
        break;
      case 4:
        if (o === 44) {
          t[++r] = $t() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      default:
        t[r] += fo(o);
    }
  while (o = rt());
  return t;
}, fm = function(t, n) {
  return Vl(dm(Bl(t), n));
}, Rs = /* @__PURE__ */ new WeakMap(), pm = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, r = t.parent, o = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r)
        return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !Rs.get(r)) && !o) {
      Rs.set(t, !0);
      for (var a = [], i = fm(n, a), s = r.props, c = 0, l = 0; c < i.length; c++)
        for (var d = 0; d < s.length; d++, l++)
          t.props[l] = a[c] ? i[c].replace(/&\f/g, s[d]) : s[d] + " " + i[c];
    }
  }
}, bm = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
}, gm = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", mm = function(t) {
  return t.type === "comm" && t.children.indexOf(gm) > -1;
}, hm = function(t) {
  return function(n, r, o) {
    if (!(n.type !== "rule" || t.compat)) {
      var a = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (a) {
        for (var i = !!n.parent, s = i ? n.parent.children : (
          // global rule at the root level
          o
        ), c = s.length - 1; c >= 0; c--) {
          var l = s[c];
          if (l.line < n.line)
            break;
          if (l.column < n.column) {
            if (mm(l))
              return;
            break;
          }
        }
        a.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, Gl = function(t) {
  return t.type.charCodeAt(1) === 105 && t.type.charCodeAt(0) === 64;
}, vm = function(t, n) {
  for (var r = t - 1; r >= 0; r--)
    if (!Gl(n[r]))
      return !0;
  return !1;
}, Ms = function(t) {
  t.type = "", t.value = "", t.return = "", t.children = "", t.props = "";
}, $m = function(t, n, r) {
  Gl(t) && (t.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Ms(t)) : vm(n, r) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Ms(t)));
};
function Wl(e, t) {
  switch (Ug(e, t)) {
    case 5103:
      return me + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return me + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return me + e + zr + e + He + e + e;
    case 6828:
    case 4268:
      return me + e + He + e + e;
    case 6165:
      return me + e + He + "flex-" + e + e;
    case 5187:
      return me + e + he(e, /(\w+).+(:[^]+)/, me + "box-$1$2" + He + "flex-$1$2") + e;
    case 5443:
      return me + e + He + "flex-item-" + he(e, /flex-|-self/, "") + e;
    case 4675:
      return me + e + He + "flex-line-pack" + he(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return me + e + He + he(e, "shrink", "negative") + e;
    case 5292:
      return me + e + He + he(e, "basis", "preferred-size") + e;
    case 6060:
      return me + "box-" + he(e, "-grow", "") + me + e + He + he(e, "grow", "positive") + e;
    case 4554:
      return me + he(e, /([^-])(transform)/g, "$1" + me + "$2") + e;
    case 6187:
      return he(he(he(e, /(zoom-|grab)/, me + "$1"), /(image-set)/, me + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return he(e, /(image-set\([^]*)/, me + "$1$`$1");
    case 4968:
      return he(he(e, /(.+:)(flex-)?(.*)/, me + "box-pack:$3" + He + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + me + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return he(e, /(.+)-inline(.+)/, me + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (mt(e) - 1 - t > 6)
        switch (ze(e, t + 1)) {
          case 109:
            if (ze(e, t + 4) !== 45)
              break;
          case 102:
            return he(e, /(.+:)(.+)-([^]+)/, "$1" + me + "$2-$3$1" + zr + (ze(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~Ca(e, "stretch") ? Wl(he(e, "stretch", "fill-available"), t) + e : e;
        }
      break;
    case 4949:
      if (ze(e, t + 1) !== 115)
        break;
    case 6444:
      switch (ze(e, mt(e) - 3 - (~Ca(e, "!important") && 10))) {
        case 107:
          return he(e, ":", ":" + me) + e;
        case 101:
          return he(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + me + (ze(e, 14) === 45 ? "inline-" : "") + "box$3$1" + me + "$2$3$1" + He + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (ze(e, t + 11)) {
        case 114:
          return me + e + He + he(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return me + e + He + he(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return me + e + He + he(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return me + e + He + e + e;
  }
  return e;
}
var xm = function(t, n, r, o) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case li:
        t.return = Wl(t.value, t.length);
        break;
      case Nl:
        return xn([On(t, {
          value: he(t.value, "@", "@" + me)
        })], o);
      case ci:
        if (t.length)
          return Qg(t.props, function(a) {
            switch (Jg(a, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return xn([On(t, {
                  props: [he(a, /:(read-\w+)/, ":" + zr + "$1")]
                })], o);
              case "::placeholder":
                return xn([On(t, {
                  props: [he(a, /:(plac\w+)/, ":" + me + "input-$1")]
                }), On(t, {
                  props: [he(a, /:(plac\w+)/, ":" + zr + "$1")]
                }), On(t, {
                  props: [he(a, /:(plac\w+)/, He + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, ym = [xm], Cm = function(t) {
  var n = t.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(b) {
      var m = b.getAttribute("data-emotion");
      m.indexOf(" ") !== -1 && (document.head.appendChild(b), b.setAttribute("data-s", ""));
    });
  }
  var o = t.stylisPlugins || ym;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var a = {}, i, s = [];
  i = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(b) {
      for (var m = b.getAttribute("data-emotion").split(" "), v = 1; v < m.length; v++)
        a[m[v]] = !0;
      s.push(b);
    }
  );
  var c, l = [pm, bm];
  process.env.NODE_ENV !== "production" && l.push(hm({
    get compat() {
      return g.compat;
    }
  }), $m);
  {
    var d, u = [im, process.env.NODE_ENV !== "production" ? function(b) {
      b.root || (b.return ? d.insert(b.return) : b.value && b.type !== si && d.insert(b.value + "{}"));
    } : cm(function(b) {
      d.insert(b);
    })], f = sm(l.concat(o, u)), p = function(m) {
      return xn(om(m), f);
    };
    c = function(m, v, $, x) {
      d = $, process.env.NODE_ENV !== "production" && v.map !== void 0 && (d = {
        insert: function(C) {
          $.insert(C + v.map);
        }
      }), p(m ? m + "{" + v.styles + "}" : v.styles), x && (g.inserted[v.name] = !0);
    };
  }
  var g = {
    key: n,
    sheet: new zg({
      key: n,
      container: i,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: a,
    registered: {},
    insert: c
  };
  return g.sheet.hydrate(s), g;
}, Ia = { exports: {} }, ve = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ds;
function wm() {
  if (Ds)
    return ve;
  Ds = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, $ = e ? Symbol.for("react.scope") : 60119;
  function x(C) {
    if (typeof C == "object" && C !== null) {
      var P = C.$$typeof;
      switch (P) {
        case t:
          switch (C = C.type, C) {
            case c:
            case l:
            case r:
            case a:
            case o:
            case u:
              return C;
            default:
              switch (C = C && C.$$typeof, C) {
                case s:
                case d:
                case g:
                case p:
                case i:
                  return C;
                default:
                  return P;
              }
          }
        case n:
          return P;
      }
    }
  }
  function w(C) {
    return x(C) === l;
  }
  return ve.AsyncMode = c, ve.ConcurrentMode = l, ve.ContextConsumer = s, ve.ContextProvider = i, ve.Element = t, ve.ForwardRef = d, ve.Fragment = r, ve.Lazy = g, ve.Memo = p, ve.Portal = n, ve.Profiler = a, ve.StrictMode = o, ve.Suspense = u, ve.isAsyncMode = function(C) {
    return w(C) || x(C) === c;
  }, ve.isConcurrentMode = w, ve.isContextConsumer = function(C) {
    return x(C) === s;
  }, ve.isContextProvider = function(C) {
    return x(C) === i;
  }, ve.isElement = function(C) {
    return typeof C == "object" && C !== null && C.$$typeof === t;
  }, ve.isForwardRef = function(C) {
    return x(C) === d;
  }, ve.isFragment = function(C) {
    return x(C) === r;
  }, ve.isLazy = function(C) {
    return x(C) === g;
  }, ve.isMemo = function(C) {
    return x(C) === p;
  }, ve.isPortal = function(C) {
    return x(C) === n;
  }, ve.isProfiler = function(C) {
    return x(C) === a;
  }, ve.isStrictMode = function(C) {
    return x(C) === o;
  }, ve.isSuspense = function(C) {
    return x(C) === u;
  }, ve.isValidElementType = function(C) {
    return typeof C == "string" || typeof C == "function" || C === r || C === l || C === a || C === o || C === u || C === f || typeof C == "object" && C !== null && (C.$$typeof === g || C.$$typeof === p || C.$$typeof === i || C.$$typeof === s || C.$$typeof === d || C.$$typeof === m || C.$$typeof === v || C.$$typeof === $ || C.$$typeof === b);
  }, ve.typeOf = x, ve;
}
var $e = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Os;
function Im() {
  return Os || (Os = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, $ = e ? Symbol.for("react.scope") : 60119;
    function x(X) {
      return typeof X == "string" || typeof X == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      X === r || X === l || X === a || X === o || X === u || X === f || typeof X == "object" && X !== null && (X.$$typeof === g || X.$$typeof === p || X.$$typeof === i || X.$$typeof === s || X.$$typeof === d || X.$$typeof === m || X.$$typeof === v || X.$$typeof === $ || X.$$typeof === b);
    }
    function w(X) {
      if (typeof X == "object" && X !== null) {
        var Ve = X.$$typeof;
        switch (Ve) {
          case t:
            var Ze = X.type;
            switch (Ze) {
              case c:
              case l:
              case r:
              case a:
              case o:
              case u:
                return Ze;
              default:
                var Pe = Ze && Ze.$$typeof;
                switch (Pe) {
                  case s:
                  case d:
                  case g:
                  case p:
                  case i:
                    return Pe;
                  default:
                    return Ve;
                }
            }
          case n:
            return Ve;
        }
      }
    }
    var C = c, P = l, E = s, T = i, F = t, V = d, _ = r, W = g, H = p, D = n, M = a, j = o, U = u, ee = !1;
    function z(X) {
      return ee || (ee = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), oe(X) || w(X) === c;
    }
    function oe(X) {
      return w(X) === l;
    }
    function le(X) {
      return w(X) === s;
    }
    function ie(X) {
      return w(X) === i;
    }
    function fe(X) {
      return typeof X == "object" && X !== null && X.$$typeof === t;
    }
    function Ae(X) {
      return w(X) === d;
    }
    function Re(X) {
      return w(X) === r;
    }
    function B(X) {
      return w(X) === g;
    }
    function ue(X) {
      return w(X) === p;
    }
    function we(X) {
      return w(X) === n;
    }
    function ce(X) {
      return w(X) === a;
    }
    function Le(X) {
      return w(X) === o;
    }
    function Je(X) {
      return w(X) === u;
    }
    $e.AsyncMode = C, $e.ConcurrentMode = P, $e.ContextConsumer = E, $e.ContextProvider = T, $e.Element = F, $e.ForwardRef = V, $e.Fragment = _, $e.Lazy = W, $e.Memo = H, $e.Portal = D, $e.Profiler = M, $e.StrictMode = j, $e.Suspense = U, $e.isAsyncMode = z, $e.isConcurrentMode = oe, $e.isContextConsumer = le, $e.isContextProvider = ie, $e.isElement = fe, $e.isForwardRef = Ae, $e.isFragment = Re, $e.isLazy = B, $e.isMemo = ue, $e.isPortal = we, $e.isProfiler = ce, $e.isStrictMode = Le, $e.isSuspense = Je, $e.isValidElementType = x, $e.typeOf = w;
  }()), $e;
}
process.env.NODE_ENV === "production" ? Ia.exports = wm() : Ia.exports = Im();
var Sm = Ia.exports, jl = Sm, Am = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Em = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, zl = {};
zl[jl.ForwardRef] = Am;
zl[jl.Memo] = Em;
var Pm = !0;
function Hl(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? t.push(e[o] + ";") : r += o + " ";
  }), r;
}
var di = function(t, n, r) {
  var o = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Pm === !1) && t.registered[o] === void 0 && (t.registered[o] = n.styles);
}, fi = function(t, n, r) {
  di(t, n, r);
  var o = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var a = n;
    do
      t.insert(n === a ? "." + o : "", a, t.sheet, !0), a = a.next;
    while (a !== void 0);
  }
};
function Tm(e) {
  for (var t = 0, n, r = 0, o = e.length; o >= 4; ++r, o -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Rm = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Fs = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Mm = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Dm = /[A-Z]|^ms/g, Xl = /_EMO_([^_]+?)_([^]*?)_EMO_/g, pi = function(t) {
  return t.charCodeAt(1) === 45;
}, ks = function(t) {
  return t != null && typeof t != "boolean";
}, Zo = /* @__PURE__ */ lm(function(e) {
  return pi(e) ? e : e.replace(Dm, "-$&").toLowerCase();
}), Hr = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(Xl, function(r, o, a) {
          return lt = {
            name: o,
            styles: a,
            next: lt
          }, o;
        });
  }
  return Rm[t] !== 1 && !pi(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var Om = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, Fm = ["normal", "none", "initial", "inherit", "unset"], km = Hr, Nm = /^-ms-/, _m = /-(.)/g, Ns = {};
  Hr = function(t, n) {
    if (t === "content" && (typeof n != "string" || Fm.indexOf(n) === -1 && !Om.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var r = km(t, n);
    return r !== "" && !pi(t) && t.indexOf("-") !== -1 && Ns[t] === void 0 && (Ns[t] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + t.replace(Nm, "ms-").replace(_m, function(o, a) {
      return a.toUpperCase();
    }) + "?")), r;
  };
}
var Zl = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Hn(e, t, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(Zl);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return lt = {
          name: n.name,
          styles: n.styles,
          next: lt
        }, n.name;
      if (n.styles !== void 0) {
        var r = n.next;
        if (r !== void 0)
          for (; r !== void 0; )
            lt = {
              name: r.name,
              styles: r.styles,
              next: lt
            }, r = r.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return Lm(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var a = lt, i = n(e);
        return lt = a, Hn(e, t, i);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var s = [], c = n.replace(Xl, function(d, u, f) {
          var p = "animation" + s.length;
          return s.push("const " + p + " = keyframes`" + f.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + p + "}";
        });
        s.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(s, ["`" + c + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + c + "`"));
      }
      break;
  }
  if (t == null)
    return n;
  var l = t[n];
  return l !== void 0 ? l : n;
}
function Lm(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      r += Hn(e, t, n[o]) + ";";
  else
    for (var a in n) {
      var i = n[a];
      if (typeof i != "object")
        t != null && t[i] !== void 0 ? r += a + "{" + t[i] + "}" : ks(i) && (r += Zo(a) + ":" + Hr(a, i) + ";");
      else {
        if (a === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(Zl);
        if (Array.isArray(i) && typeof i[0] == "string" && (t == null || t[i[0]] === void 0))
          for (var s = 0; s < i.length; s++)
            ks(i[s]) && (r += Zo(a) + ":" + Hr(a, i[s]) + ";");
        else {
          var c = Hn(e, t, i);
          switch (a) {
            case "animation":
            case "animationName": {
              r += Zo(a) + ":" + c + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && a === "undefined" && console.error(Mm), r += a + "{" + c + "}";
          }
        }
      }
    }
  return r;
}
var _s = /label:\s*([^\s;\n{]+)\s*(;|$)/g, Yl;
process.env.NODE_ENV !== "production" && (Yl = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var lt, Xn = function(t, n, r) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var o = !0, a = "";
  lt = void 0;
  var i = t[0];
  i == null || i.raw === void 0 ? (o = !1, a += Hn(r, n, i)) : (process.env.NODE_ENV !== "production" && i[0] === void 0 && console.error(Fs), a += i[0]);
  for (var s = 1; s < t.length; s++)
    a += Hn(r, n, t[s]), o && (process.env.NODE_ENV !== "production" && i[s] === void 0 && console.error(Fs), a += i[s]);
  var c;
  process.env.NODE_ENV !== "production" && (a = a.replace(Yl, function(f) {
    return c = f, "";
  })), _s.lastIndex = 0;
  for (var l = "", d; (d = _s.exec(a)) !== null; )
    l += "-" + // $FlowFixMe we know it's not null
    d[1];
  var u = Tm(a) + l;
  return process.env.NODE_ENV !== "production" ? {
    name: u,
    styles: a,
    map: c,
    next: lt,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: u,
    styles: a,
    next: lt
  };
}, Bm = function(t) {
  return t();
}, Ul = N["useInsertionEffect"] ? N["useInsertionEffect"] : !1, Jl = Ul || Bm, Ls = Ul || N.useLayoutEffect, bi = {}.hasOwnProperty, gi = /* @__PURE__ */ N.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Cm({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (gi.displayName = "EmotionCacheContext");
gi.Provider;
var mi = function(t) {
  return /* @__PURE__ */ R(function(n, r) {
    var o = ct(gi);
    return t(n, o, r);
  });
}, go = /* @__PURE__ */ N.createContext({});
process.env.NODE_ENV !== "production" && (go.displayName = "EmotionThemeContext");
var Bs = function(t) {
  var n = t.split(".");
  return n[n.length - 1];
}, Vm = function(t) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(t);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(t), n))
    return Bs(n[1]);
}, Gm = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), Wm = function(t) {
  return t.replace(/\$/g, "-");
}, jm = function(t) {
  if (t)
    for (var n = t.split(`
`), r = 0; r < n.length; r++) {
      var o = Vm(n[r]);
      if (o) {
        if (Gm.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return Wm(o);
      }
    }
}, Sa = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", Aa = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", zm = function(t, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var r = {};
  for (var o in n)
    bi.call(n, o) && (r[o] = n[o]);
  if (r[Sa] = t, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var a = jm(new Error().stack);
    a && (r[Aa] = a);
  }
  return r;
}, Hm = function(t) {
  var n = t.cache, r = t.serialized, o = t.isStringTag;
  return di(n, r, o), Jl(function() {
    return fi(n, r, o);
  }), null;
}, Ql = /* @__PURE__ */ mi(function(e, t, n) {
  var r = e.css;
  typeof r == "string" && t.registered[r] !== void 0 && (r = t.registered[r]);
  var o = e[Sa], a = [r], i = "";
  typeof e.className == "string" ? i = Hl(t.registered, a, e.className) : e.className != null && (i = e.className + " ");
  var s = Xn(a, void 0, N.useContext(go));
  if (process.env.NODE_ENV !== "production" && s.name.indexOf("-") === -1) {
    var c = e[Aa];
    c && (s = Xn([s, "label:" + c + ";"]));
  }
  i += t.key + "-" + s.name;
  var l = {};
  for (var d in e)
    bi.call(e, d) && d !== "css" && d !== Sa && (process.env.NODE_ENV === "production" || d !== Aa) && (l[d] = e[d]);
  return l.ref = n, l.className = i, /* @__PURE__ */ N.createElement(N.Fragment, null, /* @__PURE__ */ N.createElement(Hm, {
    cache: t,
    serialized: s,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ N.createElement(o, l));
});
process.env.NODE_ENV !== "production" && (Ql.displayName = "EmotionCssPropInternal");
var Xm = Ql, Zm = {
  name: "@emotion/react",
  version: "11.11.4",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  exports: {
    ".": {
      module: {
        worker: "./dist/emotion-react.worker.esm.js",
        browser: "./dist/emotion-react.browser.esm.js",
        default: "./dist/emotion-react.esm.js"
      },
      import: "./dist/emotion-react.cjs.mjs",
      default: "./dist/emotion-react.cjs.js"
    },
    "./jsx-runtime": {
      module: {
        worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
        browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
        default: "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
      },
      import: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
      default: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
    },
    "./_isolated-hnrs": {
      module: {
        worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
        browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
        default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
      },
      import: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
      default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
    },
    "./jsx-dev-runtime": {
      module: {
        worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
        browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
        default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
      },
      import: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
      default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
    },
    "./package.json": "./package.json",
    "./types/css-prop": "./types/css-prop.d.ts",
    "./macro": {
      types: {
        import: "./macro.d.mts",
        default: "./macro.d.ts"
      },
      default: "./macro.js"
    }
  },
  types: "types/index.d.ts",
  files: [
    "src",
    "dist",
    "jsx-runtime",
    "jsx-dev-runtime",
    "_isolated-hnrs",
    "types/*.d.ts",
    "macro.*"
  ],
  sideEffects: !1,
  author: "Emotion Contributors",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.18.3",
    "@emotion/babel-plugin": "^11.11.0",
    "@emotion/cache": "^11.11.0",
    "@emotion/serialize": "^1.1.3",
    "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
    "@emotion/utils": "^1.2.1",
    "@emotion/weak-memoize": "^0.3.1",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@types/react": {
      optional: !0
    }
  },
  devDependencies: {
    "@definitelytyped/dtslint": "0.0.112",
    "@emotion/css": "11.11.2",
    "@emotion/css-prettifier": "1.1.3",
    "@emotion/server": "11.11.0",
    "@emotion/styled": "11.11.0",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1",
    typescript: "^4.5.5"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: [
      "./index.js",
      "./jsx-runtime.js",
      "./jsx-dev-runtime.js",
      "./_isolated-hnrs.js"
    ],
    umdName: "emotionReact",
    exports: {
      envConditions: [
        "browser",
        "worker"
      ],
      extra: {
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
          types: {
            import: "./macro.d.mts",
            default: "./macro.d.ts"
          },
          default: "./macro.js"
        }
      }
    }
  }
}, ne = function(t, n) {
  var r = arguments;
  if (n == null || !bi.call(n, "css"))
    return N.createElement.apply(void 0, r);
  var o = r.length, a = new Array(o);
  a[0] = Xm, a[1] = zm(t, n);
  for (var i = 2; i < o; i++)
    a[i] = r[i];
  return N.createElement.apply(null, a);
}, Vs = !1, Ym = /* @__PURE__ */ mi(function(e, t) {
  process.env.NODE_ENV !== "production" && !Vs && // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  (e.className || e.css) && (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), Vs = !0);
  var n = e.styles, r = Xn([n], void 0, N.useContext(go)), o = N.useRef();
  return Ls(function() {
    var a = t.key + "-global", i = new t.sheet.constructor({
      key: a,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), s = !1, c = document.querySelector('style[data-emotion="' + a + " " + r.name + '"]');
    return t.sheet.tags.length && (i.before = t.sheet.tags[0]), c !== null && (s = !0, c.setAttribute("data-emotion", a), i.hydrate([c])), o.current = [i, s], function() {
      i.flush();
    };
  }, [t]), Ls(function() {
    var a = o.current, i = a[0], s = a[1];
    if (s) {
      a[1] = !1;
      return;
    }
    if (r.next !== void 0 && fi(t, r.next, !0), i.tags.length) {
      var c = i.tags[i.tags.length - 1].nextElementSibling;
      i.before = c, i.flush();
    }
    t.insert("", r, i, !1);
  }, [t, r.name]), null;
});
process.env.NODE_ENV !== "production" && (Ym.displayName = "EmotionGlobal");
function hi() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return Xn(t);
}
var Um = function() {
  var t = hi.apply(void 0, arguments), n = "animation-" + t.name;
  return {
    name: n,
    styles: "@keyframes " + n + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, Jm = function e(t) {
  for (var n = t.length, r = 0, o = ""; r < n; r++) {
    var a = t[r];
    if (a != null) {
      var i = void 0;
      switch (typeof a) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(a))
            i = e(a);
          else {
            process.env.NODE_ENV !== "production" && a.styles !== void 0 && a.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), i = "";
            for (var s in a)
              a[s] && s && (i && (i += " "), i += s);
          }
          break;
        }
        default:
          i = a;
      }
      i && (o && (o += " "), o += i);
    }
  }
  return o;
};
function Qm(e, t, n) {
  var r = [], o = Hl(e, r, n);
  return r.length < 2 ? n : o + t(r);
}
var Km = function(t) {
  var n = t.cache, r = t.serializedArr;
  return Jl(function() {
    for (var o = 0; o < r.length; o++)
      fi(n, r[o], !1);
  }), null;
}, qm = /* @__PURE__ */ mi(function(e, t) {
  var n = !1, r = [], o = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("css can only be used during render");
    for (var l = arguments.length, d = new Array(l), u = 0; u < l; u++)
      d[u] = arguments[u];
    var f = Xn(d, t.registered);
    return r.push(f), di(t, f, !1), t.key + "-" + f.name;
  }, a = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("cx can only be used during render");
    for (var l = arguments.length, d = new Array(l), u = 0; u < l; u++)
      d[u] = arguments[u];
    return Qm(t.registered, o, Jm(d));
  }, i = {
    css: o,
    cx: a,
    theme: N.useContext(go)
  }, s = e.children(i);
  return n = !0, /* @__PURE__ */ N.createElement(N.Fragment, null, /* @__PURE__ */ N.createElement(Km, {
    cache: t,
    serializedArr: r
  }), s);
});
process.env.NODE_ENV !== "production" && (qm.displayName = "EmotionClassNames");
if (process.env.NODE_ENV !== "production") {
  var Gs = !0, eh = typeof jest < "u" || typeof vi < "u";
  if (Gs && !eh) {
    var Ws = (
      // $FlowIgnore
      typeof globalThis < "u" ? globalThis : Gs ? window : global
    ), js = "__EMOTION_REACT_" + Zm.version.split(".")[0] + "__";
    Ws[js] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), Ws[js] = !0;
  }
}
function th(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
const nh = ["top", "right", "bottom", "left"], At = Math.min, qe = Math.max, kt = Math.round, Ft = Math.floor, at = (e) => ({
  x: e,
  y: e
}), rh = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, oh = {
  start: "end",
  end: "start"
};
function Ea(e, t, n) {
  return qe(e, At(t, n));
}
function Et(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Pt(e) {
  return e.split("-")[0];
}
function An(e) {
  return e.split("-")[1];
}
function $i(e) {
  return e === "x" ? "y" : "x";
}
function xi(e) {
  return e === "y" ? "height" : "width";
}
function En(e) {
  return ["top", "bottom"].includes(Pt(e)) ? "y" : "x";
}
function yi(e) {
  return $i(En(e));
}
function ah(e, t, n) {
  n === void 0 && (n = !1);
  const r = An(e), o = yi(e), a = xi(o);
  let i = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (i = Xr(i)), [i, Xr(i)];
}
function ih(e) {
  const t = Xr(e);
  return [Pa(e), t, Pa(t)];
}
function Pa(e) {
  return e.replace(/start|end/g, (t) => oh[t]);
}
function sh(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], a = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? a : i;
    default:
      return [];
  }
}
function ch(e, t, n, r) {
  const o = An(e);
  let a = sh(Pt(e), n === "start", r);
  return o && (a = a.map((i) => i + "-" + o), t && (a = a.concat(a.map(Pa)))), a;
}
function Xr(e) {
  return e.replace(/left|right|bottom|top/g, (t) => rh[t]);
}
function lh(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Kl(e) {
  return typeof e != "number" ? lh(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Zn(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function Nt(e) {
  return ql(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function We(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function yt(e) {
  var t;
  return (t = (ql(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function ql(e) {
  return e instanceof Node || e instanceof We(e).Node;
}
function it(e) {
  return e instanceof Element || e instanceof We(e).Element;
}
function st(e) {
  return e instanceof HTMLElement || e instanceof We(e).HTMLElement;
}
function zs(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof We(e).ShadowRoot;
}
function or(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = tt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function uh(e) {
  return ["table", "td", "th"].includes(Nt(e));
}
function Ci(e) {
  const t = mo(), n = tt(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function dh(e) {
  let t = wn(e);
  for (; st(t) && !ho(t); ) {
    if (Ci(t))
      return t;
    t = wn(t);
  }
  return null;
}
function mo() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ho(e) {
  return ["html", "body", "#document"].includes(Nt(e));
}
function tt(e) {
  return We(e).getComputedStyle(e);
}
function vo(e) {
  return it(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function wn(e) {
  if (Nt(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    zs(e) && e.host || // Fallback.
    yt(e)
  );
  return zs(t) ? t.host : t;
}
function eu(e) {
  const t = wn(e);
  return ho(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : st(t) && or(t) ? t : eu(t);
}
function qt(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = eu(e), a = o === ((r = e.ownerDocument) == null ? void 0 : r.body), i = We(o);
  return a ? t.concat(i, i.visualViewport || [], or(o) ? o : [], i.frameElement && n ? qt(i.frameElement) : []) : t.concat(o, qt(o, [], n));
}
function fh(e) {
  const t = tt(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = st(e), a = o ? e.offsetWidth : n, i = o ? e.offsetHeight : r, s = kt(n) !== a || kt(r) !== i;
  return s && (n = a, r = i), {
    width: n,
    height: r,
    $: s
  };
}
function wi(e) {
  return it(e) ? e : e.contextElement;
}
function Yo(e) {
  const t = wi(e);
  if (!st(t))
    return at(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: a
  } = fh(t);
  let i = (a ? kt(n.width) : n.width) / r, s = (a ? kt(n.height) : n.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const ph = /* @__PURE__ */ at(0);
function bh(e) {
  const t = We(e);
  return !mo() || !t.visualViewport ? ph : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function gh(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== We(e) ? !1 : t;
}
function Hs(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), a = wi(e);
  let i = at(1);
  t && (r ? it(r) && (i = Yo(r)) : i = Yo(e));
  const s = gh(a, n, r) ? bh(a) : at(0);
  let c = (o.left + s.x) / i.x, l = (o.top + s.y) / i.y, d = o.width / i.x, u = o.height / i.y;
  if (a) {
    const f = We(a), p = r && it(r) ? We(r) : r;
    let g = f, b = g.frameElement;
    for (; b && r && p !== g; ) {
      const m = Yo(b), v = b.getBoundingClientRect(), $ = tt(b), x = v.left + (b.clientLeft + parseFloat($.paddingLeft)) * m.x, w = v.top + (b.clientTop + parseFloat($.paddingTop)) * m.y;
      c *= m.x, l *= m.y, d *= m.x, u *= m.y, c += x, l += w, g = We(b), b = g.frameElement;
    }
  }
  return Zn({
    width: d,
    height: u,
    x: c,
    y: l
  });
}
function mh(e, t) {
  let n = null, r;
  const o = yt(e);
  function a() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function i(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), a();
    const {
      left: l,
      top: d,
      width: u,
      height: f
    } = e.getBoundingClientRect();
    if (s || t(), !u || !f)
      return;
    const p = Ft(d), g = Ft(o.clientWidth - (l + u)), b = Ft(o.clientHeight - (d + f)), m = Ft(l), $ = {
      rootMargin: -p + "px " + -g + "px " + -b + "px " + -m + "px",
      threshold: qe(0, At(1, c)) || 1
    };
    let x = !0;
    function w(C) {
      const P = C[0].intersectionRatio;
      if (P !== c) {
        if (!x)
          return i();
        P ? i(!1, P) : r = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      x = !1;
    }
    try {
      n = new IntersectionObserver(w, {
        ...$,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(w, $);
    }
    n.observe(e);
  }
  return i(!0), a;
}
function hh(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, l = wi(e), d = o || a ? [...l ? qt(l) : [], ...qt(t)] : [];
  d.forEach((v) => {
    o && v.addEventListener("scroll", n, {
      passive: !0
    }), a && v.addEventListener("resize", n);
  });
  const u = l && s ? mh(l, n) : null;
  let f = -1, p = null;
  i && (p = new ResizeObserver((v) => {
    let [$] = v;
    $ && $.target === l && p && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var x;
      (x = p) == null || x.observe(t);
    })), n();
  }), l && !c && p.observe(l), p.observe(t));
  let g, b = c ? Hs(e) : null;
  c && m();
  function m() {
    const v = Hs(e);
    b && (v.x !== b.x || v.y !== b.y || v.width !== b.width || v.height !== b.height) && n(), b = v, g = requestAnimationFrame(m);
  }
  return n(), () => {
    var v;
    d.forEach(($) => {
      o && $.removeEventListener("scroll", n), a && $.removeEventListener("resize", n);
    }), u == null || u(), (v = p) == null || v.disconnect(), p = null, c && cancelAnimationFrame(g);
  };
}
var Ta = ao, vh = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], Zr = function() {
};
function $h(e, t) {
  return t ? t[0] === "-" ? e + t : e + "__" + t : e;
}
function xh(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++)
    r[o - 2] = arguments[o];
  var a = [].concat(r);
  if (t && e)
    for (var i in t)
      t.hasOwnProperty(i) && t[i] && a.push("".concat($h(e, i)));
  return a.filter(function(s) {
    return s;
  }).map(function(s) {
    return String(s).trim();
  }).join(" ");
}
var Xs = function(t) {
  return Th(t) ? t.filter(Boolean) : jr(t) === "object" && t !== null ? [t] : [];
}, tu = function(t) {
  t.className, t.clearValue, t.cx, t.getStyles, t.getClassNames, t.getValue, t.hasValue, t.isMulti, t.isRtl, t.options, t.selectOption, t.selectProps, t.setValue, t.theme;
  var n = Tt(t, vh);
  return re({}, n);
}, Me = function(t, n, r) {
  var o = t.cx, a = t.getStyles, i = t.getClassNames, s = t.className;
  return {
    css: a(n, t),
    className: o(r ?? {}, i(n, t), s)
  };
};
function $o(e) {
  return [document.documentElement, document.body, window].indexOf(e) > -1;
}
function yh(e) {
  return $o(e) ? window.innerHeight : e.clientHeight;
}
function nu(e) {
  return $o(e) ? window.pageYOffset : e.scrollTop;
}
function Yr(e, t) {
  if ($o(e)) {
    window.scrollTo(0, t);
    return;
  }
  e.scrollTop = t;
}
function Ch(e) {
  var t = getComputedStyle(e), n = t.position === "absolute", r = /(auto|scroll)/;
  if (t.position === "fixed")
    return document.documentElement;
  for (var o = e; o = o.parentElement; )
    if (t = getComputedStyle(o), !(n && t.position === "static") && r.test(t.overflow + t.overflowY + t.overflowX))
      return o;
  return document.documentElement;
}
function wh(e, t, n, r) {
  return n * ((e = e / r - 1) * e * e + 1) + t;
}
function vr(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Zr, o = nu(e), a = t - o, i = 10, s = 0;
  function c() {
    s += i;
    var l = wh(s, o, a, n);
    Yr(e, l), s < n ? window.requestAnimationFrame(c) : r(e);
  }
  c();
}
function Zs(e, t) {
  var n = e.getBoundingClientRect(), r = t.getBoundingClientRect(), o = t.offsetHeight / 3;
  r.bottom + o > n.bottom ? Yr(e, Math.min(t.offsetTop + t.clientHeight - e.offsetHeight + o, e.scrollHeight)) : r.top - o < n.top && Yr(e, Math.max(t.offsetTop - o, 0));
}
function Ih(e) {
  var t = e.getBoundingClientRect();
  return {
    bottom: t.bottom,
    height: t.height,
    left: t.left,
    right: t.right,
    top: t.top,
    width: t.width
  };
}
function Ys() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function Sh() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var ru = !1, Ah = {
  get passive() {
    return ru = !0;
  }
}, $r = typeof window < "u" ? window : {};
$r.addEventListener && $r.removeEventListener && ($r.addEventListener("p", Zr, Ah), $r.removeEventListener("p", Zr, !1));
var Eh = ru;
function Ph(e) {
  return e != null;
}
function Th(e) {
  return Array.isArray(e);
}
function xr(e, t, n) {
  return e ? t : n;
}
var Rh = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
    r[o - 1] = arguments[o];
  var a = Object.entries(t).filter(function(i) {
    var s = wt(i, 1), c = s[0];
    return !r.includes(c);
  });
  return a.reduce(function(i, s) {
    var c = wt(s, 2), l = c[0], d = c[1];
    return i[l] = d, i;
  }, {});
}, Mh = ["children", "innerProps"], Dh = ["children", "innerProps"];
function Oh(e) {
  var t = e.maxHeight, n = e.menuEl, r = e.minHeight, o = e.placement, a = e.shouldScroll, i = e.isFixedPosition, s = e.controlHeight, c = Ch(n), l = {
    placement: "bottom",
    maxHeight: t
  };
  if (!n || !n.offsetParent)
    return l;
  var d = c.getBoundingClientRect(), u = d.height, f = n.getBoundingClientRect(), p = f.bottom, g = f.height, b = f.top, m = n.offsetParent.getBoundingClientRect(), v = m.top, $ = i ? window.innerHeight : yh(c), x = nu(c), w = parseInt(getComputedStyle(n).marginBottom, 10), C = parseInt(getComputedStyle(n).marginTop, 10), P = v - C, E = $ - b, T = P + x, F = u - x - b, V = p - $ + x + w, _ = x + b - C, W = 160;
  switch (o) {
    case "auto":
    case "bottom":
      if (E >= g)
        return {
          placement: "bottom",
          maxHeight: t
        };
      if (F >= g && !i)
        return a && vr(c, V, W), {
          placement: "bottom",
          maxHeight: t
        };
      if (!i && F >= r || i && E >= r) {
        a && vr(c, V, W);
        var H = i ? E - w : F - w;
        return {
          placement: "bottom",
          maxHeight: H
        };
      }
      if (o === "auto" || i) {
        var D = t, M = i ? P : T;
        return M >= r && (D = Math.min(M - w - s, t)), {
          placement: "top",
          maxHeight: D
        };
      }
      if (o === "bottom")
        return a && Yr(c, V), {
          placement: "bottom",
          maxHeight: t
        };
      break;
    case "top":
      if (P >= g)
        return {
          placement: "top",
          maxHeight: t
        };
      if (T >= g && !i)
        return a && vr(c, _, W), {
          placement: "top",
          maxHeight: t
        };
      if (!i && T >= r || i && P >= r) {
        var j = t;
        return (!i && T >= r || i && P >= r) && (j = i ? P - C : T - C), a && vr(c, _, W), {
          placement: "top",
          maxHeight: j
        };
      }
      return {
        placement: "bottom",
        maxHeight: t
      };
    default:
      throw new Error('Invalid placement provided "'.concat(o, '".'));
  }
  return l;
}
function Fh(e) {
  var t = {
    bottom: "top",
    top: "bottom"
  };
  return e ? t[e] : "bottom";
}
var ou = function(t) {
  return t === "auto" ? "bottom" : t;
}, kh = function(t, n) {
  var r, o = t.placement, a = t.theme, i = a.borderRadius, s = a.spacing, c = a.colors;
  return re((r = {
    label: "menu"
  }, Gn(r, Fh(o), "100%"), Gn(r, "position", "absolute"), Gn(r, "width", "100%"), Gn(r, "zIndex", 1), r), n ? {} : {
    backgroundColor: c.neutral0,
    borderRadius: i,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: s.menuGutter,
    marginTop: s.menuGutter
  });
}, au = /* @__PURE__ */ Kt(null), Nh = function(t) {
  var n = t.children, r = t.minMenuHeight, o = t.maxMenuHeight, a = t.menuPlacement, i = t.menuPosition, s = t.menuShouldScrollIntoView, c = t.theme, l = ct(au) || {}, d = l.setPortalPlacement, u = O(null), f = J(o), p = wt(f, 2), g = p[0], b = p[1], m = J(null), v = wt(m, 2), $ = v[0], x = v[1], w = c.spacing.controlHeight;
  return Ta(function() {
    var C = u.current;
    if (C) {
      var P = i === "fixed", E = s && !P, T = Oh({
        maxHeight: o,
        menuEl: C,
        minHeight: r,
        placement: a,
        shouldScroll: E,
        isFixedPosition: P,
        controlHeight: w
      });
      b(T.maxHeight), x(T.placement), d == null || d(T.placement);
    }
  }, [o, a, i, s, r, d, w]), n({
    ref: u,
    placerProps: re(re({}, t), {}, {
      placement: $ || ou(a),
      maxHeight: g
    })
  });
}, _h = function(t) {
  var n = t.children, r = t.innerRef, o = t.innerProps;
  return ne("div", S({}, Me(t, "menu", {
    menu: !0
  }), {
    ref: r
  }, o), n);
}, Lh = _h, Bh = function(t, n) {
  var r = t.maxHeight, o = t.theme.spacing.baseUnit;
  return re({
    maxHeight: r,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, n ? {} : {
    paddingBottom: o,
    paddingTop: o
  });
}, Vh = function(t) {
  var n = t.children, r = t.innerProps, o = t.innerRef, a = t.isMulti;
  return ne("div", S({}, Me(t, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": a
  }), {
    ref: o
  }, r), n);
}, iu = function(t, n) {
  var r = t.theme, o = r.spacing.baseUnit, a = r.colors;
  return re({
    textAlign: "center"
  }, n ? {} : {
    color: a.neutral40,
    padding: "".concat(o * 2, "px ").concat(o * 3, "px")
  });
}, Gh = iu, Wh = iu, jh = function(t) {
  var n = t.children, r = n === void 0 ? "No options" : n, o = t.innerProps, a = Tt(t, Mh);
  return ne("div", S({}, Me(re(re({}, a), {}, {
    children: r,
    innerProps: o
  }), "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), o), r);
}, zh = function(t) {
  var n = t.children, r = n === void 0 ? "Loading..." : n, o = t.innerProps, a = Tt(t, Dh);
  return ne("div", S({}, Me(re(re({}, a), {}, {
    children: r,
    innerProps: o
  }), "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), o), r);
}, Hh = function(t) {
  var n = t.rect, r = t.offset, o = t.position;
  return {
    left: n.left,
    position: o,
    top: r,
    width: n.width,
    zIndex: 1
  };
}, Xh = function(t) {
  var n = t.appendTo, r = t.children, o = t.controlElement, a = t.innerProps, i = t.menuPlacement, s = t.menuPosition, c = O(null), l = O(null), d = J(ou(i)), u = wt(d, 2), f = u[0], p = u[1], g = Ne(function() {
    return {
      setPortalPlacement: p
    };
  }, []), b = J(null), m = wt(b, 2), v = m[0], $ = m[1], x = K(function() {
    if (o) {
      var E = Ih(o), T = s === "fixed" ? 0 : window.pageYOffset, F = E[f] + T;
      (F !== (v == null ? void 0 : v.offset) || E.left !== (v == null ? void 0 : v.rect.left) || E.width !== (v == null ? void 0 : v.rect.width)) && $({
        offset: F,
        rect: E
      });
    }
  }, [o, s, f, v == null ? void 0 : v.offset, v == null ? void 0 : v.rect.left, v == null ? void 0 : v.rect.width]);
  Ta(function() {
    x();
  }, [x]);
  var w = K(function() {
    typeof l.current == "function" && (l.current(), l.current = null), o && c.current && (l.current = hh(o, c.current, x, {
      elementResize: "ResizeObserver" in window
    }));
  }, [o, x]);
  Ta(function() {
    w();
  }, [w]);
  var C = K(function(E) {
    c.current = E, w();
  }, [w]);
  if (!n && s !== "fixed" || !v)
    return null;
  var P = ne("div", S({
    ref: C
  }, Me(re(re({}, t), {}, {
    offset: v.offset,
    position: s,
    rect: v.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), a), r);
  return ne(au.Provider, {
    value: g
  }, n ? /* @__PURE__ */ nl(P, n) : P);
}, Zh = function(t) {
  var n = t.isDisabled, r = t.isRtl;
  return {
    label: "container",
    direction: r ? "rtl" : void 0,
    pointerEvents: n ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, Yh = function(t) {
  var n = t.children, r = t.innerProps, o = t.isDisabled, a = t.isRtl;
  return ne("div", S({}, Me(t, "container", {
    "--is-disabled": o,
    "--is-rtl": a
  }), r), n);
}, Uh = function(t, n) {
  var r = t.theme.spacing, o = t.isMulti, a = t.hasValue, i = t.selectProps.controlShouldRenderValue;
  return re({
    alignItems: "center",
    display: o && a && i ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, n ? {} : {
    padding: "".concat(r.baseUnit / 2, "px ").concat(r.baseUnit * 2, "px")
  });
}, Jh = function(t) {
  var n = t.children, r = t.innerProps, o = t.isMulti, a = t.hasValue;
  return ne("div", S({}, Me(t, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": o,
    "value-container--has-value": a
  }), r), n);
}, Qh = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, Kh = function(t) {
  var n = t.children, r = t.innerProps;
  return ne("div", S({}, Me(t, "indicatorsContainer", {
    indicators: !0
  }), r), n);
}, Us, qh = ["size"], e2 = ["innerProps", "isRtl", "size"];
function t2() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var n2 = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: t2
}, su = function(t) {
  var n = t.size, r = Tt(t, qh);
  return ne("svg", S({
    height: n,
    width: n,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: n2
  }, r));
}, Ii = function(t) {
  return ne(su, S({
    size: 20
  }, t), ne("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, cu = function(t) {
  return ne(su, S({
    size: 20
  }, t), ne("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, lu = function(t, n) {
  var r = t.isFocused, o = t.theme, a = o.spacing.baseUnit, i = o.colors;
  return re({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, n ? {} : {
    color: r ? i.neutral60 : i.neutral20,
    padding: a * 2,
    ":hover": {
      color: r ? i.neutral80 : i.neutral40
    }
  });
}, r2 = lu, o2 = function(t) {
  var n = t.children, r = t.innerProps;
  return ne("div", S({}, Me(t, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), r), n || ne(cu, null));
}, a2 = lu, i2 = function(t) {
  var n = t.children, r = t.innerProps;
  return ne("div", S({}, Me(t, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), r), n || ne(Ii, null));
}, s2 = function(t, n) {
  var r = t.isDisabled, o = t.theme, a = o.spacing.baseUnit, i = o.colors;
  return re({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, n ? {} : {
    backgroundColor: r ? i.neutral10 : i.neutral20,
    marginBottom: a * 2,
    marginTop: a * 2
  });
}, c2 = function(t) {
  var n = t.innerProps;
  return ne("span", S({}, n, Me(t, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, l2 = Um(Us || (Us = th([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), u2 = function(t, n) {
  var r = t.isFocused, o = t.size, a = t.theme, i = a.colors, s = a.spacing.baseUnit;
  return re({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: o,
    lineHeight: 1,
    marginRight: o,
    textAlign: "center",
    verticalAlign: "middle"
  }, n ? {} : {
    color: r ? i.neutral60 : i.neutral20,
    padding: s * 2
  });
}, Uo = function(t) {
  var n = t.delay, r = t.offset;
  return ne("span", {
    css: /* @__PURE__ */ hi({
      animation: "".concat(l2, " 1s ease-in-out ").concat(n, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: r ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, d2 = function(t) {
  var n = t.innerProps, r = t.isRtl, o = t.size, a = o === void 0 ? 4 : o, i = Tt(t, e2);
  return ne("div", S({}, Me(re(re({}, i), {}, {
    innerProps: n,
    isRtl: r,
    size: a
  }), "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), n), ne(Uo, {
    delay: 0,
    offset: r
  }), ne(Uo, {
    delay: 160,
    offset: !0
  }), ne(Uo, {
    delay: 320,
    offset: !r
  }));
}, f2 = function(t, n) {
  var r = t.isDisabled, o = t.isFocused, a = t.theme, i = a.colors, s = a.borderRadius, c = a.spacing;
  return re({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: c.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, n ? {} : {
    backgroundColor: r ? i.neutral5 : i.neutral0,
    borderColor: r ? i.neutral10 : o ? i.primary : i.neutral20,
    borderRadius: s,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: o ? "0 0 0 1px ".concat(i.primary) : void 0,
    "&:hover": {
      borderColor: o ? i.primary : i.neutral30
    }
  });
}, p2 = function(t) {
  var n = t.children, r = t.isDisabled, o = t.isFocused, a = t.innerRef, i = t.innerProps, s = t.menuIsOpen;
  return ne("div", S({
    ref: a
  }, Me(t, "control", {
    control: !0,
    "control--is-disabled": r,
    "control--is-focused": o,
    "control--menu-is-open": s
  }), i, {
    "aria-disabled": r || void 0
  }), n);
}, b2 = p2, g2 = ["data"], m2 = function(t, n) {
  var r = t.theme.spacing;
  return n ? {} : {
    paddingBottom: r.baseUnit * 2,
    paddingTop: r.baseUnit * 2
  };
}, h2 = function(t) {
  var n = t.children, r = t.cx, o = t.getStyles, a = t.getClassNames, i = t.Heading, s = t.headingProps, c = t.innerProps, l = t.label, d = t.theme, u = t.selectProps;
  return ne("div", S({}, Me(t, "group", {
    group: !0
  }), c), ne(i, S({}, s, {
    selectProps: u,
    theme: d,
    getStyles: o,
    getClassNames: a,
    cx: r
  }), l), ne("div", null, n));
}, v2 = function(t, n) {
  var r = t.theme, o = r.colors, a = r.spacing;
  return re({
    label: "group",
    cursor: "default",
    display: "block"
  }, n ? {} : {
    color: o.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: a.baseUnit * 3,
    paddingRight: a.baseUnit * 3,
    textTransform: "uppercase"
  });
}, $2 = function(t) {
  var n = tu(t);
  n.data;
  var r = Tt(n, g2);
  return ne("div", S({}, Me(t, "groupHeading", {
    "group-heading": !0
  }), r));
}, x2 = h2, y2 = ["innerRef", "isDisabled", "isHidden", "inputClassName"], C2 = function(t, n) {
  var r = t.isDisabled, o = t.value, a = t.theme, i = a.spacing, s = a.colors;
  return re(re({
    visibility: r ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: o ? "translateZ(0)" : ""
  }, w2), n ? {} : {
    margin: i.baseUnit / 2,
    paddingBottom: i.baseUnit / 2,
    paddingTop: i.baseUnit / 2,
    color: s.neutral80
  });
}, uu = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, w2 = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": re({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, uu)
}, I2 = function(t) {
  return re({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: t ? 0 : 1,
    width: "100%"
  }, uu);
}, S2 = function(t) {
  var n = t.cx, r = t.value, o = tu(t), a = o.innerRef, i = o.isDisabled, s = o.isHidden, c = o.inputClassName, l = Tt(o, y2);
  return ne("div", S({}, Me(t, "input", {
    "input-container": !0
  }), {
    "data-value": r || ""
  }), ne("input", S({
    className: n({
      input: !0
    }, c),
    ref: a,
    style: I2(s),
    disabled: i
  }, l)));
}, A2 = S2, E2 = function(t, n) {
  var r = t.theme, o = r.spacing, a = r.borderRadius, i = r.colors;
  return re({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, n ? {} : {
    backgroundColor: i.neutral10,
    borderRadius: a / 2,
    margin: o.baseUnit / 2
  });
}, P2 = function(t, n) {
  var r = t.theme, o = r.borderRadius, a = r.colors, i = t.cropWithEllipsis;
  return re({
    overflow: "hidden",
    textOverflow: i || i === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, n ? {} : {
    borderRadius: o / 2,
    color: a.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, T2 = function(t, n) {
  var r = t.theme, o = r.spacing, a = r.borderRadius, i = r.colors, s = t.isFocused;
  return re({
    alignItems: "center",
    display: "flex"
  }, n ? {} : {
    borderRadius: a / 2,
    backgroundColor: s ? i.dangerLight : void 0,
    paddingLeft: o.baseUnit,
    paddingRight: o.baseUnit,
    ":hover": {
      backgroundColor: i.dangerLight,
      color: i.danger
    }
  });
}, du = function(t) {
  var n = t.children, r = t.innerProps;
  return ne("div", r, n);
}, R2 = du, M2 = du;
function D2(e) {
  var t = e.children, n = e.innerProps;
  return ne("div", S({
    role: "button"
  }, n), t || ne(Ii, {
    size: 14
  }));
}
var O2 = function(t) {
  var n = t.children, r = t.components, o = t.data, a = t.innerProps, i = t.isDisabled, s = t.removeProps, c = t.selectProps, l = r.Container, d = r.Label, u = r.Remove;
  return ne(l, {
    data: o,
    innerProps: re(re({}, Me(t, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": i
    })), a),
    selectProps: c
  }, ne(d, {
    data: o,
    innerProps: re({}, Me(t, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: c
  }, n), ne(u, {
    data: o,
    innerProps: re(re({}, Me(t, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(n || "option")
    }, s),
    selectProps: c
  }));
}, F2 = O2, k2 = function(t, n) {
  var r = t.isDisabled, o = t.isFocused, a = t.isSelected, i = t.theme, s = i.spacing, c = i.colors;
  return re({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, n ? {} : {
    backgroundColor: a ? c.primary : o ? c.primary25 : "transparent",
    color: r ? c.neutral20 : a ? c.neutral0 : "inherit",
    padding: "".concat(s.baseUnit * 2, "px ").concat(s.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: r ? void 0 : a ? c.primary : c.primary50
    }
  });
}, N2 = function(t) {
  var n = t.children, r = t.isDisabled, o = t.isFocused, a = t.isSelected, i = t.innerRef, s = t.innerProps;
  return ne("div", S({}, Me(t, "option", {
    option: !0,
    "option--is-disabled": r,
    "option--is-focused": o,
    "option--is-selected": a
  }), {
    ref: i,
    "aria-disabled": r
  }, s), n);
}, _2 = N2, L2 = function(t, n) {
  var r = t.theme, o = r.spacing, a = r.colors;
  return re({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, n ? {} : {
    color: a.neutral50,
    marginLeft: o.baseUnit / 2,
    marginRight: o.baseUnit / 2
  });
}, B2 = function(t) {
  var n = t.children, r = t.innerProps;
  return ne("div", S({}, Me(t, "placeholder", {
    placeholder: !0
  }), r), n);
}, V2 = B2, G2 = function(t, n) {
  var r = t.isDisabled, o = t.theme, a = o.spacing, i = o.colors;
  return re({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, n ? {} : {
    color: r ? i.neutral40 : i.neutral80,
    marginLeft: a.baseUnit / 2,
    marginRight: a.baseUnit / 2
  });
}, W2 = function(t) {
  var n = t.children, r = t.isDisabled, o = t.innerProps;
  return ne("div", S({}, Me(t, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": r
  }), o), n);
}, j2 = W2, z2 = {
  ClearIndicator: i2,
  Control: b2,
  DropdownIndicator: o2,
  DownChevron: cu,
  CrossIcon: Ii,
  Group: x2,
  GroupHeading: $2,
  IndicatorsContainer: Kh,
  IndicatorSeparator: c2,
  Input: A2,
  LoadingIndicator: d2,
  Menu: Lh,
  MenuList: Vh,
  MenuPortal: Xh,
  LoadingMessage: zh,
  NoOptionsMessage: jh,
  MultiValue: F2,
  MultiValueContainer: R2,
  MultiValueLabel: M2,
  MultiValueRemove: D2,
  Option: _2,
  Placeholder: V2,
  SelectContainer: Yh,
  SingleValue: j2,
  ValueContainer: Jh
}, H2 = function(t) {
  return re(re({}, z2), t.components);
}, Js = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function X2(e, t) {
  return !!(e === t || Js(e) && Js(t));
}
function Z2(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!X2(e[n], t[n]))
      return !1;
  return !0;
}
function Y2(e, t) {
  t === void 0 && (t = Z2);
  var n = null;
  function r() {
    for (var o = [], a = 0; a < arguments.length; a++)
      o[a] = arguments[a];
    if (n && n.lastThis === this && t(o, n.lastArgs))
      return n.lastResult;
    var i = e.apply(this, o);
    return n = {
      lastResult: i,
      lastArgs: o,
      lastThis: this
    }, i;
  }
  return r.clear = function() {
    n = null;
  }, r;
}
function U2() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var J2 = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: U2
}, Q2 = function(t) {
  return ne("span", S({
    css: J2
  }, t));
}, Qs = Q2, K2 = {
  guidance: function(t) {
    var n = t.isSearchable, r = t.isMulti, o = t.tabSelectsValue, a = t.context, i = t.isInitialFocus;
    switch (a) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(o ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return i ? "".concat(t["aria-label"] || "Select", " is focused ").concat(n ? ",type to refine list" : "", ", press Down to open the menu, ").concat(r ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(t) {
    var n = t.action, r = t.label, o = r === void 0 ? "" : r, a = t.labels, i = t.isDisabled;
    switch (n) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(o, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(a.length > 1 ? "s" : "", " ").concat(a.join(","), ", selected.");
      case "select-option":
        return i ? "option ".concat(o, " is disabled. Select another option.") : "option ".concat(o, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(t) {
    var n = t.context, r = t.focused, o = t.options, a = t.label, i = a === void 0 ? "" : a, s = t.selectValue, c = t.isDisabled, l = t.isSelected, d = t.isAppleDevice, u = function(b, m) {
      return b && b.length ? "".concat(b.indexOf(m) + 1, " of ").concat(b.length) : "";
    };
    if (n === "value" && s)
      return "value ".concat(i, " focused, ").concat(u(s, r), ".");
    if (n === "menu" && d) {
      var f = c ? " disabled" : "", p = "".concat(l ? " selected" : "").concat(f);
      return "".concat(i).concat(p, ", ").concat(u(o, r), ".");
    }
    return "";
  },
  onFilter: function(t) {
    var n = t.inputValue, r = t.resultsMessage;
    return "".concat(r).concat(n ? " for search term " + n : "", ".");
  }
}, q2 = function(t) {
  var n = t.ariaSelection, r = t.focusedOption, o = t.focusedValue, a = t.focusableOptions, i = t.isFocused, s = t.selectValue, c = t.selectProps, l = t.id, d = t.isAppleDevice, u = c.ariaLiveMessages, f = c.getOptionLabel, p = c.inputValue, g = c.isMulti, b = c.isOptionDisabled, m = c.isSearchable, v = c.menuIsOpen, $ = c.options, x = c.screenReaderStatus, w = c.tabSelectsValue, C = c.isLoading, P = c["aria-label"], E = c["aria-live"], T = Ne(function() {
    return re(re({}, K2), u || {});
  }, [u]), F = Ne(function() {
    var M = "";
    if (n && T.onChange) {
      var j = n.option, U = n.options, ee = n.removedValue, z = n.removedValues, oe = n.value, le = function(we) {
        return Array.isArray(we) ? null : we;
      }, ie = ee || j || le(oe), fe = ie ? f(ie) : "", Ae = U || z || void 0, Re = Ae ? Ae.map(f) : [], B = re({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: ie && b(ie, s),
        label: fe,
        labels: Re
      }, n);
      M = T.onChange(B);
    }
    return M;
  }, [n, T, b, s, f]), V = Ne(function() {
    var M = "", j = r || o, U = !!(r && s && s.includes(r));
    if (j && T.onFocus) {
      var ee = {
        focused: j,
        label: f(j),
        isDisabled: b(j, s),
        isSelected: U,
        options: a,
        context: j === r ? "menu" : "value",
        selectValue: s,
        isAppleDevice: d
      };
      M = T.onFocus(ee);
    }
    return M;
  }, [r, o, f, b, T, a, s, d]), _ = Ne(function() {
    var M = "";
    if (v && $.length && !C && T.onFilter) {
      var j = x({
        count: a.length
      });
      M = T.onFilter({
        inputValue: p,
        resultsMessage: j
      });
    }
    return M;
  }, [a, p, v, T, $, x, C]), W = (n == null ? void 0 : n.action) === "initial-input-focus", H = Ne(function() {
    var M = "";
    if (T.guidance) {
      var j = o ? "value" : v ? "menu" : "input";
      M = T.guidance({
        "aria-label": P,
        context: j,
        isDisabled: r && b(r, s),
        isMulti: g,
        isSearchable: m,
        tabSelectsValue: w,
        isInitialFocus: W
      });
    }
    return M;
  }, [P, r, o, g, b, m, v, T, s, w, W]), D = ne(xt, null, ne("span", {
    id: "aria-selection"
  }, F), ne("span", {
    id: "aria-focused"
  }, V), ne("span", {
    id: "aria-results"
  }, _), ne("span", {
    id: "aria-guidance"
  }, H));
  return ne(xt, null, ne(Qs, {
    id: l
  }, W && D), ne(Qs, {
    "aria-live": E,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, i && !W && D));
}, ev = q2, Ra = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], tv = new RegExp("[" + Ra.map(function(e) {
  return e.letters;
}).join("") + "]", "g"), fu = {};
for (var Jo = 0; Jo < Ra.length; Jo++)
  for (var Qo = Ra[Jo], Ko = 0; Ko < Qo.letters.length; Ko++)
    fu[Qo.letters[Ko]] = Qo.base;
var pu = function(t) {
  return t.replace(tv, function(n) {
    return fu[n];
  });
}, nv = Y2(pu), Ks = function(t) {
  return t.replace(/^\s+|\s+$/g, "");
}, rv = function(t) {
  return "".concat(t.label, " ").concat(t.value);
}, ov = function(t) {
  return function(n, r) {
    if (n.data.__isNew__)
      return !0;
    var o = re({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: rv,
      trim: !0,
      matchFrom: "any"
    }, t), a = o.ignoreCase, i = o.ignoreAccents, s = o.stringify, c = o.trim, l = o.matchFrom, d = c ? Ks(r) : r, u = c ? Ks(s(n)) : s(n);
    return a && (d = d.toLowerCase(), u = u.toLowerCase()), i && (d = nv(d), u = pu(u)), l === "start" ? u.substr(0, d.length) === d : u.indexOf(d) > -1;
  };
}, av = ["innerRef"];
function iv(e) {
  var t = e.innerRef, n = Tt(e, av), r = Rh(n, "onExited", "in", "enter", "exit", "appear");
  return ne("input", S({
    ref: t
  }, r, {
    css: /* @__PURE__ */ hi({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}
var sv = function(t) {
  t.cancelable && t.preventDefault(), t.stopPropagation();
};
function cv(e) {
  var t = e.isEnabled, n = e.onBottomArrive, r = e.onBottomLeave, o = e.onTopArrive, a = e.onTopLeave, i = O(!1), s = O(!1), c = O(0), l = O(null), d = K(function(m, v) {
    if (l.current !== null) {
      var $ = l.current, x = $.scrollTop, w = $.scrollHeight, C = $.clientHeight, P = l.current, E = v > 0, T = w - C - x, F = !1;
      T > v && i.current && (r && r(m), i.current = !1), E && s.current && (a && a(m), s.current = !1), E && v > T ? (n && !i.current && n(m), P.scrollTop = w, F = !0, i.current = !0) : !E && -v > x && (o && !s.current && o(m), P.scrollTop = 0, F = !0, s.current = !0), F && sv(m);
    }
  }, [n, r, o, a]), u = K(function(m) {
    d(m, m.deltaY);
  }, [d]), f = K(function(m) {
    c.current = m.changedTouches[0].clientY;
  }, []), p = K(function(m) {
    var v = c.current - m.changedTouches[0].clientY;
    d(m, v);
  }, [d]), g = K(function(m) {
    if (m) {
      var v = Eh ? {
        passive: !1
      } : !1;
      m.addEventListener("wheel", u, v), m.addEventListener("touchstart", f, v), m.addEventListener("touchmove", p, v);
    }
  }, [p, f, u]), b = K(function(m) {
    m && (m.removeEventListener("wheel", u, !1), m.removeEventListener("touchstart", f, !1), m.removeEventListener("touchmove", p, !1));
  }, [p, f, u]);
  return Z(function() {
    if (t) {
      var m = l.current;
      return g(m), function() {
        b(m);
      };
    }
  }, [t, g, b]), function(m) {
    l.current = m;
  };
}
var qs = ["boxSizing", "height", "overflow", "paddingRight", "position"], ec = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function tc(e) {
  e.preventDefault();
}
function nc(e) {
  e.stopPropagation();
}
function rc() {
  var e = this.scrollTop, t = this.scrollHeight, n = e + this.offsetHeight;
  e === 0 ? this.scrollTop = 1 : n === t && (this.scrollTop = e - 1);
}
function oc() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var ac = !!(typeof window < "u" && window.document && window.document.createElement), Fn = 0, fn = {
  capture: !1,
  passive: !1
};
function lv(e) {
  var t = e.isEnabled, n = e.accountForScrollbars, r = n === void 0 ? !0 : n, o = O({}), a = O(null), i = K(function(c) {
    if (ac) {
      var l = document.body, d = l && l.style;
      if (r && qs.forEach(function(g) {
        var b = d && d[g];
        o.current[g] = b;
      }), r && Fn < 1) {
        var u = parseInt(o.current.paddingRight, 10) || 0, f = document.body ? document.body.clientWidth : 0, p = window.innerWidth - f + u || 0;
        Object.keys(ec).forEach(function(g) {
          var b = ec[g];
          d && (d[g] = b);
        }), d && (d.paddingRight = "".concat(p, "px"));
      }
      l && oc() && (l.addEventListener("touchmove", tc, fn), c && (c.addEventListener("touchstart", rc, fn), c.addEventListener("touchmove", nc, fn))), Fn += 1;
    }
  }, [r]), s = K(function(c) {
    if (ac) {
      var l = document.body, d = l && l.style;
      Fn = Math.max(Fn - 1, 0), r && Fn < 1 && qs.forEach(function(u) {
        var f = o.current[u];
        d && (d[u] = f);
      }), l && oc() && (l.removeEventListener("touchmove", tc, fn), c && (c.removeEventListener("touchstart", rc, fn), c.removeEventListener("touchmove", nc, fn)));
    }
  }, [r]);
  return Z(function() {
    if (t) {
      var c = a.current;
      return i(c), function() {
        s(c);
      };
    }
  }, [t, i, s]), function(c) {
    a.current = c;
  };
}
function uv() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var dv = function(t) {
  var n = t.target;
  return n.ownerDocument.activeElement && n.ownerDocument.activeElement.blur();
}, fv = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNjcm9sbE1hbmFnZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW9EVSIsImZpbGUiOiJTY3JvbGxNYW5hZ2VyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgRnJhZ21lbnQsIFJlYWN0RWxlbWVudCwgUmVmQ2FsbGJhY2ssIE1vdXNlRXZlbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgdXNlU2Nyb2xsQ2FwdHVyZSBmcm9tICcuL3VzZVNjcm9sbENhcHR1cmUnO1xuaW1wb3J0IHVzZVNjcm9sbExvY2sgZnJvbSAnLi91c2VTY3JvbGxMb2NrJztcblxuaW50ZXJmYWNlIFByb3BzIHtcbiAgcmVhZG9ubHkgY2hpbGRyZW46IChyZWY6IFJlZkNhbGxiYWNrPEhUTUxFbGVtZW50PikgPT4gUmVhY3RFbGVtZW50O1xuICByZWFkb25seSBsb2NrRW5hYmxlZDogYm9vbGVhbjtcbiAgcmVhZG9ubHkgY2FwdHVyZUVuYWJsZWQ6IGJvb2xlYW47XG4gIHJlYWRvbmx5IG9uQm90dG9tQXJyaXZlPzogKGV2ZW50OiBXaGVlbEV2ZW50IHwgVG91Y2hFdmVudCkgPT4gdm9pZDtcbiAgcmVhZG9ubHkgb25Cb3R0b21MZWF2ZT86IChldmVudDogV2hlZWxFdmVudCB8IFRvdWNoRXZlbnQpID0+IHZvaWQ7XG4gIHJlYWRvbmx5IG9uVG9wQXJyaXZlPzogKGV2ZW50OiBXaGVlbEV2ZW50IHwgVG91Y2hFdmVudCkgPT4gdm9pZDtcbiAgcmVhZG9ubHkgb25Ub3BMZWF2ZT86IChldmVudDogV2hlZWxFdmVudCB8IFRvdWNoRXZlbnQpID0+IHZvaWQ7XG59XG5cbmNvbnN0IGJsdXJTZWxlY3RJbnB1dCA9IChldmVudDogTW91c2VFdmVudDxIVE1MRGl2RWxlbWVudD4pID0+IHtcbiAgY29uc3QgZWxlbWVudCA9IGV2ZW50LnRhcmdldCBhcyBIVE1MRGl2RWxlbWVudDtcbiAgcmV0dXJuIChcbiAgICBlbGVtZW50Lm93bmVyRG9jdW1lbnQuYWN0aXZlRWxlbWVudCAmJlxuICAgIChlbGVtZW50Lm93bmVyRG9jdW1lbnQuYWN0aXZlRWxlbWVudCBhcyBIVE1MRWxlbWVudCkuYmx1cigpXG4gICk7XG59O1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBTY3JvbGxNYW5hZ2VyKHtcbiAgY2hpbGRyZW4sXG4gIGxvY2tFbmFibGVkLFxuICBjYXB0dXJlRW5hYmxlZCA9IHRydWUsXG4gIG9uQm90dG9tQXJyaXZlLFxuICBvbkJvdHRvbUxlYXZlLFxuICBvblRvcEFycml2ZSxcbiAgb25Ub3BMZWF2ZSxcbn06IFByb3BzKSB7XG4gIGNvbnN0IHNldFNjcm9sbENhcHR1cmVUYXJnZXQgPSB1c2VTY3JvbGxDYXB0dXJlKHtcbiAgICBpc0VuYWJsZWQ6IGNhcHR1cmVFbmFibGVkLFxuICAgIG9uQm90dG9tQXJyaXZlLFxuICAgIG9uQm90dG9tTGVhdmUsXG4gICAgb25Ub3BBcnJpdmUsXG4gICAgb25Ub3BMZWF2ZSxcbiAgfSk7XG4gIGNvbnN0IHNldFNjcm9sbExvY2tUYXJnZXQgPSB1c2VTY3JvbGxMb2NrKHsgaXNFbmFibGVkOiBsb2NrRW5hYmxlZCB9KTtcblxuICBjb25zdCB0YXJnZXRSZWY6IFJlZkNhbGxiYWNrPEhUTUxFbGVtZW50PiA9IChlbGVtZW50KSA9PiB7XG4gICAgc2V0U2Nyb2xsQ2FwdHVyZVRhcmdldChlbGVtZW50KTtcbiAgICBzZXRTY3JvbGxMb2NrVGFyZ2V0KGVsZW1lbnQpO1xuICB9O1xuXG4gIHJldHVybiAoXG4gICAgPEZyYWdtZW50PlxuICAgICAge2xvY2tFbmFibGVkICYmIChcbiAgICAgICAgPGRpdlxuICAgICAgICAgIG9uQ2xpY2s9e2JsdXJTZWxlY3RJbnB1dH1cbiAgICAgICAgICBjc3M9e3sgcG9zaXRpb246ICdmaXhlZCcsIGxlZnQ6IDAsIGJvdHRvbTogMCwgcmlnaHQ6IDAsIHRvcDogMCB9fVxuICAgICAgICAvPlxuICAgICAgKX1cbiAgICAgIHtjaGlsZHJlbih0YXJnZXRSZWYpfVxuICAgIDwvRnJhZ21lbnQ+XG4gICk7XG59XG4iXX0= */",
  toString: uv
};
function pv(e) {
  var t = e.children, n = e.lockEnabled, r = e.captureEnabled, o = r === void 0 ? !0 : r, a = e.onBottomArrive, i = e.onBottomLeave, s = e.onTopArrive, c = e.onTopLeave, l = cv({
    isEnabled: o,
    onBottomArrive: a,
    onBottomLeave: i,
    onTopArrive: s,
    onTopLeave: c
  }), d = lv({
    isEnabled: n
  }), u = function(p) {
    l(p), d(p);
  };
  return ne(xt, null, n && ne("div", {
    onClick: dv,
    css: fv
  }), t(u));
}
function bv() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var gv = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: bv
}, mv = function(t) {
  var n = t.name, r = t.onFocus;
  return ne("input", {
    required: !0,
    name: n,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: r,
    css: gv,
    value: "",
    onChange: function() {
    }
  });
}, hv = mv;
function Si(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function vv() {
  return Si(/^iPhone/i);
}
function bu() {
  return Si(/^Mac/i);
}
function $v() {
  return Si(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  bu() && navigator.maxTouchPoints > 1;
}
function xv() {
  return vv() || $v();
}
function yv() {
  return bu() || xv();
}
var Cv = function(t) {
  return t.label;
}, wv = function(t) {
  return t.label;
}, Iv = function(t) {
  return t.value;
}, Sv = function(t) {
  return !!t.isDisabled;
}, Av = {
  clearIndicator: a2,
  container: Zh,
  control: f2,
  dropdownIndicator: r2,
  group: m2,
  groupHeading: v2,
  indicatorsContainer: Qh,
  indicatorSeparator: s2,
  input: C2,
  loadingIndicator: u2,
  loadingMessage: Wh,
  menu: kh,
  menuList: Bh,
  menuPortal: Hh,
  multiValue: E2,
  multiValueLabel: P2,
  multiValueRemove: T2,
  noOptionsMessage: Gh,
  option: k2,
  placeholder: L2,
  singleValue: G2,
  valueContainer: Uh
}, Ev = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, Pv = 4, gu = 4, Tv = 38, Rv = gu * 2, Mv = {
  baseUnit: gu,
  controlHeight: Tv,
  menuGutter: Rv
}, qo = {
  borderRadius: Pv,
  colors: Ev,
  spacing: Mv
}, Dv = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: Ys(),
  captureMenuScroll: !Ys(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: ov(),
  formatGroupLabel: Cv,
  getOptionLabel: wv,
  getOptionValue: Iv,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: Sv,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !Sh(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(t) {
    var n = t.count;
    return "".concat(n, " result").concat(n !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function ic(e, t, n, r) {
  var o = vu(e, t, n), a = $u(e, t, n), i = hu(e, t), s = Ur(e, t);
  return {
    type: "option",
    data: t,
    isDisabled: o,
    isSelected: a,
    label: i,
    value: s,
    index: r
  };
}
function Or(e, t) {
  return e.options.map(function(n, r) {
    if ("options" in n) {
      var o = n.options.map(function(i, s) {
        return ic(e, i, t, s);
      }).filter(function(i) {
        return cc(e, i);
      });
      return o.length > 0 ? {
        type: "group",
        data: n,
        options: o,
        index: r
      } : void 0;
    }
    var a = ic(e, n, t, r);
    return cc(e, a) ? a : void 0;
  }).filter(Ph);
}
function mu(e) {
  return e.reduce(function(t, n) {
    return n.type === "group" ? t.push.apply(t, ii(n.options.map(function(r) {
      return r.data;
    }))) : t.push(n.data), t;
  }, []);
}
function sc(e, t) {
  return e.reduce(function(n, r) {
    return r.type === "group" ? n.push.apply(n, ii(r.options.map(function(o) {
      return {
        data: o.data,
        id: "".concat(t, "-").concat(r.index, "-").concat(o.index)
      };
    }))) : n.push({
      data: r.data,
      id: "".concat(t, "-").concat(r.index)
    }), n;
  }, []);
}
function Ov(e, t) {
  return mu(Or(e, t));
}
function cc(e, t) {
  var n = e.inputValue, r = n === void 0 ? "" : n, o = t.data, a = t.isSelected, i = t.label, s = t.value;
  return (!yu(e) || !a) && xu(e, {
    label: i,
    value: s,
    data: o
  }, r);
}
function Fv(e, t) {
  var n = e.focusedValue, r = e.selectValue, o = r.indexOf(n);
  if (o > -1) {
    var a = t.indexOf(n);
    if (a > -1)
      return n;
    if (o < t.length)
      return t[o];
  }
  return null;
}
function kv(e, t) {
  var n = e.focusedOption;
  return n && t.indexOf(n) > -1 ? n : t[0];
}
var ea = function(t, n) {
  var r, o = (r = t.find(function(a) {
    return a.data === n;
  })) === null || r === void 0 ? void 0 : r.id;
  return o || null;
}, hu = function(t, n) {
  return t.getOptionLabel(n);
}, Ur = function(t, n) {
  return t.getOptionValue(n);
};
function vu(e, t, n) {
  return typeof e.isOptionDisabled == "function" ? e.isOptionDisabled(t, n) : !1;
}
function $u(e, t, n) {
  if (n.indexOf(t) > -1)
    return !0;
  if (typeof e.isOptionSelected == "function")
    return e.isOptionSelected(t, n);
  var r = Ur(e, t);
  return n.some(function(o) {
    return Ur(e, o) === r;
  });
}
function xu(e, t, n) {
  return e.filterOption ? e.filterOption(t, n) : !0;
}
var yu = function(t) {
  var n = t.hideSelectedOptions, r = t.isMulti;
  return n === void 0 ? r : n;
}, Nv = 1, Cu = /* @__PURE__ */ function(e) {
  Fg(n, e);
  var t = Lg(n);
  function n(r) {
    var o;
    if (Dg(this, n), o = t.call(this, r), o.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    }, o.blockOptionHover = !1, o.isComposing = !1, o.commonProps = void 0, o.initialTouchX = 0, o.initialTouchY = 0, o.openAfterFocus = !1, o.scrollToFocusedOptionOnUpdate = !1, o.userIsDragging = void 0, o.isAppleDevice = yv(), o.controlRef = null, o.getControlRef = function(c) {
      o.controlRef = c;
    }, o.focusedOptionRef = null, o.getFocusedOptionRef = function(c) {
      o.focusedOptionRef = c;
    }, o.menuListRef = null, o.getMenuListRef = function(c) {
      o.menuListRef = c;
    }, o.inputRef = null, o.getInputRef = function(c) {
      o.inputRef = c;
    }, o.focus = o.focusInput, o.blur = o.blurInput, o.onChange = function(c, l) {
      var d = o.props, u = d.onChange, f = d.name;
      l.name = f, o.ariaOnChange(c, l), u(c, l);
    }, o.setValue = function(c, l, d) {
      var u = o.props, f = u.closeMenuOnSelect, p = u.isMulti, g = u.inputValue;
      o.onInputChange("", {
        action: "set-value",
        prevInputValue: g
      }), f && (o.setState({
        inputIsHiddenAfterUpdate: !p
      }), o.onMenuClose()), o.setState({
        clearFocusValueOnUpdate: !0
      }), o.onChange(c, {
        action: l,
        option: d
      });
    }, o.selectOption = function(c) {
      var l = o.props, d = l.blurInputOnSelect, u = l.isMulti, f = l.name, p = o.state.selectValue, g = u && o.isOptionSelected(c, p), b = o.isOptionDisabled(c, p);
      if (g) {
        var m = o.getOptionValue(c);
        o.setValue(p.filter(function(v) {
          return o.getOptionValue(v) !== m;
        }), "deselect-option", c);
      } else if (!b)
        u ? o.setValue([].concat(ii(p), [c]), "select-option", c) : o.setValue(c, "select-option");
      else {
        o.ariaOnChange(c, {
          action: "select-option",
          option: c,
          name: f
        });
        return;
      }
      d && o.blurInput();
    }, o.removeValue = function(c) {
      var l = o.props.isMulti, d = o.state.selectValue, u = o.getOptionValue(c), f = d.filter(function(g) {
        return o.getOptionValue(g) !== u;
      }), p = xr(l, f, f[0] || null);
      o.onChange(p, {
        action: "remove-value",
        removedValue: c
      }), o.focusInput();
    }, o.clearValue = function() {
      var c = o.state.selectValue;
      o.onChange(xr(o.props.isMulti, [], null), {
        action: "clear",
        removedValues: c
      });
    }, o.popValue = function() {
      var c = o.props.isMulti, l = o.state.selectValue, d = l[l.length - 1], u = l.slice(0, l.length - 1), f = xr(c, u, u[0] || null);
      o.onChange(f, {
        action: "pop-value",
        removedValue: d
      });
    }, o.getFocusedOptionId = function(c) {
      return ea(o.state.focusableOptionsWithIds, c);
    }, o.getFocusableOptionsWithIds = function() {
      return sc(Or(o.props, o.state.selectValue), o.getElementId("option"));
    }, o.getValue = function() {
      return o.state.selectValue;
    }, o.cx = function() {
      for (var c = arguments.length, l = new Array(c), d = 0; d < c; d++)
        l[d] = arguments[d];
      return xh.apply(void 0, [o.props.classNamePrefix].concat(l));
    }, o.getOptionLabel = function(c) {
      return hu(o.props, c);
    }, o.getOptionValue = function(c) {
      return Ur(o.props, c);
    }, o.getStyles = function(c, l) {
      var d = o.props.unstyled, u = Av[c](l, d);
      u.boxSizing = "border-box";
      var f = o.props.styles[c];
      return f ? f(u, l) : u;
    }, o.getClassNames = function(c, l) {
      var d, u;
      return (d = (u = o.props.classNames)[c]) === null || d === void 0 ? void 0 : d.call(u, l);
    }, o.getElementId = function(c) {
      return "".concat(o.state.instancePrefix, "-").concat(c);
    }, o.getComponents = function() {
      return H2(o.props);
    }, o.buildCategorizedOptions = function() {
      return Or(o.props, o.state.selectValue);
    }, o.getCategorizedOptions = function() {
      return o.props.menuIsOpen ? o.buildCategorizedOptions() : [];
    }, o.buildFocusableOptions = function() {
      return mu(o.buildCategorizedOptions());
    }, o.getFocusableOptions = function() {
      return o.props.menuIsOpen ? o.buildFocusableOptions() : [];
    }, o.ariaOnChange = function(c, l) {
      o.setState({
        ariaSelection: re({
          value: c
        }, l)
      });
    }, o.onMenuMouseDown = function(c) {
      c.button === 0 && (c.stopPropagation(), c.preventDefault(), o.focusInput());
    }, o.onMenuMouseMove = function(c) {
      o.blockOptionHover = !1;
    }, o.onControlMouseDown = function(c) {
      if (!c.defaultPrevented) {
        var l = o.props.openMenuOnClick;
        o.state.isFocused ? o.props.menuIsOpen ? c.target.tagName !== "INPUT" && c.target.tagName !== "TEXTAREA" && o.onMenuClose() : l && o.openMenu("first") : (l && (o.openAfterFocus = !0), o.focusInput()), c.target.tagName !== "INPUT" && c.target.tagName !== "TEXTAREA" && c.preventDefault();
      }
    }, o.onDropdownIndicatorMouseDown = function(c) {
      if (!(c && c.type === "mousedown" && c.button !== 0) && !o.props.isDisabled) {
        var l = o.props, d = l.isMulti, u = l.menuIsOpen;
        o.focusInput(), u ? (o.setState({
          inputIsHiddenAfterUpdate: !d
        }), o.onMenuClose()) : o.openMenu("first"), c.preventDefault();
      }
    }, o.onClearIndicatorMouseDown = function(c) {
      c && c.type === "mousedown" && c.button !== 0 || (o.clearValue(), c.preventDefault(), o.openAfterFocus = !1, c.type === "touchend" ? o.focusInput() : setTimeout(function() {
        return o.focusInput();
      }));
    }, o.onScroll = function(c) {
      typeof o.props.closeMenuOnScroll == "boolean" ? c.target instanceof HTMLElement && $o(c.target) && o.props.onMenuClose() : typeof o.props.closeMenuOnScroll == "function" && o.props.closeMenuOnScroll(c) && o.props.onMenuClose();
    }, o.onCompositionStart = function() {
      o.isComposing = !0;
    }, o.onCompositionEnd = function() {
      o.isComposing = !1;
    }, o.onTouchStart = function(c) {
      var l = c.touches, d = l && l.item(0);
      d && (o.initialTouchX = d.clientX, o.initialTouchY = d.clientY, o.userIsDragging = !1);
    }, o.onTouchMove = function(c) {
      var l = c.touches, d = l && l.item(0);
      if (d) {
        var u = Math.abs(d.clientX - o.initialTouchX), f = Math.abs(d.clientY - o.initialTouchY), p = 5;
        o.userIsDragging = u > p || f > p;
      }
    }, o.onTouchEnd = function(c) {
      o.userIsDragging || (o.controlRef && !o.controlRef.contains(c.target) && o.menuListRef && !o.menuListRef.contains(c.target) && o.blurInput(), o.initialTouchX = 0, o.initialTouchY = 0);
    }, o.onControlTouchEnd = function(c) {
      o.userIsDragging || o.onControlMouseDown(c);
    }, o.onClearIndicatorTouchEnd = function(c) {
      o.userIsDragging || o.onClearIndicatorMouseDown(c);
    }, o.onDropdownIndicatorTouchEnd = function(c) {
      o.userIsDragging || o.onDropdownIndicatorMouseDown(c);
    }, o.handleInputChange = function(c) {
      var l = o.props.inputValue, d = c.currentTarget.value;
      o.setState({
        inputIsHiddenAfterUpdate: !1
      }), o.onInputChange(d, {
        action: "input-change",
        prevInputValue: l
      }), o.props.menuIsOpen || o.onMenuOpen();
    }, o.onInputFocus = function(c) {
      o.props.onFocus && o.props.onFocus(c), o.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (o.openAfterFocus || o.props.openMenuOnFocus) && o.openMenu("first"), o.openAfterFocus = !1;
    }, o.onInputBlur = function(c) {
      var l = o.props.inputValue;
      if (o.menuListRef && o.menuListRef.contains(document.activeElement)) {
        o.inputRef.focus();
        return;
      }
      o.props.onBlur && o.props.onBlur(c), o.onInputChange("", {
        action: "input-blur",
        prevInputValue: l
      }), o.onMenuClose(), o.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, o.onOptionHover = function(c) {
      if (!(o.blockOptionHover || o.state.focusedOption === c)) {
        var l = o.getFocusableOptions(), d = l.indexOf(c);
        o.setState({
          focusedOption: c,
          focusedOptionId: d > -1 ? o.getFocusedOptionId(c) : null
        });
      }
    }, o.shouldHideSelectedOptions = function() {
      return yu(o.props);
    }, o.onValueInputFocus = function(c) {
      c.preventDefault(), c.stopPropagation(), o.focus();
    }, o.onKeyDown = function(c) {
      var l = o.props, d = l.isMulti, u = l.backspaceRemovesValue, f = l.escapeClearsValue, p = l.inputValue, g = l.isClearable, b = l.isDisabled, m = l.menuIsOpen, v = l.onKeyDown, $ = l.tabSelectsValue, x = l.openMenuOnFocus, w = o.state, C = w.focusedOption, P = w.focusedValue, E = w.selectValue;
      if (!b && !(typeof v == "function" && (v(c), c.defaultPrevented))) {
        switch (o.blockOptionHover = !0, c.key) {
          case "ArrowLeft":
            if (!d || p)
              return;
            o.focusValue("previous");
            break;
          case "ArrowRight":
            if (!d || p)
              return;
            o.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (p)
              return;
            if (P)
              o.removeValue(P);
            else {
              if (!u)
                return;
              d ? o.popValue() : g && o.clearValue();
            }
            break;
          case "Tab":
            if (o.isComposing || c.shiftKey || !m || !$ || !C || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            x && o.isOptionSelected(C, E))
              return;
            o.selectOption(C);
            break;
          case "Enter":
            if (c.keyCode === 229)
              break;
            if (m) {
              if (!C || o.isComposing)
                return;
              o.selectOption(C);
              break;
            }
            return;
          case "Escape":
            m ? (o.setState({
              inputIsHiddenAfterUpdate: !1
            }), o.onInputChange("", {
              action: "menu-close",
              prevInputValue: p
            }), o.onMenuClose()) : g && f && o.clearValue();
            break;
          case " ":
            if (p)
              return;
            if (!m) {
              o.openMenu("first");
              break;
            }
            if (!C)
              return;
            o.selectOption(C);
            break;
          case "ArrowUp":
            m ? o.focusOption("up") : o.openMenu("last");
            break;
          case "ArrowDown":
            m ? o.focusOption("down") : o.openMenu("first");
            break;
          case "PageUp":
            if (!m)
              return;
            o.focusOption("pageup");
            break;
          case "PageDown":
            if (!m)
              return;
            o.focusOption("pagedown");
            break;
          case "Home":
            if (!m)
              return;
            o.focusOption("first");
            break;
          case "End":
            if (!m)
              return;
            o.focusOption("last");
            break;
          default:
            return;
        }
        c.preventDefault();
      }
    }, o.state.instancePrefix = "react-select-" + (o.props.instanceId || ++Nv), o.state.selectValue = Xs(r.value), r.menuIsOpen && o.state.selectValue.length) {
      var a = o.getFocusableOptionsWithIds(), i = o.buildFocusableOptions(), s = i.indexOf(o.state.selectValue[0]);
      o.state.focusableOptionsWithIds = a, o.state.focusedOption = i[s], o.state.focusedOptionId = ea(a, i[s]);
    }
    return o;
  }
  return Og(n, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && Zs(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(o) {
      var a = this.props, i = a.isDisabled, s = a.menuIsOpen, c = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (c && !i && o.isDisabled || // ensure focus is on the Input when the menu opens
      c && s && !o.menuIsOpen) && this.focusInput(), c && i && !o.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !c && !i && o.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (Zs(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(o, a) {
      this.props.onInputChange(o, a);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(o) {
      var a = this, i = this.state, s = i.selectValue, c = i.isFocused, l = this.buildFocusableOptions(), d = o === "first" ? 0 : l.length - 1;
      if (!this.props.isMulti) {
        var u = l.indexOf(s[0]);
        u > -1 && (d = u);
      }
      this.scrollToFocusedOptionOnUpdate = !(c && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: l[d],
        focusedOptionId: this.getFocusedOptionId(l[d])
      }, function() {
        return a.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(o) {
      var a = this.state, i = a.selectValue, s = a.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var c = i.indexOf(s);
        s || (c = -1);
        var l = i.length - 1, d = -1;
        if (i.length) {
          switch (o) {
            case "previous":
              c === 0 ? d = 0 : c === -1 ? d = l : d = c - 1;
              break;
            case "next":
              c > -1 && c < l && (d = c + 1);
              break;
          }
          this.setState({
            inputIsHidden: d !== -1,
            focusedValue: i[d]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", a = this.props.pageSize, i = this.state.focusedOption, s = this.getFocusableOptions();
      if (s.length) {
        var c = 0, l = s.indexOf(i);
        i || (l = -1), o === "up" ? c = l > 0 ? l - 1 : s.length - 1 : o === "down" ? c = (l + 1) % s.length : o === "pageup" ? (c = l - a, c < 0 && (c = 0)) : o === "pagedown" ? (c = l + a, c > s.length - 1 && (c = s.length - 1)) : o === "last" && (c = s.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: s[c],
          focusedValue: null,
          focusedOptionId: this.getFocusedOptionId(s[c])
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(qo) : re(re({}, qo), this.props.theme) : qo;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var o = this.clearValue, a = this.cx, i = this.getStyles, s = this.getClassNames, c = this.getValue, l = this.selectOption, d = this.setValue, u = this.props, f = u.isMulti, p = u.isRtl, g = u.options, b = this.hasValue();
      return {
        clearValue: o,
        cx: a,
        getStyles: i,
        getClassNames: s,
        getValue: c,
        hasValue: b,
        isMulti: f,
        isRtl: p,
        options: g,
        selectOption: l,
        selectProps: u,
        setValue: d,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var o = this.state.selectValue;
      return o.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var o = this.props, a = o.isClearable, i = o.isMulti;
      return a === void 0 ? i : a;
    }
  }, {
    key: "isOptionDisabled",
    value: function(o, a) {
      return vu(this.props, o, a);
    }
  }, {
    key: "isOptionSelected",
    value: function(o, a) {
      return $u(this.props, o, a);
    }
  }, {
    key: "filterOption",
    value: function(o, a) {
      return xu(this.props, o, a);
    }
  }, {
    key: "formatOptionLabel",
    value: function(o, a) {
      if (typeof this.props.formatOptionLabel == "function") {
        var i = this.props.inputValue, s = this.state.selectValue;
        return this.props.formatOptionLabel(o, {
          context: a,
          inputValue: i,
          selectValue: s
        });
      } else
        return this.getOptionLabel(o);
    }
  }, {
    key: "formatGroupLabel",
    value: function(o) {
      return this.props.formatGroupLabel(o);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var o = this.props, a = o.isDisabled, i = o.isSearchable, s = o.inputId, c = o.inputValue, l = o.tabIndex, d = o.form, u = o.menuIsOpen, f = o.required, p = this.getComponents(), g = p.Input, b = this.state, m = b.inputIsHidden, v = b.ariaSelection, $ = this.commonProps, x = s || this.getElementId("input"), w = re(re(re({
          "aria-autocomplete": "list",
          "aria-expanded": u,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": f,
          role: "combobox",
          "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, u && {
          "aria-controls": this.getElementId("listbox")
        }), !i && {
          "aria-readonly": !0
        }), this.hasValue() ? (v == null ? void 0 : v.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return i ? /* @__PURE__ */ N.createElement(g, S({}, $, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: x,
          innerRef: this.getInputRef,
          isDisabled: a,
          isHidden: m,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: l,
          form: d,
          type: "text",
          value: c
        }, w)) : /* @__PURE__ */ N.createElement(iv, S({
          id: x,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: Zr,
          onFocus: this.onInputFocus,
          disabled: a,
          tabIndex: l,
          inputMode: "none",
          form: d,
          value: ""
        }, w));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var o = this, a = this.getComponents(), i = a.MultiValue, s = a.MultiValueContainer, c = a.MultiValueLabel, l = a.MultiValueRemove, d = a.SingleValue, u = a.Placeholder, f = this.commonProps, p = this.props, g = p.controlShouldRenderValue, b = p.isDisabled, m = p.isMulti, v = p.inputValue, $ = p.placeholder, x = this.state, w = x.selectValue, C = x.focusedValue, P = x.isFocused;
      if (!this.hasValue() || !g)
        return v ? null : /* @__PURE__ */ N.createElement(u, S({}, f, {
          key: "placeholder",
          isDisabled: b,
          isFocused: P,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), $);
      if (m)
        return w.map(function(T, F) {
          var V = T === C, _ = "".concat(o.getOptionLabel(T), "-").concat(o.getOptionValue(T));
          return /* @__PURE__ */ N.createElement(i, S({}, f, {
            components: {
              Container: s,
              Label: c,
              Remove: l
            },
            isFocused: V,
            isDisabled: b,
            key: _,
            index: F,
            removeProps: {
              onClick: function() {
                return o.removeValue(T);
              },
              onTouchEnd: function() {
                return o.removeValue(T);
              },
              onMouseDown: function(H) {
                H.preventDefault();
              }
            },
            data: T
          }), o.formatOptionLabel(T, "value"));
        });
      if (v)
        return null;
      var E = w[0];
      return /* @__PURE__ */ N.createElement(d, S({}, f, {
        data: E,
        isDisabled: b
      }), this.formatOptionLabel(E, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var o = this.getComponents(), a = o.ClearIndicator, i = this.commonProps, s = this.props, c = s.isDisabled, l = s.isLoading, d = this.state.isFocused;
      if (!this.isClearable() || !a || c || !this.hasValue() || l)
        return null;
      var u = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ N.createElement(a, S({}, i, {
        innerProps: u,
        isFocused: d
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var o = this.getComponents(), a = o.LoadingIndicator, i = this.commonProps, s = this.props, c = s.isDisabled, l = s.isLoading, d = this.state.isFocused;
      if (!a || !l)
        return null;
      var u = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ N.createElement(a, S({}, i, {
        innerProps: u,
        isDisabled: c,
        isFocused: d
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var o = this.getComponents(), a = o.DropdownIndicator, i = o.IndicatorSeparator;
      if (!a || !i)
        return null;
      var s = this.commonProps, c = this.props.isDisabled, l = this.state.isFocused;
      return /* @__PURE__ */ N.createElement(i, S({}, s, {
        isDisabled: c,
        isFocused: l
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var o = this.getComponents(), a = o.DropdownIndicator;
      if (!a)
        return null;
      var i = this.commonProps, s = this.props.isDisabled, c = this.state.isFocused, l = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ N.createElement(a, S({}, i, {
        innerProps: l,
        isDisabled: s,
        isFocused: c
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var o = this, a = this.getComponents(), i = a.Group, s = a.GroupHeading, c = a.Menu, l = a.MenuList, d = a.MenuPortal, u = a.LoadingMessage, f = a.NoOptionsMessage, p = a.Option, g = this.commonProps, b = this.state.focusedOption, m = this.props, v = m.captureMenuScroll, $ = m.inputValue, x = m.isLoading, w = m.loadingMessage, C = m.minMenuHeight, P = m.maxMenuHeight, E = m.menuIsOpen, T = m.menuPlacement, F = m.menuPosition, V = m.menuPortalTarget, _ = m.menuShouldBlockScroll, W = m.menuShouldScrollIntoView, H = m.noOptionsMessage, D = m.onMenuScrollToTop, M = m.onMenuScrollToBottom;
      if (!E)
        return null;
      var j = function(fe, Ae) {
        var Re = fe.type, B = fe.data, ue = fe.isDisabled, we = fe.isSelected, ce = fe.label, Le = fe.value, Je = b === B, X = ue ? void 0 : function() {
          return o.onOptionHover(B);
        }, Ve = ue ? void 0 : function() {
          return o.selectOption(B);
        }, Ze = "".concat(o.getElementId("option"), "-").concat(Ae), Pe = {
          id: Ze,
          onClick: Ve,
          onMouseMove: X,
          onMouseOver: X,
          tabIndex: -1,
          role: "option",
          "aria-selected": o.isAppleDevice ? void 0 : we
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ N.createElement(p, S({}, g, {
          innerProps: Pe,
          data: B,
          isDisabled: ue,
          isSelected: we,
          key: Ze,
          label: ce,
          type: Re,
          value: Le,
          isFocused: Je,
          innerRef: Je ? o.getFocusedOptionRef : void 0
        }), o.formatOptionLabel(fe.data, "menu"));
      }, U;
      if (this.hasOptions())
        U = this.getCategorizedOptions().map(function(ie) {
          if (ie.type === "group") {
            var fe = ie.data, Ae = ie.options, Re = ie.index, B = "".concat(o.getElementId("group"), "-").concat(Re), ue = "".concat(B, "-heading");
            return /* @__PURE__ */ N.createElement(i, S({}, g, {
              key: B,
              data: fe,
              options: Ae,
              Heading: s,
              headingProps: {
                id: ue,
                data: ie.data
              },
              label: o.formatGroupLabel(ie.data)
            }), ie.options.map(function(we) {
              return j(we, "".concat(Re, "-").concat(we.index));
            }));
          } else if (ie.type === "option")
            return j(ie, "".concat(ie.index));
        });
      else if (x) {
        var ee = w({
          inputValue: $
        });
        if (ee === null)
          return null;
        U = /* @__PURE__ */ N.createElement(u, g, ee);
      } else {
        var z = H({
          inputValue: $
        });
        if (z === null)
          return null;
        U = /* @__PURE__ */ N.createElement(f, g, z);
      }
      var oe = {
        minMenuHeight: C,
        maxMenuHeight: P,
        menuPlacement: T,
        menuPosition: F,
        menuShouldScrollIntoView: W
      }, le = /* @__PURE__ */ N.createElement(Nh, S({}, g, oe), function(ie) {
        var fe = ie.ref, Ae = ie.placerProps, Re = Ae.placement, B = Ae.maxHeight;
        return /* @__PURE__ */ N.createElement(c, S({}, g, oe, {
          innerRef: fe,
          innerProps: {
            onMouseDown: o.onMenuMouseDown,
            onMouseMove: o.onMenuMouseMove
          },
          isLoading: x,
          placement: Re
        }), /* @__PURE__ */ N.createElement(pv, {
          captureEnabled: v,
          onTopArrive: D,
          onBottomArrive: M,
          lockEnabled: _
        }, function(ue) {
          return /* @__PURE__ */ N.createElement(l, S({}, g, {
            innerRef: function(ce) {
              o.getMenuListRef(ce), ue(ce);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": g.isMulti,
              id: o.getElementId("listbox")
            },
            isLoading: x,
            maxHeight: B,
            focusedOption: b
          }), U);
        }));
      });
      return V || F === "fixed" ? /* @__PURE__ */ N.createElement(d, S({}, g, {
        appendTo: V,
        controlElement: this.controlRef,
        menuPlacement: T,
        menuPosition: F
      }), le) : le;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var o = this, a = this.props, i = a.delimiter, s = a.isDisabled, c = a.isMulti, l = a.name, d = a.required, u = this.state.selectValue;
      if (d && !this.hasValue() && !s)
        return /* @__PURE__ */ N.createElement(hv, {
          name: l,
          onFocus: this.onValueInputFocus
        });
      if (!(!l || s))
        if (c)
          if (i) {
            var f = u.map(function(b) {
              return o.getOptionValue(b);
            }).join(i);
            return /* @__PURE__ */ N.createElement("input", {
              name: l,
              type: "hidden",
              value: f
            });
          } else {
            var p = u.length > 0 ? u.map(function(b, m) {
              return /* @__PURE__ */ N.createElement("input", {
                key: "i-".concat(m),
                name: l,
                type: "hidden",
                value: o.getOptionValue(b)
              });
            }) : /* @__PURE__ */ N.createElement("input", {
              name: l,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ N.createElement("div", null, p);
          }
        else {
          var g = u[0] ? this.getOptionValue(u[0]) : "";
          return /* @__PURE__ */ N.createElement("input", {
            name: l,
            type: "hidden",
            value: g
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var o = this.commonProps, a = this.state, i = a.ariaSelection, s = a.focusedOption, c = a.focusedValue, l = a.isFocused, d = a.selectValue, u = this.getFocusableOptions();
      return /* @__PURE__ */ N.createElement(ev, S({}, o, {
        id: this.getElementId("live-region"),
        ariaSelection: i,
        focusedOption: s,
        focusedValue: c,
        isFocused: l,
        selectValue: d,
        focusableOptions: u,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function() {
      var o = this.getComponents(), a = o.Control, i = o.IndicatorsContainer, s = o.SelectContainer, c = o.ValueContainer, l = this.props, d = l.className, u = l.id, f = l.isDisabled, p = l.menuIsOpen, g = this.state.isFocused, b = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ N.createElement(s, S({}, b, {
        className: d,
        innerProps: {
          id: u,
          onKeyDown: this.onKeyDown
        },
        isDisabled: f,
        isFocused: g
      }), this.renderLiveRegion(), /* @__PURE__ */ N.createElement(a, S({}, b, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: f,
        isFocused: g,
        menuIsOpen: p
      }), /* @__PURE__ */ N.createElement(c, S({}, b, {
        isDisabled: f
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ N.createElement(i, S({}, b, {
        isDisabled: f
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(o, a) {
      var i = a.prevProps, s = a.clearFocusValueOnUpdate, c = a.inputIsHiddenAfterUpdate, l = a.ariaSelection, d = a.isFocused, u = a.prevWasFocused, f = a.instancePrefix, p = o.options, g = o.value, b = o.menuIsOpen, m = o.inputValue, v = o.isMulti, $ = Xs(g), x = {};
      if (i && (g !== i.value || p !== i.options || b !== i.menuIsOpen || m !== i.inputValue)) {
        var w = b ? Ov(o, $) : [], C = b ? sc(Or(o, $), "".concat(f, "-option")) : [], P = s ? Fv(a, $) : null, E = kv(a, w), T = ea(C, E);
        x = {
          selectValue: $,
          focusedOption: E,
          focusedOptionId: T,
          focusableOptionsWithIds: C,
          focusedValue: P,
          clearFocusValueOnUpdate: !1
        };
      }
      var F = c != null && o !== i ? {
        inputIsHidden: c,
        inputIsHiddenAfterUpdate: void 0
      } : {}, V = l, _ = d && u;
      return d && !_ && (V = {
        value: xr(v, $, $[0] || null),
        options: $,
        action: "initial-input-focus"
      }, _ = !u), (l == null ? void 0 : l.action) === "initial-input-focus" && (V = null), re(re(re({}, x), F), {}, {
        prevProps: o,
        ariaSelection: V,
        prevWasFocused: _
      });
    }
  }]), n;
}(j1);
Cu.defaultProps = Dv;
var _v = /* @__PURE__ */ R(function(e, t) {
  var n = Mg(e);
  return /* @__PURE__ */ N.createElement(Cu, S({
    ref: t
  }, n));
}), Lv = _v;
const Ai = "Adornment", Ei = "HelperText", Pi = "CharLimitIndicator", Fr = '&[data-focused="true"]', Ma = '&[data-has-value="true"]', Bv = '&[data-has-value="true"]:not([data-focused="true"])', wu = '&[data-has-placeholder="true"]', Vv = '&[data-has-placeholder="true"]:not([data-focused="true"])', Iu = '&[data-disabled="true"]', Su = '&[data-error="true"]', Gv = `${Fr.slice(1)} &, .state--focused &`, Wv = `${Ma.slice(1)} &`, jv = `${wu.slice(1)} &`, zv = `${Su.slice(1)} &, .state--error &`, Hv = `${Iu.slice(1)} &, .state--disabled &`, Xv = "div", Au = k(Xv, {
  "--startAdornmentSize": "0px",
  "--endAdornmentSize": "0px",
  display: "inline-grid",
  verticalAlign: "middle",
  gridTemplateColumns: "1fr",
  gridTemplateRows: "1fr repeat(auto-fit, minmax(0px, 1fr))",
  gridRowGap: "$base",
  $$labelScale: 1,
  $$labelTranslateX: "calc(1rem + var(--startAdornmentSize))",
  $$labelTranslateY: "0.6rem",
  // $$labelColor: '$colors$textPrimary30',
  // $$borderColor: '$colors$uiPrimary50',
  $$labelColor: "$$labelIdle",
  $$borderColor: "$$borderIdle",
  $$legendMaxWidth: "0.01px",
  [`${Fr}, &.state--focused`]: {
    // $$borderColor: '$colors$uiPrimaryMain'
    $$borderColor: "$$borderFocus"
  },
  [`${Fr}, &.state--focused, ${Ma}, ${wu}`]: {
    $$legendMaxWidth: "9999px",
    // $$labelColor: '$colors$uiPrimaryMain',
    $$labelColor: "$$labelFocus",
    $$labelScale: 0.85,
    $$labelTranslateY: "-0.5rem",
    $$labelTranslateX: "1rem",
    "&[data-label]": {
      $$legendPx: "$space$base"
    }
  },
  [`${Bv}, ${Vv}`]: {
    $$labelColor: "$$labelWithValueIdle"
  },
  [`${Su}, .state--error`]: {
    $$borderColor: "$colors$uiError50",
    [`${Fr}, ${Ma}, &.state--focused`]: {
      $$labelColor: "$colors$textError",
      $$borderColor: "$colors$uiErrorMain"
    }
  },
  [`${Iu}, .state--disabled`]: {
    $$borderColor: "$colors$uiDisabledMain",
    $$labelColor: "$colors$uiDisabledMain",
    opacity: 0.3
  },
  variants: {
    color: {
      neutral: {
        $$borderIdle: "$colors$textPrimary30",
        $$borderFocus: "$colors$uiPrimaryMain",
        $$labelIdle: "$colors$textPrimary50",
        $$labelFocus: "$colors$uiPrimaryMain",
        $$labelWithValueIdle: "$colors$textPrimary50"
        // $$borderColor: '$colors$textPrimary30',
        // $$labelColor: '$colors$textPrimary50',
        // '&[data-has-value="true"]:not([data-focused="true"])': {
        // 	$$labelColor: '$colors$textPrimary50',
        // },
      },
      default: {
        $$labelIdle: "$colors$textPrimary30",
        $$labelFocus: "$colors$uiPrimaryMain",
        $$labelWithValueIdle: "$colors$uiPrimaryMain",
        $$borderIdle: "$colors$uiPrimary50",
        $$borderFocus: "$colors$uiPrimaryMain"
      }
    }
  },
  defaultVariants: {
    color: "default"
  }
}), Eu = k(pt, {
  position: "absolute",
  left: 0,
  top: 0,
  transformOrigin: "left",
  transform: "translate($$labelTranslateX, $$labelTranslateY) scale($$labelScale)",
  WebkitTransform: "translate($$labelTranslateX, $$labelTranslateY) scale($$labelScale)",
  transition: "color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
  pointerEvents: "none",
  color: "$$labelColor",
  userSelect: "none",
  maxWidth: "calc(100% - 1rem - var(--startAdornmentSize) - var(--endAdornmentSize))",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  overflow: "hidden",
  [`${Gv}, ${Wv}, ${jv}, .state--focused &`]: {
    maxWidth: "calc(100% - 0.5rem)"
  }
}), Pu = {
  height: "100%",
  boxSizing: "border-box",
  appearance: "none",
  background: "none",
  pl: "calc($base * 2 + var(--startAdornmentSize))",
  pr: "calc($base * 2 + var(--endAdornmentSize))",
  py: "0.625rem",
  br: "$base",
  margin: 0,
  border: "none",
  outline: "none",
  color: "$textPrimaryMain",
  width: "100%",
  fontFamily: "$base",
  resize: "none",
  fontSize: "$bodyText",
  letterSpacing: "$loose",
  "&:hover, &:focus, .state--hover &": {
    "& ~ fieldset": {
      boxShadow: "$2"
    }
  },
  "&:active, .state--active &": {
    "& ~ fieldset": {
      boxShadow: "none"
    }
  },
  "&::placeholder": {
    color: "$textPrimary30"
  }
}, Tu = k("input", {
  ...Pu,
  '&[type="number"]': {
    "moz-appearance": "textfield",
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      margin: 0,
      "-webkit-appearance": "none !important"
    }
  }
}), Zv = k("textarea", Pu), Ru = k("fieldset", {
  $$borderWidth: "1px",
  appearance: "none",
  boxSizing: "border-box",
  padding: 0,
  position: "absolute",
  top: -5,
  left: 0,
  width: "100%",
  height: "calc(100% + 5px)",
  margin: 0,
  pl: "$base",
  pr: "calc($base * 2)",
  overflow: "hidden",
  br: "$base",
  pointerEvents: "none",
  border: "$$borderWidth solid $$borderColor",
  $$transFn: "0.2s $transitions$1 0ms",
  transition: "border-color $$transFn, box-shadow $$transFn",
  gridRow: "1",
  variants: {
    borderLess: {
      true: {
        $$borderColor: "transparent"
      }
    }
  }
}), Mu = k("legend", {
  width: "auto",
  height: 11,
  display: "block",
  py: "0",
  px: "$$legendPx",
  fontSize: "calc($fontSizes$bodyText * 0.85)",
  letterSpacing: "$loose",
  fontFamily: "$base",
  maxWidth: "$$legendMaxWidth",
  textAlign: "left",
  $$transFn: "50ms $transitions$1 0ms",
  transition: "max-width $$transFn, padding $$transFn",
  visibility: "hidden"
}), Du = Kt({
  error: !1,
  borderLess: !1
});
function Ou() {
  return ct(Du);
}
function Yv({ children: e, ...t }) {
  return /* @__PURE__ */ h.jsx(Du.Provider, { value: t, children: e });
}
const Uv = k(Au, {
  display: "flex",
  justifyContent: "space-between",
  minHeight: "2.5rem",
  position: "relative",
  pl: "1rem"
}), Jv = ({
  children: e,
  menuIsOpen: t,
  isDisabled: n,
  isFocused: r,
  hasValue: o,
  innerRef: a,
  innerProps: i,
  selectProps: s,
  className: c
}) => {
  const { label: l, placeholder: d, error: u, borderLess: f } = Ou();
  return /* @__PURE__ */ h.jsxs(
    Uv,
    {
      "data-disabled": n,
      "data-focused": r,
      "data-has-value": o,
      "data-label": l,
      "data-error": u,
      "data-select-state": t ? "open" : "closed",
      "data-has-placeholder": !!d,
      "data-component-name": "Control",
      className: c,
      ...i,
      ref: a,
      children: [
        /* @__PURE__ */ h.jsx(
          Eu,
          {
            as: "label",
            style: { display: l ? "" : "none" },
            htmlFor: s.name,
            children: l
          }
        ),
        /* @__PURE__ */ h.jsx(Ru, { borderLess: f, children: /* @__PURE__ */ h.jsx(Mu, { "data-label": l, children: l }) }),
        e
      ]
    }
  );
}, Qv = (e) => {
  const {
    innerRef: t,
    className: n,
    innerProps: r,
    children: o,
    getStyles: a
  } = e, { top: i, bottom: s } = a("menu", e);
  return /* @__PURE__ */ h.jsx(
    nn,
    {
      ...r,
      className: n,
      ref: t,
      css: {
        py: "$base",
        position: "absolute",
        width: "100%"
      },
      "data-component-name": "SelectMenu",
      style: { top: i == null ? void 0 : i.toString(), bottom: s == null ? void 0 : s.toString() },
      children: o
    }
  );
}, Kv = (e) => {
  const { innerRef: t, className: n, children: r, getStyles: o, ...a } = e, { maxHeight: i, overflowY: s } = o("menuList", e);
  return /* @__PURE__ */ h.jsx(
    yg,
    {
      ...a.innerProps,
      className: n,
      as: "div",
      ref: t,
      css: {
        bgc: "$uiSecondary",
        boxShadow: "$2",
        padding: "$base",
        br: "$base"
      },
      "data-component-name": "SelectMenuList",
      style: {
        maxHeight: i,
        overflowY: s
      },
      children: r
    }
  );
}, qv = ({
  innerRef: e,
  isDisabled: t,
  isHidden: n,
  inputClassName: r,
  ...o
}) => /* @__PURE__ */ h.jsx(nn, { css: {
  visibility: "visible",
  color: "$textPrimary16",
  boxSizing: "border-box"
}, children: /* @__PURE__ */ h.jsx(
  Tu,
  {
    className: r,
    ref: e,
    css: { pl: "0" },
    style: {
      opacity: n ? 0 : 1
    },
    "data-component-name": "SelectInput",
    disabled: t,
    ...o
  }
) }), e5 = k("h1", {
  lineHeight: 1.2,
  fontFamily: "$heading",
  color: "$textPrimaryMain",
  mt: "0.1em",
  mb: "0.4em",
  variants: {
    /** Represents the importance of the heading */
    level: {
      1: {
        fontSize: "$heading1",
        letterSpacing: "$tight1"
      },
      2: {
        fontSize: "$heading2",
        letterSpacing: "$tight2"
      },
      3: {
        fontSize: "$heading3",
        letterSpacing: "$tight3",
        lineHeight: 1.3
      },
      4: {
        fontSize: "$heading4",
        letterSpacing: "$tight",
        lineHeight: 1.3
      },
      5: {
        fontSize: "$heading5",
        letterSpacing: "$base",
        lineHeight: 1.4
      },
      6: {
        fontSize: "$heading6",
        letterSpacing: "$base",
        lineHeight: 1.4
      }
    },
    /** Setup the font weight*/
    weight: { ...ai }
  },
  defaultVariants: {
    level: "1",
    weight: "regular"
  }
}), t5 = R(function({ asChild: t, level: n = 1, ...r }, o) {
  const a = Ne(() => t ? je : typeof n == "number" || typeof n == "string" ? `h${n}` : "@initial" in n ? `h${n["@initial"]}` : "h1", [n, t]);
  return /* @__PURE__ */ h.jsx(e5, { ...r, level: n, as: a, ref: o });
}), xo = k("h6", {
  fontSize: "$subtitle",
  letterSpacing: "$base",
  fontFamily: "$base",
  color: "$textPrimaryMain",
  lineHeight: 1.4,
  mt: "0.1em",
  mb: "0.4em",
  variants: {
    weight: { ...ai }
  },
  defaultVariants: {
    weight: "regular"
  }
}), NI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Body: pt,
  Heading: t5,
  Subtitle: xo
}, Symbol.toStringTag, { value: "Module" })), n5 = ({
  children: e,
  className: t,
  innerProps: n,
  innerRef: r,
  isDisabled: o,
  isFocused: a,
  isSelected: i
}) => /* @__PURE__ */ h.jsx(
  Cg,
  {
    ...n,
    as: "div",
    clickable: o,
    ref: r,
    "data-focused": a,
    state: o ? "disabled" : i ? "selected" : void 0,
    className: t,
    children: e
  }
), r5 = ({ children: e, innerProps: t, className: n }) => /* @__PURE__ */ h.jsx(pt, { ...t, css: { textAlign: "center" }, className: n, children: e });
function o5({
  getValue: e,
  setValue: t,
  isMulti: n,
  options: r,
  selectProps: {
    // These are never undefined since react-select always provides a default,
    // but since the typedefs mark them as optional we provide a fallback
    getOptionValue: o = lc,
    getOptionLabel: a = lc
  }
}) {
  const { nativeSelectProps: i } = Ou();
  function s(u) {
    if (n) {
      const f = Array.from(u.target.selectedOptions, (g) => g.value), p = r.filter(
        (g) => f.includes(o(g))
      );
      t(p, "select-option");
    } else {
      const f = r.find((p) => o(p) === u.target.value);
      t(f ?? null, "select-option");
    }
  }
  const l = e().map(o), d = n ? l : l[0];
  return /* @__PURE__ */ h.jsx(
    a5,
    {
      ...i,
      value: d,
      multiple: n,
      onChange: s,
      children: r.map((u, f) => {
        const p = o(u), g = a(u);
        return /* @__PURE__ */ h.jsx("option", { value: p, children: g }, f);
      })
    }
  );
}
const a5 = k("select", {
  position: "absolute",
  visibility: "hidden",
  pointerEvents: "none"
}), lc = (e) => `${e}`, i5 = ({ children: e, className: t, ...n }) => /* @__PURE__ */ h.jsxs(
  nn,
  {
    ...n.innerProps,
    "data-component-name": "ValueContainer",
    className: t,
    css: {
      display: "flex",
      alignItems: "center",
      flex: 1,
      flexWrap: "wrap",
      WebkitOverflowScrolling: "touch",
      position: "relative",
      overflow: "hidden"
    },
    children: [
      e,
      /* @__PURE__ */ h.jsx(o5, { ...n })
    ]
  }
), s5 = ({ removeProps: e, innerProps: t, className: n, children: r }) => /* @__PURE__ */ h.jsxs(
  Ml,
  {
    ...t,
    css: { mr: "0.25rem", my: "0.25rem" },
    className: n,
    "data-component-name": "MultiValue",
    children: [
      r,
      /* @__PURE__ */ h.jsx(Dl, { ...e })
    ]
  }
), c5 = k(pt, {
  color: "$textPrimaryMain",
  maxWidth: "calc(100% - $space$base)",
  overflow: "hidden",
  position: "absolute",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  top: "50%",
  transform: "translateY(-50%)",
  boxSizing: "border-box",
  cursor: "default",
  variants: {
    isDisabled: {
      true: {
        color: "$textPrimary50",
        cursor: "not-allowed"
      }
    }
  }
}), l5 = ({ innerProps: e, children: t, isDisabled: n }) => /* @__PURE__ */ h.jsx(c5, { ...e, isDisabled: n, "data-component-name": "SingleValue", children: t }), u5 = ({ children: e, className: t }) => /* @__PURE__ */ h.jsx(
  nn,
  {
    css: {
      display: "grid",
      placeItems: "center",
      gridAutoFlow: "column",
      gridColumnGap: "0.125rem",
      pr: "$base"
    },
    className: t,
    "data-component-name": "IndicatorsContainer",
    children: e
  }
), d5 = ({ innerProps: e, className: t }) => /* @__PURE__ */ h.jsx(
  nn,
  {
    as: "span",
    "data-component-name": "IndicatorSeparator",
    ...e,
    css: { width: 0 },
    className: t
  }
), f5 = k(rn, {
  "&&": {
    $$backgroundIdle: "transparent",
    $$backgroundHover: "transparent",
    $$textIdle: "$colors$textPrimary30",
    "&:hover, &:focus": {
      $$textIdle: "$colors$textPrimary50"
    },
    "&:focus": {
      $$borderIdle: "$colors$textPrimary16A"
    }
  },
  svg: {
    fontSize: "1.125rem"
  }
}), p5 = k(rn, {
  '[data-select-state="open"] &': {
    backgroundColor: "$uiPrimary16A",
    svg: {
      transform: "rotate(180deg)"
    }
  }
}), b5 = ({
  innerProps: e,
  className: t,
  clearValue: n
}) => {
  const r = (o) => {
    (o.key === " " || o.key === "Enter") && n();
  };
  return /* @__PURE__ */ h.jsx(
    f5,
    {
      ...e,
      type: "button",
      iconButton: !0,
      variant: "ghost",
      color: "neutral",
      onKeyUp: r,
      className: t,
      "data-component-name": "ClearIndicator",
      children: /* @__PURE__ */ h.jsx(uo, {})
    }
  );
}, g5 = ({
  innerProps: e,
  isDisabled: t,
  className: n
}) => /* @__PURE__ */ h.jsx(
  p5,
  {
    ...e,
    iconButton: !0,
    type: "button",
    color: "primary",
    variant: "ghost",
    className: n,
    disabled: t,
    "data-component-name": "DropdownIndicator",
    children: /* @__PURE__ */ h.jsx(oi, {})
  }
), m5 = k(pt, {
  color: "$textPrimary30",
  mx: "0.125rem",
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  boxSizing: "border-box"
}), h5 = ({ innerProps: e, className: t, children: n }) => /* @__PURE__ */ h.jsx(m5, { ...e, className: t, children: n }), Fu = 2147483647, v5 = {
  Control: Jv,
  Menu: Qv,
  MenuList: Kv,
  Option: n5,
  ValueContainer: i5,
  MultiValue: s5,
  SingleValue: l5,
  NoOptionsMessage: r5,
  DropdownIndicator: g5,
  ClearIndicator: b5,
  IndicatorsContainer: u5,
  Placeholder: h5,
  IndicatorSeparator: d5,
  Input: qv
}, $5 = k(Lv, {}), _I = R(function({
  borderLess: t = !1,
  label: n,
  "aria-label": r = n,
  placeholder: o = "",
  menuPlacement: a = "auto",
  menuPortalTarget: i = typeof document < "u" ? document.body : void 0,
  error: s = !1,
  components: c,
  nativeSelectProps: l,
  ...d
}, u) {
  return /* @__PURE__ */ h.jsx(Yv, { label: n, placeholder: o, error: s, borderLess: t, nativeSelectProps: l, children: /* @__PURE__ */ h.jsx(
    $5,
    {
      ref: u,
      "aria-label": r,
      placeholder: o,
      components: {
        ...v5,
        ...c
      },
      menuPlacement: a,
      menuPortalTarget: i,
      styles: {
        menuPortal: (f) => ({
          ...f,
          pointerEvents: "initial",
          zIndex: Fu
        })
      },
      ...d
    }
  ) });
});
function Ti(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
const ku = [
  "PageUp",
  "PageDown"
], Nu = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight"
], _u = {
  "from-left": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowLeft"
  ],
  "from-right": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowRight"
  ],
  "from-bottom": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowLeft"
  ],
  "from-top": [
    "Home",
    "PageDown",
    "ArrowUp",
    "ArrowLeft"
  ]
}, ar = "Slider", [Da, x5, y5] = tr(ar), [Lu, LI] = _e(ar, [
  y5
]), [C5, yo] = Lu(ar), w5 = /* @__PURE__ */ R((e, t) => {
  const { name: n, min: r = 0, max: o = 100, step: a = 1, orientation: i = "horizontal", disabled: s = !1, minStepsBetweenThumbs: c = 0, defaultValue: l = [
    r
  ], value: d, onValueChange: u = () => {
  }, onValueCommit: f = () => {
  }, inverted: p = !1, ...g } = e, [b, m] = J(null), v = se(
    t,
    (D) => m(D)
  ), $ = O(/* @__PURE__ */ new Set()), x = O(0), w = i === "horizontal", C = b ? !!b.closest("form") : !0, P = w ? I5 : S5, [E = [], T] = Te({
    prop: d,
    defaultProp: l,
    onChange: (D) => {
      var M;
      (M = [
        ...$.current
      ][x.current]) === null || M === void 0 || M.focus(), u(D);
    }
  }), F = O(E);
  function V(D) {
    const M = F5(E, D);
    H(D, M);
  }
  function _(D) {
    H(D, x.current);
  }
  function W() {
    const D = F.current[x.current];
    E[x.current] !== D && f(E);
  }
  function H(D, M, { commit: j } = {
    commit: !1
  }) {
    const U = L5(a), ee = B5(Math.round((D - r) / a) * a + r, U), z = Ti(ee, [
      r,
      o
    ]);
    T((oe = []) => {
      const le = D5(oe, z, M);
      if (_5(le, c * a)) {
        x.current = le.indexOf(z);
        const ie = String(le) !== String(oe);
        return ie && j && f(le), ie ? le : oe;
      } else
        return oe;
    });
  }
  return /* @__PURE__ */ y(C5, {
    scope: e.__scopeSlider,
    disabled: s,
    min: r,
    max: o,
    valueIndexToChangeRef: x,
    thumbs: $.current,
    values: E,
    orientation: i
  }, /* @__PURE__ */ y(Da.Provider, {
    scope: e.__scopeSlider
  }, /* @__PURE__ */ y(Da.Slot, {
    scope: e.__scopeSlider
  }, /* @__PURE__ */ y(P, S({
    "aria-disabled": s,
    "data-disabled": s ? "" : void 0
  }, g, {
    ref: v,
    onPointerDown: G(g.onPointerDown, () => {
      s || (F.current = E);
    }),
    min: r,
    max: o,
    inverted: p,
    onSlideStart: s ? void 0 : V,
    onSlideMove: s ? void 0 : _,
    onSlideEnd: s ? void 0 : W,
    onHomeKeyDown: () => !s && H(r, 0, {
      commit: !0
    }),
    onEndKeyDown: () => !s && H(o, E.length - 1, {
      commit: !0
    }),
    onStepKeyDown: ({ event: D, direction: M }) => {
      if (!s) {
        const ee = ku.includes(D.key) || D.shiftKey && Nu.includes(D.key) ? 10 : 1, z = x.current, oe = E[z], le = a * ee * M;
        H(oe + le, z, {
          commit: !0
        });
      }
    }
  })))), C && E.map(
    (D, M) => /* @__PURE__ */ y(M5, {
      key: M,
      name: n ? n + (E.length > 1 ? "[]" : "") : void 0,
      value: D
    })
  ));
}), [Bu, Vu] = Lu(ar, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), I5 = /* @__PURE__ */ R((e, t) => {
  const { min: n, max: r, dir: o, inverted: a, onSlideStart: i, onSlideMove: s, onSlideEnd: c, onStepKeyDown: l, ...d } = e, [u, f] = J(null), p = se(
    t,
    (x) => f(x)
  ), g = O(), b = Bt(o), m = b === "ltr", v = m && !a || !m && a;
  function $(x) {
    const w = g.current || u.getBoundingClientRect(), C = [
      0,
      w.width
    ], E = Ri(C, v ? [
      n,
      r
    ] : [
      r,
      n
    ]);
    return g.current = w, E(x - w.left);
  }
  return /* @__PURE__ */ y(Bu, {
    scope: e.__scopeSlider,
    startEdge: v ? "left" : "right",
    endEdge: v ? "right" : "left",
    direction: v ? 1 : -1,
    size: "width"
  }, /* @__PURE__ */ y(Gu, S({
    dir: b,
    "data-orientation": "horizontal"
  }, d, {
    ref: p,
    style: {
      ...d.style,
      ["--radix-slider-thumb-transform"]: "translateX(-50%)"
    },
    onSlideStart: (x) => {
      const w = $(x.clientX);
      i == null || i(w);
    },
    onSlideMove: (x) => {
      const w = $(x.clientX);
      s == null || s(w);
    },
    onSlideEnd: () => {
      g.current = void 0, c == null || c();
    },
    onStepKeyDown: (x) => {
      const C = _u[v ? "from-left" : "from-right"].includes(x.key);
      l == null || l({
        event: x,
        direction: C ? -1 : 1
      });
    }
  })));
}), S5 = /* @__PURE__ */ R((e, t) => {
  const { min: n, max: r, inverted: o, onSlideStart: a, onSlideMove: i, onSlideEnd: s, onStepKeyDown: c, ...l } = e, d = O(null), u = se(t, d), f = O(), p = !o;
  function g(b) {
    const m = f.current || d.current.getBoundingClientRect(), v = [
      0,
      m.height
    ], x = Ri(v, p ? [
      r,
      n
    ] : [
      n,
      r
    ]);
    return f.current = m, x(b - m.top);
  }
  return /* @__PURE__ */ y(Bu, {
    scope: e.__scopeSlider,
    startEdge: p ? "bottom" : "top",
    endEdge: p ? "top" : "bottom",
    size: "height",
    direction: p ? 1 : -1
  }, /* @__PURE__ */ y(Gu, S({
    "data-orientation": "vertical"
  }, l, {
    ref: u,
    style: {
      ...l.style,
      ["--radix-slider-thumb-transform"]: "translateY(50%)"
    },
    onSlideStart: (b) => {
      const m = g(b.clientY);
      a == null || a(m);
    },
    onSlideMove: (b) => {
      const m = g(b.clientY);
      i == null || i(m);
    },
    onSlideEnd: () => {
      f.current = void 0, s == null || s();
    },
    onStepKeyDown: (b) => {
      const v = _u[p ? "from-bottom" : "from-top"].includes(b.key);
      c == null || c({
        event: b,
        direction: v ? -1 : 1
      });
    }
  })));
}), Gu = /* @__PURE__ */ R((e, t) => {
  const { __scopeSlider: n, onSlideStart: r, onSlideMove: o, onSlideEnd: a, onHomeKeyDown: i, onEndKeyDown: s, onStepKeyDown: c, ...l } = e, d = yo(ar, n);
  return /* @__PURE__ */ y(te.span, S({}, l, {
    ref: t,
    onKeyDown: G(e.onKeyDown, (u) => {
      u.key === "Home" ? (i(u), u.preventDefault()) : u.key === "End" ? (s(u), u.preventDefault()) : ku.concat(Nu).includes(u.key) && (c(u), u.preventDefault());
    }),
    onPointerDown: G(e.onPointerDown, (u) => {
      const f = u.target;
      f.setPointerCapture(u.pointerId), u.preventDefault(), d.thumbs.has(f) ? f.focus() : r(u);
    }),
    onPointerMove: G(e.onPointerMove, (u) => {
      u.target.hasPointerCapture(u.pointerId) && o(u);
    }),
    onPointerUp: G(e.onPointerUp, (u) => {
      const f = u.target;
      f.hasPointerCapture(u.pointerId) && (f.releasePointerCapture(u.pointerId), a(u));
    })
  }));
}), A5 = "SliderTrack", E5 = /* @__PURE__ */ R((e, t) => {
  const { __scopeSlider: n, ...r } = e, o = yo(A5, n);
  return /* @__PURE__ */ y(te.span, S({
    "data-disabled": o.disabled ? "" : void 0,
    "data-orientation": o.orientation
  }, r, {
    ref: t
  }));
}), uc = "SliderRange", P5 = /* @__PURE__ */ R((e, t) => {
  const { __scopeSlider: n, ...r } = e, o = yo(uc, n), a = Vu(uc, n), i = O(null), s = se(t, i), c = o.values.length, l = o.values.map(
    (f) => Wu(f, o.min, o.max)
  ), d = c > 1 ? Math.min(...l) : 0, u = 100 - Math.max(...l);
  return /* @__PURE__ */ y(te.span, S({
    "data-orientation": o.orientation,
    "data-disabled": o.disabled ? "" : void 0
  }, r, {
    ref: s,
    style: {
      ...e.style,
      [a.startEdge]: d + "%",
      [a.endEdge]: u + "%"
    }
  }));
}), dc = "SliderThumb", T5 = /* @__PURE__ */ R((e, t) => {
  const n = x5(e.__scopeSlider), [r, o] = J(null), a = se(
    t,
    (s) => o(s)
  ), i = Ne(
    () => r ? n().findIndex(
      (s) => s.ref.current === r
    ) : -1,
    [
      n,
      r
    ]
  );
  return /* @__PURE__ */ y(R5, S({}, e, {
    ref: a,
    index: i
  }));
}), R5 = /* @__PURE__ */ R((e, t) => {
  const { __scopeSlider: n, index: r, ...o } = e, a = yo(dc, n), i = Vu(dc, n), [s, c] = J(null), l = se(
    t,
    (m) => c(m)
  ), d = nr(s), u = a.values[r], f = u === void 0 ? 0 : Wu(u, a.min, a.max), p = O5(r, a.values.length), g = d == null ? void 0 : d[i.size], b = g ? k5(g, f, i.direction) : 0;
  return Z(() => {
    if (s)
      return a.thumbs.add(s), () => {
        a.thumbs.delete(s);
      };
  }, [
    s,
    a.thumbs
  ]), /* @__PURE__ */ y("span", {
    style: {
      transform: "var(--radix-slider-thumb-transform)",
      position: "absolute",
      [i.startEdge]: `calc(${f}% + ${b}px)`
    }
  }, /* @__PURE__ */ y(Da.ItemSlot, {
    scope: e.__scopeSlider
  }, /* @__PURE__ */ y(te.span, S({
    role: "slider",
    "aria-label": e["aria-label"] || p,
    "aria-valuemin": a.min,
    "aria-valuenow": u,
    "aria-valuemax": a.max,
    "aria-orientation": a.orientation,
    "data-orientation": a.orientation,
    "data-disabled": a.disabled ? "" : void 0,
    tabIndex: a.disabled ? void 0 : 0
  }, o, {
    ref: l,
    style: u === void 0 ? {
      display: "none"
    } : e.style,
    onFocus: G(e.onFocus, () => {
      a.valueIndexToChangeRef.current = r;
    })
  }))));
}), M5 = (e) => {
  const { value: t, ...n } = e, r = O(null), o = lo(t);
  return Z(() => {
    const a = r.current, i = window.HTMLInputElement.prototype, c = Object.getOwnPropertyDescriptor(i, "value").set;
    if (o !== t && c) {
      const l = new Event("input", {
        bubbles: !0
      });
      c.call(a, t), a.dispatchEvent(l);
    }
  }, [
    o,
    t
  ]), /* @__PURE__ */ y("input", S({
    style: {
      display: "none"
    }
  }, n, {
    ref: r,
    defaultValue: t
  }));
};
function D5(e = [], t, n) {
  const r = [
    ...e
  ];
  return r[n] = t, r.sort(
    (o, a) => o - a
  );
}
function Wu(e, t, n) {
  const a = 100 / (n - t) * (e - t);
  return Ti(a, [
    0,
    100
  ]);
}
function O5(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? [
    "Minimum",
    "Maximum"
  ][e] : void 0;
}
function F5(e, t) {
  if (e.length === 1)
    return 0;
  const n = e.map(
    (o) => Math.abs(o - t)
  ), r = Math.min(...n);
  return n.indexOf(r);
}
function k5(e, t, n) {
  const r = e / 2, a = Ri([
    0,
    50
  ], [
    0,
    r
  ]);
  return (r - a(t) * n) * n;
}
function N5(e) {
  return e.slice(0, -1).map(
    (t, n) => e[n + 1] - t
  );
}
function _5(e, t) {
  if (t > 0) {
    const n = N5(e);
    return Math.min(...n) >= t;
  }
  return !0;
}
function Ri(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1])
      return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function L5(e) {
  return (String(e).split(".")[1] || "").length;
}
function B5(e, t) {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
}
const V5 = w5, G5 = E5, W5 = P5, j5 = T5;
function ju({ children: e }) {
  const { setValues: t, value: n = [] } = ct(Co);
  return /* @__PURE__ */ h.jsx(h.Fragment, { children: A.Children.map(e, (r, o) => A.cloneElement(r, {
    key: o,
    value: n[o],
    onChange: (a) => {
      t((i = []) => [
        ...i.slice(0, o),
        // values before
        a.target.valueAsNumber,
        // new thumb value
        ...i.slice(o + 1)
        // values after
      ]);
    }
  })) });
}
function It(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
const Jr = 4, z5 = k(j5, {
  display: "block",
  fontSize: "$space$base",
  width: "1em",
  height: "1em",
  bgc: "$$elementFill",
  borderRadius: "50%",
  $$borderShadow: "0 0 0 1px $colors$uiSecondary",
  $$floatShadow: "0px 4px 10px rgba(0, 0, 0, 0.16)",
  $$shadow: "$$borderShadow",
  boxShadow: "$$shadow",
  transition: "box-shadow 0.2s ease",
  cursor: "grab",
  outline: "none",
  "&[data-disabled]": {
    cursor: "default"
  },
  "&:hover, &:focus": {
    $$shadow: "$$borderShadow, $$floatShadow"
  }
}), H5 = k("span", {
  $$scale: 0,
  padding: "$base",
  br: "$base",
  bgc: "$$elementFill",
  position: "absolute",
  bottom: "100%",
  left: "50%",
  transform: "translate(-50%, -30%) scale($$scale)",
  color: "$textAlwaysLightMain",
  transition: "transform 0.2s ease",
  transformOrigin: "bottom center",
  minWidth: "4ch",
  textAlign: "center",
  "&::before": {
    content: "attr(aria-valuenow)",
    position: "absolute",
    bottom: "-10%",
    left: "calc(50% - 0.5em)",
    width: "1em",
    height: "1em",
    br: "calc($base / 4)",
    transform: "rotate(135deg)",
    bgc: "inherit"
  },
  '[data-focused="true"] &': {
    $$scale: 1
  }
}), zu = "Slider.Thumb", Mi = A.forwardRef(function({ children: t, value: n, label: r = n, onChange: o, inputProps: a = {}, className: i, asChild: s, ...c }, l) {
  const [d, u] = A.useState(!1), f = /* @__PURE__ */ h.jsx(pt, { as: H5, variant: "caption", children: r }, "value-tooltip"), p = /* @__PURE__ */ y(
    X5,
    {
      ...a,
      type: "range",
      value: n,
      onChange: It(a.onChange, o),
      key: "input-proxy"
    }
  ), g = A.Children.toArray(t)[0];
  if (s && !g)
    throw new Error(`${zu} must have a child element when asChild=true`);
  return /* @__PURE__ */ h.jsx(
    z5,
    {
      ...c,
      asChild: s,
      className: [Hu, i].filter(Boolean).join(" "),
      role: "",
      onFocus: It(c.onFocus, () => {
        u(!0);
      }),
      onBlur: It(c.onBlur, () => {
        u(!1);
      }),
      "data-focused": d,
      ref: l,
      children: s ? A.cloneElement(g, {}, f, p) : /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
        f,
        t,
        p
      ] })
    }
  );
});
Mi.displayName = zu;
const X5 = k("input", {
  // This method of hiding is necessary for the range element to still be discoverable by test tools.
  // Using display: none would make test tools ignore it.
  position: "absolute",
  visibility: "hidden",
  pointerEvents: "none"
}), Hu = tn({
  cursor: "pointer",
  position: "relative",
  "&::before": {
    content: '""',
    size: "2.5em",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  }
})(), Z5 = k(V5, {
  minWidth: 64,
  position: "relative",
  display: "flex",
  alignItems: "center",
  userSelect: "none",
  touchAction: "none",
  br: "calc($base * 1.5)",
  $$bgFill: "$colors$uiPrimary16A",
  $$elementFill: "$colors$uiPrimaryMain",
  height: "$space$base",
  boxSizing: "border-box",
  "&[data-disabled]": {
    $$bgFill: "$colors$uiDisabled25",
    $$elementFill: "$colors$uiDisabledMain",
    opacity: 0.3
  },
  variants: {
    setup: {
      default: {},
      segmentedValues: {
        minHeight: "calc($space$base * 4)",
        pb: "$base"
      }
    }
  },
  defaultVariants: {
    setup: "default"
  }
}), Xu = k(G5, {
  bgc: "$$bgFill",
  position: "relative",
  flexGrow: 1,
  height: "calc($space$base / 2)",
  br: "calc($base * 1.5)"
}), Zu = k(W5, {
  position: "absolute",
  bgc: "$$elementFill",
  br: "calc($base * 1.5)",
  height: "100%",
  maxWidth: "100%"
}), Co = A.createContext({
  min: 0,
  max: 100,
  step: 1,
  withValueSegments: !1,
  setValues: (e) => e,
  setWithValueSegments() {
    console.warn("Not contextualized");
  }
}), Y5 = A.forwardRef(function({
  min: t = 0,
  value: n,
  defaultValue: r = [t],
  onValueChange: o,
  children: a,
  asChild: i,
  ...s
}, c) {
  const [l, d] = A.useState(!1), [u = [], f] = Te({
    prop: n,
    defaultProp: r,
    onChange: o
  });
  if (i && !(a && A.isValidElement(a)))
    throw new Error("Slider got asChild=true but no valid children were provided");
  const p = {
    ...s,
    min: t,
    defaultValue: r,
    value: u,
    onValueChange: f
  }, g = {
    ...s,
    min: t,
    value: u,
    setValues: f,
    withValueSegments: l,
    setWithValueSegments: d
  }, b = A.Children.only(
    A.Children.toArray(a)[0]
  ), m = /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    /* @__PURE__ */ h.jsx(Xu, { children: /* @__PURE__ */ h.jsx(Zu, {}) }, "track"),
    /* @__PURE__ */ h.jsx(ju, { children: u.map(($, x) => /* @__PURE__ */ h.jsx(Mi, {}, x)) }, "thumbs-container")
  ] }), v = i ? A.cloneElement(
    b,
    b.props,
    b.props.children || m
  ) : a || m;
  return /* @__PURE__ */ h.jsx(Co.Provider, { value: g, children: /* @__PURE__ */ h.jsx(
    Z5,
    {
      ...p,
      asChild: i,
      setup: l ? "segmentedValues" : "default",
      ref: c,
      children: v
    }
  ) });
});
function Yu(e, t, n, r, o) {
  return (e - t) * (o - r) / (n - t) + r;
}
const U5 = "span", J5 = k(U5, {
  position: "absolute",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center"
}), Q5 = k("span", {
  content: '""',
  fontSize: "calc($space$base / 2)",
  size: "1em",
  transform: "translateX(var(--offset))",
  variants: {
    segmentType: {
      dot: {
        br: "50%",
        bgc: "$$elementFill"
      },
      dash: {
        bgc: "$textPrimary16A",
        width: 1,
        mx: "calc(0.5em - 0.5px)"
      }
    }
  },
  defaultVariants: {
    segmentType: "dot"
  }
}), Uu = A.forwardRef((e, t) => {
  const { variant: n, asChild: r, children: o, ...a } = e, { max: i = 100, step: s = 1, min: c = 0 } = A.useContext(Co);
  if (r && !(o && A.isValidElement(o)))
    throw new Error(
      "NumericSegments received asChild=true but received child is not valid React element"
    );
  const l = A.useMemo(() => {
    const u = i / s + 1 - c, f = Math.max(Math.round(u), 0);
    return Array(f).fill(0).map((p, g) => {
      const b = g === 0, m = g === f - 1, v = b || m ? 0 : Yu(g, 0, f - 1, Jr / 2, -Jr / 2);
      return /* @__PURE__ */ h.jsx(
        Q5,
        {
          segmentType: typeof n == "function" ? n(g) : n,
          className: Hu,
          ref: ($) => {
            $ && $.style.setProperty("--offset", `${v}px`);
          }
        },
        `${p}-${g}`
      );
    });
  }, [i, s, c]), d = o;
  return /* @__PURE__ */ h.jsx(J5, { ...a, as: r ? je : "span", ref: t, children: r ? A.cloneElement(d, d.props, ...l) : l });
});
Uu.displayName = "SliderSegments";
const K5 = k("span", {
  fontSize: "$caption",
  position: "absolute",
  width: "100%",
  height: "1em",
  bottom: 0,
  left: 0,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center"
}), q5 = k("span", {
  display: "block",
  transform: "translateX(-50%)",
  fontFamily: "$base",
  fontSize: "1em",
  position: "absolute",
  left: "calc(var(--position) + var(--offset))",
  textAlign: "center",
  cursor: "pointer",
  color: "$textPrimary50",
  "[data-disabled] &": {
    cursor: "default"
  },
  variants: {
    isSelected: {
      true: {
        color: "$textPrimaryMain"
      }
    }
  }
});
function e$(e, t, n, r, o) {
  if (!r)
    return !1;
  const a = t / (r - 1), i = e + a * n;
  if (!o || o.length < 1)
    return !1;
  const s = o[0], c = o[o.length - 1];
  return o.length > 1 ? i >= s && i <= c : i === s;
}
const Ju = A.forwardRef(
  function({ labels: t, asChild: n, children: r, ...o }, a) {
    const {
      min: i = 0,
      max: s = 100,
      step: c = 1,
      value: l,
      setWithValueSegments: d
    } = A.useContext(Co);
    if (A.useEffect(() => (d(!0), () => {
      d(!1);
    }), []), n && !(r && A.isValidElement(r)))
      throw new Error("ValueSegmentsRoot received asChild=true but received child is not valid React element");
    const u = s / c + 1 - i, f = Math.max(Math.round(u), 0), g = (t || Array(f).fill(0).map((m, v) => String(v))).map((m, v, $) => {
      const x = v / ($.length - 1) * 100, w = Yu(v, 0, $.length - 1, Jr, -Jr), C = e$(i, s, v, t == null ? void 0 : t.length, l);
      return /* @__PURE__ */ h.jsx(
        q5,
        {
          isSelected: C,
          ref: (P) => {
            P && (P.style.setProperty("--position", `${x.toFixed(2)}%`), P.style.setProperty("--offset", `${w}px`));
          },
          children: m
        },
        `${m}-${v}`
      );
    }), b = r;
    return /* @__PURE__ */ h.jsx(K5, { ...o, as: n ? je : "span", ref: a, children: n ? A.cloneElement(b, b.props, ...g) : g });
  }
);
Ju.displayName = "SliderSegments";
const BI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NumericSegments: Uu,
  Range: Zu,
  Root: Y5,
  Thumb: Mi,
  ThumbsContainer: ju,
  Track: Xu,
  ValueSegments: Ju
}, Symbol.toStringTag, { value: "Module" })), Qu = "Switch", [t$, VI] = _e(Qu), [n$, r$] = t$(Qu), o$ = /* @__PURE__ */ R((e, t) => {
  const { __scopeSwitch: n, name: r, checked: o, defaultChecked: a, required: i, disabled: s, value: c = "on", onCheckedChange: l, ...d } = e, [u, f] = J(null), p = se(
    t,
    ($) => f($)
  ), g = O(!1), b = u ? !!u.closest("form") : !0, [m = !1, v] = Te({
    prop: o,
    defaultProp: a,
    onChange: l
  });
  return /* @__PURE__ */ y(n$, {
    scope: n,
    checked: m,
    disabled: s
  }, /* @__PURE__ */ y(te.button, S({
    type: "button",
    role: "switch",
    "aria-checked": m,
    "aria-required": i,
    "data-state": Ku(m),
    "data-disabled": s ? "" : void 0,
    disabled: s,
    value: c
  }, d, {
    ref: p,
    onClick: G(e.onClick, ($) => {
      v(
        (x) => !x
      ), b && (g.current = $.isPropagationStopped(), g.current || $.stopPropagation());
    })
  })), b && /* @__PURE__ */ y(s$, {
    control: u,
    bubbles: !g.current,
    name: r,
    value: c,
    checked: m,
    required: i,
    disabled: s,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), a$ = "SwitchThumb", i$ = /* @__PURE__ */ R((e, t) => {
  const { __scopeSwitch: n, ...r } = e, o = r$(a$, n);
  return /* @__PURE__ */ y(te.span, S({
    "data-state": Ku(o.checked),
    "data-disabled": o.disabled ? "" : void 0
  }, r, {
    ref: t
  }));
}), s$ = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...o } = e, a = O(null), i = lo(n), s = nr(t);
  return Z(() => {
    const c = a.current, l = window.HTMLInputElement.prototype, u = Object.getOwnPropertyDescriptor(l, "checked").set;
    if (i !== n && u) {
      const f = new Event("click", {
        bubbles: r
      });
      u.call(c, n), c.dispatchEvent(f);
    }
  }, [
    i,
    n,
    r
  ]), /* @__PURE__ */ y("input", S({
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: n
  }, o, {
    tabIndex: -1,
    ref: a,
    style: {
      ...e.style,
      ...s,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function Ku(e) {
  return e ? "checked" : "unchecked";
}
const c$ = o$, l$ = i$, u$ = k(c$, {
  border: "none",
  appearance: "none",
  width: 36,
  height: 20,
  $$bgFill: "$colors$uiMonochrome30",
  $$bgFillHover: "$colors$uiMonochrome20",
  br: "calc($base * 1.25)",
  padding: 0,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  bgc: "$$bgFill",
  cursor: "pointer",
  [`.${il} &, .${sl} &`]: {
    $$bgFill: "$colors$uiMonochrome25"
  },
  '&[data-state="checked"]': {
    $$bgFill: "$colors$uiPrimaryMain",
    $$bgFillHover: "linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), $$bgFill"
  },
  "&:hover, &.state--hover": {
    background: "$$bgFillHover"
  },
  "&[data-disabled]": {
    pointerEvents: "none",
    $$bgFill: "$colors$uiDisabledMain",
    opacity: 0.25
  }
}), d$ = k(l$, {
  $$bgFill: "#FFF",
  fontSize: "0.875rem",
  width: "1em",
  height: "1em",
  br: "1em",
  bgc: "$$bgFill",
  display: "inline-block",
  // Once again the design team is at it.
  // DESPITE the pushes for a UNIFIED DESIGN LANGUAGE
  // They, to this day, still like their dribbble one-offs.
  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)",
  transform: "translateX(-$space$base)",
  transition: "transform 0.2s ease-out",
  '&[data-state="checked"]': {
    transform: "translateX($space$base)"
  },
  "&[data-disabled]": {
    $$bgFill: "$colors$textAlwaysLight30",
    boxShadow: "none"
  }
}), GI = A.forwardRef(function(t, n) {
  return /* @__PURE__ */ h.jsx(u$, { ...t, ref: n, children: /* @__PURE__ */ h.jsx(d$, {}) });
}), qu = [
  Ai,
  Ei,
  Pi
], f$ = new RegExp(
  `${qu.join("|")}`
), p$ = qu.join(", ");
function b$(e) {
  var n;
  const t = {};
  for (let r = 0; r < e.length; r++) {
    const o = e[r], a = ((n = o == null ? void 0 : o.type) == null ? void 0 : n.displayName) || "UnnamedComponent", i = f$.exec(a);
    if (!i) {
      console.warn(`
      TextField child '${a}' is not a valid TextField child.
      Accepted children are: ${p$}
      `);
      continue;
    }
    const [s] = i;
    switch (s) {
      case Ai:
        const l = `${o.props.position || "end"}Adornment`;
        t[l] = o;
        break;
      case Ei:
        t.helperText = o;
        break;
      case Pi:
        t.charLimitIndicator = o;
        break;
    }
  }
  return t;
}
const ed = Kt({
  value: "",
  endAdornmentSize: 0,
  startAdornmentSize: 0,
  maxLength: 1 / 0,
  setAdornmentSize() {
    console.warn("setAdornmentSize: Not available");
  },
  setFocused() {
    console.warn("setFocused: Not available");
  },
  setValue() {
    console.warn("setValue: Not available");
  }
});
function ir() {
  return ct(ed);
}
function g$({ children: e, ...t }) {
  return /* @__PURE__ */ h.jsx(ed.Provider, { value: t, children: e });
}
function fc(e) {
  const t = O(e);
  return Z(() => {
    t.current = e;
  }, [e]), t;
}
function td(e, t) {
  return function(r) {
    if (t && (t.current = r), !!e) {
      if (typeof e == "function") {
        e(r);
        return;
      }
      e.current = r;
    }
  };
}
const m$ = "span", h$ = k(m$, {
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  display: "inline-grid",
  placeItems: "center",
  fontFamily: "$base",
  fontSize: "$bodyText",
  color: "$$labelColor",
  [`input:invalid ~ &, ${zv}`]: {
    color: "$textError"
  },
  [Hv]: {
    color: "$uiMonochromeMain"
  },
  svg: {
    fill: "currentcolor"
  },
  variants: {
    position: {
      start: {
        left: "$base"
      },
      end: {
        right: "$base"
      }
    }
  },
  defaultVariants: {
    position: "end"
  }
}), v$ = k(El, {
  "&.SvgIcon-root": {
    fontSize: "1rem"
  }
}), Di = A.forwardRef(
  ({ asChild: e, position: t = "end", ...n }, r) => {
    const { setAdornmentSize: o } = ir(), a = A.useRef(null), i = fc(t), s = fc(o), c = td(r, a);
    return A.useEffect(() => {
      if (!a.current)
        return;
      function l() {
        var u;
        s.current(i.current, ((u = a.current) == null ? void 0 : u.clientWidth) || 0);
      }
      const d = new ResizeObserver(l);
      return d.observe(a.current), l(), () => {
        d.disconnect();
      };
    }, []), /* @__PURE__ */ h.jsx(h$, { ...n, position: t, as: e ? je : "span", ref: c });
  }
);
Di.displayName = Ai;
function $$() {
  return /* @__PURE__ */ h.jsx(Di, { css: { fontSize: "1.125rem" }, children: /* @__PURE__ */ h.jsx(v$, {}) });
}
const nd = R(function({
  children: t,
  value: n,
  defaultValue: r,
  onValueChange: o,
  label: a,
  disabled: i,
  name: s,
  error: c = !1,
  placeholder: l,
  maxLength: d = 1 / 0,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  inputProps: u,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange: f,
  ...p
}, g) {
  const [b, m] = A.useState({
    start: 0,
    end: 0
  }), [v, $] = A.useState(!1), [x = "", w] = Te({
    prop: n,
    defaultProp: r,
    onChange: o
  }), [C, P] = t, { helperText: E, startAdornment: T, endAdornment: F, charLimitIndicator: V } = b$(
    A.Children.toArray(P)
  ), _ = c ? (
    // We show "invalid" icon only when there's an error and
    // a component is not provided.
    F || /* @__PURE__ */ h.jsx($$, {})
  ) : F, H = {
    value: x,
    setAdornmentSize: (M, j) => {
      m((U) => ({
        ...U,
        [M]: j
      }));
    },
    startAdornmentSize: b.start,
    endAdornmentSize: b.end,
    maxLength: d,
    setFocused: $,
    setValue: w
  }, D = td(g);
  return /* @__PURE__ */ h.jsx(g$, { ...H, children: /* @__PURE__ */ h.jsxs(
    Au,
    {
      ...p,
      "data-disabled": !!i,
      "data-focused": v,
      "data-has-value": `${x}`.length > 0,
      "data-label": a,
      "data-error": c,
      "data-has-placeholder": !!l,
      ref: (M) => {
        D(M), M && (M.style.setProperty("--startAdornmentSize", `${H.startAdornmentSize}px`), M.style.setProperty("--endAdornmentSize", `${H.endAdornmentSize}px`));
      },
      children: [
        /* @__PURE__ */ h.jsxs(nn, { css: { position: "relative" }, children: [
          C,
          /* @__PURE__ */ h.jsx(Eu, { as: "label", css: { display: a ? "block" : "none" }, htmlFor: s, children: a }),
          T,
          _,
          /* @__PURE__ */ h.jsx(Ru, { children: /* @__PURE__ */ h.jsx(Mu, { "data-label": a, children: a }) }),
          V
        ] }),
        E && A.cloneElement(E, { error: c })
      ]
    }
  ) });
});
function rd({ error: e = !1 }) {
  const { startAdornmentSize: t, endAdornmentSize: n } = ir();
  return {
    "data-error": e,
    "data-adornment-start": t > 0,
    "data-adornment-end": n > 0
  };
}
function od(e) {
  const {
    type: t = "text",
    placeholder: n,
    name: r,
    disabled: o,
    required: a,
    inputProps: i,
    error: s,
    maxLength: c,
    ...l
  } = e;
  return [
    {
      type: t,
      placeholder: n,
      name: r,
      inputProps: i,
      maxLength: c,
      required: a,
      disabled: o,
      error: s
    },
    l
  ];
}
function x$(e) {
  const { setFocused: t, setValue: n, value: r } = ir(), [{ inputProps: o, error: a, ...i }, { onChange: s }] = od(
    e
  ), c = rd({ error: a });
  return /* @__PURE__ */ h.jsx(
    Tu,
    {
      ...i,
      ...c,
      ...o,
      value: r,
      onChange: It(s, (l) => {
        n(l.target.value);
      }),
      onFocus: It(o == null ? void 0 : o.onFocus, () => {
        t(!0);
      }),
      onBlur: It(o == null ? void 0 : o.onBlur, () => {
        t(!1);
      })
    }
  );
}
function y$(e) {
  const { setFocused: t, setValue: n, value: r } = ir(), [{ inputProps: o, error: a, ...i }, { onChange: s }] = od(
    e
  ), c = rd({ error: a });
  return /* @__PURE__ */ h.jsx(
    Zv,
    {
      ...i,
      ...c,
      ...o,
      value: r,
      onChange: It(s, (l) => {
        n(l.target.value);
      }),
      onFocus: It(o == null ? void 0 : o.onFocus, () => {
        t(!0);
      }),
      onBlur: It(o == null ? void 0 : o.onBlur, () => {
        t(!1);
      }),
      ref: (l) => {
        l && (l.style.height = "auto", l.style.height = `${l.scrollHeight}px`);
      }
    }
  );
}
const C$ = R(
  function({ children: t, ...n }, r) {
    return /* @__PURE__ */ h.jsxs(nd, { ...n, ref: r, children: [
      /* @__PURE__ */ h.jsx(x$, { ...n }),
      t
    ] });
  }
), w$ = R(
  function({ children: t, ...n }, r) {
    return /* @__PURE__ */ h.jsxs(nd, { ...n, ref: r, children: [
      /* @__PURE__ */ h.jsx(y$, { ...n }),
      t
    ] });
  }
), I$ = k(pt, {
  color: "$textPrimary50",
  variants: {
    error: {
      true: {
        color: "$textError"
      }
    }
  }
}), ad = R(
  ({ asChild: e, css: t = {}, ...n }, r) => /* @__PURE__ */ h.jsx(
    I$,
    {
      ...n,
      variant: "caption",
      css: t,
      as: e ? je : "span",
      ref: r
    }
  )
);
ad.displayName = Ei;
const S$ = k("span", {
  size: "1.5rem",
  br: "50%",
  display: "inline-block",
  position: "absolute",
  bottom: "$base",
  right: "$base"
});
function A$(e, t) {
  const r = (t - `${e}`.length) / t * 100;
  if (r > 40)
    return "primary";
  if (r > 0)
    return "attention";
  if (r <= 0)
    return "error";
}
const id = A.forwardRef(
  (e, t) => {
    const { showLabel: n = !0 } = e, { maxLength: r, value: o } = ir();
    if (!isFinite(r))
      return null;
    const i = A$(`${o}`, r), s = r - `${o}`.length, c = `You have ${s} characters left of ${r}`;
    return /* @__PURE__ */ h.jsx(S$, { ...e, ref: t, "aria-label": c, children: /* @__PURE__ */ h.jsx(
      Gr,
      {
        css: { pointerEvents: "none", $$background: "$colors$uiMonochrome30" },
        context: i,
        value: `${o}`.length,
        maxValue: r,
        size: 24,
        strokeWidth: 2,
        children: n ? /* @__PURE__ */ h.jsx($a, { children: s }) : null
      }
    ) });
  }
);
id.displayName = Pi;
const WI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Adornment: Di,
  CharLimitIndicator: id,
  HelperText: ad,
  Multi: w$,
  Single: C$
}, Symbol.toStringTag, { value: "Module" }));
function E$(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ee(e);
  Z(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const Oa = "dismissableLayer.update", P$ = "dismissableLayer.pointerDownOutside", T$ = "dismissableLayer.focusOutside";
let pc;
const sd = /* @__PURE__ */ Kt({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), sr = /* @__PURE__ */ R((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: a, onFocusOutside: i, onInteractOutside: s, onDismiss: c, ...l } = e, d = ct(sd), [u, f] = J(null), p = (n = u == null ? void 0 : u.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, g] = J({}), b = se(
    t,
    (T) => f(T)
  ), m = Array.from(d.layers), [v] = [
    ...d.layersWithOutsidePointerEventsDisabled
  ].slice(-1), $ = m.indexOf(v), x = u ? m.indexOf(u) : -1, w = d.layersWithOutsidePointerEventsDisabled.size > 0, C = x >= $, P = M$((T) => {
    const F = T.target, V = [
      ...d.branches
    ].some(
      (_) => _.contains(F)
    );
    !C || V || (a == null || a(T), s == null || s(T), T.defaultPrevented || c == null || c());
  }, p), E = D$((T) => {
    const F = T.target;
    [
      ...d.branches
    ].some(
      (_) => _.contains(F)
    ) || (i == null || i(T), s == null || s(T), T.defaultPrevented || c == null || c());
  }, p);
  return E$((T) => {
    x === d.layers.size - 1 && (o == null || o(T), !T.defaultPrevented && c && (T.preventDefault(), c()));
  }, p), Z(() => {
    if (u)
      return r && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (pc = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(u)), d.layers.add(u), bc(), () => {
        r && d.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = pc);
      };
  }, [
    u,
    p,
    r,
    d
  ]), Z(() => () => {
    u && (d.layers.delete(u), d.layersWithOutsidePointerEventsDisabled.delete(u), bc());
  }, [
    u,
    d
  ]), Z(() => {
    const T = () => g({});
    return document.addEventListener(Oa, T), () => document.removeEventListener(Oa, T);
  }, []), /* @__PURE__ */ y(te.div, S({}, l, {
    ref: b,
    style: {
      pointerEvents: w ? C ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: G(e.onFocusCapture, E.onFocusCapture),
    onBlurCapture: G(e.onBlurCapture, E.onBlurCapture),
    onPointerDownCapture: G(e.onPointerDownCapture, P.onPointerDownCapture)
  }));
}), R$ = /* @__PURE__ */ R((e, t) => {
  const n = ct(sd), r = O(null), o = se(t, r);
  return Z(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [
    n.branches
  ]), /* @__PURE__ */ y(te.div, S({}, e, {
    ref: o
  }));
});
function M$(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ee(e), r = O(!1), o = O(() => {
  });
  return Z(() => {
    const a = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          cd(P$, n, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, {
          once: !0
        })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function D$(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ee(e), r = O(!1);
  return Z(() => {
    const o = (a) => {
      a.target && !r.current && cd(T$, n, {
        originalEvent: a
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function bc() {
  const e = new CustomEvent(Oa);
  document.dispatchEvent(e);
}
function cd(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? Ka(o, a) : o.dispatchEvent(a);
}
const O$ = sr, F$ = R$;
function gc(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const a = En(t), i = yi(t), s = xi(i), c = Pt(t), l = a === "y", d = r.x + r.width / 2 - o.width / 2, u = r.y + r.height / 2 - o.height / 2, f = r[s] / 2 - o[s] / 2;
  let p;
  switch (c) {
    case "top":
      p = {
        x: d,
        y: r.y - o.height
      };
      break;
    case "bottom":
      p = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: u
      };
      break;
    case "left":
      p = {
        x: r.x - o.width,
        y: u
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (An(t)) {
    case "start":
      p[i] -= f * (n && l ? -1 : 1);
      break;
    case "end":
      p[i] += f * (n && l ? -1 : 1);
      break;
  }
  return p;
}
const k$ = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: i
  } = n, s = a.filter(Boolean), c = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let l = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: d,
    y: u
  } = gc(l, r, c), f = r, p = {}, g = 0;
  for (let b = 0; b < s.length; b++) {
    const {
      name: m,
      fn: v
    } = s[b], {
      x: $,
      y: x,
      data: w,
      reset: C
    } = await v({
      x: d,
      y: u,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: p,
      rects: l,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (d = $ ?? d, u = x ?? u, p = {
      ...p,
      [m]: {
        ...p[m],
        ...w
      }
    }, C && g <= 50) {
      g++, typeof C == "object" && (C.placement && (f = C.placement), C.rects && (l = C.rects === !0 ? await i.getElementRects({
        reference: e,
        floating: t,
        strategy: o
      }) : C.rects), {
        x: d,
        y: u
      } = gc(l, f, c)), b = -1;
      continue;
    }
  }
  return {
    x: d,
    y: u,
    placement: f,
    strategy: o,
    middlewareData: p
  };
};
async function Yn(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: a,
    rects: i,
    elements: s,
    strategy: c
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: u = "floating",
    altBoundary: f = !1,
    padding: p = 0
  } = Et(t, e), g = Kl(p), m = s[f ? u === "floating" ? "reference" : "floating" : u], v = Zn(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(m))) == null || n ? m : m.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: l,
    rootBoundary: d,
    strategy: c
  })), $ = u === "floating" ? {
    ...i.floating,
    x: r,
    y: o
  } : i.reference, x = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), w = await (a.isElement == null ? void 0 : a.isElement(x)) ? await (a.getScale == null ? void 0 : a.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, C = Zn(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: $,
    offsetParent: x,
    strategy: c
  }) : $);
  return {
    top: (v.top - C.top + g.top) / w.y,
    bottom: (C.bottom - v.bottom + g.bottom) / w.y,
    left: (v.left - C.left + g.left) / w.x,
    right: (C.right - v.right + g.right) / w.x
  };
}
const N$ = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: a,
      platform: i,
      elements: s,
      middlewareData: c
    } = t, {
      element: l,
      padding: d = 0
    } = Et(e, t) || {};
    if (l == null)
      return {};
    const u = Kl(d), f = {
      x: n,
      y: r
    }, p = yi(o), g = xi(p), b = await i.getDimensions(l), m = p === "y", v = m ? "top" : "left", $ = m ? "bottom" : "right", x = m ? "clientHeight" : "clientWidth", w = a.reference[g] + a.reference[p] - f[p] - a.floating[g], C = f[p] - a.reference[p], P = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l));
    let E = P ? P[x] : 0;
    (!E || !await (i.isElement == null ? void 0 : i.isElement(P))) && (E = s.floating[x] || a.floating[g]);
    const T = w / 2 - C / 2, F = E / 2 - b[g] / 2 - 1, V = At(u[v], F), _ = At(u[$], F), W = V, H = E - b[g] - _, D = E / 2 - b[g] / 2 + T, M = Ea(W, D, H), j = !c.arrow && An(o) != null && D != M && a.reference[g] / 2 - (D < W ? V : _) - b[g] / 2 < 0, U = j ? D < W ? D - W : D - H : 0;
    return {
      [p]: f[p] + U,
      data: {
        [p]: M,
        centerOffset: D - M - U,
        ...j && {
          alignmentOffset: U
        }
      },
      reset: j
    };
  }
}), _$ = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: a,
        rects: i,
        initialPlacement: s,
        platform: c,
        elements: l
      } = t, {
        mainAxis: d = !0,
        crossAxis: u = !0,
        fallbackPlacements: f,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: b = !0,
        ...m
      } = Et(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const v = Pt(o), $ = Pt(s) === s, x = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), w = f || ($ || !b ? [Xr(s)] : ih(s));
      !f && g !== "none" && w.push(...ch(s, b, g, x));
      const C = [s, ...w], P = await Yn(t, m), E = [];
      let T = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (d && E.push(P[v]), u) {
        const W = ah(o, i, x);
        E.push(P[W[0]], P[W[1]]);
      }
      if (T = [...T, {
        placement: o,
        overflows: E
      }], !E.every((W) => W <= 0)) {
        var F, V;
        const W = (((F = a.flip) == null ? void 0 : F.index) || 0) + 1, H = C[W];
        if (H)
          return {
            data: {
              index: W,
              overflows: T
            },
            reset: {
              placement: H
            }
          };
        let D = (V = T.filter((M) => M.overflows[0] <= 0).sort((M, j) => M.overflows[1] - j.overflows[1])[0]) == null ? void 0 : V.placement;
        if (!D)
          switch (p) {
            case "bestFit": {
              var _;
              const M = (_ = T.map((j) => [j.placement, j.overflows.filter((U) => U > 0).reduce((U, ee) => U + ee, 0)]).sort((j, U) => j[1] - U[1])[0]) == null ? void 0 : _[0];
              M && (D = M);
              break;
            }
            case "initialPlacement":
              D = s;
              break;
          }
        if (o !== D)
          return {
            reset: {
              placement: D
            }
          };
      }
      return {};
    }
  };
};
function mc(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function hc(e) {
  return nh.some((t) => e[t] >= 0);
}
const L$ = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = Et(e, t);
      switch (r) {
        case "referenceHidden": {
          const a = await Yn(t, {
            ...o,
            elementContext: "reference"
          }), i = mc(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: hc(i)
            }
          };
        }
        case "escaped": {
          const a = await Yn(t, {
            ...o,
            altBoundary: !0
          }), i = mc(a, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: hc(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function B$(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), i = Pt(n), s = An(n), c = En(n) === "y", l = ["left", "top"].includes(i) ? -1 : 1, d = a && c ? -1 : 1, u = Et(t, e);
  let {
    mainAxis: f,
    crossAxis: p,
    alignmentAxis: g
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...u
  };
  return s && typeof g == "number" && (p = s === "end" ? g * -1 : g), c ? {
    x: p * d,
    y: f * l
  } : {
    x: f * l,
    y: p * d
  };
}
const V$ = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: a,
        placement: i,
        middlewareData: s
      } = t, c = await B$(t, e);
      return i === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: o + c.x,
        y: a + c.y,
        data: {
          ...c,
          placement: i
        }
      };
    }
  };
}, G$ = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: a = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (m) => {
            let {
              x: v,
              y: $
            } = m;
            return {
              x: v,
              y: $
            };
          }
        },
        ...c
      } = Et(e, t), l = {
        x: n,
        y: r
      }, d = await Yn(t, c), u = En(Pt(o)), f = $i(u);
      let p = l[f], g = l[u];
      if (a) {
        const m = f === "y" ? "top" : "left", v = f === "y" ? "bottom" : "right", $ = p + d[m], x = p - d[v];
        p = Ea($, p, x);
      }
      if (i) {
        const m = u === "y" ? "top" : "left", v = u === "y" ? "bottom" : "right", $ = g + d[m], x = g - d[v];
        g = Ea($, g, x);
      }
      const b = s.fn({
        ...t,
        [f]: p,
        [u]: g
      });
      return {
        ...b,
        data: {
          x: b.x - n,
          y: b.y - r
        }
      };
    }
  };
}, W$ = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: a,
        middlewareData: i
      } = t, {
        offset: s = 0,
        mainAxis: c = !0,
        crossAxis: l = !0
      } = Et(e, t), d = {
        x: n,
        y: r
      }, u = En(o), f = $i(u);
      let p = d[f], g = d[u];
      const b = Et(s, t), m = typeof b == "number" ? {
        mainAxis: b,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...b
      };
      if (c) {
        const x = f === "y" ? "height" : "width", w = a.reference[f] - a.floating[x] + m.mainAxis, C = a.reference[f] + a.reference[x] - m.mainAxis;
        p < w ? p = w : p > C && (p = C);
      }
      if (l) {
        var v, $;
        const x = f === "y" ? "width" : "height", w = ["top", "left"].includes(Pt(o)), C = a.reference[u] - a.floating[x] + (w && ((v = i.offset) == null ? void 0 : v[u]) || 0) + (w ? 0 : m.crossAxis), P = a.reference[u] + a.reference[x] + (w ? 0 : (($ = i.offset) == null ? void 0 : $[u]) || 0) - (w ? m.crossAxis : 0);
        g < C ? g = C : g > P && (g = P);
      }
      return {
        [f]: p,
        [u]: g
      };
    }
  };
}, j$ = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: o,
        elements: a
      } = t, {
        apply: i = () => {
        },
        ...s
      } = Et(e, t), c = await Yn(t, s), l = Pt(n), d = An(n), u = En(n) === "y", {
        width: f,
        height: p
      } = r.floating;
      let g, b;
      l === "top" || l === "bottom" ? (g = l, b = d === (await (o.isRTL == null ? void 0 : o.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (b = l, g = d === "end" ? "top" : "bottom");
      const m = p - c[g], v = f - c[b], $ = !t.middlewareData.shift;
      let x = m, w = v;
      if (u) {
        const P = f - c.left - c.right;
        w = d || $ ? At(v, P) : P;
      } else {
        const P = p - c.top - c.bottom;
        x = d || $ ? At(m, P) : P;
      }
      if ($ && !d) {
        const P = qe(c.left, 0), E = qe(c.right, 0), T = qe(c.top, 0), F = qe(c.bottom, 0);
        u ? w = f - 2 * (P !== 0 || E !== 0 ? P + E : qe(c.left, c.right)) : x = p - 2 * (T !== 0 || F !== 0 ? T + F : qe(c.top, c.bottom));
      }
      await i({
        ...t,
        availableWidth: w,
        availableHeight: x
      });
      const C = await o.getDimensions(a.floating);
      return f !== C.width || p !== C.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function ld(e) {
  const t = tt(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = st(e), a = o ? e.offsetWidth : n, i = o ? e.offsetHeight : r, s = kt(n) !== a || kt(r) !== i;
  return s && (n = a, r = i), {
    width: n,
    height: r,
    $: s
  };
}
function Oi(e) {
  return it(e) ? e : e.contextElement;
}
function yn(e) {
  const t = Oi(e);
  if (!st(t))
    return at(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: a
  } = ld(t);
  let i = (a ? kt(n.width) : n.width) / r, s = (a ? kt(n.height) : n.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const z$ = /* @__PURE__ */ at(0);
function ud(e) {
  const t = We(e);
  return !mo() || !t.visualViewport ? z$ : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function H$(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== We(e) ? !1 : t;
}
function en(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), a = Oi(e);
  let i = at(1);
  t && (r ? it(r) && (i = yn(r)) : i = yn(e));
  const s = H$(a, n, r) ? ud(a) : at(0);
  let c = (o.left + s.x) / i.x, l = (o.top + s.y) / i.y, d = o.width / i.x, u = o.height / i.y;
  if (a) {
    const f = We(a), p = r && it(r) ? We(r) : r;
    let g = f.frameElement;
    for (; g && r && p !== f; ) {
      const b = yn(g), m = g.getBoundingClientRect(), v = tt(g), $ = m.left + (g.clientLeft + parseFloat(v.paddingLeft)) * b.x, x = m.top + (g.clientTop + parseFloat(v.paddingTop)) * b.y;
      c *= b.x, l *= b.y, d *= b.x, u *= b.y, c += $, l += x, g = We(g).frameElement;
    }
  }
  return Zn({
    width: d,
    height: u,
    x: c,
    y: l
  });
}
function X$(e) {
  let {
    rect: t,
    offsetParent: n,
    strategy: r
  } = e;
  const o = st(n), a = yt(n);
  if (n === a)
    return t;
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = at(1);
  const c = at(0);
  if ((o || !o && r !== "fixed") && ((Nt(n) !== "body" || or(a)) && (i = vo(n)), st(n))) {
    const l = en(n);
    s = yn(n), c.x = l.x + n.clientLeft, c.y = l.y + n.clientTop;
  }
  return {
    width: t.width * s.x,
    height: t.height * s.y,
    x: t.x * s.x - i.scrollLeft * s.x + c.x,
    y: t.y * s.y - i.scrollTop * s.y + c.y
  };
}
function Z$(e) {
  return Array.from(e.getClientRects());
}
function dd(e) {
  return en(yt(e)).left + vo(e).scrollLeft;
}
function Y$(e) {
  const t = yt(e), n = vo(e), r = e.ownerDocument.body, o = qe(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = qe(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let i = -n.scrollLeft + dd(e);
  const s = -n.scrollTop;
  return tt(r).direction === "rtl" && (i += qe(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: a,
    x: i,
    y: s
  };
}
function U$(e, t) {
  const n = We(e), r = yt(e), o = n.visualViewport;
  let a = r.clientWidth, i = r.clientHeight, s = 0, c = 0;
  if (o) {
    a = o.width, i = o.height;
    const l = mo();
    (!l || l && t === "fixed") && (s = o.offsetLeft, c = o.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: s,
    y: c
  };
}
function J$(e, t) {
  const n = en(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, a = st(e) ? yn(e) : at(1), i = e.clientWidth * a.x, s = e.clientHeight * a.y, c = o * a.x, l = r * a.y;
  return {
    width: i,
    height: s,
    x: c,
    y: l
  };
}
function vc(e, t, n) {
  let r;
  if (t === "viewport")
    r = U$(e, n);
  else if (t === "document")
    r = Y$(yt(e));
  else if (it(t))
    r = J$(t, n);
  else {
    const o = ud(e);
    r = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return Zn(r);
}
function fd(e, t) {
  const n = wn(e);
  return n === t || !it(n) || ho(n) ? !1 : tt(n).position === "fixed" || fd(n, t);
}
function Q$(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = qt(e, [], !1).filter((s) => it(s) && Nt(s) !== "body"), o = null;
  const a = tt(e).position === "fixed";
  let i = a ? wn(e) : e;
  for (; it(i) && !ho(i); ) {
    const s = tt(i), c = Ci(i);
    !c && s.position === "fixed" && (o = null), (a ? !c && !o : !c && s.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || or(i) && !c && fd(e, i)) ? r = r.filter((d) => d !== i) : o = s, i = wn(i);
  }
  return t.set(e, r), r;
}
function K$(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const i = [...n === "clippingAncestors" ? Q$(t, this._c) : [].concat(n), r], s = i[0], c = i.reduce((l, d) => {
    const u = vc(t, d, o);
    return l.top = qe(u.top, l.top), l.right = At(u.right, l.right), l.bottom = At(u.bottom, l.bottom), l.left = qe(u.left, l.left), l;
  }, vc(t, s, o));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function q$(e) {
  const {
    width: t,
    height: n
  } = ld(e);
  return {
    width: t,
    height: n
  };
}
function e3(e, t, n) {
  const r = st(t), o = yt(t), a = n === "fixed", i = en(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = at(0);
  if (r || !r && !a)
    if ((Nt(t) !== "body" || or(o)) && (s = vo(t)), r) {
      const l = en(t, !0, a, t);
      c.x = l.x + t.clientLeft, c.y = l.y + t.clientTop;
    } else
      o && (c.x = dd(o));
  return {
    x: i.left + s.scrollLeft - c.x,
    y: i.top + s.scrollTop - c.y,
    width: i.width,
    height: i.height
  };
}
function $c(e, t) {
  return !st(e) || tt(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function pd(e, t) {
  const n = We(e);
  if (!st(e))
    return n;
  let r = $c(e, t);
  for (; r && uh(r) && tt(r).position === "static"; )
    r = $c(r, t);
  return r && (Nt(r) === "html" || Nt(r) === "body" && tt(r).position === "static" && !Ci(r)) ? n : r || dh(e) || n;
}
const t3 = async function(e) {
  let {
    reference: t,
    floating: n,
    strategy: r
  } = e;
  const o = this.getOffsetParent || pd, a = this.getDimensions;
  return {
    reference: e3(t, await o(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await a(n)
    }
  };
};
function n3(e) {
  return tt(e).direction === "rtl";
}
const r3 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: X$,
  getDocumentElement: yt,
  getClippingRect: K$,
  getOffsetParent: pd,
  getElementRects: t3,
  getClientRects: Z$,
  getDimensions: q$,
  getScale: yn,
  isElement: it,
  isRTL: n3
};
function o3(e, t) {
  let n = null, r;
  const o = yt(e);
  function a() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function i(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), a();
    const {
      left: l,
      top: d,
      width: u,
      height: f
    } = e.getBoundingClientRect();
    if (s || t(), !u || !f)
      return;
    const p = Ft(d), g = Ft(o.clientWidth - (l + u)), b = Ft(o.clientHeight - (d + f)), m = Ft(l), $ = {
      rootMargin: -p + "px " + -g + "px " + -b + "px " + -m + "px",
      threshold: qe(0, At(1, c)) || 1
    };
    let x = !0;
    function w(C) {
      const P = C[0].intersectionRatio;
      if (P !== c) {
        if (!x)
          return i();
        P ? i(!1, P) : r = setTimeout(() => {
          i(!1, 1e-7);
        }, 100);
      }
      x = !1;
    }
    try {
      n = new IntersectionObserver(w, {
        ...$,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(w, $);
    }
    n.observe(e);
  }
  return i(!0), a;
}
function a3(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, l = Oi(e), d = o || a ? [...l ? qt(l) : [], ...qt(t)] : [];
  d.forEach((v) => {
    o && v.addEventListener("scroll", n, {
      passive: !0
    }), a && v.addEventListener("resize", n);
  });
  const u = l && s ? o3(l, n) : null;
  let f = -1, p = null;
  i && (p = new ResizeObserver((v) => {
    let [$] = v;
    $ && $.target === l && p && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      p && p.observe(t);
    })), n();
  }), l && !c && p.observe(l), p.observe(t));
  let g, b = c ? en(e) : null;
  c && m();
  function m() {
    const v = en(e);
    b && (v.x !== b.x || v.y !== b.y || v.width !== b.width || v.height !== b.height) && n(), b = v, g = requestAnimationFrame(m);
  }
  return n(), () => {
    d.forEach((v) => {
      o && v.removeEventListener("scroll", n), a && v.removeEventListener("resize", n);
    }), u && u(), p && p.disconnect(), p = null, c && cancelAnimationFrame(g);
  };
}
const i3 = G$, s3 = _$, c3 = j$, l3 = L$, xc = N$, u3 = W$, d3 = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: r3,
    ...n
  }, a = {
    ...o.platform,
    _c: r
  };
  return k$(e, t, {
    ...o,
    platform: a
  });
}, f3 = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? xc({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? xc({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
};
var kr = typeof document < "u" ? ao : Z;
function Qr(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!Qr(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const a = o[r];
      if (!(a === "_owner" && e.$$typeof) && !Qr(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function bd(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function yc(e, t) {
  const n = bd(e);
  return Math.round(t * n) / n;
}
function Cc(e) {
  const t = N.useRef(e);
  return kr(() => {
    t.current = e;
  }), t;
}
function p3(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: a,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: l
  } = e, [d, u] = N.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, p] = N.useState(r);
  Qr(f, r) || p(r);
  const [g, b] = N.useState(null), [m, v] = N.useState(null), $ = N.useCallback((U) => {
    U !== P.current && (P.current = U, b(U));
  }, []), x = N.useCallback((U) => {
    U !== E.current && (E.current = U, v(U));
  }, []), w = a || g, C = i || m, P = N.useRef(null), E = N.useRef(null), T = N.useRef(d), F = c != null, V = Cc(c), _ = Cc(o), W = N.useCallback(() => {
    if (!P.current || !E.current)
      return;
    const U = {
      placement: t,
      strategy: n,
      middleware: f
    };
    _.current && (U.platform = _.current), d3(P.current, E.current, U).then((ee) => {
      const z = {
        ...ee,
        isPositioned: !0
      };
      H.current && !Qr(T.current, z) && (T.current = z, z1.flushSync(() => {
        u(z);
      }));
    });
  }, [f, t, n, _]);
  kr(() => {
    l === !1 && T.current.isPositioned && (T.current.isPositioned = !1, u((U) => ({
      ...U,
      isPositioned: !1
    })));
  }, [l]);
  const H = N.useRef(!1);
  kr(() => (H.current = !0, () => {
    H.current = !1;
  }), []), kr(() => {
    if (w && (P.current = w), C && (E.current = C), w && C) {
      if (V.current)
        return V.current(w, C, W);
      W();
    }
  }, [w, C, W, V, F]);
  const D = N.useMemo(() => ({
    reference: P,
    floating: E,
    setReference: $,
    setFloating: x
  }), [$, x]), M = N.useMemo(() => ({
    reference: w,
    floating: C
  }), [w, C]), j = N.useMemo(() => {
    const U = {
      position: n,
      left: 0,
      top: 0
    };
    if (!M.floating)
      return U;
    const ee = yc(M.floating, d.x), z = yc(M.floating, d.y);
    return s ? {
      ...U,
      transform: "translate(" + ee + "px, " + z + "px)",
      ...bd(M.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: ee,
      top: z
    };
  }, [n, s, M.floating, d.x, d.y]);
  return N.useMemo(() => ({
    ...d,
    update: W,
    refs: D,
    elements: M,
    floatingStyles: j
  }), [d, W, D, M, j]);
}
const b3 = /* @__PURE__ */ R((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...a } = e;
  return /* @__PURE__ */ y(te.svg, S({}, a, {
    ref: t,
    width: r,
    height: o,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), e.asChild ? n : /* @__PURE__ */ y("polygon", {
    points: "0,0 30,0 15,10"
  }));
}), g3 = b3, gd = "Popper", [md, Pn] = _e(gd), [m3, hd] = md(gd), h3 = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = J(null);
  return /* @__PURE__ */ y(m3, {
    scope: t,
    anchor: r,
    onAnchorChange: o
  }, n);
}, v3 = "PopperAnchor", $3 = /* @__PURE__ */ R((e, t) => {
  const { __scopePopper: n, virtualRef: r, ...o } = e, a = hd(v3, n), i = O(null), s = se(t, i);
  return Z(() => {
    a.onAnchorChange((r == null ? void 0 : r.current) || i.current);
  }), r ? null : /* @__PURE__ */ y(te.div, S({}, o, {
    ref: s
  }));
}), vd = "PopperContent", [x3, y3] = md(vd), C3 = /* @__PURE__ */ R((e, t) => {
  var n, r, o, a, i, s, c, l;
  const { __scopePopper: d, side: u = "bottom", sideOffset: f = 0, align: p = "center", alignOffset: g = 0, arrowPadding: b = 0, avoidCollisions: m = !0, collisionBoundary: v = [], collisionPadding: $ = 0, sticky: x = "partial", hideWhenDetached: w = !1, updatePositionStrategy: C = "optimized", onPlaced: P, ...E } = e, T = hd(vd, d), [F, V] = J(null), _ = se(
    t,
    (Pe) => V(Pe)
  ), [W, H] = J(null), D = nr(W), M = (n = D == null ? void 0 : D.width) !== null && n !== void 0 ? n : 0, j = (r = D == null ? void 0 : D.height) !== null && r !== void 0 ? r : 0, U = u + (p !== "center" ? "-" + p : ""), ee = typeof $ == "number" ? $ : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...$
  }, z = Array.isArray(v) ? v : [
    v
  ], oe = z.length > 0, le = {
    padding: ee,
    boundary: z.filter(A3),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: oe
  }, { refs: ie, floatingStyles: fe, placement: Ae, isPositioned: Re, middlewareData: B } = p3({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: U,
    whileElementsMounted: (...Pe) => a3(...Pe, {
      animationFrame: C === "always"
    }),
    elements: {
      reference: T.anchor
    },
    middleware: [
      V$({
        mainAxis: f + j,
        alignmentAxis: g
      }),
      m && i3({
        mainAxis: !0,
        crossAxis: !1,
        limiter: x === "partial" ? u3() : void 0,
        ...le
      }),
      m && s3({
        ...le
      }),
      c3({
        ...le,
        apply: ({ elements: Pe, rects: gt, availableWidth: br, availableHeight: gr }) => {
          const { width: sn, height: Bo } = gt.reference, cn = Pe.floating.style;
          cn.setProperty("--radix-popper-available-width", `${br}px`), cn.setProperty("--radix-popper-available-height", `${gr}px`), cn.setProperty("--radix-popper-anchor-width", `${sn}px`), cn.setProperty("--radix-popper-anchor-height", `${Bo}px`);
        }
      }),
      W && f3({
        element: W,
        padding: b
      }),
      E3({
        arrowWidth: M,
        arrowHeight: j
      }),
      w && l3({
        strategy: "referenceHidden",
        ...le
      })
    ]
  }), [ue, we] = $d(Ae), ce = Ee(P);
  ft(() => {
    Re && (ce == null || ce());
  }, [
    Re,
    ce
  ]);
  const Le = (o = B.arrow) === null || o === void 0 ? void 0 : o.x, Je = (a = B.arrow) === null || a === void 0 ? void 0 : a.y, X = ((i = B.arrow) === null || i === void 0 ? void 0 : i.centerOffset) !== 0, [Ve, Ze] = J();
  return ft(() => {
    F && Ze(window.getComputedStyle(F).zIndex);
  }, [
    F
  ]), /* @__PURE__ */ y("div", {
    ref: ie.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...fe,
      transform: Re ? fe.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: Ve,
      ["--radix-popper-transform-origin"]: [
        (s = B.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (c = B.transformOrigin) === null || c === void 0 ? void 0 : c.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ y(x3, {
    scope: d,
    placedSide: ue,
    onArrowChange: H,
    arrowX: Le,
    arrowY: Je,
    shouldHideArrow: X
  }, /* @__PURE__ */ y(te.div, S({
    "data-side": ue,
    "data-align": we
  }, E, {
    ref: _,
    style: {
      ...E.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: Re ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (l = B.hide) !== null && l !== void 0 && l.referenceHidden ? 0 : void 0
    }
  }))));
}), w3 = "PopperArrow", I3 = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, S3 = /* @__PURE__ */ R(function(t, n) {
  const { __scopePopper: r, ...o } = t, a = y3(w3, r), i = I3[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ y("span", {
      ref: a.onArrowChange,
      style: {
        position: "absolute",
        left: a.arrowX,
        top: a.arrowY,
        [i]: 0,
        transformOrigin: {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[a.placedSide],
        transform: {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: "rotate(180deg)",
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[a.placedSide],
        visibility: a.shouldHideArrow ? "hidden" : void 0
      }
    }, /* @__PURE__ */ y(g3, S({}, o, {
      ref: n,
      style: {
        ...o.style,
        // ensures the element can be measured correctly (mostly for if SVG)
        display: "block"
      }
    })))
  );
});
function A3(e) {
  return e !== null;
}
const E3 = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, r, o, a, i;
    const { placement: s, rects: c, middlewareData: l } = t, u = ((n = l.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, f = u ? 0 : e.arrowWidth, p = u ? 0 : e.arrowHeight, [g, b] = $d(s), m = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[b], v = ((r = (o = l.arrow) === null || o === void 0 ? void 0 : o.x) !== null && r !== void 0 ? r : 0) + f / 2, $ = ((a = (i = l.arrow) === null || i === void 0 ? void 0 : i.y) !== null && a !== void 0 ? a : 0) + p / 2;
    let x = "", w = "";
    return g === "bottom" ? (x = u ? m : `${v}px`, w = `${-p}px`) : g === "top" ? (x = u ? m : `${v}px`, w = `${c.floating.height + p}px`) : g === "right" ? (x = `${-p}px`, w = u ? m : `${$}px`) : g === "left" && (x = `${c.floating.width + p}px`, w = u ? m : `${$}px`), {
      data: {
        x,
        y: w
      }
    };
  }
});
function $d(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const wo = h3, Io = $3, Fi = C3, ki = S3, on = /* @__PURE__ */ R((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = e;
  return r ? /* @__PURE__ */ H1.createPortal(/* @__PURE__ */ y(te.div, S({}, o, {
    ref: t
  })), r) : null;
}), P3 = on, jI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Portal: on,
  Root: P3
}, Symbol.toStringTag, { value: "Module" })), Ni = /* @__PURE__ */ R((e, t) => /* @__PURE__ */ y(te.span, S({}, e, {
  ref: t,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...e.style
  }
}))), T3 = Ni, [So, zI] = _e("Tooltip", [
  Pn
]), Ao = Pn(), R3 = "TooltipProvider", M3 = 700, Fa = "tooltip.open", [D3, _i] = So(R3), O3 = (e) => {
  const { __scopeTooltip: t, delayDuration: n = M3, skipDelayDuration: r = 300, disableHoverableContent: o = !1, children: a } = e, [i, s] = J(!0), c = O(!1), l = O(0);
  return Z(() => {
    const d = l.current;
    return () => window.clearTimeout(d);
  }, []), /* @__PURE__ */ y(D3, {
    scope: t,
    isOpenDelayed: i,
    delayDuration: n,
    onOpen: K(() => {
      window.clearTimeout(l.current), s(!1);
    }, []),
    onClose: K(() => {
      window.clearTimeout(l.current), l.current = window.setTimeout(
        () => s(!0),
        r
      );
    }, [
      r
    ]),
    isPointerInTransitRef: c,
    onPointerInTransitChange: K((d) => {
      c.current = d;
    }, []),
    disableHoverableContent: o
  }, a);
}, Li = "Tooltip", [F3, cr] = So(Li), k3 = (e) => {
  const { __scopeTooltip: t, children: n, open: r, defaultOpen: o = !1, onOpenChange: a, disableHoverableContent: i, delayDuration: s } = e, c = _i(Li, e.__scopeTooltip), l = Ao(t), [d, u] = J(null), f = nt(), p = O(0), g = i ?? c.disableHoverableContent, b = s ?? c.delayDuration, m = O(!1), [v = !1, $] = Te({
    prop: r,
    defaultProp: o,
    onChange: (E) => {
      E ? (c.onOpen(), document.dispatchEvent(new CustomEvent(Fa))) : c.onClose(), a == null || a(E);
    }
  }), x = Ne(() => v ? m.current ? "delayed-open" : "instant-open" : "closed", [
    v
  ]), w = K(() => {
    window.clearTimeout(p.current), m.current = !1, $(!0);
  }, [
    $
  ]), C = K(() => {
    window.clearTimeout(p.current), $(!1);
  }, [
    $
  ]), P = K(() => {
    window.clearTimeout(p.current), p.current = window.setTimeout(() => {
      m.current = !0, $(!0);
    }, b);
  }, [
    b,
    $
  ]);
  return Z(() => () => window.clearTimeout(p.current), []), /* @__PURE__ */ y(wo, l, /* @__PURE__ */ y(F3, {
    scope: t,
    contentId: f,
    open: v,
    stateAttribute: x,
    trigger: d,
    onTriggerChange: u,
    onTriggerEnter: K(() => {
      c.isOpenDelayed ? P() : w();
    }, [
      c.isOpenDelayed,
      P,
      w
    ]),
    onTriggerLeave: K(() => {
      g ? C() : window.clearTimeout(p.current);
    }, [
      C,
      g
    ]),
    onOpen: w,
    onClose: C,
    disableHoverableContent: g
  }, n));
}, wc = "TooltipTrigger", N3 = /* @__PURE__ */ R((e, t) => {
  const { __scopeTooltip: n, ...r } = e, o = cr(wc, n), a = _i(wc, n), i = Ao(n), s = O(null), c = se(t, s, o.onTriggerChange), l = O(!1), d = O(!1), u = K(
    () => l.current = !1,
    []
  );
  return Z(() => () => document.removeEventListener("pointerup", u), [
    u
  ]), /* @__PURE__ */ y(Io, S({
    asChild: !0
  }, i), /* @__PURE__ */ y(te.button, S({
    // We purposefully avoid adding `type=button` here because tooltip triggers are also
    // commonly anchors and the anchor `type` attribute signifies MIME type.
    "aria-describedby": o.open ? o.contentId : void 0,
    "data-state": o.stateAttribute
  }, r, {
    ref: c,
    onPointerMove: G(e.onPointerMove, (f) => {
      f.pointerType !== "touch" && !d.current && !a.isPointerInTransitRef.current && (o.onTriggerEnter(), d.current = !0);
    }),
    onPointerLeave: G(e.onPointerLeave, () => {
      o.onTriggerLeave(), d.current = !1;
    }),
    onPointerDown: G(e.onPointerDown, () => {
      l.current = !0, document.addEventListener("pointerup", u, {
        once: !0
      });
    }),
    onFocus: G(e.onFocus, () => {
      l.current || o.onOpen();
    }),
    onBlur: G(e.onBlur, o.onClose),
    onClick: G(e.onClick, o.onClose)
  })));
}), xd = "TooltipPortal", [_3, L3] = So(xd, {
  forceMount: void 0
}), B3 = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: o } = e, a = cr(xd, t);
  return /* @__PURE__ */ y(_3, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ y(Oe, {
    present: n || a.open
  }, /* @__PURE__ */ y(on, {
    asChild: !0,
    container: o
  }, r)));
}, Un = "TooltipContent", V3 = /* @__PURE__ */ R((e, t) => {
  const n = L3(Un, e.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...a } = e, i = cr(Un, e.__scopeTooltip);
  return /* @__PURE__ */ y(Oe, {
    present: r || i.open
  }, i.disableHoverableContent ? /* @__PURE__ */ y(yd, S({
    side: o
  }, a, {
    ref: t
  })) : /* @__PURE__ */ y(G3, S({
    side: o
  }, a, {
    ref: t
  })));
}), G3 = /* @__PURE__ */ R((e, t) => {
  const n = cr(Un, e.__scopeTooltip), r = _i(Un, e.__scopeTooltip), o = O(null), a = se(t, o), [i, s] = J(null), { trigger: c, onClose: l } = n, d = o.current, { onPointerInTransitChange: u } = r, f = K(() => {
    s(null), u(!1);
  }, [
    u
  ]), p = K((g, b) => {
    const m = g.currentTarget, v = {
      x: g.clientX,
      y: g.clientY
    }, $ = X3(v, m.getBoundingClientRect()), x = Z3(v, $), w = Y3(b.getBoundingClientRect()), C = J3([
      ...x,
      ...w
    ]);
    s(C), u(!0);
  }, [
    u
  ]);
  return Z(() => () => f(), [
    f
  ]), Z(() => {
    if (c && d) {
      const g = (m) => p(m, d), b = (m) => p(m, c);
      return c.addEventListener("pointerleave", g), d.addEventListener("pointerleave", b), () => {
        c.removeEventListener("pointerleave", g), d.removeEventListener("pointerleave", b);
      };
    }
  }, [
    c,
    d,
    p,
    f
  ]), Z(() => {
    if (i) {
      const g = (b) => {
        const m = b.target, v = {
          x: b.clientX,
          y: b.clientY
        }, $ = (c == null ? void 0 : c.contains(m)) || (d == null ? void 0 : d.contains(m)), x = !U3(v, i);
        $ ? f() : x && (f(), l());
      };
      return document.addEventListener("pointermove", g), () => document.removeEventListener("pointermove", g);
    }
  }, [
    c,
    d,
    i,
    l,
    f
  ]), /* @__PURE__ */ y(yd, S({}, e, {
    ref: a
  }));
}), [W3, j3] = So(Li, {
  isInside: !1
}), yd = /* @__PURE__ */ R((e, t) => {
  const { __scopeTooltip: n, children: r, "aria-label": o, onEscapeKeyDown: a, onPointerDownOutside: i, ...s } = e, c = cr(Un, n), l = Ao(n), { onClose: d } = c;
  return Z(() => (document.addEventListener(Fa, d), () => document.removeEventListener(Fa, d)), [
    d
  ]), Z(() => {
    if (c.trigger) {
      const u = (f) => {
        const p = f.target;
        p != null && p.contains(c.trigger) && d();
      };
      return window.addEventListener("scroll", u, {
        capture: !0
      }), () => window.removeEventListener("scroll", u, {
        capture: !0
      });
    }
  }, [
    c.trigger,
    d
  ]), /* @__PURE__ */ y(sr, {
    asChild: !0,
    disableOutsidePointerEvents: !1,
    onEscapeKeyDown: a,
    onPointerDownOutside: i,
    onFocusOutside: (u) => u.preventDefault(),
    onDismiss: d
  }, /* @__PURE__ */ y(Fi, S({
    "data-state": c.stateAttribute
  }, l, s, {
    ref: t,
    style: {
      ...s.style,
      "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
      "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
      "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }), /* @__PURE__ */ y(cl, null, r), /* @__PURE__ */ y(W3, {
    scope: n,
    isInside: !0
  }, /* @__PURE__ */ y(T3, {
    id: c.contentId,
    role: "tooltip"
  }, o || r))));
}), z3 = "TooltipArrow", H3 = /* @__PURE__ */ R((e, t) => {
  const { __scopeTooltip: n, ...r } = e, o = Ao(n);
  return j3(z3, n).isInside ? null : /* @__PURE__ */ y(ki, S({}, o, r, {
    ref: t
  }));
});
function X3(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, a)) {
    case a:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function Z3(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push({
        x: e.x - n,
        y: e.y + n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "bottom":
      r.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y - n
      });
      break;
    case "left":
      r.push({
        x: e.x + n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "right":
      r.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x - n,
        y: e.y + n
      });
      break;
  }
  return r;
}
function Y3(e) {
  const { top: t, right: n, bottom: r, left: o } = e;
  return [
    {
      x: o,
      y: t
    },
    {
      x: n,
      y: t
    },
    {
      x: n,
      y: r
    },
    {
      x: o,
      y: r
    }
  ];
}
function U3(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const s = t[a].x, c = t[a].y, l = t[i].x, d = t[i].y;
    c > r != d > r && n < (l - s) * (r - c) / (d - c) + s && (o = !o);
  }
  return o;
}
function J3(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), Q3(t);
}
function Q3(e) {
  if (e.length <= 1)
    return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const a = t[t.length - 1], i = t[t.length - 2];
      if ((a.x - i.x) * (o.y - i.y) >= (a.y - i.y) * (o.x - i.x))
        t.pop();
      else
        break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const a = n[n.length - 1], i = n[n.length - 2];
      if ((a.x - i.x) * (o.y - i.y) >= (a.y - i.y) * (o.x - i.x))
        n.pop();
      else
        break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
const K3 = O3, Cd = k3, wd = N3, q3 = B3, e9 = V3, t9 = H3, n9 = k(e9, {
  br: "calc($base/2)",
  padding: "$base",
  fontSize: "$caption",
  color: "$textPrimary70",
  mt: "calc($base / 2)",
  bgc: "$$themeColor",
  fontFamily: "$base",
  variants: {
    appearance: {
      neutral: {
        $$themeColor: "$colors$uiTertiary"
      },
      primary: {
        $$themeColor: "$colors$uiPrimaryMain"
      }
    },
    outlined: {
      true: {
        border: "1px solid $divider"
      }
    }
  },
  defaultVariants: {
    appearance: "neutral",
    outlined: !0
  }
}), Id = R(
  (e, t) => /* @__PURE__ */ h.jsx(q3, { children: /* @__PURE__ */ h.jsx(n9, { ...e, ref: t }) })
), r9 = k(t9, {
  fill: "$$themeColor"
}), Sd = R((e, t) => /* @__PURE__ */ h.jsx(r9, { ...e, ref: t })), o9 = A.Fragment, HI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Arrow: Sd,
  Content: Id,
  Portal: o9,
  Provider: K3,
  Root: Cd,
  Trigger: wd
}, Symbol.toStringTag, { value: "Module" })), ta = "rovingFocusGroup.onEntryFocus", a9 = {
  bubbles: !1,
  cancelable: !0
}, Bi = "RovingFocusGroup", [ka, Ad, i9] = tr(Bi), [s9, Gt] = _e(Bi, [
  i9
]), [c9, l9] = s9(Bi), u9 = /* @__PURE__ */ R((e, t) => /* @__PURE__ */ y(ka.Provider, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ y(ka.Slot, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ y(d9, S({}, e, {
  ref: t
}))))), d9 = /* @__PURE__ */ R((e, t) => {
  const { __scopeRovingFocusGroup: n, orientation: r, loop: o = !1, dir: a, currentTabStopId: i, defaultCurrentTabStopId: s, onCurrentTabStopIdChange: c, onEntryFocus: l, ...d } = e, u = O(null), f = se(t, u), p = Bt(a), [g = null, b] = Te({
    prop: i,
    defaultProp: s,
    onChange: c
  }), [m, v] = J(!1), $ = Ee(l), x = Ad(n), w = O(!1), [C, P] = J(0);
  return Z(() => {
    const E = u.current;
    if (E)
      return E.addEventListener(ta, $), () => E.removeEventListener(ta, $);
  }, [
    $
  ]), /* @__PURE__ */ y(c9, {
    scope: n,
    orientation: r,
    dir: p,
    loop: o,
    currentTabStopId: g,
    onItemFocus: K(
      (E) => b(E),
      [
        b
      ]
    ),
    onItemShiftTab: K(
      () => v(!0),
      []
    ),
    onFocusableItemAdd: K(
      () => P(
        (E) => E + 1
      ),
      []
    ),
    onFocusableItemRemove: K(
      () => P(
        (E) => E - 1
      ),
      []
    )
  }, /* @__PURE__ */ y(te.div, S({
    tabIndex: m || C === 0 ? -1 : 0,
    "data-orientation": r
  }, d, {
    ref: f,
    style: {
      outline: "none",
      ...e.style
    },
    onMouseDown: G(e.onMouseDown, () => {
      w.current = !0;
    }),
    onFocus: G(e.onFocus, (E) => {
      const T = !w.current;
      if (E.target === E.currentTarget && T && !m) {
        const F = new CustomEvent(ta, a9);
        if (E.currentTarget.dispatchEvent(F), !F.defaultPrevented) {
          const V = x().filter(
            (M) => M.focusable
          ), _ = V.find(
            (M) => M.active
          ), W = V.find(
            (M) => M.id === g
          ), D = [
            _,
            W,
            ...V
          ].filter(Boolean).map(
            (M) => M.ref.current
          );
          Ed(D);
        }
      }
      w.current = !1;
    }),
    onBlur: G(
      e.onBlur,
      () => v(!1)
    )
  })));
}), f9 = "RovingFocusGroupItem", p9 = /* @__PURE__ */ R((e, t) => {
  const { __scopeRovingFocusGroup: n, focusable: r = !0, active: o = !1, tabStopId: a, ...i } = e, s = nt(), c = a || s, l = l9(f9, n), d = l.currentTabStopId === c, u = Ad(n), { onFocusableItemAdd: f, onFocusableItemRemove: p } = l;
  return Z(() => {
    if (r)
      return f(), () => p();
  }, [
    r,
    f,
    p
  ]), /* @__PURE__ */ y(ka.ItemSlot, {
    scope: n,
    id: c,
    focusable: r,
    active: o
  }, /* @__PURE__ */ y(te.span, S({
    tabIndex: d ? 0 : -1,
    "data-orientation": l.orientation
  }, i, {
    ref: t,
    onMouseDown: G(e.onMouseDown, (g) => {
      r ? l.onItemFocus(c) : g.preventDefault();
    }),
    onFocus: G(
      e.onFocus,
      () => l.onItemFocus(c)
    ),
    onKeyDown: G(e.onKeyDown, (g) => {
      if (g.key === "Tab" && g.shiftKey) {
        l.onItemShiftTab();
        return;
      }
      if (g.target !== g.currentTarget)
        return;
      const b = m9(g, l.orientation, l.dir);
      if (b !== void 0) {
        g.preventDefault();
        let v = u().filter(
          ($) => $.focusable
        ).map(
          ($) => $.ref.current
        );
        if (b === "last")
          v.reverse();
        else if (b === "prev" || b === "next") {
          b === "prev" && v.reverse();
          const $ = v.indexOf(g.currentTarget);
          v = l.loop ? h9(v, $ + 1) : v.slice($ + 1);
        }
        setTimeout(
          () => Ed(v)
        );
      }
    })
  })));
}), b9 = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function g9(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function m9(e, t, n) {
  const r = g9(e.key, n);
  if (!(t === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(r)) && !(t === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(r)))
    return b9[r];
}
function Ed(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function h9(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
const Eo = u9, Po = p9, Pd = "Radio", [v9, Td] = _e(Pd), [$9, x9] = v9(Pd), y9 = /* @__PURE__ */ R((e, t) => {
  const { __scopeRadio: n, name: r, checked: o = !1, required: a, disabled: i, value: s = "on", onCheck: c, ...l } = e, [d, u] = J(null), f = se(
    t,
    (b) => u(b)
  ), p = O(!1), g = d ? !!d.closest("form") : !0;
  return /* @__PURE__ */ y($9, {
    scope: n,
    checked: o,
    disabled: i
  }, /* @__PURE__ */ y(te.button, S({
    type: "button",
    role: "radio",
    "aria-checked": o,
    "data-state": Rd(o),
    "data-disabled": i ? "" : void 0,
    disabled: i,
    value: s
  }, l, {
    ref: f,
    onClick: G(e.onClick, (b) => {
      o || c == null || c(), g && (p.current = b.isPropagationStopped(), p.current || b.stopPropagation());
    })
  })), g && /* @__PURE__ */ y(I9, {
    control: d,
    bubbles: !p.current,
    name: r,
    value: s,
    checked: o,
    required: a,
    disabled: i,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), C9 = "RadioIndicator", w9 = /* @__PURE__ */ R((e, t) => {
  const { __scopeRadio: n, forceMount: r, ...o } = e, a = x9(C9, n);
  return /* @__PURE__ */ y(Oe, {
    present: r || a.checked
  }, /* @__PURE__ */ y(te.span, S({
    "data-state": Rd(a.checked),
    "data-disabled": a.disabled ? "" : void 0
  }, o, {
    ref: t
  })));
}), I9 = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...o } = e, a = O(null), i = lo(n), s = nr(t);
  return Z(() => {
    const c = a.current, l = window.HTMLInputElement.prototype, u = Object.getOwnPropertyDescriptor(l, "checked").set;
    if (i !== n && u) {
      const f = new Event("click", {
        bubbles: r
      });
      u.call(c, n), c.dispatchEvent(f);
    }
  }, [
    i,
    n,
    r
  ]), /* @__PURE__ */ y("input", S({
    type: "radio",
    "aria-hidden": !0,
    defaultChecked: n
  }, o, {
    tabIndex: -1,
    ref: a,
    style: {
      ...e.style,
      ...s,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function Rd(e) {
  return e ? "checked" : "unchecked";
}
const S9 = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight"
], Md = "RadioGroup", [A9, XI] = _e(Md, [
  Gt,
  Td
]), Dd = Gt(), Od = Td(), [E9, P9] = A9(Md), T9 = /* @__PURE__ */ R((e, t) => {
  const { __scopeRadioGroup: n, name: r, defaultValue: o, value: a, required: i = !1, disabled: s = !1, orientation: c, dir: l, loop: d = !0, onValueChange: u, ...f } = e, p = Dd(n), g = Bt(l), [b, m] = Te({
    prop: a,
    defaultProp: o,
    onChange: u
  });
  return /* @__PURE__ */ y(E9, {
    scope: n,
    name: r,
    required: i,
    disabled: s,
    value: b,
    onValueChange: m
  }, /* @__PURE__ */ y(Eo, S({
    asChild: !0
  }, p, {
    orientation: c,
    dir: g,
    loop: d
  }), /* @__PURE__ */ y(te.div, S({
    role: "radiogroup",
    "aria-required": i,
    "aria-orientation": c,
    "data-disabled": s ? "" : void 0,
    dir: g
  }, f, {
    ref: t
  }))));
}), R9 = "RadioGroupItem", M9 = /* @__PURE__ */ R((e, t) => {
  const { __scopeRadioGroup: n, disabled: r, ...o } = e, a = P9(R9, n), i = a.disabled || r, s = Dd(n), c = Od(n), l = O(null), d = se(t, l), u = a.value === o.value, f = O(!1);
  return Z(() => {
    const p = (b) => {
      S9.includes(b.key) && (f.current = !0);
    }, g = () => f.current = !1;
    return document.addEventListener("keydown", p), document.addEventListener("keyup", g), () => {
      document.removeEventListener("keydown", p), document.removeEventListener("keyup", g);
    };
  }, []), /* @__PURE__ */ y(Po, S({
    asChild: !0
  }, s, {
    focusable: !i,
    active: u
  }), /* @__PURE__ */ y(y9, S({
    disabled: i,
    required: a.required,
    checked: u
  }, c, o, {
    name: a.name,
    ref: d,
    onCheck: () => a.onValueChange(o.value),
    onKeyDown: G((p) => {
      p.key === "Enter" && p.preventDefault();
    }),
    onFocus: G(o.onFocus, () => {
      var p;
      f.current && ((p = l.current) === null || p === void 0 || p.click());
    })
  })));
}), D9 = /* @__PURE__ */ R((e, t) => {
  const { __scopeRadioGroup: n, ...r } = e, o = Od(n);
  return /* @__PURE__ */ y(w9, S({}, o, r, {
    ref: t
  }));
}), O9 = T9, F9 = M9, k9 = D9, N9 = O9, _9 = k(F9, {
  margin: 2,
  appearance: "none",
  border: "1px solid rgba(0,0,0,0.3)",
  fontSize: "$bodyText",
  width: "1em",
  height: "1em",
  br: "$xl",
  padding: 0,
  position: "relative",
  cursor: "pointer",
  backgroundColor: "transparent",
  borderRadius: "50%",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  verticalAlign: "middle",
  boxShadow: "inset 0px 2px 4px $colors$uiMonochrome25",
  "&::before": {
    content: '""',
    width: "1.5rem",
    height: "1.5rem",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  },
  "&:hover, &.state--hover": {
    border: "1px solid $uiPrimaryMain"
  },
  '&[data-state="checked"]': {
    border: "none"
  },
  "&[data-disabled]": {
    opacity: 0.7,
    boxSizing: "border-box",
    pointerEvents: "none",
    border: "1px solid $uiDisabled25",
    background: "$uiDisabled16",
    '&[data-state="checked"]': {
      border: "none"
    }
  }
}), L9 = k(k9, {
  width: "inherit",
  height: "inherit",
  borderRadius: "50%",
  border: "$$size solid $$fillColor",
  $$size: "4px",
  $$fillColor: "$colors$uiPrimaryMain",
  boxSizing: "border-box",
  "&[data-disabled]": {
    $$fillColor: "$colors$uiMonochrome75"
  }
}), B9 = A.forwardRef(
  function(t, n) {
    return /* @__PURE__ */ h.jsx(_9, { ...t, ref: n, children: /* @__PURE__ */ h.jsx(L9, {}) });
  }
), ZI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Item: B9,
  Root: N9
}, Symbol.toStringTag, { value: "Module" })), Fd = /* @__PURE__ */ R((e, t) => {
  const { pressed: n, defaultPressed: r = !1, onPressedChange: o, ...a } = e, [i = !1, s] = Te({
    prop: n,
    onChange: o,
    defaultProp: r
  });
  return /* @__PURE__ */ y(te.button, S({
    type: "button",
    "aria-pressed": i,
    "data-state": i ? "on" : "off",
    "data-disabled": e.disabled ? "" : void 0
  }, a, {
    ref: t,
    onClick: G(e.onClick, () => {
      e.disabled || s(!i);
    })
  }));
}), V9 = Fd, kd = {
  fontFamily: "$base",
  cursor: "pointer",
  px: "$8",
  py: "$8",
  fontSize: "$bodyText",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "transparent",
  color: "$textPrimary50",
  border: "1px solid transparent",
  borderRadius: "$base",
  "&:hover, &:focus": {
    boxShadow: "$2"
  },
  "&:active": {
    backgroundColor: "$uiPrimary16"
  },
  "&:disabled": {
    opacity: 0.3,
    color: "$uiDisabledMain"
  },
  '&[data-state="on"]': {
    color: "$brandPrimaryMain",
    borderColor: "$uiPrimary50"
  }
}, YI = k(V9, {
  ...kd
}), G9 = k("span", {}), UI = R(
  ({ className: e, ...t }, n) => /* @__PURE__ */ h.jsx(G9, { ...t, ref: n, className: `material-icons-round ${e}` })
);
function W9(e, t) {
  return el((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const Nd = "ScrollArea", [_d, JI] = _e(Nd), [j9, Ct] = _d(Nd), z9 = /* @__PURE__ */ R((e, t) => {
  const { __scopeScrollArea: n, type: r = "hover", dir: o, scrollHideDelay: a = 600, ...i } = e, [s, c] = J(null), [l, d] = J(null), [u, f] = J(null), [p, g] = J(null), [b, m] = J(null), [v, $] = J(0), [x, w] = J(0), [C, P] = J(!1), [E, T] = J(!1), F = se(
    t,
    (_) => c(_)
  ), V = Bt(o);
  return /* @__PURE__ */ y(j9, {
    scope: n,
    type: r,
    dir: V,
    scrollHideDelay: a,
    scrollArea: s,
    viewport: l,
    onViewportChange: d,
    content: u,
    onContentChange: f,
    scrollbarX: p,
    onScrollbarXChange: g,
    scrollbarXEnabled: C,
    onScrollbarXEnabledChange: P,
    scrollbarY: b,
    onScrollbarYChange: m,
    scrollbarYEnabled: E,
    onScrollbarYEnabledChange: T,
    onCornerWidthChange: $,
    onCornerHeightChange: w
  }, /* @__PURE__ */ y(te.div, S({
    dir: V
  }, i, {
    ref: F,
    style: {
      position: "relative",
      // Pass corner sizes as CSS vars to reduce re-renders of context consumers
      ["--radix-scroll-area-corner-width"]: v + "px",
      ["--radix-scroll-area-corner-height"]: x + "px",
      ...e.style
    }
  })));
}), H9 = "ScrollAreaViewport", X9 = /* @__PURE__ */ R((e, t) => {
  const { __scopeScrollArea: n, children: r, ...o } = e, a = Ct(H9, n), i = O(null), s = se(t, i, a.onViewportChange);
  return /* @__PURE__ */ y(xt, null, /* @__PURE__ */ y("style", {
    dangerouslySetInnerHTML: {
      __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
    }
  }), /* @__PURE__ */ y(te.div, S({
    "data-radix-scroll-area-viewport": ""
  }, o, {
    ref: s,
    style: {
      /**
      * We don't support `visible` because the intention is to have at least one scrollbar
      * if this component is used and `visible` will behave like `auto` in that case
      * https://developer.mozilla.org/en-US/docs/Web/CSS/overflowed#description
      *
      * We don't handle `auto` because the intention is for the native implementation
      * to be hidden if using this component. We just want to ensure the node is scrollable
      * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
      * the browser from having to work out whether to render native scrollbars or not,
      * we tell it to with the intention of hiding them in CSS.
      */
      overflowX: a.scrollbarXEnabled ? "scroll" : "hidden",
      overflowY: a.scrollbarYEnabled ? "scroll" : "hidden",
      ...e.style
    }
  }), /* @__PURE__ */ y("div", {
    ref: a.onContentChange,
    style: {
      minWidth: "100%",
      display: "table"
    }
  }, r)));
}), Rt = "ScrollAreaScrollbar", Z9 = /* @__PURE__ */ R((e, t) => {
  const { forceMount: n, ...r } = e, o = Ct(Rt, e.__scopeScrollArea), { onScrollbarXEnabledChange: a, onScrollbarYEnabledChange: i } = o, s = e.orientation === "horizontal";
  return Z(() => (s ? a(!0) : i(!0), () => {
    s ? a(!1) : i(!1);
  }), [
    s,
    a,
    i
  ]), o.type === "hover" ? /* @__PURE__ */ y(Y9, S({}, r, {
    ref: t,
    forceMount: n
  })) : o.type === "scroll" ? /* @__PURE__ */ y(U9, S({}, r, {
    ref: t,
    forceMount: n
  })) : o.type === "auto" ? /* @__PURE__ */ y(Ld, S({}, r, {
    ref: t,
    forceMount: n
  })) : o.type === "always" ? /* @__PURE__ */ y(Vi, S({}, r, {
    ref: t
  })) : null;
}), Y9 = /* @__PURE__ */ R((e, t) => {
  const { forceMount: n, ...r } = e, o = Ct(Rt, e.__scopeScrollArea), [a, i] = J(!1);
  return Z(() => {
    const s = o.scrollArea;
    let c = 0;
    if (s) {
      const l = () => {
        window.clearTimeout(c), i(!0);
      }, d = () => {
        c = window.setTimeout(
          () => i(!1),
          o.scrollHideDelay
        );
      };
      return s.addEventListener("pointerenter", l), s.addEventListener("pointerleave", d), () => {
        window.clearTimeout(c), s.removeEventListener("pointerenter", l), s.removeEventListener("pointerleave", d);
      };
    }
  }, [
    o.scrollArea,
    o.scrollHideDelay
  ]), /* @__PURE__ */ y(Oe, {
    present: n || a
  }, /* @__PURE__ */ y(Ld, S({
    "data-state": a ? "visible" : "hidden"
  }, r, {
    ref: t
  })));
}), U9 = /* @__PURE__ */ R((e, t) => {
  const { forceMount: n, ...r } = e, o = Ct(Rt, e.__scopeScrollArea), a = e.orientation === "horizontal", i = Ro(
    () => c("SCROLL_END"),
    100
  ), [s, c] = W9("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return Z(() => {
    if (s === "idle") {
      const l = window.setTimeout(
        () => c("HIDE"),
        o.scrollHideDelay
      );
      return () => window.clearTimeout(l);
    }
  }, [
    s,
    o.scrollHideDelay,
    c
  ]), Z(() => {
    const l = o.viewport, d = a ? "scrollLeft" : "scrollTop";
    if (l) {
      let u = l[d];
      const f = () => {
        const p = l[d];
        u !== p && (c("SCROLL"), i()), u = p;
      };
      return l.addEventListener("scroll", f), () => l.removeEventListener("scroll", f);
    }
  }, [
    o.viewport,
    a,
    c,
    i
  ]), /* @__PURE__ */ y(Oe, {
    present: n || s !== "hidden"
  }, /* @__PURE__ */ y(Vi, S({
    "data-state": s === "hidden" ? "hidden" : "visible"
  }, r, {
    ref: t,
    onPointerEnter: G(
      e.onPointerEnter,
      () => c("POINTER_ENTER")
    ),
    onPointerLeave: G(
      e.onPointerLeave,
      () => c("POINTER_LEAVE")
    )
  })));
}), Ld = /* @__PURE__ */ R((e, t) => {
  const n = Ct(Rt, e.__scopeScrollArea), { forceMount: r, ...o } = e, [a, i] = J(!1), s = e.orientation === "horizontal", c = Ro(() => {
    if (n.viewport) {
      const l = n.viewport.offsetWidth < n.viewport.scrollWidth, d = n.viewport.offsetHeight < n.viewport.scrollHeight;
      i(s ? l : d);
    }
  }, 10);
  return qr(n.viewport, c), qr(n.content, c), /* @__PURE__ */ y(Oe, {
    present: r || a
  }, /* @__PURE__ */ y(Vi, S({
    "data-state": a ? "visible" : "hidden"
  }, o, {
    ref: t
  })));
}), Vi = /* @__PURE__ */ R((e, t) => {
  const { orientation: n = "vertical", ...r } = e, o = Ct(Rt, e.__scopeScrollArea), a = O(null), i = O(0), [s, c] = J({
    content: 0,
    viewport: 0,
    scrollbar: {
      size: 0,
      paddingStart: 0,
      paddingEnd: 0
    }
  }), l = Gd(s.viewport, s.content), d = {
    ...r,
    sizes: s,
    onSizesChange: c,
    hasThumb: l > 0 && l < 1,
    onThumbChange: (f) => a.current = f,
    onThumbPointerUp: () => i.current = 0,
    onThumbPointerDown: (f) => i.current = f
  };
  function u(f, p) {
    return t4(f, i.current, s, p);
  }
  return n === "horizontal" ? /* @__PURE__ */ y(J9, S({}, d, {
    ref: t,
    onThumbPositionChange: () => {
      if (o.viewport && a.current) {
        const f = o.viewport.scrollLeft, p = Ic(f, s, o.dir);
        a.current.style.transform = `translate3d(${p}px, 0, 0)`;
      }
    },
    onWheelScroll: (f) => {
      o.viewport && (o.viewport.scrollLeft = f);
    },
    onDragScroll: (f) => {
      o.viewport && (o.viewport.scrollLeft = u(f, o.dir));
    }
  })) : n === "vertical" ? /* @__PURE__ */ y(Q9, S({}, d, {
    ref: t,
    onThumbPositionChange: () => {
      if (o.viewport && a.current) {
        const f = o.viewport.scrollTop, p = Ic(f, s);
        a.current.style.transform = `translate3d(0, ${p}px, 0)`;
      }
    },
    onWheelScroll: (f) => {
      o.viewport && (o.viewport.scrollTop = f);
    },
    onDragScroll: (f) => {
      o.viewport && (o.viewport.scrollTop = u(f));
    }
  })) : null;
}), J9 = /* @__PURE__ */ R((e, t) => {
  const { sizes: n, onSizesChange: r, ...o } = e, a = Ct(Rt, e.__scopeScrollArea), [i, s] = J(), c = O(null), l = se(t, c, a.onScrollbarXChange);
  return Z(() => {
    c.current && s(getComputedStyle(c.current));
  }, [
    c
  ]), /* @__PURE__ */ y(Vd, S({
    "data-orientation": "horizontal"
  }, o, {
    ref: l,
    sizes: n,
    style: {
      bottom: 0,
      left: a.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
      right: a.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
      ["--radix-scroll-area-thumb-width"]: To(n) + "px",
      ...e.style
    },
    onThumbPointerDown: (d) => e.onThumbPointerDown(d.x),
    onDragScroll: (d) => e.onDragScroll(d.x),
    onWheelScroll: (d, u) => {
      if (a.viewport) {
        const f = a.viewport.scrollLeft + d.deltaX;
        e.onWheelScroll(f), jd(f, u) && d.preventDefault();
      }
    },
    onResize: () => {
      c.current && a.viewport && i && r({
        content: a.viewport.scrollWidth,
        viewport: a.viewport.offsetWidth,
        scrollbar: {
          size: c.current.clientWidth,
          paddingStart: Kr(i.paddingLeft),
          paddingEnd: Kr(i.paddingRight)
        }
      });
    }
  }));
}), Q9 = /* @__PURE__ */ R((e, t) => {
  const { sizes: n, onSizesChange: r, ...o } = e, a = Ct(Rt, e.__scopeScrollArea), [i, s] = J(), c = O(null), l = se(t, c, a.onScrollbarYChange);
  return Z(() => {
    c.current && s(getComputedStyle(c.current));
  }, [
    c
  ]), /* @__PURE__ */ y(Vd, S({
    "data-orientation": "vertical"
  }, o, {
    ref: l,
    sizes: n,
    style: {
      top: 0,
      right: a.dir === "ltr" ? 0 : void 0,
      left: a.dir === "rtl" ? 0 : void 0,
      bottom: "var(--radix-scroll-area-corner-height)",
      ["--radix-scroll-area-thumb-height"]: To(n) + "px",
      ...e.style
    },
    onThumbPointerDown: (d) => e.onThumbPointerDown(d.y),
    onDragScroll: (d) => e.onDragScroll(d.y),
    onWheelScroll: (d, u) => {
      if (a.viewport) {
        const f = a.viewport.scrollTop + d.deltaY;
        e.onWheelScroll(f), jd(f, u) && d.preventDefault();
      }
    },
    onResize: () => {
      c.current && a.viewport && i && r({
        content: a.viewport.scrollHeight,
        viewport: a.viewport.offsetHeight,
        scrollbar: {
          size: c.current.clientHeight,
          paddingStart: Kr(i.paddingTop),
          paddingEnd: Kr(i.paddingBottom)
        }
      });
    }
  }));
}), [K9, Bd] = _d(Rt), Vd = /* @__PURE__ */ R((e, t) => {
  const { __scopeScrollArea: n, sizes: r, hasThumb: o, onThumbChange: a, onThumbPointerUp: i, onThumbPointerDown: s, onThumbPositionChange: c, onDragScroll: l, onWheelScroll: d, onResize: u, ...f } = e, p = Ct(Rt, n), [g, b] = J(null), m = se(
    t,
    (F) => b(F)
  ), v = O(null), $ = O(""), x = p.viewport, w = r.content - r.viewport, C = Ee(d), P = Ee(c), E = Ro(u, 10);
  function T(F) {
    if (v.current) {
      const V = F.clientX - v.current.left, _ = F.clientY - v.current.top;
      l({
        x: V,
        y: _
      });
    }
  }
  return Z(() => {
    const F = (V) => {
      const _ = V.target;
      (g == null ? void 0 : g.contains(_)) && C(V, w);
    };
    return document.addEventListener("wheel", F, {
      passive: !1
    }), () => document.removeEventListener("wheel", F, {
      passive: !1
    });
  }, [
    x,
    g,
    w,
    C
  ]), Z(P, [
    r,
    P
  ]), qr(g, E), qr(p.content, E), /* @__PURE__ */ y(K9, {
    scope: n,
    scrollbar: g,
    hasThumb: o,
    onThumbChange: Ee(a),
    onThumbPointerUp: Ee(i),
    onThumbPositionChange: P,
    onThumbPointerDown: Ee(s)
  }, /* @__PURE__ */ y(te.div, S({}, f, {
    ref: m,
    style: {
      position: "absolute",
      ...f.style
    },
    onPointerDown: G(e.onPointerDown, (F) => {
      F.button === 0 && (F.target.setPointerCapture(F.pointerId), v.current = g.getBoundingClientRect(), $.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", p.viewport && (p.viewport.style.scrollBehavior = "auto"), T(F));
    }),
    onPointerMove: G(e.onPointerMove, T),
    onPointerUp: G(e.onPointerUp, (F) => {
      const V = F.target;
      V.hasPointerCapture(F.pointerId) && V.releasePointerCapture(F.pointerId), document.body.style.webkitUserSelect = $.current, p.viewport && (p.viewport.style.scrollBehavior = ""), v.current = null;
    })
  })));
}), Na = "ScrollAreaThumb", q9 = /* @__PURE__ */ R((e, t) => {
  const { forceMount: n, ...r } = e, o = Bd(Na, e.__scopeScrollArea);
  return /* @__PURE__ */ y(Oe, {
    present: n || o.hasThumb
  }, /* @__PURE__ */ y(e4, S({
    ref: t
  }, r)));
}), e4 = /* @__PURE__ */ R((e, t) => {
  const { __scopeScrollArea: n, style: r, ...o } = e, a = Ct(Na, n), i = Bd(Na, n), { onThumbPositionChange: s } = i, c = se(
    t,
    (u) => i.onThumbChange(u)
  ), l = O(), d = Ro(() => {
    l.current && (l.current(), l.current = void 0);
  }, 100);
  return Z(() => {
    const u = a.viewport;
    if (u) {
      const f = () => {
        if (d(), !l.current) {
          const p = n4(u, s);
          l.current = p, s();
        }
      };
      return s(), u.addEventListener("scroll", f), () => u.removeEventListener("scroll", f);
    }
  }, [
    a.viewport,
    d,
    s
  ]), /* @__PURE__ */ y(te.div, S({
    "data-state": i.hasThumb ? "visible" : "hidden"
  }, o, {
    ref: c,
    style: {
      width: "var(--radix-scroll-area-thumb-width)",
      height: "var(--radix-scroll-area-thumb-height)",
      ...r
    },
    onPointerDownCapture: G(e.onPointerDownCapture, (u) => {
      const p = u.target.getBoundingClientRect(), g = u.clientX - p.left, b = u.clientY - p.top;
      i.onThumbPointerDown({
        x: g,
        y: b
      });
    }),
    onPointerUp: G(e.onPointerUp, i.onThumbPointerUp)
  }));
});
function Kr(e) {
  return e ? parseInt(e, 10) : 0;
}
function Gd(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function To(e) {
  const t = Gd(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, r = (e.scrollbar.size - n) * t;
  return Math.max(r, 18);
}
function t4(e, t, n, r = "ltr") {
  const o = To(n), a = o / 2, i = t || a, s = o - i, c = n.scrollbar.paddingStart + i, l = n.scrollbar.size - n.scrollbar.paddingEnd - s, d = n.content - n.viewport, u = r === "ltr" ? [
    0,
    d
  ] : [
    d * -1,
    0
  ];
  return Wd([
    c,
    l
  ], u)(e);
}
function Ic(e, t, n = "ltr") {
  const r = To(t), o = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, a = t.scrollbar.size - o, i = t.content - t.viewport, s = a - r, c = n === "ltr" ? [
    0,
    i
  ] : [
    i * -1,
    0
  ], l = Ti(e, c);
  return Wd([
    0,
    i
  ], [
    0,
    s
  ])(l);
}
function Wd(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1])
      return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function jd(e, t) {
  return e > 0 && e < t;
}
const n4 = (e, t = () => {
}) => {
  let n = {
    left: e.scrollLeft,
    top: e.scrollTop
  }, r = 0;
  return function o() {
    const a = {
      left: e.scrollLeft,
      top: e.scrollTop
    }, i = n.left !== a.left, s = n.top !== a.top;
    (i || s) && t(), n = a, r = window.requestAnimationFrame(o);
  }(), () => window.cancelAnimationFrame(r);
};
function Ro(e, t) {
  const n = Ee(e), r = O(0);
  return Z(
    () => () => window.clearTimeout(r.current),
    []
  ), K(() => {
    window.clearTimeout(r.current), r.current = window.setTimeout(n, t);
  }, [
    n,
    t
  ]);
}
function qr(e, t) {
  const n = Ee(t);
  ft(() => {
    let r = 0;
    if (e) {
      const o = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return o.observe(e), () => {
        window.cancelAnimationFrame(r), o.unobserve(e);
      };
    }
  }, [
    e,
    n
  ]);
}
const r4 = z9, o4 = X9, a4 = q9, zd = k(r4, {
  width: "100%",
  height: "100%"
}), i4 = k(o4, {
  width: "100%",
  height: "100%"
}), s4 = k(Z9, {
  display: "flex",
  background: "transparent",
  "&:hover": {
    background: "$textPrimary16"
  },
  transition: "background $transitions$1",
  variants: {
    scrollDirection: {
      horizontal: {
        height: 4,
        flexDirection: "column"
      },
      vertical: {
        width: 4,
        flexDirection: "row"
      }
    }
  }
}), c4 = k(a4, {
  flex: 1,
  background: "$textPrimary30",
  borderRadius: 4
}), _a = R(
  function({ orientation: t = "vertical", forceMount: n, ...r }, o) {
    return /* @__PURE__ */ h.jsx(
      s4,
      {
        ...r,
        orientation: t,
        scrollDirection: t,
        dir: t,
        forceMount: n === !0 ? n : void 0,
        ref: o,
        children: /* @__PURE__ */ h.jsx(c4, {})
      }
    );
  }
), Hd = R(function(t, n) {
  return /* @__PURE__ */ h.jsx(i4, { ...t, ref: n });
}), La = A.forwardRef((e, t) => {
  const {
    className: n,
    classes: r = {},
    css: o,
    viewportCss: a,
    children: i,
    orientation: s = "vertical",
    convertNativeScrollToHorizontal: c = s === "horizontal",
    ...l
  } = e, d = O(null);
  function u(p) {
    if (d.current && c) {
      p.preventDefault();
      const g = d.current.scrollLeft + p.deltaY;
      d.current.scrollTo({ left: g, behavior: "smooth" });
    }
  }
  const f = [n, r.root].filter(Boolean).join(" ");
  return /* @__PURE__ */ h.jsxs(zd, { className: f, css: o, ...l, ref: t, children: [
    /* @__PURE__ */ h.jsx(
      Hd,
      {
        css: a,
        className: r.viewport,
        ref: d,
        onWheel: u,
        children: i
      }
    ),
    /* @__PURE__ */ h.jsx(_a, {}),
    // When orientation is horizontal, we need to render a second scrollbar
    s === "horizontal" && /* @__PURE__ */ h.jsx(_a, { orientation: "horizontal" })
  ] });
}), QI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ScrollArea: La,
  ScrollAreaComposed: La,
  ScrollAreaRoot: zd,
  ScrollAreaScrollbar: _a,
  ScrollAreaViewport: Hd
}, Symbol.toStringTag, { value: "Module" }));
let na = 0;
function Gi() {
  Z(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : Sc()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : Sc()), na++, () => {
      na === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), na--;
    };
  }, []);
}
function Sc() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const ra = "focusScope.autoFocusOnMount", oa = "focusScope.autoFocusOnUnmount", Ac = {
  bubbles: !1,
  cancelable: !0
}, Wi = /* @__PURE__ */ R((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: a, ...i } = e, [s, c] = J(null), l = Ee(o), d = Ee(a), u = O(null), f = se(
    t,
    (b) => c(b)
  ), p = O({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  Z(() => {
    if (r) {
      let b = function(x) {
        if (p.paused || !s)
          return;
        const w = x.target;
        s.contains(w) ? u.current = w : Mt(u.current, {
          select: !0
        });
      }, m = function(x) {
        if (p.paused || !s)
          return;
        const w = x.relatedTarget;
        w !== null && (s.contains(w) || Mt(u.current, {
          select: !0
        }));
      }, v = function(x) {
        if (document.activeElement === document.body)
          for (const C of x)
            C.removedNodes.length > 0 && Mt(s);
      };
      document.addEventListener("focusin", b), document.addEventListener("focusout", m);
      const $ = new MutationObserver(v);
      return s && $.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", b), document.removeEventListener("focusout", m), $.disconnect();
      };
    }
  }, [
    r,
    s,
    p.paused
  ]), Z(() => {
    if (s) {
      Pc.add(p);
      const b = document.activeElement;
      if (!s.contains(b)) {
        const v = new CustomEvent(ra, Ac);
        s.addEventListener(ra, l), s.dispatchEvent(v), v.defaultPrevented || (l4(b4(Xd(s)), {
          select: !0
        }), document.activeElement === b && Mt(s));
      }
      return () => {
        s.removeEventListener(ra, l), setTimeout(() => {
          const v = new CustomEvent(oa, Ac);
          s.addEventListener(oa, d), s.dispatchEvent(v), v.defaultPrevented || Mt(b ?? document.body, {
            select: !0
          }), s.removeEventListener(oa, d), Pc.remove(p);
        }, 0);
      };
    }
  }, [
    s,
    l,
    d,
    p
  ]);
  const g = K((b) => {
    if (!n && !r || p.paused)
      return;
    const m = b.key === "Tab" && !b.altKey && !b.ctrlKey && !b.metaKey, v = document.activeElement;
    if (m && v) {
      const $ = b.currentTarget, [x, w] = u4($);
      x && w ? !b.shiftKey && v === w ? (b.preventDefault(), n && Mt(x, {
        select: !0
      })) : b.shiftKey && v === x && (b.preventDefault(), n && Mt(w, {
        select: !0
      })) : v === $ && b.preventDefault();
    }
  }, [
    n,
    r,
    p.paused
  ]);
  return /* @__PURE__ */ y(te.div, S({
    tabIndex: -1
  }, i, {
    ref: f,
    onKeyDown: g
  }));
});
function l4(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Mt(r, {
      select: t
    }), document.activeElement !== n)
      return;
}
function u4(e) {
  const t = Xd(e), n = Ec(t, e), r = Ec(t.reverse(), e);
  return [
    n,
    r
  ];
}
function Xd(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function Ec(e, t) {
  for (const n of e)
    if (!d4(n, {
      upTo: t
    }))
      return n;
}
function d4(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function f4(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Mt(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && f4(e) && t && e.select();
  }
}
const Pc = p4();
function p4() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Tc(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Tc(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function Tc(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function b4(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
var g4 = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, pn = /* @__PURE__ */ new WeakMap(), yr = /* @__PURE__ */ new WeakMap(), Cr = {}, aa = 0, ji = function(e, t, n) {
  t === void 0 && (t = g4(e)), n === void 0 && (n = "data-aria-hidden");
  var r = Array.isArray(e) ? e : [e];
  Cr[n] || (Cr[n] = /* @__PURE__ */ new WeakMap());
  var o = Cr[n], a = [], i = /* @__PURE__ */ new Set(), s = function(l) {
    !l || i.has(l) || (i.add(l), s(l.parentNode));
  };
  r.forEach(s);
  var c = function(l) {
    !l || r.indexOf(l) >= 0 || Array.prototype.forEach.call(l.children, function(d) {
      if (i.has(d))
        c(d);
      else {
        var u = d.getAttribute("aria-hidden"), f = u !== null && u !== "false", p = (pn.get(d) || 0) + 1, g = (o.get(d) || 0) + 1;
        pn.set(d, p), o.set(d, g), a.push(d), p === 1 && f && yr.set(d, !0), g === 1 && d.setAttribute(n, "true"), f || d.setAttribute("aria-hidden", "true");
      }
    });
  };
  return c(t), i.clear(), aa++, function() {
    a.forEach(function(l) {
      var d = pn.get(l) - 1, u = o.get(l) - 1;
      pn.set(l, d), o.set(l, u), d || (yr.has(l) || l.removeAttribute("aria-hidden"), yr.delete(l)), u || l.removeAttribute(n);
    }), aa--, aa || (pn = /* @__PURE__ */ new WeakMap(), pn = /* @__PURE__ */ new WeakMap(), yr = /* @__PURE__ */ new WeakMap(), Cr = {});
  };
}, vt = function() {
  return vt = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, vt.apply(this, arguments);
};
function Zd(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function m4(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, a; r < o; r++)
      (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var Nr = "right-scroll-bar-position", _r = "width-before-scroll-bar", h4 = "with-scroll-bars-hidden", v4 = "--removed-body-scroll-bar-size";
function $4(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function x4(e, t) {
  var n = J(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
function y4(e, t) {
  return x4(t || null, function(n) {
    return e.forEach(function(r) {
      return $4(r, n);
    });
  });
}
function C4(e) {
  return e;
}
function w4(e, t) {
  t === void 0 && (t = C4);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var i = t(a, r);
      return n.push(i), function() {
        n = n.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (r = !0; n.length; ) {
        var i = n;
        n = [], i.forEach(a);
      }
      n = {
        push: function(s) {
          return a(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      r = !0;
      var i = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(a), i = n;
      }
      var c = function() {
        var d = i;
        i = [], d.forEach(a);
      }, l = function() {
        return Promise.resolve().then(c);
      };
      l(), n = {
        push: function(d) {
          i.push(d), l();
        },
        filter: function(d) {
          return i = i.filter(d), n;
        }
      };
    }
  };
  return o;
}
function I4(e) {
  e === void 0 && (e = {});
  var t = w4(null);
  return t.options = vt({ async: !0, ssr: !1 }, e), t;
}
var Yd = function(e) {
  var t = e.sideCar, n = Zd(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return N.createElement(r, vt({}, n));
};
Yd.isSideCarExport = !0;
function S4(e, t) {
  return e.useMedium(t), Yd;
}
var Ud = I4(), ia = function() {
}, Mo = N.forwardRef(function(e, t) {
  var n = N.useRef(null), r = N.useState({
    onScrollCapture: ia,
    onWheelCapture: ia,
    onTouchMoveCapture: ia
  }), o = r[0], a = r[1], i = e.forwardProps, s = e.children, c = e.className, l = e.removeScrollBar, d = e.enabled, u = e.shards, f = e.sideCar, p = e.noIsolation, g = e.inert, b = e.allowPinchZoom, m = e.as, v = m === void 0 ? "div" : m, $ = Zd(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), x = f, w = y4([n, t]), C = vt(vt({}, $), o);
  return N.createElement(
    N.Fragment,
    null,
    d && N.createElement(x, { sideCar: Ud, removeScrollBar: l, shards: u, noIsolation: p, inert: g, setCallbacks: a, allowPinchZoom: !!b, lockRef: n }),
    i ? N.cloneElement(N.Children.only(s), vt(vt({}, C), { ref: w })) : N.createElement(v, vt({}, C, { className: c, ref: w }), s)
  );
});
Mo.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Mo.classNames = {
  fullWidth: _r,
  zeroRight: Nr
};
var Rc, A4 = function() {
  if (Rc)
    return Rc;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function E4() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = A4();
  return t && e.setAttribute("nonce", t), e;
}
function P4(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function T4(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var R4 = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = E4()) && (P4(t, n), T4(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, M4 = function() {
  var e = R4();
  return function(t, n) {
    N.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Jd = function() {
  var e = M4(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, D4 = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, sa = function(e) {
  return parseInt(e || "", 10) || 0;
}, O4 = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [sa(n), sa(r), sa(o)];
}, F4 = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return D4;
  var t = O4(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, k4 = Jd(), N4 = function(e, t, n, r) {
  var o = e.left, a = e.top, i = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(h4, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Nr, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(_r, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Nr, " .").concat(Nr, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(_r, " .").concat(_r, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body {
    `).concat(v4, ": ").concat(s, `px;
  }
`);
}, _4 = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r, a = N.useMemo(function() {
    return F4(o);
  }, [o]);
  return N.createElement(k4, { styles: N4(a, !t, o, n ? "" : "!important") });
}, Ba = !1;
if (typeof window < "u")
  try {
    var wr = Object.defineProperty({}, "passive", {
      get: function() {
        return Ba = !0, !0;
      }
    });
    window.addEventListener("test", wr, wr), window.removeEventListener("test", wr, wr);
  } catch {
    Ba = !1;
  }
var bn = Ba ? { passive: !1 } : !1, L4 = function(e) {
  return e.tagName === "TEXTAREA";
}, Qd = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !L4(e) && n[t] === "visible")
  );
}, B4 = function(e) {
  return Qd(e, "overflowY");
}, V4 = function(e) {
  return Qd(e, "overflowX");
}, Mc = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = Kd(e, n);
    if (r) {
      var o = qd(e, n), a = o[1], i = o[2];
      if (a > i)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, G4 = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, W4 = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Kd = function(e, t) {
  return e === "v" ? B4(t) : V4(t);
}, qd = function(e, t) {
  return e === "v" ? G4(t) : W4(t);
}, j4 = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, z4 = function(e, t, n, r, o) {
  var a = j4(e, window.getComputedStyle(t).direction), i = a * r, s = n.target, c = t.contains(s), l = !1, d = i > 0, u = 0, f = 0;
  do {
    var p = qd(e, s), g = p[0], b = p[1], m = p[2], v = b - m - a * g;
    (g || v) && Kd(e, s) && (u += v, f += g), s = s.parentNode;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (d && (o && u === 0 || !o && i > u) || !d && (o && f === 0 || !o && -i > f)) && (l = !0), l;
}, Ir = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Dc = function(e) {
  return [e.deltaX, e.deltaY];
}, Oc = function(e) {
  return e && "current" in e ? e.current : e;
}, H4 = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, X4 = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Z4 = 0, gn = [];
function Y4(e) {
  var t = N.useRef([]), n = N.useRef([0, 0]), r = N.useRef(), o = N.useState(Z4++)[0], a = N.useState(function() {
    return Jd();
  })[0], i = N.useRef(e);
  N.useEffect(function() {
    i.current = e;
  }, [e]), N.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var b = m4([e.lockRef.current], (e.shards || []).map(Oc), !0).filter(Boolean);
      return b.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), b.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = N.useCallback(function(b, m) {
    if ("touches" in b && b.touches.length === 2)
      return !i.current.allowPinchZoom;
    var v = Ir(b), $ = n.current, x = "deltaX" in b ? b.deltaX : $[0] - v[0], w = "deltaY" in b ? b.deltaY : $[1] - v[1], C, P = b.target, E = Math.abs(x) > Math.abs(w) ? "h" : "v";
    if ("touches" in b && E === "h" && P.type === "range")
      return !1;
    var T = Mc(E, P);
    if (!T)
      return !0;
    if (T ? C = E : (C = E === "v" ? "h" : "v", T = Mc(E, P)), !T)
      return !1;
    if (!r.current && "changedTouches" in b && (x || w) && (r.current = C), !C)
      return !0;
    var F = r.current || C;
    return z4(F, m, b, F === "h" ? x : w, !0);
  }, []), c = N.useCallback(function(b) {
    var m = b;
    if (!(!gn.length || gn[gn.length - 1] !== a)) {
      var v = "deltaY" in m ? Dc(m) : Ir(m), $ = t.current.filter(function(C) {
        return C.name === m.type && C.target === m.target && H4(C.delta, v);
      })[0];
      if ($ && $.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!$) {
        var x = (i.current.shards || []).map(Oc).filter(Boolean).filter(function(C) {
          return C.contains(m.target);
        }), w = x.length > 0 ? s(m, x[0]) : !i.current.noIsolation;
        w && m.cancelable && m.preventDefault();
      }
    }
  }, []), l = N.useCallback(function(b, m, v, $) {
    var x = { name: b, delta: m, target: v, should: $ };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(w) {
        return w !== x;
      });
    }, 1);
  }, []), d = N.useCallback(function(b) {
    n.current = Ir(b), r.current = void 0;
  }, []), u = N.useCallback(function(b) {
    l(b.type, Dc(b), b.target, s(b, e.lockRef.current));
  }, []), f = N.useCallback(function(b) {
    l(b.type, Ir(b), b.target, s(b, e.lockRef.current));
  }, []);
  N.useEffect(function() {
    return gn.push(a), e.setCallbacks({
      onScrollCapture: u,
      onWheelCapture: u,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", c, bn), document.addEventListener("touchmove", c, bn), document.addEventListener("touchstart", d, bn), function() {
      gn = gn.filter(function(b) {
        return b !== a;
      }), document.removeEventListener("wheel", c, bn), document.removeEventListener("touchmove", c, bn), document.removeEventListener("touchstart", d, bn);
    };
  }, []);
  var p = e.removeScrollBar, g = e.inert;
  return N.createElement(
    N.Fragment,
    null,
    g ? N.createElement(a, { styles: X4(o) }) : null,
    p ? N.createElement(_4, { gapMode: "margin" }) : null
  );
}
const U4 = S4(Ud, Y4);
var ef = N.forwardRef(function(e, t) {
  return N.createElement(Mo, vt({}, e, { ref: t, sideCar: U4 }));
});
ef.classNames = Mo.classNames;
const zi = ef, Va = [
  "Enter",
  " "
], J4 = [
  "ArrowDown",
  "PageUp",
  "Home"
], tf = [
  "ArrowUp",
  "PageDown",
  "End"
], Q4 = [
  ...J4,
  ...tf
], K4 = {
  ltr: [
    ...Va,
    "ArrowRight"
  ],
  rtl: [
    ...Va,
    "ArrowLeft"
  ]
}, q4 = {
  ltr: [
    "ArrowLeft"
  ],
  rtl: [
    "ArrowRight"
  ]
}, Do = "Menu", [Jn, ex, tx] = tr(Do), [an, nf] = _e(Do, [
  tx,
  Pn,
  Gt
]), lr = Pn(), rf = Gt(), [of, Wt] = an(Do), [nx, ur] = an(Do), rx = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: a, modal: i = !0 } = e, s = lr(t), [c, l] = J(null), d = O(!1), u = Ee(a), f = Bt(o);
  return Z(() => {
    const p = () => {
      d.current = !0, document.addEventListener("pointerdown", g, {
        capture: !0,
        once: !0
      }), document.addEventListener("pointermove", g, {
        capture: !0,
        once: !0
      });
    }, g = () => d.current = !1;
    return document.addEventListener("keydown", p, {
      capture: !0
    }), () => {
      document.removeEventListener("keydown", p, {
        capture: !0
      }), document.removeEventListener("pointerdown", g, {
        capture: !0
      }), document.removeEventListener("pointermove", g, {
        capture: !0
      });
    };
  }, []), /* @__PURE__ */ y(wo, s, /* @__PURE__ */ y(of, {
    scope: t,
    open: n,
    onOpenChange: u,
    content: c,
    onContentChange: l
  }, /* @__PURE__ */ y(nx, {
    scope: t,
    onClose: K(
      () => u(!1),
      [
        u
      ]
    ),
    isUsingKeyboardRef: d,
    dir: f,
    modal: i
  }, r)));
}, af = /* @__PURE__ */ R((e, t) => {
  const { __scopeMenu: n, ...r } = e, o = lr(n);
  return /* @__PURE__ */ y(Io, S({}, o, r, {
    ref: t
  }));
}), sf = "MenuPortal", [ox, cf] = an(sf, {
  forceMount: void 0
}), ax = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, a = Wt(sf, t);
  return /* @__PURE__ */ y(ox, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ y(Oe, {
    present: n || a.open
  }, /* @__PURE__ */ y(on, {
    asChild: !0,
    container: o
  }, r)));
}, dt = "MenuContent", [ix, Hi] = an(dt), sx = /* @__PURE__ */ R((e, t) => {
  const n = cf(dt, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, a = Wt(dt, e.__scopeMenu), i = ur(dt, e.__scopeMenu);
  return /* @__PURE__ */ y(Jn.Provider, {
    scope: e.__scopeMenu
  }, /* @__PURE__ */ y(Oe, {
    present: r || a.open
  }, /* @__PURE__ */ y(Jn.Slot, {
    scope: e.__scopeMenu
  }, i.modal ? /* @__PURE__ */ y(cx, S({}, o, {
    ref: t
  })) : /* @__PURE__ */ y(lx, S({}, o, {
    ref: t
  })))));
}), cx = /* @__PURE__ */ R((e, t) => {
  const n = Wt(dt, e.__scopeMenu), r = O(null), o = se(t, r);
  return Z(() => {
    const a = r.current;
    if (a)
      return ji(a);
  }, []), /* @__PURE__ */ y(Xi, S({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: n.open,
    disableOutsideScroll: !0,
    onFocusOutside: G(
      e.onFocusOutside,
      (a) => a.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    ),
    onDismiss: () => n.onOpenChange(!1)
  }));
}), lx = /* @__PURE__ */ R((e, t) => {
  const n = Wt(dt, e.__scopeMenu);
  return /* @__PURE__ */ y(Xi, S({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    disableOutsideScroll: !1,
    onDismiss: () => n.onOpenChange(!1)
  }));
}), Xi = /* @__PURE__ */ R((e, t) => {
  const { __scopeMenu: n, loop: r = !1, trapFocus: o, onOpenAutoFocus: a, onCloseAutoFocus: i, disableOutsidePointerEvents: s, onEntryFocus: c, onEscapeKeyDown: l, onPointerDownOutside: d, onFocusOutside: u, onInteractOutside: f, onDismiss: p, disableOutsideScroll: g, ...b } = e, m = Wt(dt, n), v = ur(dt, n), $ = lr(n), x = rf(n), w = ex(n), [C, P] = J(null), E = O(null), T = se(t, E, m.onContentChange), F = O(0), V = O(""), _ = O(0), W = O(null), H = O("right"), D = O(0), M = g ? zi : xt, j = g ? {
    as: je,
    allowPinchZoom: !0
  } : void 0, U = (z) => {
    var oe, le;
    const ie = V.current + z, fe = w().filter(
      (ce) => !ce.disabled
    ), Ae = document.activeElement, Re = (oe = fe.find(
      (ce) => ce.ref.current === Ae
    )) === null || oe === void 0 ? void 0 : oe.textValue, B = fe.map(
      (ce) => ce.textValue
    ), ue = Tx(B, ie, Re), we = (le = fe.find(
      (ce) => ce.textValue === ue
    )) === null || le === void 0 ? void 0 : le.ref.current;
    (function ce(Le) {
      V.current = Le, window.clearTimeout(F.current), Le !== "" && (F.current = window.setTimeout(
        () => ce(""),
        1e3
      ));
    })(ie), we && setTimeout(
      () => we.focus()
    );
  };
  Z(() => () => window.clearTimeout(F.current), []), Gi();
  const ee = K((z) => {
    var oe, le;
    return H.current === ((oe = W.current) === null || oe === void 0 ? void 0 : oe.side) && Mx(z, (le = W.current) === null || le === void 0 ? void 0 : le.area);
  }, []);
  return /* @__PURE__ */ y(ix, {
    scope: n,
    searchRef: V,
    onItemEnter: K((z) => {
      ee(z) && z.preventDefault();
    }, [
      ee
    ]),
    onItemLeave: K((z) => {
      var oe;
      ee(z) || ((oe = E.current) === null || oe === void 0 || oe.focus(), P(null));
    }, [
      ee
    ]),
    onTriggerLeave: K((z) => {
      ee(z) && z.preventDefault();
    }, [
      ee
    ]),
    pointerGraceTimerRef: _,
    onPointerGraceIntentChange: K((z) => {
      W.current = z;
    }, [])
  }, /* @__PURE__ */ y(M, j, /* @__PURE__ */ y(Wi, {
    asChild: !0,
    trapped: o,
    onMountAutoFocus: G(a, (z) => {
      var oe;
      z.preventDefault(), (oe = E.current) === null || oe === void 0 || oe.focus();
    }),
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ y(sr, {
    asChild: !0,
    disableOutsidePointerEvents: s,
    onEscapeKeyDown: l,
    onPointerDownOutside: d,
    onFocusOutside: u,
    onInteractOutside: f,
    onDismiss: p
  }, /* @__PURE__ */ y(Eo, S({
    asChild: !0
  }, x, {
    dir: v.dir,
    orientation: "vertical",
    loop: r,
    currentTabStopId: C,
    onCurrentTabStopIdChange: P,
    onEntryFocus: G(c, (z) => {
      v.isUsingKeyboardRef.current || z.preventDefault();
    })
  }), /* @__PURE__ */ y(Fi, S({
    role: "menu",
    "aria-orientation": "vertical",
    "data-state": gf(m.open),
    "data-radix-menu-content": "",
    dir: v.dir
  }, $, b, {
    ref: T,
    style: {
      outline: "none",
      ...b.style
    },
    onKeyDown: G(b.onKeyDown, (z) => {
      const le = z.target.closest("[data-radix-menu-content]") === z.currentTarget, ie = z.ctrlKey || z.altKey || z.metaKey, fe = z.key.length === 1;
      le && (z.key === "Tab" && z.preventDefault(), !ie && fe && U(z.key));
      const Ae = E.current;
      if (z.target !== Ae || !Q4.includes(z.key))
        return;
      z.preventDefault();
      const B = w().filter(
        (ue) => !ue.disabled
      ).map(
        (ue) => ue.ref.current
      );
      tf.includes(z.key) && B.reverse(), Ex(B);
    }),
    onBlur: G(e.onBlur, (z) => {
      z.currentTarget.contains(z.target) || (window.clearTimeout(F.current), V.current = "");
    }),
    onPointerMove: G(e.onPointerMove, Qn((z) => {
      const oe = z.target, le = D.current !== z.clientX;
      if (z.currentTarget.contains(oe) && le) {
        const ie = z.clientX > D.current ? "right" : "left";
        H.current = ie, D.current = z.clientX;
      }
    }))
  })))))));
}), lf = /* @__PURE__ */ R((e, t) => {
  const { __scopeMenu: n, ...r } = e;
  return /* @__PURE__ */ y(te.div, S({
    role: "group"
  }, r, {
    ref: t
  }));
}), ux = /* @__PURE__ */ R((e, t) => {
  const { __scopeMenu: n, ...r } = e;
  return /* @__PURE__ */ y(te.div, S({}, r, {
    ref: t
  }));
}), Ga = "MenuItem", Fc = "menu.itemSelect", Zi = /* @__PURE__ */ R((e, t) => {
  const { disabled: n = !1, onSelect: r, ...o } = e, a = O(null), i = ur(Ga, e.__scopeMenu), s = Hi(Ga, e.__scopeMenu), c = se(t, a), l = O(!1), d = () => {
    const u = a.current;
    if (!n && u) {
      const f = new CustomEvent(Fc, {
        bubbles: !0,
        cancelable: !0
      });
      u.addEventListener(
        Fc,
        (p) => r == null ? void 0 : r(p),
        {
          once: !0
        }
      ), Ka(u, f), f.defaultPrevented ? l.current = !1 : i.onClose();
    }
  };
  return /* @__PURE__ */ y(uf, S({}, o, {
    ref: c,
    disabled: n,
    onClick: G(e.onClick, d),
    onPointerDown: (u) => {
      var f;
      (f = e.onPointerDown) === null || f === void 0 || f.call(e, u), l.current = !0;
    },
    onPointerUp: G(e.onPointerUp, (u) => {
      var f;
      l.current || (f = u.currentTarget) === null || f === void 0 || f.click();
    }),
    onKeyDown: G(e.onKeyDown, (u) => {
      const f = s.searchRef.current !== "";
      n || f && u.key === " " || Va.includes(u.key) && (u.currentTarget.click(), u.preventDefault());
    })
  }));
}), uf = /* @__PURE__ */ R((e, t) => {
  const { __scopeMenu: n, disabled: r = !1, textValue: o, ...a } = e, i = Hi(Ga, n), s = rf(n), c = O(null), l = se(t, c), [d, u] = J(!1), [f, p] = J("");
  return Z(() => {
    const g = c.current;
    if (g) {
      var b;
      p(((b = g.textContent) !== null && b !== void 0 ? b : "").trim());
    }
  }, [
    a.children
  ]), /* @__PURE__ */ y(Jn.ItemSlot, {
    scope: n,
    disabled: r,
    textValue: o ?? f
  }, /* @__PURE__ */ y(Po, S({
    asChild: !0
  }, s, {
    focusable: !r
  }), /* @__PURE__ */ y(te.div, S({
    role: "menuitem",
    "data-highlighted": d ? "" : void 0,
    "aria-disabled": r || void 0,
    "data-disabled": r ? "" : void 0
  }, a, {
    ref: l,
    onPointerMove: G(e.onPointerMove, Qn((g) => {
      r ? i.onItemLeave(g) : (i.onItemEnter(g), g.defaultPrevented || g.currentTarget.focus());
    })),
    onPointerLeave: G(e.onPointerLeave, Qn(
      (g) => i.onItemLeave(g)
    )),
    onFocus: G(
      e.onFocus,
      () => u(!0)
    ),
    onBlur: G(
      e.onBlur,
      () => u(!1)
    )
  }))));
}), dx = /* @__PURE__ */ R((e, t) => {
  const { checked: n = !1, onCheckedChange: r, ...o } = e;
  return /* @__PURE__ */ y(ff, {
    scope: e.__scopeMenu,
    checked: n
  }, /* @__PURE__ */ y(Zi, S({
    role: "menuitemcheckbox",
    "aria-checked": eo(n) ? "mixed" : n
  }, o, {
    ref: t,
    "data-state": Yi(n),
    onSelect: G(
      o.onSelect,
      () => r == null ? void 0 : r(eo(n) ? !0 : !n),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), fx = "MenuRadioGroup", [px, bx] = an(fx, {
  value: void 0,
  onValueChange: () => {
  }
}), gx = /* @__PURE__ */ R((e, t) => {
  const { value: n, onValueChange: r, ...o } = e, a = Ee(r);
  return /* @__PURE__ */ y(px, {
    scope: e.__scopeMenu,
    value: n,
    onValueChange: a
  }, /* @__PURE__ */ y(lf, S({}, o, {
    ref: t
  })));
}), mx = "MenuRadioItem", hx = /* @__PURE__ */ R((e, t) => {
  const { value: n, ...r } = e, o = bx(mx, e.__scopeMenu), a = n === o.value;
  return /* @__PURE__ */ y(ff, {
    scope: e.__scopeMenu,
    checked: a
  }, /* @__PURE__ */ y(Zi, S({
    role: "menuitemradio",
    "aria-checked": a
  }, r, {
    ref: t,
    "data-state": Yi(a),
    onSelect: G(r.onSelect, () => {
      var i;
      return (i = o.onValueChange) === null || i === void 0 ? void 0 : i.call(o, n);
    }, {
      checkForDefaultPrevented: !1
    })
  })));
}), df = "MenuItemIndicator", [ff, vx] = an(df, {
  checked: !1
}), $x = /* @__PURE__ */ R((e, t) => {
  const { __scopeMenu: n, forceMount: r, ...o } = e, a = vx(df, n);
  return /* @__PURE__ */ y(Oe, {
    present: r || eo(a.checked) || a.checked === !0
  }, /* @__PURE__ */ y(te.span, S({}, o, {
    ref: t,
    "data-state": Yi(a.checked)
  })));
}), xx = /* @__PURE__ */ R((e, t) => {
  const { __scopeMenu: n, ...r } = e;
  return /* @__PURE__ */ y(te.div, S({
    role: "separator",
    "aria-orientation": "horizontal"
  }, r, {
    ref: t
  }));
}), yx = /* @__PURE__ */ R((e, t) => {
  const { __scopeMenu: n, ...r } = e, o = lr(n);
  return /* @__PURE__ */ y(ki, S({}, o, r, {
    ref: t
  }));
}), pf = "MenuSub", [Cx, bf] = an(pf), wx = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: o } = e, a = Wt(pf, t), i = lr(t), [s, c] = J(null), [l, d] = J(null), u = Ee(o);
  return Z(() => (a.open === !1 && u(!1), () => u(!1)), [
    a.open,
    u
  ]), /* @__PURE__ */ y(wo, i, /* @__PURE__ */ y(of, {
    scope: t,
    open: r,
    onOpenChange: u,
    content: l,
    onContentChange: d
  }, /* @__PURE__ */ y(Cx, {
    scope: t,
    contentId: nt(),
    triggerId: nt(),
    trigger: s,
    onTriggerChange: c
  }, n)));
}, Sr = "MenuSubTrigger", Ix = /* @__PURE__ */ R((e, t) => {
  const n = Wt(Sr, e.__scopeMenu), r = ur(Sr, e.__scopeMenu), o = bf(Sr, e.__scopeMenu), a = Hi(Sr, e.__scopeMenu), i = O(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: c } = a, l = {
    __scopeMenu: e.__scopeMenu
  }, d = K(() => {
    i.current && window.clearTimeout(i.current), i.current = null;
  }, []);
  return Z(
    () => d,
    [
      d
    ]
  ), Z(() => {
    const u = s.current;
    return () => {
      window.clearTimeout(u), c(null);
    };
  }, [
    s,
    c
  ]), /* @__PURE__ */ y(af, S({
    asChild: !0
  }, l), /* @__PURE__ */ y(uf, S({
    id: o.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": n.open,
    "aria-controls": o.contentId,
    "data-state": gf(n.open)
  }, e, {
    ref: io(t, o.onTriggerChange),
    onClick: (u) => {
      var f;
      (f = e.onClick) === null || f === void 0 || f.call(e, u), !(e.disabled || u.defaultPrevented) && (u.currentTarget.focus(), n.open || n.onOpenChange(!0));
    },
    onPointerMove: G(e.onPointerMove, Qn((u) => {
      a.onItemEnter(u), !u.defaultPrevented && !e.disabled && !n.open && !i.current && (a.onPointerGraceIntentChange(null), i.current = window.setTimeout(() => {
        n.onOpenChange(!0), d();
      }, 100));
    })),
    onPointerLeave: G(e.onPointerLeave, Qn((u) => {
      var f;
      d();
      const p = (f = n.content) === null || f === void 0 ? void 0 : f.getBoundingClientRect();
      if (p) {
        var g;
        const b = (g = n.content) === null || g === void 0 ? void 0 : g.dataset.side, m = b === "right", v = m ? -5 : 5, $ = p[m ? "left" : "right"], x = p[m ? "right" : "left"];
        a.onPointerGraceIntentChange({
          area: [
            // consistently within polygon bounds
            {
              x: u.clientX + v,
              y: u.clientY
            },
            {
              x: $,
              y: p.top
            },
            {
              x,
              y: p.top
            },
            {
              x,
              y: p.bottom
            },
            {
              x: $,
              y: p.bottom
            }
          ],
          side: b
        }), window.clearTimeout(s.current), s.current = window.setTimeout(
          () => a.onPointerGraceIntentChange(null),
          300
        );
      } else {
        if (a.onTriggerLeave(u), u.defaultPrevented)
          return;
        a.onPointerGraceIntentChange(null);
      }
    })),
    onKeyDown: G(e.onKeyDown, (u) => {
      const f = a.searchRef.current !== "";
      if (!(e.disabled || f && u.key === " ") && K4[r.dir].includes(u.key)) {
        var p;
        n.onOpenChange(!0), (p = n.content) === null || p === void 0 || p.focus(), u.preventDefault();
      }
    })
  })));
}), Sx = "MenuSubContent", Ax = /* @__PURE__ */ R((e, t) => {
  const n = cf(dt, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, a = Wt(dt, e.__scopeMenu), i = ur(dt, e.__scopeMenu), s = bf(Sx, e.__scopeMenu), c = O(null), l = se(t, c);
  return /* @__PURE__ */ y(Jn.Provider, {
    scope: e.__scopeMenu
  }, /* @__PURE__ */ y(Oe, {
    present: r || a.open
  }, /* @__PURE__ */ y(Jn.Slot, {
    scope: e.__scopeMenu
  }, /* @__PURE__ */ y(Xi, S({
    id: s.contentId,
    "aria-labelledby": s.triggerId
  }, o, {
    ref: l,
    align: "start",
    side: i.dir === "rtl" ? "left" : "right",
    disableOutsidePointerEvents: !1,
    disableOutsideScroll: !1,
    trapFocus: !1,
    onOpenAutoFocus: (d) => {
      var u;
      i.isUsingKeyboardRef.current && ((u = c.current) === null || u === void 0 || u.focus()), d.preventDefault();
    },
    onCloseAutoFocus: (d) => d.preventDefault(),
    onFocusOutside: G(e.onFocusOutside, (d) => {
      d.target !== s.trigger && a.onOpenChange(!1);
    }),
    onEscapeKeyDown: G(e.onEscapeKeyDown, (d) => {
      i.onClose(), d.preventDefault();
    }),
    onKeyDown: G(e.onKeyDown, (d) => {
      const u = d.currentTarget.contains(d.target), f = q4[i.dir].includes(d.key);
      if (u && f) {
        var p;
        a.onOpenChange(!1), (p = s.trigger) === null || p === void 0 || p.focus(), d.preventDefault();
      }
    })
  })))));
});
function gf(e) {
  return e ? "open" : "closed";
}
function eo(e) {
  return e === "indeterminate";
}
function Yi(e) {
  return eo(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function Ex(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function Px(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
function Tx(e, t, n) {
  const o = t.length > 1 && Array.from(t).every(
    (l) => l === t[0]
  ) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let i = Px(e, Math.max(a, 0));
  o.length === 1 && (i = i.filter(
    (l) => l !== n
  ));
  const c = i.find(
    (l) => l.toLowerCase().startsWith(o.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function Rx(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const s = t[a].x, c = t[a].y, l = t[i].x, d = t[i].y;
    c > r != d > r && n < (l - s) * (r - c) / (d - c) + s && (o = !o);
  }
  return o;
}
function Mx(e, t) {
  if (!t)
    return !1;
  const n = {
    x: e.clientX,
    y: e.clientY
  };
  return Rx(n, t);
}
function Qn(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
const Dx = rx, Ox = af, Fx = ax, kx = sx, Nx = lf, _x = ux, Lx = Zi, Bx = dx, Vx = gx, Gx = hx, Wx = $x, jx = xx, zx = yx, Hx = wx, Xx = Ix, Zx = Ax, mf = "DropdownMenu", [Yx, KI] = _e(mf, [
  nf
]), Xe = nf(), [Ux, hf] = Yx(mf), Jx = (e) => {
  const { __scopeDropdownMenu: t, children: n, dir: r, open: o, defaultOpen: a, onOpenChange: i, modal: s = !0 } = e, c = Xe(t), l = O(null), [d = !1, u] = Te({
    prop: o,
    defaultProp: a,
    onChange: i
  });
  return /* @__PURE__ */ y(Ux, {
    scope: t,
    triggerId: nt(),
    triggerRef: l,
    contentId: nt(),
    open: d,
    onOpenChange: u,
    onOpenToggle: K(
      () => u(
        (f) => !f
      ),
      [
        u
      ]
    ),
    modal: s
  }, /* @__PURE__ */ y(Dx, S({}, c, {
    open: d,
    onOpenChange: u,
    dir: r,
    modal: s
  }), n));
}, Qx = "DropdownMenuTrigger", Kx = /* @__PURE__ */ R((e, t) => {
  const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, a = hf(Qx, n), i = Xe(n);
  return /* @__PURE__ */ y(Ox, S({
    asChild: !0
  }, i), /* @__PURE__ */ y(te.button, S({
    type: "button",
    id: a.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": a.open,
    "aria-controls": a.open ? a.contentId : void 0,
    "data-state": a.open ? "open" : "closed",
    "data-disabled": r ? "" : void 0,
    disabled: r
  }, o, {
    ref: io(t, a.triggerRef),
    onPointerDown: G(e.onPointerDown, (s) => {
      !r && s.button === 0 && s.ctrlKey === !1 && (a.onOpenToggle(), a.open || s.preventDefault());
    }),
    onKeyDown: G(e.onKeyDown, (s) => {
      r || ([
        "Enter",
        " "
      ].includes(s.key) && a.onOpenToggle(), s.key === "ArrowDown" && a.onOpenChange(!0), [
        "Enter",
        " ",
        "ArrowDown"
      ].includes(s.key) && s.preventDefault());
    })
  })));
}), qx = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = Xe(t);
  return /* @__PURE__ */ y(Fx, S({}, r, n));
}, ey = "DropdownMenuContent", ty = /* @__PURE__ */ R((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = hf(ey, n), a = Xe(n), i = O(!1);
  return /* @__PURE__ */ y(kx, S({
    id: o.contentId,
    "aria-labelledby": o.triggerId
  }, a, r, {
    ref: t,
    onCloseAutoFocus: G(e.onCloseAutoFocus, (s) => {
      var c;
      i.current || (c = o.triggerRef.current) === null || c === void 0 || c.focus(), i.current = !1, s.preventDefault();
    }),
    onInteractOutside: G(e.onInteractOutside, (s) => {
      const c = s.detail.originalEvent, l = c.button === 0 && c.ctrlKey === !0, d = c.button === 2 || l;
      (!o.modal || d) && (i.current = !0);
    }),
    style: {
      ...e.style,
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), ny = /* @__PURE__ */ R((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Xe(n);
  return /* @__PURE__ */ y(Nx, S({}, o, r, {
    ref: t
  }));
}), ry = /* @__PURE__ */ R((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Xe(n);
  return /* @__PURE__ */ y(_x, S({}, o, r, {
    ref: t
  }));
}), oy = /* @__PURE__ */ R((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Xe(n);
  return /* @__PURE__ */ y(Lx, S({}, o, r, {
    ref: t
  }));
}), ay = /* @__PURE__ */ R((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Xe(n);
  return /* @__PURE__ */ y(Bx, S({}, o, r, {
    ref: t
  }));
}), iy = /* @__PURE__ */ R((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Xe(n);
  return /* @__PURE__ */ y(Vx, S({}, o, r, {
    ref: t
  }));
}), sy = /* @__PURE__ */ R((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Xe(n);
  return /* @__PURE__ */ y(Gx, S({}, o, r, {
    ref: t
  }));
}), cy = /* @__PURE__ */ R((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Xe(n);
  return /* @__PURE__ */ y(Wx, S({}, o, r, {
    ref: t
  }));
}), ly = /* @__PURE__ */ R((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Xe(n);
  return /* @__PURE__ */ y(jx, S({}, o, r, {
    ref: t
  }));
}), uy = /* @__PURE__ */ R((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Xe(n);
  return /* @__PURE__ */ y(zx, S({}, o, r, {
    ref: t
  }));
}), dy = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: o, defaultOpen: a } = e, i = Xe(t), [s = !1, c] = Te({
    prop: r,
    defaultProp: a,
    onChange: o
  });
  return /* @__PURE__ */ y(Hx, S({}, i, {
    open: s,
    onOpenChange: c
  }), n);
}, fy = /* @__PURE__ */ R((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Xe(n);
  return /* @__PURE__ */ y(Xx, S({}, o, r, {
    ref: t
  }));
}), py = /* @__PURE__ */ R((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Xe(n);
  return /* @__PURE__ */ y(Zx, S({}, o, r, {
    ref: t,
    style: {
      ...e.style,
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), by = Jx, gy = Kx, vf = qx, $f = ty, my = ny, hy = ry, vy = oy, $y = ay, xy = iy, yy = sy, Cy = cy, wy = ly, Iy = uy, Sy = dy, Ay = fy, Ey = py, Py = k($f, {
  boxShadow: "$2",
  borderRadius: "$base",
  bgc: "$uiSecondary",
  variants: {
    bg: {
      secondary: {
        bgc: "$uiSecondary"
      },
      tertiary: {
        bgc: "$uiTertiary"
      },
      quaternary: {
        bgc: "$uiQuaternary"
      }
    },
    density: {
      default: {
        padding: "0.5rem"
      },
      compact: {
        padding: "0.25rem 0"
      }
    },
    outlined: {
      true: {
        border: "1px solid $divider"
      }
    }
  },
  defaultVariants: {
    bg: "secondary",
    density: "default",
    outlined: !0
  }
}), Ty = k(Ey, {
  boxShadow: "$2",
  borderRadius: "$base",
  bgc: "$uiSecondary",
  variants: {
    bg: {
      secondary: {
        bgc: "$uiSecondary"
      },
      tertiary: {
        bgc: "$uiTertiary"
      },
      quaternary: {
        bgc: "$uiQuaternary"
      }
    },
    density: {
      default: {
        padding: "0.5rem"
      },
      compact: {
        padding: "0.25rem 0"
      }
    },
    outlined: {
      true: {
        border: "1px solid $divider"
      }
    }
  },
  defaultVariants: {
    bg: "secondary",
    density: "default",
    outlined: !0
  }
}), Ry = R((e, t) => /* @__PURE__ */ h.jsx(vf, { children: /* @__PURE__ */ h.jsx(Py, { ...e, ref: t }) })), My = R(({ sideOffset: e = 8, ...t }, n) => /* @__PURE__ */ h.jsx(vf, { children: /* @__PURE__ */ h.jsx(Ty, { ...t, sideOffset: e, ref: n }) })), Dy = k(wy, Fl), Oy = A.Fragment, Fy = k(gy, {
  fontFamily: "$dropdownTrigger"
}), ky = k(vy, {
  fontFamily: "$dropdownItem"
}), Ny = k(Ay, {
  fontFamily: "$dropdownSubTrigger"
}), _y = R((e, t) => /* @__PURE__ */ h.jsx(Fy, { ...e, ref: t })), Ly = R(function(t, n) {
  return /* @__PURE__ */ h.jsx(Ny, { ...t, ref: n });
}), By = R((e, t) => /* @__PURE__ */ h.jsx(ky, { ...e, ref: t })), qI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Arrow: Iy,
  CheckboxItem: $y,
  Content: Ry,
  Group: my,
  Item: By,
  ItemIndicator: Cy,
  Label: hy,
  Portal: Oy,
  RadioGroup: xy,
  RadioItem: yy,
  RdxContent: $f,
  Root: by,
  Separator: Dy,
  Sub: Sy,
  SubContent: My,
  SubTrigger: Ly,
  Trigger: _y
}, Symbol.toStringTag, { value: "Module" })), xf = "ToastProvider", [Ui, Vy, Gy] = tr("Toast"), [yf, e8] = _e("Toast", [
  Gy
]), [Wy, Oo] = yf(xf), Cf = (e) => {
  const { __scopeToast: t, label: n = "Notification", duration: r = 5e3, swipeDirection: o = "right", swipeThreshold: a = 50, children: i } = e, [s, c] = J(null), [l, d] = J(0), u = O(!1), f = O(!1);
  return /* @__PURE__ */ y(Ui.Provider, {
    scope: t
  }, /* @__PURE__ */ y(Wy, {
    scope: t,
    label: n,
    duration: r,
    swipeDirection: o,
    swipeThreshold: a,
    toastCount: l,
    viewport: s,
    onViewportChange: c,
    onToastAdd: K(
      () => d(
        (p) => p + 1
      ),
      []
    ),
    onToastRemove: K(
      () => d(
        (p) => p - 1
      ),
      []
    ),
    isFocusedToastEscapeKeyDownRef: u,
    isClosePausedRef: f
  }, i));
};
Cf.propTypes = {
  label(e) {
    if (e.label && typeof e.label == "string" && !e.label.trim()) {
      const t = `Invalid prop \`label\` supplied to \`${xf}\`. Expected non-empty \`string\`.`;
      return new Error(t);
    }
    return null;
  }
};
const jy = "ToastViewport", zy = [
  "F8"
], Wa = "toast.viewportPause", ja = "toast.viewportResume", Hy = /* @__PURE__ */ R((e, t) => {
  const { __scopeToast: n, hotkey: r = zy, label: o = "Notifications ({hotkey})", ...a } = e, i = Oo(jy, n), s = Vy(n), c = O(null), l = O(null), d = O(null), u = O(null), f = se(t, u, i.onViewportChange), p = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), g = i.toastCount > 0;
  Z(() => {
    const m = (v) => {
      var $;
      r.every(
        (w) => v[w] || v.code === w
      ) && (($ = u.current) === null || $ === void 0 || $.focus());
    };
    return document.addEventListener("keydown", m), () => document.removeEventListener("keydown", m);
  }, [
    r
  ]), Z(() => {
    const m = c.current, v = u.current;
    if (g && m && v) {
      const $ = () => {
        if (!i.isClosePausedRef.current) {
          const P = new CustomEvent(Wa);
          v.dispatchEvent(P), i.isClosePausedRef.current = !0;
        }
      }, x = () => {
        if (i.isClosePausedRef.current) {
          const P = new CustomEvent(ja);
          v.dispatchEvent(P), i.isClosePausedRef.current = !1;
        }
      }, w = (P) => {
        !m.contains(P.relatedTarget) && x();
      }, C = () => {
        m.contains(document.activeElement) || x();
      };
      return m.addEventListener("focusin", $), m.addEventListener("focusout", w), m.addEventListener("pointermove", $), m.addEventListener("pointerleave", C), window.addEventListener("blur", $), window.addEventListener("focus", x), () => {
        m.removeEventListener("focusin", $), m.removeEventListener("focusout", w), m.removeEventListener("pointermove", $), m.removeEventListener("pointerleave", C), window.removeEventListener("blur", $), window.removeEventListener("focus", x);
      };
    }
  }, [
    g,
    i.isClosePausedRef
  ]);
  const b = K(({ tabbingDirection: m }) => {
    const $ = s().map((x) => {
      const w = x.ref.current, C = [
        w,
        ...iC(w)
      ];
      return m === "forwards" ? C : C.reverse();
    });
    return (m === "forwards" ? $.reverse() : $).flat();
  }, [
    s
  ]);
  return Z(() => {
    const m = u.current;
    if (m) {
      const v = ($) => {
        const x = $.altKey || $.ctrlKey || $.metaKey;
        if ($.key === "Tab" && !x) {
          const T = document.activeElement, F = $.shiftKey;
          if ($.target === m && F) {
            var C;
            (C = l.current) === null || C === void 0 || C.focus();
            return;
          }
          const W = b({
            tabbingDirection: F ? "backwards" : "forwards"
          }), H = W.findIndex(
            (D) => D === T
          );
          if (ca(W.slice(H + 1)))
            $.preventDefault();
          else {
            var P, E;
            F ? (P = l.current) === null || P === void 0 || P.focus() : (E = d.current) === null || E === void 0 || E.focus();
          }
        }
      };
      return m.addEventListener("keydown", v), () => m.removeEventListener("keydown", v);
    }
  }, [
    s,
    b
  ]), /* @__PURE__ */ y(F$, {
    ref: c,
    role: "region",
    "aria-label": o.replace("{hotkey}", p),
    tabIndex: -1,
    style: {
      pointerEvents: g ? void 0 : "none"
    }
  }, g && /* @__PURE__ */ y(kc, {
    ref: l,
    onFocusFromOutsideViewport: () => {
      const m = b({
        tabbingDirection: "forwards"
      });
      ca(m);
    }
  }), /* @__PURE__ */ y(Ui.Slot, {
    scope: n
  }, /* @__PURE__ */ y(te.ol, S({
    tabIndex: -1
  }, a, {
    ref: f
  }))), g && /* @__PURE__ */ y(kc, {
    ref: d,
    onFocusFromOutsideViewport: () => {
      const m = b({
        tabbingDirection: "backwards"
      });
      ca(m);
    }
  }));
}), Xy = "ToastFocusProxy", kc = /* @__PURE__ */ R((e, t) => {
  const { __scopeToast: n, onFocusFromOutsideViewport: r, ...o } = e, a = Oo(Xy, n);
  return /* @__PURE__ */ y(Ni, S({
    "aria-hidden": !0,
    tabIndex: 0
  }, o, {
    ref: t,
    style: {
      position: "fixed"
    },
    onFocus: (i) => {
      var s;
      const c = i.relatedTarget;
      !((s = a.viewport) !== null && s !== void 0 && s.contains(c)) && r();
    }
  }));
}), Fo = "Toast", Zy = "toast.swipeStart", Yy = "toast.swipeMove", Uy = "toast.swipeCancel", Jy = "toast.swipeEnd", Qy = /* @__PURE__ */ R((e, t) => {
  const { forceMount: n, open: r, defaultOpen: o, onOpenChange: a, ...i } = e, [s = !0, c] = Te({
    prop: r,
    defaultProp: o,
    onChange: a
  });
  return /* @__PURE__ */ y(Oe, {
    present: n || s
  }, /* @__PURE__ */ y(wf, S({
    open: s
  }, i, {
    ref: t,
    onClose: () => c(!1),
    onPause: Ee(e.onPause),
    onResume: Ee(e.onResume),
    onSwipeStart: G(e.onSwipeStart, (l) => {
      l.currentTarget.setAttribute("data-swipe", "start");
    }),
    onSwipeMove: G(e.onSwipeMove, (l) => {
      const { x: d, y: u } = l.detail.delta;
      l.currentTarget.setAttribute("data-swipe", "move"), l.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${d}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${u}px`);
    }),
    onSwipeCancel: G(e.onSwipeCancel, (l) => {
      l.currentTarget.setAttribute("data-swipe", "cancel"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
    }),
    onSwipeEnd: G(e.onSwipeEnd, (l) => {
      const { x: d, y: u } = l.detail.delta;
      l.currentTarget.setAttribute("data-swipe", "end"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${d}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${u}px`), c(!1);
    })
  })));
}), [Ky, qy] = yf(Fo, {
  onClose() {
  }
}), wf = /* @__PURE__ */ R((e, t) => {
  const { __scopeToast: n, type: r = "foreground", duration: o, open: a, onClose: i, onEscapeKeyDown: s, onPause: c, onResume: l, onSwipeStart: d, onSwipeMove: u, onSwipeCancel: f, onSwipeEnd: p, ...g } = e, b = Oo(Fo, n), [m, v] = J(null), $ = se(
    t,
    (D) => v(D)
  ), x = O(null), w = O(null), C = o || b.duration, P = O(0), E = O(C), T = O(0), { onToastAdd: F, onToastRemove: V } = b, _ = Ee(() => {
    var D;
    (m == null ? void 0 : m.contains(document.activeElement)) && ((D = b.viewport) === null || D === void 0 || D.focus()), i();
  }), W = K((D) => {
    !D || D === 1 / 0 || (window.clearTimeout(T.current), P.current = (/* @__PURE__ */ new Date()).getTime(), T.current = window.setTimeout(_, D));
  }, [
    _
  ]);
  Z(() => {
    const D = b.viewport;
    if (D) {
      const M = () => {
        W(E.current), l == null || l();
      }, j = () => {
        const U = (/* @__PURE__ */ new Date()).getTime() - P.current;
        E.current = E.current - U, window.clearTimeout(T.current), c == null || c();
      };
      return D.addEventListener(Wa, j), D.addEventListener(ja, M), () => {
        D.removeEventListener(Wa, j), D.removeEventListener(ja, M);
      };
    }
  }, [
    b.viewport,
    C,
    c,
    l,
    W
  ]), Z(() => {
    a && !b.isClosePausedRef.current && W(C);
  }, [
    a,
    C,
    b.isClosePausedRef,
    W
  ]), Z(() => (F(), () => V()), [
    F,
    V
  ]);
  const H = Ne(() => m ? Ef(m) : null, [
    m
  ]);
  return b.viewport ? /* @__PURE__ */ y(xt, null, H && /* @__PURE__ */ y(eC, {
    __scopeToast: n,
    role: "status",
    "aria-live": r === "foreground" ? "assertive" : "polite",
    "aria-atomic": !0
  }, H), /* @__PURE__ */ y(Ky, {
    scope: n,
    onClose: _
  }, /* @__PURE__ */ nl(/* @__PURE__ */ y(Ui.ItemSlot, {
    scope: n
  }, /* @__PURE__ */ y(O$, {
    asChild: !0,
    onEscapeKeyDown: G(s, () => {
      b.isFocusedToastEscapeKeyDownRef.current || _(), b.isFocusedToastEscapeKeyDownRef.current = !1;
    })
  }, /* @__PURE__ */ y(te.li, S({
    // Ensure toasts are announced as status list or status when focused
    role: "status",
    "aria-live": "off",
    "aria-atomic": !0,
    tabIndex: 0,
    "data-state": a ? "open" : "closed",
    "data-swipe-direction": b.swipeDirection
  }, g, {
    ref: $,
    style: {
      userSelect: "none",
      touchAction: "none",
      ...e.style
    },
    onKeyDown: G(e.onKeyDown, (D) => {
      D.key === "Escape" && (s == null || s(D.nativeEvent), D.nativeEvent.defaultPrevented || (b.isFocusedToastEscapeKeyDownRef.current = !0, _()));
    }),
    onPointerDown: G(e.onPointerDown, (D) => {
      D.button === 0 && (x.current = {
        x: D.clientX,
        y: D.clientY
      });
    }),
    onPointerMove: G(e.onPointerMove, (D) => {
      if (!x.current)
        return;
      const M = D.clientX - x.current.x, j = D.clientY - x.current.y, U = !!w.current, ee = [
        "left",
        "right"
      ].includes(b.swipeDirection), z = [
        "left",
        "up"
      ].includes(b.swipeDirection) ? Math.min : Math.max, oe = ee ? z(0, M) : 0, le = ee ? 0 : z(0, j), ie = D.pointerType === "touch" ? 10 : 2, fe = {
        x: oe,
        y: le
      }, Ae = {
        originalEvent: D,
        delta: fe
      };
      U ? (w.current = fe, Ar(Yy, u, Ae, {
        discrete: !1
      })) : Nc(fe, b.swipeDirection, ie) ? (w.current = fe, Ar(Zy, d, Ae, {
        discrete: !1
      }), D.target.setPointerCapture(D.pointerId)) : (Math.abs(M) > ie || Math.abs(j) > ie) && (x.current = null);
    }),
    onPointerUp: G(e.onPointerUp, (D) => {
      const M = w.current, j = D.target;
      if (j.hasPointerCapture(D.pointerId) && j.releasePointerCapture(D.pointerId), w.current = null, x.current = null, M) {
        const U = D.currentTarget, ee = {
          originalEvent: D,
          delta: M
        };
        Nc(M, b.swipeDirection, b.swipeThreshold) ? Ar(Jy, p, ee, {
          discrete: !0
        }) : Ar(Uy, f, ee, {
          discrete: !0
        }), U.addEventListener(
          "click",
          (z) => z.preventDefault(),
          {
            once: !0
          }
        );
      }
    })
  })))), b.viewport))) : null;
});
wf.propTypes = {
  type(e) {
    if (e.type && ![
      "foreground",
      "background"
    ].includes(e.type)) {
      const t = `Invalid prop \`type\` supplied to \`${Fo}\`. Expected \`foreground | background\`.`;
      return new Error(t);
    }
    return null;
  }
};
const eC = (e) => {
  const { __scopeToast: t, children: n, ...r } = e, o = Oo(Fo, t), [a, i] = J(!1), [s, c] = J(!1);
  return oC(
    () => i(!0)
  ), Z(() => {
    const l = window.setTimeout(
      () => c(!0),
      1e3
    );
    return () => window.clearTimeout(l);
  }, []), s ? null : /* @__PURE__ */ y(on, {
    asChild: !0
  }, /* @__PURE__ */ y(Ni, r, a && /* @__PURE__ */ y(xt, null, o.label, " ", n)));
}, tC = /* @__PURE__ */ R((e, t) => {
  const { __scopeToast: n, ...r } = e;
  return /* @__PURE__ */ y(te.div, S({}, r, {
    ref: t
  }));
}), nC = "ToastAction", If = /* @__PURE__ */ R((e, t) => {
  const { altText: n, ...r } = e;
  return n ? /* @__PURE__ */ y(Af, {
    altText: n,
    asChild: !0
  }, /* @__PURE__ */ y(Sf, S({}, r, {
    ref: t
  }))) : null;
});
If.propTypes = {
  altText(e) {
    return e.altText ? null : new Error(`Missing prop \`altText\` expected on \`${nC}\``);
  }
};
const rC = "ToastClose", Sf = /* @__PURE__ */ R((e, t) => {
  const { __scopeToast: n, ...r } = e, o = qy(rC, n);
  return /* @__PURE__ */ y(Af, {
    asChild: !0
  }, /* @__PURE__ */ y(te.button, S({
    type: "button"
  }, r, {
    ref: t,
    onClick: G(e.onClick, o.onClose)
  })));
}), Af = /* @__PURE__ */ R((e, t) => {
  const { __scopeToast: n, altText: r, ...o } = e;
  return /* @__PURE__ */ y(te.div, S({
    "data-radix-toast-announce-exclude": "",
    "data-radix-toast-announce-alt": r || void 0
  }, o, {
    ref: t
  }));
});
function Ef(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && t.push(r.textContent), aC(r)) {
      const o = r.ariaHidden || r.hidden || r.style.display === "none", a = r.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (a) {
          const i = r.dataset.radixToastAnnounceAlt;
          i && t.push(i);
        } else
          t.push(...Ef(r));
    }
  }), t;
}
function Ar(e, t, n, { discrete: r }) {
  const o = n.originalEvent.currentTarget, a = new CustomEvent(e, {
    bubbles: !0,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? Ka(o, a) : o.dispatchEvent(a);
}
const Nc = (e, t, n = 0) => {
  const r = Math.abs(e.x), o = Math.abs(e.y), a = r > o;
  return t === "left" || t === "right" ? a && r > n : !a && o > n;
};
function oC(e = () => {
}) {
  const t = Ee(e);
  ft(() => {
    let n = 0, r = 0;
    return n = window.requestAnimationFrame(
      () => r = window.requestAnimationFrame(t)
    ), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [
    t
  ]);
}
function aC(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function iC(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function ca(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
const sC = Cf, cC = Hy, lC = Qy, Pf = tC, uC = If, dC = Sf, fC = Lt({
  from: { opacity: 1 },
  to: { opacity: 0 }
}), _c = Lt({
  from: { transform: "translateX(calc(100% * var(--toast-direction) + 0.5rem))" },
  to: { transform: "translateX(0)" }
}), Lc = Lt({
  from: { transform: "translateY(calc(100% * var(--toast-direction) + 0.5rem))" },
  to: { transform: "translateY(0)" }
}), pC = Lt({
  from: { transform: "translate(var(--radix-toast-swipe-end-x), var(--radix-toast-swipe-end-y))" },
  to: { transform: "translate(0, 0)" }
}), bC = sC, gC = k(cC, {
  position: "fixed",
  bottom: 0,
  right: 0,
  display: "flex",
  flexDirection: "column",
  padding: "0.5rem",
  gap: 10,
  width: 390,
  maxWidth: "100vw",
  margin: 0,
  listStyle: "none",
  zIndex: 2147483647,
  outline: "none",
  pointerEvent: "none"
}), mC = k(lC, {
  color: "$$textColor",
  bgc: "$$bgColor",
  boxShadow: "$4",
  pointerEvents: "initial",
  padding: "0.5rem",
  display: "inline-grid",
  gridTemplate: `
    "title action" auto
    "desc action" max-content / 1fr auto
  `,
  minHeight: "2.5rem",
  alignItems: "center",
  br: "0.5rem",
  overflow: "hidden",
  columnGap: "0.5rem",
  "@media (prefers-reduced-motion: no-preference)": {
    '&[data-swipe-direction="up"]': {
      $$animationName: `${Lc}`,
      "--toast-direction": -1
    },
    '&[data-swipe-direction="down"]': {
      $$animationName: `${Lc}`,
      "--toast-direction": 1
    },
    '&[data-swipe-direction="left"]': {
      $$animationName: `${_c}`,
      "--toast-direction": -1
    },
    '&[data-swipe-direction="right"]': {
      $$animationName: `${_c}`,
      "--toast-direction": 1
    },
    '&[data-state="open"]': {
      animation: "$$animationName 0.250s cubic-bezier(0.16, 1, 0.3, 1)"
    },
    '&[data-state="closed"]': {
      animation: `${fC} 0.250s ease-in forwards`
    },
    '&[data-swipe="move"]': {
      transform: "translate(var(--radix-toast-swipe-move-x), var(--radix-toast-swipe-move-y))",
      transition: "transform 0.250s ease-out"
    },
    '&[data-swipe="cancel"]': {
      transform: "translate(0, 0)",
      transition: "transform 0.250s ease-out"
    },
    '&[data-swipe="end"]': {
      animation: `${pC} 0.250s ease-out forwards`
    }
  },
  variants: {
    color: {
      info: {
        $$bgColor: "$colors$uiPrimary16",
        $$textColor: "$colors$textPrimaryMain"
      },
      success: {
        $$bgColor: "$colors$uiSuccess16",
        $$textColor: "$colors$textSuccess"
      },
      error: {
        $$bgColor: "$colors$uiError16",
        $$textColor: "$colors$textError"
      },
      attention: {
        $$bgColor: "$colors$uiAttention16",
        $$textColor: "$colors$textAttention"
      }
    }
  },
  defaultVariants: {
    color: "info"
  }
}), hC = R(function({ asChild: t, children: n, ...r }, o) {
  return /* @__PURE__ */ h.jsx(Pf, { asChild: !0, children: /* @__PURE__ */ h.jsx(
    xo,
    {
      ...r,
      css: { mb: 0, color: "$$textColor", gridArea: "title", ...r.css },
      as: t ? je : "div",
      ref: o,
      children: n
    }
  ) });
}), vC = R(function({ asChild: t, ...n }, r) {
  return /* @__PURE__ */ h.jsx(Pf, { asChild: !0, children: /* @__PURE__ */ h.jsx(
    pt,
    {
      ...n,
      css: { mb: 0, color: "$$textColor", gridArea: "desc", ...n.css },
      as: t ? je : "div",
      ref: r
    }
  ) });
});
function $C(e) {
  return /* @__PURE__ */ h.jsx(dC, { asChild: !0, children: /* @__PURE__ */ h.jsx("div", { style: { gridArea: "action" }, children: e.children }) });
}
function xC({
  altText: e = "Press space or enter to dismiss",
  children: t
}) {
  return /* @__PURE__ */ h.jsx(uC, { asChild: !0, altText: e, children: /* @__PURE__ */ h.jsx("div", { style: { gridArea: "action" }, children: t }) });
}
const t8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Action: xC,
  Close: $C,
  Description: vC,
  Provider: bC,
  Root: mC,
  Title: hC,
  Viewport: gC
}, Symbol.toStringTag, { value: "Module" })), Tf = "Popover", [Rf, n8] = _e(Tf, [
  Pn
]), dr = Pn(), [yC, jt] = Rf(Tf), CC = (e) => {
  const { __scopePopover: t, children: n, open: r, defaultOpen: o, onOpenChange: a, modal: i = !1 } = e, s = dr(t), c = O(null), [l, d] = J(!1), [u = !1, f] = Te({
    prop: r,
    defaultProp: o,
    onChange: a
  });
  return /* @__PURE__ */ y(wo, s, /* @__PURE__ */ y(yC, {
    scope: t,
    contentId: nt(),
    triggerRef: c,
    open: u,
    onOpenChange: f,
    onOpenToggle: K(
      () => f(
        (p) => !p
      ),
      [
        f
      ]
    ),
    hasCustomAnchor: l,
    onCustomAnchorAdd: K(
      () => d(!0),
      []
    ),
    onCustomAnchorRemove: K(
      () => d(!1),
      []
    ),
    modal: i
  }, n));
}, wC = "PopoverAnchor", IC = /* @__PURE__ */ R((e, t) => {
  const { __scopePopover: n, ...r } = e, o = jt(wC, n), a = dr(n), { onCustomAnchorAdd: i, onCustomAnchorRemove: s } = o;
  return Z(() => (i(), () => s()), [
    i,
    s
  ]), /* @__PURE__ */ y(Io, S({}, a, r, {
    ref: t
  }));
}), SC = "PopoverTrigger", AC = /* @__PURE__ */ R((e, t) => {
  const { __scopePopover: n, ...r } = e, o = jt(SC, n), a = dr(n), i = se(t, o.triggerRef), s = /* @__PURE__ */ y(te.button, S({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": o.open,
    "aria-controls": o.contentId,
    "data-state": Of(o.open)
  }, r, {
    ref: i,
    onClick: G(e.onClick, o.onOpenToggle)
  }));
  return o.hasCustomAnchor ? s : /* @__PURE__ */ y(Io, S({
    asChild: !0
  }, a), s);
}), Mf = "PopoverPortal", [EC, PC] = Rf(Mf, {
  forceMount: void 0
}), TC = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: o } = e, a = jt(Mf, t);
  return /* @__PURE__ */ y(EC, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ y(Oe, {
    present: n || a.open
  }, /* @__PURE__ */ y(on, {
    asChild: !0,
    container: o
  }, r)));
}, Kn = "PopoverContent", RC = /* @__PURE__ */ R((e, t) => {
  const n = PC(Kn, e.__scopePopover), { forceMount: r = n.forceMount, ...o } = e, a = jt(Kn, e.__scopePopover);
  return /* @__PURE__ */ y(Oe, {
    present: r || a.open
  }, a.modal ? /* @__PURE__ */ y(MC, S({}, o, {
    ref: t
  })) : /* @__PURE__ */ y(DC, S({}, o, {
    ref: t
  })));
}), MC = /* @__PURE__ */ R((e, t) => {
  const n = jt(Kn, e.__scopePopover), r = O(null), o = se(t, r), a = O(!1);
  return Z(() => {
    const i = r.current;
    if (i)
      return ji(i);
  }, []), /* @__PURE__ */ y(zi, {
    as: je,
    allowPinchZoom: !0
  }, /* @__PURE__ */ y(Df, S({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: G(e.onCloseAutoFocus, (i) => {
      var s;
      i.preventDefault(), a.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus();
    }),
    onPointerDownOutside: G(e.onPointerDownOutside, (i) => {
      const s = i.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0, l = s.button === 2 || c;
      a.current = l;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: G(
      e.onFocusOutside,
      (i) => i.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), DC = /* @__PURE__ */ R((e, t) => {
  const n = jt(Kn, e.__scopePopover), r = O(!1), o = O(!1);
  return /* @__PURE__ */ y(Df, S({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (a) => {
      var i;
      if ((i = e.onCloseAutoFocus) === null || i === void 0 || i.call(e, a), !a.defaultPrevented) {
        var s;
        r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), a.preventDefault();
      }
      r.current = !1, o.current = !1;
    },
    onInteractOutside: (a) => {
      var i, s;
      (i = e.onInteractOutside) === null || i === void 0 || i.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
      const c = a.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(c)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
    }
  }));
}), Df = /* @__PURE__ */ R((e, t) => {
  const { __scopePopover: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: a, disableOutsidePointerEvents: i, onEscapeKeyDown: s, onPointerDownOutside: c, onFocusOutside: l, onInteractOutside: d, ...u } = e, f = jt(Kn, n), p = dr(n);
  return Gi(), /* @__PURE__ */ y(Wi, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a
  }, /* @__PURE__ */ y(sr, {
    asChild: !0,
    disableOutsidePointerEvents: i,
    onInteractOutside: d,
    onEscapeKeyDown: s,
    onPointerDownOutside: c,
    onFocusOutside: l,
    onDismiss: () => f.onOpenChange(!1)
  }, /* @__PURE__ */ y(Fi, S({
    "data-state": Of(f.open),
    role: "dialog",
    id: f.contentId
  }, p, u, {
    ref: t,
    style: {
      ...u.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
}), OC = "PopoverClose", FC = /* @__PURE__ */ R((e, t) => {
  const { __scopePopover: n, ...r } = e, o = jt(OC, n);
  return /* @__PURE__ */ y(te.button, S({
    type: "button"
  }, r, {
    ref: t,
    onClick: G(
      e.onClick,
      () => o.onOpenChange(!1)
    )
  }));
}), kC = /* @__PURE__ */ R((e, t) => {
  const { __scopePopover: n, ...r } = e, o = dr(n);
  return /* @__PURE__ */ y(ki, S({}, o, r, {
    ref: t
  }));
});
function Of(e) {
  return e ? "open" : "closed";
}
const NC = CC, _C = IC, LC = AC, BC = TC, VC = RC, GC = FC, WC = kC, jC = k(VC, {
  br: "$base",
  padding: "calc($base * 2)",
  color: "$textAlwaysLightMain",
  $$fillColor: "$colors$uiPrimaryMain",
  bgc: "$$fillColor"
}), zC = R((e, t) => /* @__PURE__ */ h.jsx(BC, { children: /* @__PURE__ */ h.jsx(jC, { ...e, ref: t }) })), HC = k(WC, {
  fill: "$$fillColor"
}), XC = xt, r8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Anchor: _C,
  Arrow: HC,
  Close: GC,
  Content: zC,
  Portal: XC,
  Root: NC,
  Trigger: LC
}, Symbol.toStringTag, { value: "Module" }));
var Er = {
  lessThanXSeconds: { one: "less than a second", other: "less than {{count}} seconds" },
  xSeconds: { one: "1 second", other: "{{count}} seconds" },
  halfAMinute: "half a minute",
  lessThanXMinutes: { one: "less than a minute", other: "less than {{count}} minutes" },
  xMinutes: { one: "1 minute", other: "{{count}} minutes" },
  aboutXHours: { one: "about 1 hour", other: "about {{count}} hours" },
  xHours: { one: "1 hour", other: "{{count}} hours" },
  xDays: { one: "1 day", other: "{{count}} days" },
  aboutXWeeks: { one: "about 1 week", other: "about {{count}} weeks" },
  xWeeks: { one: "1 week", other: "{{count}} weeks" },
  aboutXMonths: { one: "about 1 month", other: "about {{count}} months" },
  xMonths: { one: "1 month", other: "{{count}} months" },
  aboutXYears: { one: "about 1 year", other: "about {{count}} years" },
  xYears: { one: "1 year", other: "{{count}} years" },
  overXYears: { one: "over 1 year", other: "over {{count}} years" },
  almostXYears: { one: "almost 1 year", other: "almost {{count}} years" }
};
function la(e) {
  return function(t) {
    var n = t || {}, r = n.width ? String(n.width) : e.defaultWidth;
    return e.formats[r] || e.formats[e.defaultWidth];
  };
}
var ZC = {
  date: la({
    formats: {
      full: "EEEE, MMMM do, y",
      long: "MMMM do, y",
      medium: "MMM d, y",
      short: "MM/dd/yyyy"
    },
    defaultWidth: "full"
  }),
  time: la({
    formats: { full: "h:mm:ss a zzzz", long: "h:mm:ss a z", medium: "h:mm:ss a", short: "h:mm a" },
    defaultWidth: "full"
  }),
  dateTime: la({
    formats: {
      full: "{{date}} 'at' {{time}}",
      long: "{{date}} 'at' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    },
    defaultWidth: "full"
  })
}, YC = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
function kn(e) {
  return function(t, n) {
    var r, o = n || {};
    if ((o.context ? String(o.context) : "standalone") === "formatting" && e.formattingValues) {
      var a = e.defaultFormattingWidth || e.defaultWidth, i = o.width ? String(o.width) : a;
      r = e.formattingValues[i] || e.formattingValues[a];
    } else {
      var s = e.defaultWidth, c = o.width ? String(o.width) : e.defaultWidth;
      r = e.values[c] || e.values[s];
    }
    return r[e.argumentCallback ? e.argumentCallback(t) : t];
  };
}
function Nn(e) {
  return function(t, n) {
    var r = String(t), o = n || {}, a = o.width, i = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], s = r.match(i);
    if (!s)
      return null;
    var c, l = s[0], d = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth];
    return c = Object.prototype.toString.call(d) === "[object Array]" ? function(u, f) {
      for (var p = 0; p < u.length; p++)
        if (f(u[p]))
          return p;
    }(d, function(u) {
      return u.test(l);
    }) : function(u, f) {
      for (var p in u)
        if (u.hasOwnProperty(p) && f(u[p]))
          return p;
    }(d, function(u) {
      return u.test(l);
    }), c = e.valueCallback ? e.valueCallback(c) : c, { value: c = o.valueCallback ? o.valueCallback(c) : c, rest: r.slice(l.length) };
  };
}
var _n, UC = {
  code: "en-US",
  formatDistance: function(e, t, n) {
    var r;
    return n = n || {}, r = typeof Er[e] == "string" ? Er[e] : t === 1 ? Er[e].one : Er[e].other.replace("{{count}}", t), n.addSuffix ? n.comparison > 0 ? "in " + r : r + " ago" : r;
  },
  formatLong: ZC,
  formatRelative: function(e, t, n, r) {
    return YC[e];
  },
  localize: {
    ordinalNumber: function(e, t) {
      var n = Number(e), r = n % 100;
      if (r > 20 || r < 10)
        switch (r % 10) {
          case 1:
            return n + "st";
          case 2:
            return n + "nd";
          case 3:
            return n + "rd";
        }
      return n + "th";
    },
    era: kn({
      values: {
        narrow: ["B", "A"],
        abbreviated: ["BC", "AD"],
        wide: ["Before Christ", "Anno Domini"]
      },
      defaultWidth: "wide"
    }),
    quarter: kn({
      values: {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
      },
      defaultWidth: "wide",
      argumentCallback: function(e) {
        return Number(e) - 1;
      }
    }),
    month: kn({
      values: {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ],
        wide: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ]
      },
      defaultWidth: "wide"
    }),
    day: kn({
      values: {
        narrow: ["S", "M", "T", "W", "T", "F", "S"],
        short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
      },
      defaultWidth: "wide"
    }),
    dayPeriod: kn({
      values: {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "mi",
          noon: "n",
          morning: "morning",
          afternoon: "afternoon",
          evening: "evening",
          night: "night"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "midnight",
          noon: "noon",
          morning: "morning",
          afternoon: "afternoon",
          evening: "evening",
          night: "night"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "midnight",
          noon: "noon",
          morning: "morning",
          afternoon: "afternoon",
          evening: "evening",
          night: "night"
        }
      },
      defaultWidth: "wide",
      formattingValues: {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "mi",
          noon: "n",
          morning: "in the morning",
          afternoon: "in the afternoon",
          evening: "in the evening",
          night: "at night"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "midnight",
          noon: "noon",
          morning: "in the morning",
          afternoon: "in the afternoon",
          evening: "in the evening",
          night: "at night"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "midnight",
          noon: "noon",
          morning: "in the morning",
          afternoon: "in the afternoon",
          evening: "in the evening",
          night: "at night"
        }
      },
      defaultFormattingWidth: "wide"
    })
  },
  match: {
    ordinalNumber: (_n = {
      matchPattern: /^(\d+)(th|st|nd|rd)?/i,
      parsePattern: /\d+/i,
      valueCallback: function(e) {
        return parseInt(e, 10);
      }
    }, function(e, t) {
      var n = String(e), r = t || {}, o = n.match(_n.matchPattern);
      if (!o)
        return null;
      var a = o[0], i = n.match(_n.parsePattern);
      if (!i)
        return null;
      var s = _n.valueCallback ? _n.valueCallback(i[0]) : i[0];
      return { value: s = r.valueCallback ? r.valueCallback(s) : s, rest: n.slice(a.length) };
    }),
    era: Nn({
      matchPatterns: {
        narrow: /^(b|a)/i,
        abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
        wide: /^(before christ|before common era|anno domini|common era)/i
      },
      defaultMatchWidth: "wide",
      parsePatterns: { any: [/^b/i, /^(a|c)/i] },
      defaultParseWidth: "any"
    }),
    quarter: Nn({
      matchPatterns: {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](th|st|nd|rd)? quarter/i
      },
      defaultMatchWidth: "wide",
      parsePatterns: { any: [/1/i, /2/i, /3/i, /4/i] },
      defaultParseWidth: "any",
      valueCallback: function(e) {
        return e + 1;
      }
    }),
    month: Nn({
      matchPatterns: {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
        wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
      },
      defaultMatchWidth: "wide",
      parsePatterns: {
        narrow: [
          /^j/i,
          /^f/i,
          /^m/i,
          /^a/i,
          /^m/i,
          /^j/i,
          /^j/i,
          /^a/i,
          /^s/i,
          /^o/i,
          /^n/i,
          /^d/i
        ],
        any: [
          /^ja/i,
          /^f/i,
          /^mar/i,
          /^ap/i,
          /^may/i,
          /^jun/i,
          /^jul/i,
          /^au/i,
          /^s/i,
          /^o/i,
          /^n/i,
          /^d/i
        ]
      },
      defaultParseWidth: "any"
    }),
    day: Nn({
      matchPatterns: {
        narrow: /^[smtwf]/i,
        short: /^(su|mo|tu|we|th|fr|sa)/i,
        abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
        wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
      },
      defaultMatchWidth: "wide",
      parsePatterns: {
        narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
        any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
      },
      defaultParseWidth: "any"
    }),
    dayPeriod: Nn({
      matchPatterns: {
        narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
        any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
      },
      defaultMatchWidth: "any",
      parsePatterns: {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mi/i,
          noon: /^no/i,
          morning: /morning/i,
          afternoon: /afternoon/i,
          evening: /evening/i,
          night: /night/i
        }
      },
      defaultParseWidth: "any"
    })
  },
  options: { weekStartsOn: 0, firstWeekContainsDate: 1 }
};
function Ge(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function Ce(e, t) {
  if (t.length < e)
    throw new TypeError(
      e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present"
    );
}
function xe(e) {
  Ce(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : (typeof e != "string" && t !== "[object String]" || typeof console > "u" || (console.warn(
    "Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"
  ), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function JC(e, t) {
  Ce(2, arguments);
  var n = xe(e).getTime(), r = Ge(t);
  return new Date(n + r);
}
function QC(e, t) {
  Ce(2, arguments);
  var n = Ge(t);
  return JC(e, -n);
}
function Bc(e, t) {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}
function Vc(e, t) {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}
var KC = {
  p: Vc,
  P: function(e, t) {
    var n, r = e.match(/(P+)(p+)?/), o = r[1], a = r[2];
    if (!a)
      return Bc(e, t);
    switch (o) {
      case "P":
        n = t.dateTime({ width: "short" });
        break;
      case "PP":
        n = t.dateTime({ width: "medium" });
        break;
      case "PPP":
        n = t.dateTime({ width: "long" });
        break;
      case "PPPP":
      default:
        n = t.dateTime({ width: "full" });
    }
    return n.replace("{{date}}", Bc(o, t)).replace("{{time}}", Vc(a, t));
  }
};
function Gc(e) {
  return e.getTime() % 6e4;
}
function qC(e) {
  var t = new Date(e.getTime()), n = Math.ceil(t.getTimezoneOffset());
  return t.setSeconds(0, 0), 6e4 * n + (n > 0 ? (6e4 + Gc(t)) % 6e4 : Gc(t));
}
var e6 = ["D", "DD"], t6 = ["YY", "YYYY"];
function n6(e) {
  return e6.indexOf(e) !== -1;
}
function r6(e) {
  return t6.indexOf(e) !== -1;
}
function Wc(e) {
  if (e === "YYYY")
    throw new RangeError(
      "Use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr"
    );
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr");
  if (e === "D")
    throw new RangeError(
      "Use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr"
    );
  if (e === "DD")
    throw new RangeError(
      "Use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr"
    );
}
function to(e, t) {
  Ce(1, arguments);
  var n = t || {}, r = n.locale, o = r && r.options && r.options.weekStartsOn, a = o == null ? 0 : Ge(o), i = n.weekStartsOn == null ? a : Ge(n.weekStartsOn);
  if (!(i >= 0 && i <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var s = xe(e), c = s.getUTCDay(), l = (c < i ? 7 : 0) + c - i;
  return s.setUTCDate(s.getUTCDate() - l), s.setUTCHours(0, 0, 0, 0), s;
}
function Ff(e, t) {
  Ce(1, arguments);
  var n = xe(e, t), r = n.getUTCFullYear(), o = t || {}, a = o.locale, i = a && a.options && a.options.firstWeekContainsDate, s = i == null ? 1 : Ge(i), c = o.firstWeekContainsDate == null ? s : Ge(o.firstWeekContainsDate);
  if (!(c >= 1 && c <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var l = /* @__PURE__ */ new Date(0);
  l.setUTCFullYear(r + 1, 0, c), l.setUTCHours(0, 0, 0, 0);
  var d = to(l, t), u = /* @__PURE__ */ new Date(0);
  u.setUTCFullYear(r, 0, c), u.setUTCHours(0, 0, 0, 0);
  var f = to(u, t);
  return n.getTime() >= d.getTime() ? r + 1 : n.getTime() >= f.getTime() ? r : r - 1;
}
function no(e) {
  Ce(1, arguments);
  var t = 1, n = xe(e), r = n.getUTCDay(), o = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - o), n.setUTCHours(0, 0, 0, 0), n;
}
function kf(e) {
  Ce(1, arguments);
  var t = xe(e), n = t.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var o = no(r), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(n, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var i = no(a);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= i.getTime() ? n : n - 1;
}
function o6(e) {
  Ce(1, arguments);
  var t = kf(e), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = no(n);
  return r;
}
function a6(e) {
  Ce(1, arguments);
  var t = xe(e), n = no(t).getTime() - o6(t).getTime();
  return Math.round(n / 6048e5) + 1;
}
function i6(e, t) {
  Ce(1, arguments);
  var n = t || {}, r = n.locale, o = r && r.options && r.options.firstWeekContainsDate, a = o == null ? 1 : Ge(o), i = n.firstWeekContainsDate == null ? a : Ge(n.firstWeekContainsDate), s = Ff(e, t), c = /* @__PURE__ */ new Date(0);
  c.setUTCFullYear(s, 0, i), c.setUTCHours(0, 0, 0, 0);
  var l = to(c, t);
  return l;
}
function s6(e, t) {
  Ce(1, arguments);
  var n = xe(e), r = to(n, t).getTime() - i6(n, t).getTime();
  return Math.round(r / 6048e5) + 1;
}
function c6(e) {
  Ce(1, arguments);
  var t = xe(e);
  return !isNaN(t);
}
function ye(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t; )
    r = "0" + r;
  return n + r;
}
var l6 = function(e, t) {
  var n = e.getUTCFullYear(), r = n > 0 ? n : 1 - n;
  return ye(t === "yy" ? r % 100 : r, t.length);
}, u6 = function(e, t) {
  var n = e.getUTCMonth();
  return t === "M" ? String(n + 1) : ye(n + 1, 2);
}, d6 = function(e, t) {
  return ye(e.getUTCDate(), t.length);
}, f6 = function(e, t) {
  return ye(e.getUTCHours() % 12 || 12, t.length);
}, p6 = function(e, t) {
  return ye(e.getUTCHours(), t.length);
}, b6 = function(e, t) {
  return ye(e.getUTCMinutes(), t.length);
}, g6 = function(e, t) {
  return ye(e.getUTCSeconds(), t.length);
}, m6 = function(e, t) {
  var n = t.length, r = e.getUTCMilliseconds();
  return ye(Math.floor(r * Math.pow(10, n - 3)), t.length);
}, h6 = "midnight", v6 = "noon", $6 = "morning", x6 = "afternoon", y6 = "evening", C6 = "night", w6 = {
  G: function(e, t, n) {
    var r = e.getUTCFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  y: function(e, t, n) {
    if (t === "yo") {
      var r = e.getUTCFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return l6(e, t);
  },
  Y: function(e, t, n, r) {
    var o = Ff(e, r), a = o > 0 ? o : 1 - o;
    return t === "YY" ? ye(a % 100, 2) : t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : ye(a, t.length);
  },
  R: function(e, t) {
    return ye(kf(e), t.length);
  },
  u: function(e, t) {
    return ye(e.getUTCFullYear(), t.length);
  },
  Q: function(e, t, n) {
    var r = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return ye(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, { width: "abbreviated", context: "formatting" });
      case "QQQQQ":
        return n.quarter(r, { width: "narrow", context: "formatting" });
      case "QQQQ":
      default:
        return n.quarter(r, { width: "wide", context: "formatting" });
    }
  },
  q: function(e, t, n) {
    var r = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return ye(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, { width: "abbreviated", context: "standalone" });
      case "qqqqq":
        return n.quarter(r, { width: "narrow", context: "standalone" });
      case "qqqq":
      default:
        return n.quarter(r, { width: "wide", context: "standalone" });
    }
  },
  M: function(e, t, n) {
    var r = e.getUTCMonth();
    switch (t) {
      case "M":
      case "MM":
        return u6(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, { width: "abbreviated", context: "formatting" });
      case "MMMMM":
        return n.month(r, { width: "narrow", context: "formatting" });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  L: function(e, t, n) {
    var r = e.getUTCMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return ye(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, { width: "abbreviated", context: "standalone" });
      case "LLLLL":
        return n.month(r, { width: "narrow", context: "standalone" });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  w: function(e, t, n, r) {
    var o = s6(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : ye(o, t.length);
  },
  I: function(e, t, n) {
    var r = a6(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : ye(r, t.length);
  },
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getUTCDate(), { unit: "date" }) : d6(e, t);
  },
  D: function(e, t, n) {
    var r = function(o) {
      Ce(1, arguments);
      var a = xe(o), i = a.getTime();
      a.setUTCMonth(0, 1), a.setUTCHours(0, 0, 0, 0);
      var s = a.getTime(), c = i - s;
      return Math.floor(c / 864e5) + 1;
    }(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : ye(r, t.length);
  },
  E: function(e, t, n) {
    var r = e.getUTCDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, { width: "abbreviated", context: "formatting" });
      case "EEEEE":
        return n.day(r, { width: "narrow", context: "formatting" });
      case "EEEEEE":
        return n.day(r, { width: "short", context: "formatting" });
      case "EEEE":
      default:
        return n.day(r, { width: "wide", context: "formatting" });
    }
  },
  e: function(e, t, n, r) {
    var o = e.getUTCDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(a);
      case "ee":
        return ye(a, 2);
      case "eo":
        return n.ordinalNumber(a, { unit: "day" });
      case "eee":
        return n.day(o, { width: "abbreviated", context: "formatting" });
      case "eeeee":
        return n.day(o, { width: "narrow", context: "formatting" });
      case "eeeeee":
        return n.day(o, { width: "short", context: "formatting" });
      case "eeee":
      default:
        return n.day(o, { width: "wide", context: "formatting" });
    }
  },
  c: function(e, t, n, r) {
    var o = e.getUTCDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(a);
      case "cc":
        return ye(a, t.length);
      case "co":
        return n.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return n.day(o, { width: "abbreviated", context: "standalone" });
      case "ccccc":
        return n.day(o, { width: "narrow", context: "standalone" });
      case "cccccc":
        return n.day(o, { width: "short", context: "standalone" });
      case "cccc":
      default:
        return n.day(o, { width: "wide", context: "standalone" });
    }
  },
  i: function(e, t, n) {
    var r = e.getUTCDay(), o = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(o);
      case "ii":
        return ye(o, t.length);
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      case "iii":
        return n.day(r, { width: "abbreviated", context: "formatting" });
      case "iiiii":
        return n.day(r, { width: "narrow", context: "formatting" });
      case "iiiiii":
        return n.day(r, { width: "short", context: "formatting" });
      case "iiii":
      default:
        return n.day(r, { width: "wide", context: "formatting" });
    }
  },
  a: function(e, t, n) {
    var r = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
      case "aaa":
        return n.dayPeriod(r, { width: "abbreviated", context: "formatting" });
      case "aaaaa":
        return n.dayPeriod(r, { width: "narrow", context: "formatting" });
      case "aaaa":
      default:
        return n.dayPeriod(r, { width: "wide", context: "formatting" });
    }
  },
  b: function(e, t, n) {
    var r, o = e.getUTCHours();
    switch (r = o === 12 ? v6 : o === 0 ? h6 : o / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
      case "bbb":
        return n.dayPeriod(r, { width: "abbreviated", context: "formatting" });
      case "bbbbb":
        return n.dayPeriod(r, { width: "narrow", context: "formatting" });
      case "bbbb":
      default:
        return n.dayPeriod(r, { width: "wide", context: "formatting" });
    }
  },
  B: function(e, t, n) {
    var r, o = e.getUTCHours();
    switch (r = o >= 17 ? y6 : o >= 12 ? x6 : o >= 4 ? $6 : C6, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(r, { width: "abbreviated", context: "formatting" });
      case "BBBBB":
        return n.dayPeriod(r, { width: "narrow", context: "formatting" });
      case "BBBB":
      default:
        return n.dayPeriod(r, { width: "wide", context: "formatting" });
    }
  },
  h: function(e, t, n) {
    if (t === "ho") {
      var r = e.getUTCHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return f6(e, t);
  },
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getUTCHours(), { unit: "hour" }) : p6(e, t);
  },
  K: function(e, t, n) {
    var r = e.getUTCHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : ye(r, t.length);
  },
  k: function(e, t, n) {
    var r = e.getUTCHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : ye(r, t.length);
  },
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getUTCMinutes(), { unit: "minute" }) : b6(e, t);
  },
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getUTCSeconds(), { unit: "second" }) : g6(e, t);
  },
  S: function(e, t) {
    return m6(e, t);
  },
  X: function(e, t, n, r) {
    var o = (r._originalDate || e).getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (t) {
      case "X":
        return zc(o);
      case "XXXX":
      case "XX":
        return Xt(o);
      case "XXXXX":
      case "XXX":
      default:
        return Xt(o, ":");
    }
  },
  x: function(e, t, n, r) {
    var o = (r._originalDate || e).getTimezoneOffset();
    switch (t) {
      case "x":
        return zc(o);
      case "xxxx":
      case "xx":
        return Xt(o);
      case "xxxxx":
      case "xxx":
      default:
        return Xt(o, ":");
    }
  },
  O: function(e, t, n, r) {
    var o = (r._originalDate || e).getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + jc(o, ":");
      case "OOOO":
      default:
        return "GMT" + Xt(o, ":");
    }
  },
  z: function(e, t, n, r) {
    var o = (r._originalDate || e).getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + jc(o, ":");
      case "zzzz":
      default:
        return "GMT" + Xt(o, ":");
    }
  },
  t: function(e, t, n, r) {
    var o = r._originalDate || e;
    return ye(Math.floor(o.getTime() / 1e3), t.length);
  },
  T: function(e, t, n, r) {
    return ye((r._originalDate || e).getTime(), t.length);
  }
};
function jc(e, t) {
  var n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.floor(r / 60), a = r % 60;
  if (a === 0)
    return n + String(o);
  var i = t || "";
  return n + String(o) + i + ye(a, 2);
}
function zc(e, t) {
  return e % 60 == 0 ? (e > 0 ? "-" : "+") + ye(Math.abs(e) / 60, 2) : Xt(e, t);
}
function Xt(e, t) {
  var n = t || "", r = e > 0 ? "-" : "+", o = Math.abs(e);
  return r + ye(Math.floor(o / 60), 2) + n + ye(o % 60, 2);
}
var I6 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, S6 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, A6 = /^'([^]*?)'?$/, E6 = /''/g, P6 = /[a-zA-Z]/;
function fr(e, t, n) {
  Ce(2, arguments);
  var r = String(t), o = n || {}, a = o.locale || UC, i = a.options && a.options.firstWeekContainsDate, s = i == null ? 1 : Ge(i), c = o.firstWeekContainsDate == null ? s : Ge(o.firstWeekContainsDate);
  if (!(c >= 1 && c <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var l = a.options && a.options.weekStartsOn, d = l == null ? 0 : Ge(l), u = o.weekStartsOn == null ? d : Ge(o.weekStartsOn);
  if (!(u >= 0 && u <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!a.localize)
    throw new RangeError("locale must contain localize property");
  if (!a.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var f = xe(e);
  if (!c6(f))
    throw new RangeError("Invalid time value");
  var p = qC(f), g = QC(f, p), b = { firstWeekContainsDate: c, weekStartsOn: u, locale: a, _originalDate: f }, m = r.match(S6).map(function(v) {
    var $ = v[0];
    return $ === "p" || $ === "P" ? (0, KC[$])(v, a.formatLong, b) : v;
  }).join("").match(I6).map(function(v) {
    if (v === "''")
      return "'";
    var $ = v[0];
    if ($ === "'")
      return T6(v);
    var x = w6[$];
    if (x)
      return !o.useAdditionalWeekYearTokens && r6(v) && Wc(v), !o.useAdditionalDayOfYearTokens && n6(v) && Wc(v), x(g, v, a.localize, b);
    if ($.match(P6))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + $ + "`"
      );
    return v;
  }).join("");
  return m;
}
function T6(e) {
  return e.match(A6)[1].replace(E6, "'");
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function Be(e, t) {
  Ce(2, arguments);
  var n = xe(e), r = Ge(t);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function Qt(e, t) {
  Ce(1, arguments);
  var n = e || {}, r = xe(n.start), o = xe(n.end), a = o.getTime();
  if (!(r.getTime() <= a))
    throw new RangeError("Invalid interval");
  var i = [], s = r;
  s.setHours(0, 0, 0, 0);
  var c = t && "step" in t ? Number(t.step) : 1;
  if (c < 1 || isNaN(c))
    throw new RangeError("`options.step` must be a number greater than 1");
  for (; s.getTime() <= a; )
    i.push(xe(s)), s.setDate(s.getDate() + c), s.setHours(0, 0, 0, 0);
  return i;
}
function R6(e, t) {
  Ce(1, arguments);
  var n = t || {}, r = n.locale, o = r && r.options && r.options.weekStartsOn, a = o == null ? 0 : Ge(o), i = n.weekStartsOn == null ? a : Ge(n.weekStartsOn);
  if (!(i >= 0 && i <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var s = xe(e), c = s.getDay(), l = 6 + (c < i ? -7 : 0) - (c - i);
  return s.setDate(s.getDate() + l), s.setHours(23, 59, 59, 999), s;
}
function Nf(e) {
  Ce(1, arguments);
  var t = xe(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function M6(e, t) {
  Ce(1, arguments);
  var n = t || {}, r = n.locale, o = r && r.options && r.options.weekStartsOn, a = o == null ? 0 : Ge(o), i = n.weekStartsOn == null ? a : Ge(n.weekStartsOn);
  if (!(i >= 0 && i <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var s = xe(e), c = s.getDay(), l = (c < i ? 7 : 0) + c - i;
  return s.setDate(s.getDate() - l), s.setHours(0, 0, 0, 0), s;
}
function D6(e) {
  var t = e === void 0 ? {} : e, n = t.firstDayOfWeek, r = n === void 0 ? 1 : n, o = t.weekdayLabelFormat, a = o === void 0 ? function(s) {
    return fr(s, "iiiiii");
  } : o, i = /* @__PURE__ */ new Date();
  return Qt({ start: Be(M6(i), r), end: Be(R6(i), r) }).reduce(function(s, c) {
    return s.push(a(c)), s;
  }, []);
}
function O6(e) {
  var t = e.year, n = e.month, r = e.firstDayOfWeek, o = r === void 0 ? 1 : r, a = e.dayLabelFormat, i = a === void 0 ? function(u) {
    return fr(u, "dd");
  } : a, s = new Date(t, n), c = Nf(s), l = function(u) {
    Ce(1, arguments);
    var f = xe(u), p = f.getDay();
    return p;
  }(c), d = function(u) {
    Ce(1, arguments);
    var f = xe(u), p = f.getMonth();
    return f.setFullYear(f.getFullYear(), p + 1, 0), f.setHours(23, 59, 59, 999), f;
  }(s);
  return function() {
    for (var u = 0, f = 0, p = arguments.length; f < p; f++)
      u += arguments[f].length;
    var g = Array(u), b = 0;
    for (f = 0; f < p; f++)
      for (var m = arguments[f], v = 0, $ = m.length; v < $; v++, b++)
        g[b] = m[v];
    return g;
  }(
    Array.from(Array(l >= o ? l - o : 6 - o + l + 1).keys()).fill(0),
    Qt({ start: c, end: d }).map(function(u) {
      return { date: u, dayLabel: i(u) };
    })
  );
}
var F6 = function(e) {
  return fr(e, "dd");
}, k6 = function(e) {
  return fr(e, "eeeeee");
}, N6 = function(e) {
  return fr(e, "MMMM yyyy");
};
function _6(e) {
  var t = e.year, n = e.month, r = e.firstDayOfWeek, o = r === void 0 ? 1 : r, a = e.dayLabelFormat, i = a === void 0 ? F6 : a, s = e.weekdayLabelFormat, c = s === void 0 ? k6 : s, l = e.monthLabelFormat, d = l === void 0 ? N6 : l;
  return {
    days: Ne(
      function() {
        return O6({ year: t, month: n, firstDayOfWeek: o, dayLabelFormat: i });
      },
      [t, n, o, i]
    ),
    weekdayLabels: Ne(
      function() {
        return D6({ firstDayOfWeek: o, weekdayLabelFormat: c });
      },
      [o, c]
    ),
    monthLabel: d(new Date(t, n))
  };
}
function Dt(e, t) {
  Ce(2, arguments);
  var n = xe(e), r = xe(t);
  return n.getTime() < r.getTime();
}
function Wn(e, t) {
  Ce(2, arguments);
  var n = xe(e), r = xe(t);
  return n.getTime() > r.getTime();
}
function $n(e, t) {
  Ce(2, arguments);
  var n = t || {}, r = xe(e).getTime(), o = xe(n.start).getTime(), a = xe(n.end).getTime();
  if (!(o <= a))
    throw new RangeError("Invalid interval");
  return r >= o && r <= a;
}
function za(e) {
  Ce(1, arguments);
  var t = xe(e);
  return t.setHours(0, 0, 0, 0), t;
}
function ut(e, t) {
  Ce(2, arguments);
  var n = za(e), r = za(t);
  return n.getTime() === r.getTime();
}
function Ha(e, t) {
  Ce(2, arguments);
  var n = xe(e), r = Ge(t);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var o = n.getDate(), a = new Date(n.getTime());
  a.setMonth(n.getMonth() + r + 1, 0);
  var i = a.getDate();
  return o >= i ? a : (n.setFullYear(a.getFullYear(), a.getMonth(), o), n);
}
var _f = function(e, t) {
  return e === void 0 && (e = []), e.some(function(n) {
    return ut(t, n);
  });
};
function L6(e, t, n) {
  return !(!t || !n) && $n(e, { start: t, end: n });
}
function B6(e, t, n) {
  return !!(t && ut(e, t) || n && ut(e, n));
}
function V6(e, t) {
  return !(!t || !ut(e, t));
}
function G6(e, t) {
  return !(!t || !ut(e, t));
}
function W6(e) {
  var t = e.date, n = e.minBookingDate, r = e.maxBookingDate, o = e.isDateBlockedFn, a = e.startDate, i = e.endDate, s = e.minBookingDays, c = s === void 0 ? 1 : s, l = e.unavailableDates, d = l === void 0 ? [] : l, u = n && new Date(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0, 0), f = r && new Date(r.getFullYear(), r.getMonth(), r.getDate(), 0, 0, 0);
  return !!(_f(d, t) || u && Dt(t, u) || f && Wn(t, f) || a && !i && c > 1 && $n(t, { start: a, end: Be(a, c - 2) }) || o && o(t));
}
function qn(e) {
  var t = Nf(e);
  return {
    year: function(n) {
      Ce(1, arguments);
      var r = xe(n), o = r.getFullYear();
      return o;
    }(t),
    month: function(n) {
      Ce(1, arguments);
      var r = xe(n), o = r.getMonth();
      return o;
    }(t),
    date: t
  };
}
function j6() {
  return qn(za(Date.now()));
}
function Ln(e, t) {
  var n = t ? qn(t) : j6(), r = n.date, o = [n];
  return e > 1 && (o = Array.from(Array(e - 1).keys()).reduce(function(a) {
    return r = Ha(a[a.length - 1].date, 1), a.concat([qn(r)]);
  }, o)), o;
}
function mn(e, t, n, r) {
  var o = e[r ? n > 0 ? 0 : e.length - r : n > 0 ? e.length - 1 : 0].date;
  return Array.from(Array(t).keys()).reduce(function(a) {
    return o = a.length === 0 ? Ha(o, n) : Ha(o, n >= 0 ? 1 : -1), n > 0 ? a.concat([qn(o)]) : [qn(o)].concat(a);
  }, []);
}
function Bn(e) {
  var t = e.startDate, n = e.endDate, r = e.isDateBlocked, o = e.minBookingDays, a = e.exactMinBookingDays, i = e.minBookingDate, s = e.maxBookingDate, c = !i || !Dt(t, Be(i, -1)), l = !s || !Wn(Be(t, o - 1), s);
  return !(!t || o !== 1 || n || r(t)) || (t && o > 1 && !n && !a || t && o > 0 && a && c && l || t && o > 0 && a && !i && !s ? !Qt({ start: t, end: Be(t, o - 1) }).some(function(d) {
    return r(d);
  }) : !(!t || !n || a) && !Dt(n, Be(t, o - 1)) && !Qt({ start: t, end: n }).some(function(d) {
    return r(d);
  }));
}
var ko = "startDate";
function Lf(e) {
  var t = e.startDate, n = e.endDate, r = e.focusedInput, o = e.minBookingDate, a = e.maxBookingDate, i = e.onDatesChange, s = e.initialVisibleMonth, c = e.exactMinBookingDays, l = c !== void 0 && c, d = e.minBookingDays, u = d === void 0 ? 1 : d, f = e.numberOfMonths, p = f === void 0 ? 2 : f, g = e.firstDayOfWeek, b = g === void 0 ? 1 : g, m = e.isDateBlocked, v = m === void 0 ? function() {
    return !1;
  } : m, $ = e.unavailableDates, x = $ === void 0 ? [] : $, w = e.changeActiveMonthOnSelect, C = w === void 0 || w, P = J(function() {
    return Ln(p, t || s || null);
  }), E = P[0], T = P[1], F = J(null), V = F[0], _ = F[1], W = J(t), H = W[0], D = W[1];
  Z(function() {
    return typeof window < "u" && window.addEventListener && window.addEventListener("keydown", ee), function() {
      window.removeEventListener && window.removeEventListener("keydown", ee);
    };
  });
  var M = function(B) {
    return _f(x, B) || v(B);
  }, j = function(B) {
    D(B), (!H || H && !ut(B, H)) && T(Ln(p, B));
  }, U = function(B) {
    return W6({
      date: B,
      minBookingDate: o,
      maxBookingDate: a,
      startDate: t,
      endDate: n,
      minBookingDays: u,
      isDateBlockedFn: M
    });
  };
  function ee(B) {
    if ((B.key === "ArrowRight" || B.key === "ArrowLeft" || B.key === "ArrowDown" || B.key === "ArrowUp") && !H) {
      var ue = E[0];
      j(ue.date), T(Ln(p, ue.date));
    }
  }
  var z = K(
    function() {
      T(mn(E, p, -1)), D(null);
    },
    [E, p]
  ), oe = K(
    function() {
      T(mn(E, p, -1, 1)), D(null);
    },
    [E, p]
  ), le = K(
    function() {
      T(mn(E, p, 1)), D(null);
    },
    [E, p]
  ), ie = K(
    function() {
      T(mn(E, p, 1, 1)), D(null);
    },
    [E, p]
  ), fe = K(
    function(B) {
      T(Ln(p, B)), D(null);
    },
    [p]
  ), Ae = K(
    function(B) {
      B === void 0 && (B = 1), T(mn(E, p, -(12 * B - p + 1))), D(null);
    },
    [E, p]
  ), Re = K(
    function(B) {
      B === void 0 && (B = 1), T(mn(E, p, 12 * B - p + 1)), D(null);
    },
    [E, p]
  );
  return {
    firstDayOfWeek: b,
    activeMonths: E,
    isDateSelected: function(B) {
      return L6(B, t, n);
    },
    isDateHovered: function(B) {
      return function(ue) {
        var we = ue.date, ce = ue.startDate, Le = ue.endDate, Je = ue.isDateBlocked, X = ue.hoveredDate, Ve = ue.minBookingDays, Ze = ue.exactMinBookingDays;
        return X && Ve > 1 && Ze && $n(we, { start: X, end: Be(X, Ve - 1) }) ? !Qt({ start: X, end: Be(X, Ve - 1) }).some(function(Pe) {
          return Je(Pe);
        }) : ce && !Le && X && $n(we, { start: ce, end: Be(ce, Ve - 1) }) && ut(ce, X) && Ve > 1 ? !Qt({ start: ce, end: Be(ce, Ve - 1) }).some(function(Pe) {
          return Je(Pe);
        }) : !(!ce || Le || !X || Dt(X, ce) || !$n(we, { start: ce, end: X })) && !Qt({ start: ce, end: X }).some(function(Pe) {
          return Je(Pe);
        });
      }({
        date: B,
        hoveredDate: V,
        startDate: t,
        endDate: n,
        minBookingDays: u,
        exactMinBookingDays: l,
        isDateBlocked: M
      });
    },
    isFirstOrLastSelectedDate: function(B) {
      return B6(B, t, n);
    },
    isStartDate: function(B) {
      return V6(B, t);
    },
    isEndDate: function(B) {
      return G6(B, n);
    },
    isDateBlocked: U,
    numberOfMonths: p,
    isDateFocused: function(B) {
      return !!H && ut(B, H);
    },
    focusedDate: H,
    hoveredDate: V,
    onResetDates: function() {
      i({ startDate: null, endDate: null, focusedInput: "startDate" });
    },
    onDateHover: function(B) {
      if (B) {
        if (B) {
          var ue = !U(B) || t && ut(B, t), we = !o || !Dt(B, Be(o, -1)), ce = !a || !Wn(B, a), Le = Be(B, u - 1), Je = !o || !Dt(Le, o), X = !a || !Wn(Le, a), Ve = l && u > 1 && we && ce && Je && X, Ze = t && !n && !l && we && ce, Pe = !(u > 1 && t) || $n(B, { start: t, end: Be(t, u - 2) }), gt = t && ut(B, t) && Pe;
          ue && (Ve || Ze || gt) ? _(B) : V !== null && _(null);
        }
      } else
        _(null);
    },
    onDateSelect: function(B) {
      (r === "endDate" || r === "startDate") && u > 0 && l && Bn({
        minBookingDays: u,
        exactMinBookingDays: l,
        minBookingDate: o,
        maxBookingDate: a,
        isDateBlocked: M,
        startDate: B,
        endDate: null
      }) ? i({ startDate: B, endDate: Be(B, u - 1), focusedInput: null }) : (r === "endDate" && t && Dt(B, t) || r === "startDate" && n && Wn(B, n)) && !l && Bn({ minBookingDays: u, isDateBlocked: M, startDate: B, endDate: null }) ? i({ endDate: null, startDate: B, focusedInput: "endDate" }) : r === "startDate" && !l && Bn({ minBookingDays: u, isDateBlocked: M, endDate: n, startDate: B }) ? i({ endDate: n, startDate: B, focusedInput: "endDate" }) : r === "startDate" && !l && Bn({ minBookingDays: u, isDateBlocked: M, endDate: null, startDate: B }) ? i({ endDate: null, startDate: B, focusedInput: "endDate" }) : r === "endDate" && t && !Dt(B, t) && !l && Bn({ minBookingDays: u, isDateBlocked: M, startDate: t, endDate: B }) && i({ startDate: t, endDate: B, focusedInput: null }), r !== "endDate" && (!H || H && !ut(B, H)) && C && T(Ln(p, B));
    },
    onDateFocus: j,
    goToPreviousMonths: z,
    goToPreviousMonthsByOneMonth: oe,
    goToNextMonths: le,
    goToNextMonthsByOneMonth: ie,
    goToDate: fe,
    goToPreviousYear: Ae,
    goToNextYear: Re
  };
}
function z6(e) {
  var t = e.date, n = e.focusedDate, r = e.isDateSelected, o = e.isDateFocused, a = e.isFirstOrLastSelectedDate, i = e.isDateHovered, s = e.isDateBlocked, c = e.onDateSelect, l = e.onDateFocus, d = e.onDateHover, u = K(
    function() {
      return c(t);
    },
    [t, c]
  ), f = K(
    function() {
      return d(t);
    },
    [t, d]
  ), p = s(t) && !i(t);
  return {
    tabIndex: n === null || o(t) ? 0 : -1,
    isSelected: r(t),
    isSelectedStartOrEnd: a(t),
    isWithinHoverRange: i(t),
    disabledDate: p,
    onKeyDown: function(g) {
      g.key === "ArrowRight" ? l(Be(t, 1)) : g.key === "ArrowLeft" ? l(Be(t, -1)) : g.key === "ArrowUp" ? l(Be(t, -7)) : g.key === "ArrowDown" && l(Be(t, 7));
    },
    onClick: p ? function() {
    } : u,
    onMouseEnter: f
  };
}
function Ke(e, t) {
  return !e || !t ? !1 : e.getDate() === t.getDate() && e.getMonth() === t.getMonth() && e.getFullYear() === t.getFullYear();
}
function Bf(e, t) {
  const { days: n, weekdayLabels: r, monthLabel: o } = _6({
    year: e.year,
    month: e.month,
    firstDayOfWeek: t
  });
  return {
    days: n,
    weekdayLabels: r,
    monthLabel: o,
    firstCalendarDay: n.find((a) => typeof a == "object").date,
    lastCalendarDay: [...n].reverse().find((a) => typeof a == "object").date
  };
}
function ua(e) {
  return e % 7 === 0;
}
function da(e) {
  return (e + 1) % 7 === 0;
}
function H6(e, t, n, r, o, a, i, s, c, l, d) {
  if (t && (c || Ke(r, o)))
    return "isSelectedStartOrEnd";
  if (Ke(r, a) && t && o && !Ke(s, a) && !da(d))
    return "isSelectedStart";
  if (Ke(o, a) && t && !Ke(i, a) && !ua(d))
    return "isSelectedEnd";
  if (e && da(d) && Ke(i, a))
    return "isSelectedStartSingle";
  if (t)
    return "isSelectedStartOrEnd";
  if (e && ua(d) && Ke(s, a))
    return "isSelectedEndSingle";
  if (e && (da(d) || Ke(s, a)))
    return "isSelectedLineEnd";
  if (e && (ua(d) || Ke(i, a)))
    return "isSelectedLineStart";
  if (e)
    return "isSelected";
  if (l)
    return "isStartDisabled";
  if (n)
    return "isToday";
}
const X6 = k("footer", {
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gridRowGap: "0.5rem",
  fontFamily: "$base",
  fontSize: "$caption",
  color: "$uiDisabled50",
  paddding: "1.25rem",
  variants: {
    size: {
      medium: {
        gridTemplateColumns: "1fr",
        textAlign: "center"
      }
    }
  }
}), Z6 = k("div", {
  textAlign: "right",
  variants: {
    size: {
      medium: {
        textAlign: "center"
      }
    }
  }
}), fa = k("a", {
  color: "$textLink",
  padding: "0 $base"
}), Y6 = tn({
  color: "$uiErrorMain"
})();
function o8() {
  return /* @__PURE__ */ h.jsxs(X6, { size: { max1024: "medium" }, children: [
    /* @__PURE__ */ h.jsxs("div", { children: [
      "Created with ",
      /* @__PURE__ */ h.jsx("span", { className: Y6, children: "♥" }),
      " by StreamElements © All rights reserved"
    ] }),
    /* @__PURE__ */ h.jsxs(Z6, { size: { max1024: "medium" }, children: [
      /* @__PURE__ */ h.jsx(fa, { rel: "noopener", target: "_blank", href: "https://streamelements.com/contact", children: "Contact us" }),
      /* @__PURE__ */ h.jsx(fa, { rel: "noopener", target: "_blank", href: "https://streamelements.com/terms", children: "Terms of Service" }),
      /* @__PURE__ */ h.jsx(fa, { rel: "noopener", target: "_blank", href: "https://streamelements.com/privacy", children: "Privacy Policy" })
    ] })
  ] });
}
const Xa = k("div", {
  background: "$uiSecondary",
  transition: "box-shadow 0.2s ease-in",
  height: "fit-content",
  br: "$24",
  padding: "$40",
  compoundVariants: [
    {
      radius: "sm",
      padding: "generous",
      css: { padding: "$24" }
    },
    {
      radius: "md",
      padding: "generous",
      css: { padding: "$32" }
    },
    {
      radius: "lg",
      padding: "generous",
      css: { padding: "$40" }
    },
    {
      radius: "sm",
      padding: "regular",
      css: { padding: "$16" }
    },
    {
      radius: "md",
      padding: "regular",
      css: { padding: "$24" }
    },
    {
      radius: "lg",
      padding: "regular",
      css: { padding: "$32" }
    },
    {
      radius: "sm",
      padding: "compact",
      css: { padding: "$8" }
    },
    {
      radius: "md",
      padding: "compact",
      css: { padding: "$16" }
    },
    {
      radius: "lg",
      padding: "compact",
      css: { padding: "$24" }
    }
  ],
  variants: {
    hoverable: {
      true: {
        "&:hover, &:focus": {
          boxShadow: "$3"
        }
      }
    },
    clickable: {
      true: {
        cursor: "pointer"
      }
    },
    padding: {
      generous: { padding: "$40" },
      regular: { padding: "$16" },
      compact: { padding: "$8" }
    },
    radius: {
      default: { br: "$24" },
      lg: { br: "$24" },
      md: { br: "$16" },
      sm: { br: "$8" }
    },
    outline: {
      true: {
        border: "1px $divider solid"
      }
    },
    shadow: {
      none: {},
      sm: { boxShadow: "$1" },
      md: { boxShadow: "$2" },
      lg: { boxShadow: "$3" }
    }
  },
  defaultVariants: {
    shadow: "sm"
  }
}), U6 = k("div", {
  fontFamily: "$base",
  fontSize: "$bodyText",
  lineHeight: 1,
  pb: "$base"
}), J6 = k("div", {
  fontFamily: "$base",
  pt: "$base"
}), Q6 = tn({
  visibility: "hidden",
  width: "100%"
})(), K6 = k("div", {
  position: "relative"
}), q6 = k("div", {
  userSelect: "none",
  display: "block",
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  position: "absolute",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0
});
function ew({ image: e, title: t, ...n }) {
  return /* @__PURE__ */ h.jsxs(K6, { ...n, children: [
    /* @__PURE__ */ h.jsx(q6, { title: t, style: { backgroundImage: `url(${e})` } }),
    /* @__PURE__ */ h.jsx("img", { src: e, alt: t, className: Q6 })
  ] });
}
const tw = tn({
  lineHeight: 1,
  margin: 0,
  color: "$textPrimary70"
})();
function nw({ title: e, ...t }) {
  return /* @__PURE__ */ h.jsx(xo, { as: "div", className: tw, weight: "bold", ...t, children: e });
}
const a8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Body: J6,
  Cover: ew,
  Default: Xa,
  Header: U6,
  Meta: nw,
  Root: Xa
}, Symbol.toStringTag, { value: "Module" })), Vf = "Dialog", [Gf, i8] = _e(Vf), [rw, bt] = Gf(Vf), ow = (e) => {
  const { __scopeDialog: t, children: n, open: r, defaultOpen: o, onOpenChange: a, modal: i = !0 } = e, s = O(null), c = O(null), [l = !1, d] = Te({
    prop: r,
    defaultProp: o,
    onChange: a
  });
  return /* @__PURE__ */ y(rw, {
    scope: t,
    triggerRef: s,
    contentRef: c,
    contentId: nt(),
    titleId: nt(),
    descriptionId: nt(),
    open: l,
    onOpenChange: d,
    onOpenToggle: K(
      () => d(
        (u) => !u
      ),
      [
        d
      ]
    ),
    modal: i
  }, n);
}, aw = "DialogTrigger", iw = /* @__PURE__ */ R((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = bt(aw, n), a = se(t, o.triggerRef);
  return /* @__PURE__ */ y(te.button, S({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": o.open,
    "aria-controls": o.contentId,
    "data-state": Ji(o.open)
  }, r, {
    ref: a,
    onClick: G(e.onClick, o.onOpenToggle)
  }));
}), Wf = "DialogPortal", [sw, jf] = Gf(Wf, {
  forceMount: void 0
}), cw = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, a = bt(Wf, t);
  return /* @__PURE__ */ y(sw, {
    scope: t,
    forceMount: n
  }, Zt.map(
    r,
    (i) => /* @__PURE__ */ y(Oe, {
      present: n || a.open
    }, /* @__PURE__ */ y(on, {
      asChild: !0,
      container: o
    }, i))
  ));
}, Za = "DialogOverlay", lw = /* @__PURE__ */ R((e, t) => {
  const n = jf(Za, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = bt(Za, e.__scopeDialog);
  return a.modal ? /* @__PURE__ */ y(Oe, {
    present: r || a.open
  }, /* @__PURE__ */ y(uw, S({}, o, {
    ref: t
  }))) : null;
}), uw = /* @__PURE__ */ R((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = bt(Za, n);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ y(zi, {
      as: je,
      allowPinchZoom: !0,
      shards: [
        o.contentRef
      ]
    }, /* @__PURE__ */ y(te.div, S({
      "data-state": Ji(o.open)
    }, r, {
      ref: t,
      style: {
        pointerEvents: "auto",
        ...r.style
      }
    })))
  );
}), er = "DialogContent", dw = /* @__PURE__ */ R((e, t) => {
  const n = jf(er, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = bt(er, e.__scopeDialog);
  return /* @__PURE__ */ y(Oe, {
    present: r || a.open
  }, a.modal ? /* @__PURE__ */ y(fw, S({}, o, {
    ref: t
  })) : /* @__PURE__ */ y(pw, S({}, o, {
    ref: t
  })));
}), fw = /* @__PURE__ */ R((e, t) => {
  const n = bt(er, e.__scopeDialog), r = O(null), o = se(t, n.contentRef, r);
  return Z(() => {
    const a = r.current;
    if (a)
      return ji(a);
  }, []), /* @__PURE__ */ y(zf, S({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: G(e.onCloseAutoFocus, (a) => {
      var i;
      a.preventDefault(), (i = n.triggerRef.current) === null || i === void 0 || i.focus();
    }),
    onPointerDownOutside: G(e.onPointerDownOutside, (a) => {
      const i = a.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
      (i.button === 2 || s) && a.preventDefault();
    }),
    onFocusOutside: G(
      e.onFocusOutside,
      (a) => a.preventDefault()
    )
  }));
}), pw = /* @__PURE__ */ R((e, t) => {
  const n = bt(er, e.__scopeDialog), r = O(!1), o = O(!1);
  return /* @__PURE__ */ y(zf, S({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (a) => {
      var i;
      if ((i = e.onCloseAutoFocus) === null || i === void 0 || i.call(e, a), !a.defaultPrevented) {
        var s;
        r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), a.preventDefault();
      }
      r.current = !1, o.current = !1;
    },
    onInteractOutside: (a) => {
      var i, s;
      (i = e.onInteractOutside) === null || i === void 0 || i.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
      const c = a.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(c)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
    }
  }));
}), zf = /* @__PURE__ */ R((e, t) => {
  const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: a, ...i } = e, s = bt(er, n), c = O(null), l = se(t, c);
  return Gi(), /* @__PURE__ */ y(xt, null, /* @__PURE__ */ y(Wi, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a
  }, /* @__PURE__ */ y(sr, S({
    role: "dialog",
    id: s.contentId,
    "aria-describedby": s.descriptionId,
    "aria-labelledby": s.titleId,
    "data-state": Ji(s.open)
  }, i, {
    ref: l,
    onDismiss: () => s.onOpenChange(!1)
  }))), !1);
}), bw = "DialogTitle", gw = /* @__PURE__ */ R((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = bt(bw, n);
  return /* @__PURE__ */ y(te.h2, S({
    id: o.titleId
  }, r, {
    ref: t
  }));
}), mw = "DialogDescription", hw = /* @__PURE__ */ R((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = bt(mw, n);
  return /* @__PURE__ */ y(te.p, S({
    id: o.descriptionId
  }, r, {
    ref: t
  }));
}), vw = "DialogClose", $w = /* @__PURE__ */ R((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = bt(vw, n);
  return /* @__PURE__ */ y(te.button, S({
    type: "button"
  }, r, {
    ref: t,
    onClick: G(
      e.onClick,
      () => o.onOpenChange(!1)
    )
  }));
});
function Ji(e) {
  return e ? "open" : "closed";
}
const Hf = ow, Xf = iw, xw = cw, yw = lw, Cw = dw, ww = gw, Iw = hw, Qi = $w, Sw = k(rn, {
  variants: {
    modalClose: {
      true: {}
    }
  },
  compoundVariants: [
    {
      modalClose: "true",
      color: "neutral",
      iconButton: "true",
      css: {
        $$textIdle: "$colors$textPrimary50",
        position: "absolute",
        top: "$base",
        right: "$base"
      }
    }
  ],
  defaultVariants: {
    modalClose: "true"
  }
}), Aw = R(function(t, n) {
  return /* @__PURE__ */ h.jsx(Qi, { asChild: !0, children: /* @__PURE__ */ h.jsx(Sw, { iconButton: !0, variant: "ghost", color: "neutral", ...t, ref: n, children: /* @__PURE__ */ h.jsx(uo, { ...t }) }) });
}), Ew = k(yw, {
  backgroundColor: "rgba(0, 0, 0, .5)",
  position: "fixed",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}), Pw = k(Cw, {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: 240,
  maxHeight: "85vh",
  mt: "-5vh",
  backgroundColor: "$uiSecondary",
  borderRadius: "calc($base * 2)",
  boxShadow: "$3",
  overflow: "hidden",
  "&:focus": {
    outline: "none"
  },
  variants: {
    presence: {
      fullscreen: {
        top: 0,
        right: 0,
        left: 0,
        transform: "none",
        height: "100%",
        maxHeight: "100%",
        maxWidth: "100%",
        borderRadius: 0,
        boxShadow: "none",
        marginTop: 0
      }
    }
  }
}), Zf = R(
  (e, t) => /* @__PURE__ */ h.jsxs(xw, { children: [
    /* @__PURE__ */ h.jsx(Ew, {}),
    /* @__PURE__ */ h.jsx(Pw, { ...e, ref: t }),
    ";"
  ] })
), Tw = k("div", {
  mt: "$40",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexWrap: "wrap",
  gap: "$16",
  variants: {
    layout: {
      row: {
        flexDirection: "row"
      },
      column: {
        flexDirection: "column"
      }
    }
  }
}), Yf = R(function({ children: t, layout: n = { "@initial": "row", "@max768": "column" }, ...r }, o) {
  return /* @__PURE__ */ h.jsx(Tw, { layout: n, ...r, ref: o, children: t });
});
function Uf({ children: e }) {
  return /* @__PURE__ */ h.jsx(Xf, { asChild: !0, children: e });
}
function Rw({
  children: e,
  css: t,
  hideClose: n,
  open: r,
  defaultOpen: o,
  onOpenChange: a,
  forceMount: i,
  onOpenAutoFocus: s,
  onCloseAutoFocus: c,
  onEscapeKeyDown: l,
  onPointerDownOutside: d,
  onInteractOutside: u,
  ...f
}) {
  const { children: p, actions: g, trigger: b } = Ne(() => {
    const m = [], v = [], $ = [];
    return e == null || e.forEach((x) => {
      x.type === Yf ? v.push(x) : x.type === Uf ? $.push(x) : m.push(x);
    }), { children: m, actions: v, trigger: $ };
  }, [e]);
  return /* @__PURE__ */ h.jsxs(Hf, { open: r, defaultOpen: o, onOpenChange: a, children: [
    b,
    /* @__PURE__ */ h.jsxs(
      Zf,
      {
        css: { padding: "$32 $32 $24", zIndex: Fu, ...t },
        forceMount: i,
        onOpenAutoFocus: s,
        onCloseAutoFocus: c,
        onEscapeKeyDown: l,
        onPointerDownOutside: d,
        onInteractOutside: u,
        ...f,
        children: [
          !n && /* @__PURE__ */ h.jsx(Qi, { asChild: !0, children: /* @__PURE__ */ h.jsx(
            rn,
            {
              variant: "ghost",
              iconButton: !0,
              color: "neutral",
              css: { position: "absolute", top: "$8", right: "$8" },
              children: /* @__PURE__ */ h.jsx(uo, {})
            }
          ) }),
          p,
          g
        ]
      }
    )
  ] });
}
function Mw({ children: e }) {
  return /* @__PURE__ */ h.jsx(Xf, { asChild: !0, children: e });
}
let Hc = !1;
const Dw = R((e, t) => (Z(() => {
  Hc || (console.warn("StreamElements/Frontend-UI: Used Modal.Overlay component, but it is't necessary. It is automatically rendered by the Modal.Content component."), Hc = !0);
}, []), /* @__PURE__ */ h.jsx(A.Fragment, { children: e.children }))), Ow = A.Fragment, s8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Actions: Yf,
  Close: Aw,
  ClosePrimitive: Qi,
  Content: Zf,
  ContentComposition: Rw,
  Description: Iw,
  Dismiss: Mw,
  Overlay: Dw,
  Portal: Ow,
  Root: Hf,
  Title: ww,
  Trigger: Uf
}, Symbol.toStringTag, { value: "Module" })), Jf = k(Xa, {
  position: "relative",
  width: "fit-content",
  display: "grid",
  gridAutoFlow: "column",
  placeItems: "start",
  columnGap: "calc($base * 4)",
  py: "calc($base * 4)",
  px: "calc($base * 2)",
  boxShadow: "$2",
  br: "$base"
}), Fw = k("button", {
  $$buttonColor: "$colors$textPrimaryMain",
  $$buttonBackground: "transparent",
  fontFamily: "$base",
  position: "relative",
  border: "none",
  padding: "$base",
  size: "2rem",
  fontSize: "$caption",
  transition: "color .2s $1, background-color .2s $1",
  zIndex: 1,
  cursor: "pointer",
  fontWeight: "$bold",
  br: "50%",
  bgc: "$$buttonBackground",
  color: "$$buttonColor",
  "&[disabled]": {
    color: "$textPrimary30",
    cursor: "unset",
    "&:hover": {
      bgc: "transparent"
    }
  },
  "&:hover": {
    $$buttonBackground: "$colors$uiPrimary16A"
  },
  variants: {
    buttonState: {
      isSelectedStartOrEnd: {
        $$buttonBackground: "$colors$uiPrimaryMain",
        $$buttonColor: "$colors$textAlwaysLightMain",
        "&:hover": {
          $$buttonBackground: "$colors$uiPrimaryMain"
        }
      },
      isSelectedStart: {
        $$buttonBackground: "$colors$uiPrimaryMain",
        $$buttonColor: "$colors$textAlwaysLightMain",
        "&:hover": {
          $$buttonBackground: "$colors$uiPrimaryMain"
        },
        "&::after": {
          content: '""',
          width: "50%",
          height: "100%",
          top: 0,
          zIndex: -1,
          left: "50%",
          position: "absolute",
          bgc: "$uiPrimary16A"
        }
      },
      isSelectedEnd: {
        $$buttonBackground: "$colors$uiPrimaryMain",
        $$buttonColor: "$colors$textAlwaysLightMain",
        "&:hover": {
          $$buttonBackground: "$colors$uiPrimaryMain"
        },
        "&::before": {
          content: '""',
          width: "50%",
          height: "100%",
          top: 0,
          zIndex: -1,
          right: "50%",
          position: "absolute",
          bgc: "$uiPrimary16A"
        }
      },
      isSelected: {
        $$buttonBackground: "$colors$uiPrimary16A",
        br: "unset",
        "&:hover": {
          br: "unset"
        }
      },
      isSelectedLineStart: {
        $$buttonBackground: "$colors$uiPrimary16A",
        br: "unset",
        borderTopLeftRadius: "50%",
        borderBottomLeftRadius: "50%"
      },
      isSelectedStartSingle: {
        $$buttonBackground: "$colors$uiPrimary16A",
        br: "50%"
      },
      isSelectedEndSingle: {
        $$buttonBackground: "$colors$uiPrimary16A",
        br: "50%"
      },
      isSelectedLineEnd: {
        br: "unset",
        $$buttonBackground: "$colors$uiPrimary16A",
        borderTopRightRadius: "50%",
        borderBottomRightRadius: "50%"
      },
      isToday: {
        $$buttonColor: "$colors$uiPrimaryMain"
      },
      isStartDisabled: {
        color: "$textPrimary30",
        cursor: "unset",
        "&:hover": {
          bgc: "transparent"
        }
      }
    }
  }
}), kw = k(Id, {
  bgc: "$uiPrimaryMain",
  maxWidth: 208,
  margin: 0,
  padding: "calc($base * 2)"
}), Nw = k(Sd, {
  fill: "$uiPrimaryMain"
});
function _w({
  content: e,
  children: t
}) {
  return e ? /* @__PURE__ */ h.jsxs(Cd, { children: [
    /* @__PURE__ */ h.jsx(wd, { asChild: !0, children: t }),
    /* @__PURE__ */ h.jsxs(kw, { side: "bottom", align: "end", alignOffset: -10, sideOffset: 4, children: [
      /* @__PURE__ */ h.jsx(pt, { variant: "caption", css: { color: "$textAlwaysLightMain" }, children: e }),
      /* @__PURE__ */ h.jsx(Nw, { offset: 18, width: 15, height: 8 })
    ] })
  ] }) : t;
}
function Qf({
  dayLabel: e,
  date: t,
  startDate: n,
  endDate: r,
  firstCalendarDay: o,
  lastCalendarDay: a,
  isSinglePicker: i,
  startDisabledReason: s = void 0,
  idx: c,
  ...l
}) {
  const d = O(null);
  if (!t || !e)
    return /* @__PURE__ */ h.jsx("div", {});
  const {
    isSelected: u,
    isSelectedStartOrEnd: f,
    disabledDate: p,
    onClick: g,
    onKeyDown: b,
    onMouseEnter: m,
    tabIndex: v
  } = z6({
    date: t,
    ...l,
    dayRef: d
  }), $ = H6(
    u,
    f,
    Ke(t, /* @__PURE__ */ new Date()),
    n,
    r,
    t,
    o,
    a,
    i,
    s,
    c
  );
  return /* @__PURE__ */ h.jsx(_w, { content: s, children: /* @__PURE__ */ h.jsx(
    Fw,
    {
      buttonState: $,
      disabled: p,
      onClick: g,
      onKeyDown: b,
      onMouseEnter: m,
      tabIndex: v,
      type: "button",
      ref: d,
      children: parseInt(e, 10)
    }
  ) });
}
function Ki(e, t, n, r) {
  Object.defineProperty(e, t, { get: n, set: r, enumerable: !0, configurable: !0 });
}
var qi = {};
Ki(qi, "SSRProvider", () => Lw);
Ki(qi, "useSSRSafeId", () => Kf);
Ki(qi, "useIsSSR", () => Vw);
const No = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, ro = /* @__PURE__ */ A.createContext(No);
function Lw(e) {
  let t = ct(ro), n = Ne(
    () => ({
      // If this is the first SSRProvider, start with an empty string prefix, otherwise
      // append and increment the counter.
      prefix: t === No ? "" : `${t.prefix}-${++t.current}`,
      current: 0
    }),
    [
      t
    ]
  );
  return /* @__PURE__ */ A.createElement(ro.Provider, {
    value: n
  }, e.children);
}
let Bw = !!(typeof window < "u" && window.document && window.document.createElement);
function Kf(e) {
  let t = ct(ro);
  return t === No && !Bw && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server."), Ne(
    () => e || `react-aria${t.prefix}-${++t.current}`,
    [
      e
    ]
  );
}
function Vw() {
  let t = ct(ro) !== No, [n, r] = J(t);
  return typeof window < "u" && t && ao(() => {
    r(!1);
  }, []), n;
}
function qf(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = qf(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function Gw() {
  for (var e = 0, t, n, r = ""; e < arguments.length; )
    (t = arguments[e++]) && (n = qf(t)) && (r && (r += " "), r += n);
  return r;
}
function _o(e, t, n, r) {
  Object.defineProperty(e, t, { get: n, set: r, enumerable: !0, configurable: !0 });
}
var Ww = {};
_o(Ww, "useControlledState", () => jw);
function jw(e, t, n) {
  let [r, o] = J(e || t), a = O(e !== void 0), i = a.current, s = e !== void 0, c = O(r);
  i !== s && console.warn(`WARN: A component changed from ${i ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}.`), a.current = s;
  let l = K((d, ...u) => {
    let f = (p, ...g) => {
      n && (Object.is(c.current, p) || n(p, ...g)), s || (c.current = p);
    };
    typeof d == "function" ? (console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320"), o((g, ...b) => {
      let m = d(s ? c.current : g, ...b);
      return f(m, ...u), s ? g : m;
    })) : (s || o(d), f(d, ...u));
  }, [
    s,
    n
  ]);
  return s ? c.current = e : e = r, [
    e,
    l
  ];
}
var es = {};
_o(es, "clamp", () => e1);
_o(es, "snapValueToStep", () => t1);
_o(es, "toFixedNumber", () => zw);
function e1(e, t = -1 / 0, n = 1 / 0) {
  return Math.min(Math.max(e, t), n);
}
function t1(e, t, n, r) {
  let o = (e - (isNaN(t) ? 0 : t)) % r, a = Math.abs(o) * 2 >= r ? e + Math.sign(o) * (r - Math.abs(o)) : e - o;
  isNaN(t) ? !isNaN(n) && a > n && (a = Math.floor(n / r) * r) : a < t ? a = t : !isNaN(n) && a > n && (a = t + Math.floor((n - t) / r) * r);
  let i = r.toString(), s = i.indexOf("."), c = s >= 0 ? i.length - s : 0;
  if (c > 0) {
    let l = Math.pow(10, c);
    a = Math.round(a * l) / l;
  }
  return a;
}
function zw(e, t, n = 10) {
  const r = Math.pow(n, t);
  return Math.round(e * r) / r;
}
function be(e, t, n, r) {
  Object.defineProperty(e, t, { get: n, set: r, enumerable: !0, configurable: !0 });
}
var ts = {};
be(ts, "useId", () => pr);
be(ts, "mergeIds", () => n1);
be(ts, "useSlotId", () => Xw);
var Hw = {};
be(Hw, "useLayoutEffect", () => _t);
const _t = typeof window < "u" ? A.useLayoutEffect : () => {
};
let oo = /* @__PURE__ */ new Map();
function pr(e) {
  let t = O(!0);
  t.current = !0;
  let [n, r] = J(e), o = O(null), a = Kf(n), i = (s) => {
    t.current ? o.current = s : r(s);
  };
  return oo.set(a, i), _t(() => {
    t.current = !1;
  }, [
    i
  ]), _t(() => {
    let s = a;
    return () => {
      oo.delete(s);
    };
  }, [
    a
  ]), Z(() => {
    let s = o.current;
    s && (r(s), o.current = null);
  }, [
    r,
    i
  ]), a;
}
function n1(e, t) {
  if (e === t)
    return e;
  let n = oo.get(e);
  if (n)
    return n(t), t;
  let r = oo.get(t);
  return r ? (r(e), e) : t;
}
function Xw(e = []) {
  let t = pr(), [n, r] = u1(t), o = K(() => {
    r(function* () {
      yield t, yield document.getElementById(t) ? t : null;
    });
  }, [
    t,
    r
  ]);
  return _t(o, [
    t,
    o,
    ...e
  ]), n;
}
var Zw = {};
be(Zw, "chain", () => r1);
function r1(...e) {
  return (...t) => {
    for (let n of e)
      typeof n == "function" && n(...t);
  };
}
var Yw = {};
be(Yw, "mergeProps", () => Uw);
function Uw(...e) {
  let t = {
    ...e[0]
  };
  for (let n = 1; n < e.length; n++) {
    let r = e[n];
    for (let o in r) {
      let a = t[o], i = r[o];
      typeof a == "function" && typeof i == "function" && // This is a lot faster than a regex.
      o[0] === "o" && o[1] === "n" && o.charCodeAt(2) >= /* 'A' */
      65 && o.charCodeAt(2) <= /* 'Z' */
      90 ? t[o] = r1(a, i) : (o === "className" || o === "UNSAFE_className") && typeof a == "string" && typeof i == "string" ? t[o] = Gw(a, i) : o === "id" && a && i ? t.id = n1(a, i) : t[o] = i !== void 0 ? i : a;
    }
  }
  return t;
}
var Jw = {};
be(Jw, "filterDOMProps", () => e7);
const Qw = /* @__PURE__ */ new Set([
  "id"
]), Kw = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), qw = /^(data-.*)$/;
function e7(e, t = {}) {
  let { labelable: n, propNames: r } = t, o = {};
  for (const a in e)
    Object.prototype.hasOwnProperty.call(e, a) && (Qw.has(a) || n && Kw.has(a) || r != null && r.has(a) || qw.test(a)) && (o[a] = e[a]);
  return o;
}
var t7 = {};
be(t7, "focusWithoutScrolling", () => n7);
function n7(e) {
  if (r7())
    e.focus({
      preventScroll: !0
    });
  else {
    let t = o7(e);
    e.focus(), a7(t);
  }
}
let Pr = null;
function r7() {
  if (Pr == null) {
    Pr = !1;
    try {
      var e = document.createElement("div");
      e.focus({
        get preventScroll() {
          return Pr = !0, !0;
        }
      });
    } catch {
    }
  }
  return Pr;
}
function o7(e) {
  for (var t = e.parentNode, n = [], r = document.scrollingElement || document.documentElement; t instanceof HTMLElement && t !== r; )
    (t.offsetHeight < t.scrollHeight || t.offsetWidth < t.scrollWidth) && n.push({
      element: t,
      scrollTop: t.scrollTop,
      scrollLeft: t.scrollLeft
    }), t = t.parentNode;
  return r instanceof HTMLElement && n.push({
    element: r,
    scrollTop: r.scrollTop,
    scrollLeft: r.scrollLeft
  }), n;
}
function a7(e) {
  for (let { element: t, scrollTop: n, scrollLeft: r } of e)
    t.scrollTop = n, t.scrollLeft = r;
}
var i7 = {};
be(i7, "getOffset", () => o1);
function o1(e, t, n = "horizontal") {
  let r = e.getBoundingClientRect();
  return t ? n === "horizontal" ? r.right : r.bottom : n === "horizontal" ? r.left : r.top;
}
var a1 = {};
be(a1, "clamp", () => e1);
be(a1, "snapValueToStep", () => t1);
var s7 = {};
be(s7, "runAfterTransition", () => c7);
let hn = /* @__PURE__ */ new Map(), Ya = /* @__PURE__ */ new Set();
function Xc() {
  if (typeof window > "u")
    return;
  let e = (n) => {
    let r = hn.get(n.target);
    r || (r = /* @__PURE__ */ new Set(), hn.set(n.target, r), n.target.addEventListener("transitioncancel", t)), r.add(n.propertyName);
  }, t = (n) => {
    let r = hn.get(n.target);
    if (r && (r.delete(n.propertyName), r.size === 0 && (n.target.removeEventListener("transitioncancel", t), hn.delete(n.target)), hn.size === 0)) {
      for (let o of Ya)
        o();
      Ya.clear();
    }
  };
  document.body.addEventListener("transitionrun", e), document.body.addEventListener("transitionend", t);
}
typeof document < "u" && (document.readyState !== "loading" ? Xc() : document.addEventListener("DOMContentLoaded", Xc));
function c7(e) {
  requestAnimationFrame(() => {
    hn.size === 0 ? e() : Ya.add(e);
  });
}
var l7 = {};
be(l7, "useDrag1D", () => u7);
const Tr = [];
function u7(e) {
  console.warn("useDrag1D is deprecated, please use `useMove` instead https://react-spectrum.adobe.com/react-aria/useMove.html");
  let { containerRef: t, reverse: n, orientation: r, onHover: o, onDrag: a, onPositionChange: i, onIncrement: s, onDecrement: c, onIncrementToMax: l, onDecrementToMin: d, onCollapseToggle: u } = e, f = (E) => r === "horizontal" ? E.clientX : E.clientY, p = (E) => {
    let T = o1(t.current, n, r), F = f(E);
    return n ? T - F : F - T;
  }, g = O(!1), b = O(0), m = O({
    onPositionChange: i,
    onDrag: a
  });
  m.current.onDrag = a, m.current.onPositionChange = i;
  let v = (E) => {
    E.preventDefault();
    let T = p(E);
    g.current || (g.current = !0, m.current.onDrag && m.current.onDrag(!0), m.current.onPositionChange && m.current.onPositionChange(T)), b.current !== T && (b.current = T, i && i(T));
  }, $ = (E) => {
    const T = E.target;
    g.current = !1;
    let F = p(E);
    m.current.onDrag && m.current.onDrag(!1), m.current.onPositionChange && m.current.onPositionChange(F), Tr.splice(Tr.indexOf(T), 1), window.removeEventListener("mouseup", $, !1), window.removeEventListener("mousemove", v, !1);
  };
  return {
    onMouseDown: (E) => {
      const T = E.currentTarget;
      Tr.some(
        (F) => T.contains(F)
      ) || (Tr.push(T), window.addEventListener("mousemove", v, !1), window.addEventListener("mouseup", $, !1));
    },
    onMouseEnter: () => {
      o && o(!0);
    },
    onMouseOut: () => {
      o && o(!1);
    },
    onKeyDown: (E) => {
      switch (E.key) {
        case "Left":
        case "ArrowLeft":
          r === "horizontal" && (E.preventDefault(), c && !n ? c() : s && n && s());
          break;
        case "Up":
        case "ArrowUp":
          r === "vertical" && (E.preventDefault(), c && !n ? c() : s && n && s());
          break;
        case "Right":
        case "ArrowRight":
          r === "horizontal" && (E.preventDefault(), s && !n ? s() : c && n && c());
          break;
        case "Down":
        case "ArrowDown":
          r === "vertical" && (E.preventDefault(), s && !n ? s() : c && n && c());
          break;
        case "Home":
          E.preventDefault(), d && d();
          break;
        case "End":
          E.preventDefault(), l && l();
          break;
        case "Enter":
          E.preventDefault(), u && u();
          break;
      }
    }
  };
}
var d7 = {};
be(d7, "useGlobalListeners", () => f7);
function f7() {
  let e = O(/* @__PURE__ */ new Map()), t = K((o, a, i, s) => {
    let c = s != null && s.once ? (...l) => {
      e.current.delete(i), i(...l);
    } : i;
    e.current.set(i, {
      type: a,
      eventTarget: o,
      fn: c,
      options: s
    }), o.addEventListener(a, i, s);
  }, []), n = K((o, a, i, s) => {
    var c;
    let l = ((c = e.current.get(i)) === null || c === void 0 ? void 0 : c.fn) || i;
    o.removeEventListener(a, l, s), e.current.delete(i);
  }, []), r = K(() => {
    e.current.forEach((o, a) => {
      n(o.eventTarget, o.type, a, o.options);
    });
  }, [
    n
  ]);
  return Z(() => r, [
    r
  ]), {
    addGlobalListener: t,
    removeGlobalListener: n,
    removeAllGlobalListeners: r
  };
}
var p7 = {};
be(p7, "useLabels", () => b7);
function b7(e, t) {
  let { id: n, "aria-label": r, "aria-labelledby": o } = e;
  return n = pr(n), o && r ? o = [
    .../* @__PURE__ */ new Set([
      ...o.trim().split(/\s+/),
      n
    ])
  ].join(" ") : o && (o = o.trim().split(/\s+/).join(" ")), !r && !o && t && (r = t), {
    id: n,
    "aria-label": r,
    "aria-labelledby": o
  };
}
var g7 = {};
be(g7, "useObjectRef", () => m7);
function m7(e) {
  const t = O();
  return _t(() => {
    e && (typeof e == "function" ? e(t.current) : e.current = t.current);
  }, [
    e
  ]), t;
}
var h7 = {};
be(h7, "useUpdateEffect", () => v7);
function v7(e, t) {
  const n = O(!0);
  Z(() => {
    n.current ? n.current = !1 : e();
  }, t);
}
var $7 = {};
be($7, "useResizeObserver", () => y7);
function x7() {
  return typeof window.ResizeObserver < "u";
}
function y7(e) {
  const { ref: t, onResize: n } = e;
  Z(() => {
    let r = t == null ? void 0 : t.current;
    if (r)
      if (x7()) {
        const o = new window.ResizeObserver((a) => {
          a.length && n();
        });
        return o.observe(r), () => {
          r && o.unobserve(r);
        };
      } else
        return window.addEventListener("resize", n, !1), () => {
          window.removeEventListener("resize", n, !1);
        };
  }, [
    n,
    t
  ]);
}
var C7 = {};
be(C7, "useSyncRef", () => w7);
function w7(e, t) {
  _t(() => {
    if (e && e.ref && t)
      return e.ref.current = t.current, () => {
        e.ref.current = null;
      };
  }, [
    e,
    t
  ]);
}
var I7 = {};
be(I7, "getScrollParent", () => S7);
function S7(e) {
  for (; e && !A7(e); )
    e = e.parentElement;
  return e || document.scrollingElement || document.documentElement;
}
function A7(e) {
  let t = window.getComputedStyle(e);
  return /(auto|scroll)/.test(t.overflow + t.overflowX + t.overflowY);
}
var E7 = {};
be(E7, "useViewportSize", () => P7);
let ht = typeof window < "u" && window.visualViewport;
function P7() {
  let [e, t] = J(
    () => Zc()
  );
  return Z(() => {
    let n = () => {
      t((r) => {
        let o = Zc();
        return o.width === r.width && o.height === r.height ? r : o;
      });
    };
    return ht ? ht.addEventListener("resize", n) : window.addEventListener("resize", n), () => {
      ht ? ht.removeEventListener("resize", n) : window.removeEventListener("resize", n);
    };
  }, []), e;
}
function Zc() {
  return {
    width: (ht == null ? void 0 : ht.width) || window.innerWidth,
    height: (ht == null ? void 0 : ht.height) || window.innerHeight
  };
}
var T7 = {};
be(T7, "useDescription", () => M7);
let R7 = 0;
const pa = /* @__PURE__ */ new Map();
function M7(e) {
  let [t, n] = J(null);
  return _t(() => {
    if (!e)
      return;
    let r = pa.get(e);
    if (r)
      n(r.element.id);
    else {
      let o = `react-aria-description-${R7++}`;
      n(o);
      let a = document.createElement("div");
      a.id = o, a.style.display = "none", a.textContent = e, document.body.appendChild(a), r = {
        refCount: 0,
        element: a
      }, pa.set(e, r);
    }
    return r.refCount++, () => {
      --r.refCount === 0 && (r.element.remove(), pa.delete(e));
    };
  }, [
    e
  ]), {
    "aria-describedby": e ? t : void 0
  };
}
var zt = {};
be(zt, "isMac", () => os);
be(zt, "isIPhone", () => i1);
be(zt, "isIPad", () => s1);
be(zt, "isIOS", () => c1);
be(zt, "isAppleDevice", () => D7);
be(zt, "isWebKit", () => O7);
be(zt, "isChrome", () => l1);
be(zt, "isAndroid", () => F7);
function ns(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some(
    (n) => e.test(n.brand)
  )) || e.test(window.navigator.userAgent);
}
function rs(e) {
  return typeof window < "u" && window.navigator != null ? e.test((window.navigator.userAgentData || window.navigator).platform) : !1;
}
function os() {
  return rs(/^Mac/i);
}
function i1() {
  return rs(/^iPhone/i);
}
function s1() {
  return rs(/^iPad/i) || os() && navigator.maxTouchPoints > 1;
}
function c1() {
  return i1() || s1();
}
function D7() {
  return os() || c1();
}
function O7() {
  return ns(/AppleWebKit/i) && !l1();
}
function l1() {
  return ns(/Chrome/i);
}
function F7() {
  return ns(/Android/i);
}
var k7 = {};
be(k7, "useEvent", () => N7);
function N7(e, t, n, r) {
  let o = O(n);
  o.current = n;
  let a = n == null;
  Z(() => {
    if (a)
      return;
    let i = e.current, s = (c) => o.current.call(this, c);
    return i.addEventListener(t, s, r), () => {
      i.removeEventListener(t, s, r);
    };
  }, [
    e,
    t,
    r,
    a
  ]);
}
var _7 = {};
be(_7, "useValueEffect", () => u1);
function u1(e) {
  let [t, n] = J(e), r = O(t), o = O(null);
  r.current = t;
  let a = O(null);
  a.current = () => {
    let s = o.current.next();
    if (s.done) {
      o.current = null;
      return;
    }
    t === s.value ? a.current() : n(s.value);
  }, _t(() => {
    o.current && a.current();
  });
  let i = K((s) => {
    o.current = s(r.current), a.current();
  }, [
    o,
    a
  ]);
  return [
    t,
    i
  ];
}
var L7 = {};
be(L7, "scrollIntoView", () => B7);
function B7(e, t) {
  let n = Yc(e, t, "left"), r = Yc(e, t, "top"), o = t.offsetWidth, a = t.offsetHeight, i = e.scrollLeft, s = e.scrollTop, c = i + e.offsetWidth, l = s + e.offsetHeight;
  n <= i ? i = n : n + o > c && (i += n + o - c), r <= s ? s = r : r + a > l && (s += r + a - l), e.scrollLeft = i, e.scrollTop = s;
}
function Yc(e, t, n) {
  const r = n === "left" ? "offsetLeft" : "offsetTop";
  let o = 0;
  for (; t.offsetParent && (o += t[r], t.offsetParent !== e); ) {
    if (t.offsetParent.contains(e)) {
      o -= e[r];
      break;
    }
    t = t.offsetParent;
  }
  return o;
}
function d1({ goToPreviousMonths: e, goToNextMonths: t }) {
  return /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    /* @__PURE__ */ h.jsx(
      Uc,
      {
        type: "button",
        iconButton: !0,
        variant: "ghost",
        side: "left",
        "aria-label": "Previous month",
        onClick: e,
        children: /* @__PURE__ */ h.jsx(Il, {})
      }
    ),
    /* @__PURE__ */ h.jsx(
      Uc,
      {
        type: "button",
        iconButton: !0,
        variant: "ghost",
        side: "right",
        onClick: t,
        "aria-label": "Next month",
        children: /* @__PURE__ */ h.jsx(Al, {})
      }
    )
  ] });
}
const Uc = k(rn, {
  "&&": {
    position: "absolute",
    top: "calc($base * 4)",
    color: "$textPrimary50",
    transition: "box-shadow .2s $1, color .2s $1"
  },
  "&:hover": {
    color: "$textPrimary70"
  },
  variants: {
    side: {
      left: {
        left: "calc($base * 2.5)"
      },
      right: {
        right: "calc($base * 2.5)"
      }
    }
  }
});
function f1({
  monthLabel: e,
  weekdayLabels: t,
  children: n,
  onToggleOpenYearPicker: r,
  isYearPickerOpen: o
}) {
  return /* @__PURE__ */ h.jsxs(V7, { children: [
    /* @__PURE__ */ h.jsxs(
      xo,
      {
        weight: "bold",
        css: {
          color: "$textPrimaryMain",
          margin: 0,
          mb: "calc($base * 2)",
          textAlign: "center"
        },
        onClick: r,
        children: [
          e,
          r && /* @__PURE__ */ h.jsx(
            rn,
            {
              iconButton: !0,
              variant: "ghost",
              color: "neutral",
              "aria-label": "Toggle year picker",
              css: {
                ml: "0.25em",
                verticalAlign: "middle",
                $$textIdle: "$colors$textPrimary50",
                svg: { fontSize: "1.25rem" }
              },
              children: o ? /* @__PURE__ */ h.jsx(Sl, {}) : /* @__PURE__ */ h.jsx(oi, {})
            }
          )
        ]
      }
    ),
    !o && /* @__PURE__ */ h.jsx(G7, { tabIndex: o ? -1 : void 0, children: t.map((a) => /* @__PURE__ */ h.jsx(pt, { variant: "caption", css: { color: "$textPrimary50" }, children: a.charAt(0) }, a)) }),
    n
  ] });
}
const V7 = k("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  maxWidth: 272,
  width: "100%"
}), G7 = k("div", {
  display: "grid",
  width: "100%",
  gridTemplateColumns: "repeat(7, 1fr)",
  placeItems: "center",
  marginBottom: "calc($base * 2)",
  gap: "$base"
}), p1 = k("div", {
  display: "grid",
  gridTemplateColumns: "repeat(7, 1fr)",
  placeItems: "center",
  rowGap: "$base",
  width: "100%"
});
function W7({
  minYear: e = 2e3,
  maxYear: t = (/* @__PURE__ */ new Date()).getFullYear(),
  currentYear: n = (/* @__PURE__ */ new Date()).getFullYear(),
  onYearSelected: r
}) {
  const o = Array.from({ length: t - e + 1 }, (a, i) => e + i).reverse();
  return /* @__PURE__ */ h.jsx(
    La,
    {
      type: "always",
      css: { height: "100%", width: "100%", gridColumn: "1/-1", minWidth: 224 },
      viewportCss: { maxHeight: 232 },
      children: /* @__PURE__ */ h.jsx(
        nn,
        {
          css: {
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(3.5rem, 1fr))",
            gap: "0.25rem",
            padding: "0.25rem"
          },
          children: o.map((a) => /* @__PURE__ */ h.jsx(
            rn,
            {
              density: "compact",
              color: n === a ? "primary" : "neutral",
              variant: n === a ? "outlined" : "ghost",
              onClick: r == null ? void 0 : r.bind(null, a),
              children: a
            },
            a
          ))
        }
      )
    }
  );
}
const Jc = {
  startDate: null,
  endDate: null,
  focusedInput: ko
};
function j7({
  value: e,
  defaultValue: t,
  onValueChange: n,
  minDate: r,
  maxDate: o,
  unavailableDates: a,
  unavailableStartDates: i,
  inputProps: s = {},
  innerRef: c,
  name: l,
  id: d
}) {
  var H, D;
  const u = pr(d), [f = Jc, p] = Te({
    prop: e ? { startDate: e, endDate: null, focusedInput: "startDate" } : void 0,
    defaultProp: t ? { startDate: t, endDate: null, focusedInput: "startDate" } : void 0,
    onChange(M) {
      n && n(M == null ? void 0 : M.startDate);
    }
  }), [g, b] = A.useState(!1), {
    firstDayOfWeek: m,
    activeMonths: v,
    isDateBlocked: $,
    goToPreviousMonths: x,
    goToNextMonths: w,
    goToDate: C,
    ...P
  } = Lf({
    startDate: f.startDate,
    endDate: f.endDate,
    focusedInput: f.focusedInput,
    firstDayOfWeek: 0,
    numberOfMonths: 1,
    exactMinBookingDays: !0,
    changeActiveMonthOnSelect: !1,
    unavailableDates: a,
    minBookingDate: r,
    maxBookingDate: o,
    onDatesChange: (M) => {
      i != null && i.find((j) => Ke(j.date, M == null ? void 0 : M.startDate)) || (M.focusedInput ? p(M) : p({ ...M, focusedInput: ko }));
    }
  }), { days: E, monthLabel: T, weekdayLabels: F, firstCalendarDay: V, lastCalendarDay: _ } = v.map(
    (M) => Bf(M, m)
  )[0], W = `DatePicker-${u}`;
  return /* @__PURE__ */ h.jsxs(Jf, { id: W, ref: c, children: [
    /* @__PURE__ */ h.jsx(
      "input",
      {
        type: "hidden",
        value: ((H = f == null ? void 0 : f.startDate) == null ? void 0 : H.toISOString()) || "",
        name: `${l || W}.startDate`,
        onChange: (M) => {
          p({ ...f || Jc, startDate: new Date(M.target.value) });
        },
        ...s || {}
      }
    ),
    !g && /* @__PURE__ */ h.jsx(d1, { goToNextMonths: w, goToPreviousMonths: x }),
    /* @__PURE__ */ h.jsxs(
      f1,
      {
        monthLabel: T,
        weekdayLabels: F,
        onToggleOpenYearPicker: () => b((M) => !M),
        isYearPickerOpen: g,
        children: [
          /* @__PURE__ */ h.jsx(p1, { children: !g && E.map((M, j) => {
            var U;
            return /* @__PURE__ */ h.jsx(
              Qf,
              {
                startDate: f.startDate,
                endDate: f.endDate,
                isSinglePicker: !0,
                firstCalendarDay: V,
                startDisabledReason: (U = i == null ? void 0 : i.find((ee) => typeof M == "object" ? Ke(ee.date, M.date) : null)) == null ? void 0 : U.reason,
                lastCalendarDay: _,
                ...typeof M == "object" ? M : {},
                ...P,
                isDateBlocked: $,
                idx: j
              },
              typeof M == "object" ? M.date.toString() : j
            );
          }) }),
          g && /* @__PURE__ */ h.jsx(
            W7,
            {
              minYear: r == null ? void 0 : r.getFullYear(),
              maxYear: o == null ? void 0 : o.getFullYear(),
              currentYear: (D = f.startDate) == null ? void 0 : D.getFullYear(),
              onYearSelected: (M) => {
                var U, ee;
                const j = new Date(
                  M,
                  ((U = f.startDate) == null ? void 0 : U.getMonth()) ?? 0,
                  ((ee = f.startDate) == null ? void 0 : ee.getDate()) ?? 1
                );
                console.log(j), C(j), p({ ...f, startDate: j, endDate: null }), b(!1);
              }
            }
          )
        ]
      }
    )
  ] });
}
const ba = {
  startDate: null,
  endDate: null,
  focusedInput: ko
}, Qc = {
  start: "startDate",
  end: "endDate",
  both: "startDate"
};
function z7({
  value: e,
  defaultValue: t,
  onValueChange: n,
  minDate: r,
  maxDate: o,
  editable: a = "both",
  unavailableDates: i,
  unavailableStartDates: s,
  inputProps: c = [],
  innerRef: l,
  name: d,
  id: u
}) {
  var F, V;
  const f = pr(u), [p, g] = A.useState(
    Qc[a]
  ), [b = ba, m] = Te({
    prop: e ? { startDate: e[0], endDate: e[1], focusedInput: p } : void 0,
    defaultProp: t ? { startDate: t[0], endDate: t[1], focusedInput: p } : void 0,
    onChange(_) {
      g(
        a === "both" ? _.focusedInput : Qc[a]
      ), n && n([_ == null ? void 0 : _.startDate, _ == null ? void 0 : _.endDate]);
    }
  }), {
    firstDayOfWeek: v,
    activeMonths: $,
    isDateBlocked: x,
    goToPreviousMonths: w,
    goToNextMonths: C,
    ...P
  } = Lf({
    startDate: b.startDate,
    endDate: b.endDate,
    focusedInput: b.focusedInput,
    firstDayOfWeek: 0,
    numberOfMonths: 2,
    changeActiveMonthOnSelect: !1,
    unavailableDates: i,
    minBookingDate: r,
    maxBookingDate: o,
    onDatesChange: (_) => {
      s != null && s.find((W) => Ke(W.date, _ == null ? void 0 : _.startDate)) || (g(_.focusedInput), _.focusedInput ? m({ ..._, focusedInput: _.focusedInput }) : m({ ..._, focusedInput: ko }));
    }
  }), E = $.map((_) => Bf(_, v)), T = `DatePicker-${f}`;
  return /* @__PURE__ */ h.jsxs(Jf, { id: T, ref: l, children: [
    /* @__PURE__ */ h.jsx(
      "input",
      {
        type: "hidden",
        value: ((F = b == null ? void 0 : b.startDate) == null ? void 0 : F.toISOString()) || "",
        name: `${d || T}.startDate`,
        onChange: (_) => {
          m({ ...b || ba, startDate: new Date(_.target.value) });
        },
        ...c[0] || {}
      }
    ),
    /* @__PURE__ */ h.jsx(
      "input",
      {
        type: "hidden",
        value: ((V = b == null ? void 0 : b.endDate) == null ? void 0 : V.toISOString()) || "",
        name: `${d || T}.endDate`,
        onChange: (_) => {
          m({ ...b || ba, endDate: new Date(_.target.value) });
        },
        ...c[1] || {}
      }
    ),
    /* @__PURE__ */ h.jsx(d1, { goToNextMonths: C, goToPreviousMonths: w }),
    E.map(
      ({ days: _, monthLabel: W, weekdayLabels: H, firstCalendarDay: D, lastCalendarDay: M }) => /* @__PURE__ */ h.jsx(
        f1,
        {
          monthLabel: W,
          weekdayLabels: H,
          children: /* @__PURE__ */ h.jsx(p1, { children: _.map((j, U) => {
            var ee;
            return /* @__PURE__ */ h.jsx(
              Qf,
              {
                startDate: b.startDate,
                endDate: b.endDate,
                isSinglePicker: !1,
                firstCalendarDay: D,
                startDisabledReason: (ee = s == null ? void 0 : s.find((z) => typeof j == "object" ? Ke(z.date, j.date) : null)) == null ? void 0 : ee.reason,
                lastCalendarDay: M,
                ...typeof j == "object" ? j : {},
                ...P,
                isDateBlocked: x,
                idx: U
              },
              typeof j == "object" ? j.date.toString() : U
            );
          }) })
        },
        W
      )
    )
  ] });
}
const c8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Range: z7,
  Single: j7
}, Symbol.toStringTag, { value: "Module" })), b1 = "Tabs", [H7, l8] = _e(b1, [
  Gt
]), g1 = Gt(), [X7, as] = H7(b1), Z7 = /* @__PURE__ */ R((e, t) => {
  const { __scopeTabs: n, value: r, onValueChange: o, defaultValue: a, orientation: i = "horizontal", dir: s, activationMode: c = "automatic", ...l } = e, d = Bt(s), [u, f] = Te({
    prop: r,
    onChange: o,
    defaultProp: a
  });
  return /* @__PURE__ */ y(X7, {
    scope: n,
    baseId: nt(),
    value: u,
    onValueChange: f,
    orientation: i,
    dir: d,
    activationMode: c
  }, /* @__PURE__ */ y(te.div, S({
    dir: d,
    "data-orientation": i
  }, l, {
    ref: t
  })));
}), Y7 = "TabsList", U7 = /* @__PURE__ */ R((e, t) => {
  const { __scopeTabs: n, loop: r = !0, ...o } = e, a = as(Y7, n), i = g1(n);
  return /* @__PURE__ */ y(Eo, S({
    asChild: !0
  }, i, {
    orientation: a.orientation,
    dir: a.dir,
    loop: r
  }), /* @__PURE__ */ y(te.div, S({
    role: "tablist",
    "aria-orientation": a.orientation
  }, o, {
    ref: t
  })));
}), J7 = "TabsTrigger", Q7 = /* @__PURE__ */ R((e, t) => {
  const { __scopeTabs: n, value: r, disabled: o = !1, ...a } = e, i = as(J7, n), s = g1(n), c = m1(i.baseId, r), l = h1(i.baseId, r), d = r === i.value;
  return /* @__PURE__ */ y(Po, S({
    asChild: !0
  }, s, {
    focusable: !o,
    active: d
  }), /* @__PURE__ */ y(te.button, S({
    type: "button",
    role: "tab",
    "aria-selected": d,
    "aria-controls": l,
    "data-state": d ? "active" : "inactive",
    "data-disabled": o ? "" : void 0,
    disabled: o,
    id: c
  }, a, {
    ref: t,
    onMouseDown: G(e.onMouseDown, (u) => {
      !o && u.button === 0 && u.ctrlKey === !1 ? i.onValueChange(r) : u.preventDefault();
    }),
    onKeyDown: G(e.onKeyDown, (u) => {
      [
        " ",
        "Enter"
      ].includes(u.key) && i.onValueChange(r);
    }),
    onFocus: G(e.onFocus, () => {
      const u = i.activationMode !== "manual";
      !d && !o && u && i.onValueChange(r);
    })
  })));
}), K7 = "TabsContent", q7 = /* @__PURE__ */ R((e, t) => {
  const { __scopeTabs: n, value: r, forceMount: o, children: a, ...i } = e, s = as(K7, n), c = m1(s.baseId, r), l = h1(s.baseId, r), d = r === s.value, u = O(d);
  return Z(() => {
    const f = requestAnimationFrame(
      () => u.current = !1
    );
    return () => cancelAnimationFrame(f);
  }, []), /* @__PURE__ */ y(
    Oe,
    {
      present: o || d
    },
    ({ present: f }) => /* @__PURE__ */ y(te.div, S({
      "data-state": d ? "active" : "inactive",
      "data-orientation": s.orientation,
      role: "tabpanel",
      "aria-labelledby": c,
      hidden: !f,
      id: l,
      tabIndex: 0
    }, i, {
      ref: t,
      style: {
        ...e.style,
        animationDuration: u.current ? "0s" : void 0
      }
    }), f && a)
  );
});
function m1(e, t) {
  return `${e}-trigger-${t}`;
}
function h1(e, t) {
  return `${e}-content-${t}`;
}
const eI = Z7, tI = U7, nI = Q7, rI = q7, oI = k(tI, {
  display: "grid",
  gridAutoFlow: "column",
  gridAutoColumns: "max-content",
  gap: "$32",
  overflowX: "scroll",
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    // Chrome
    width: 0,
    height: 0
  }
}), Kc = "4px", aI = k(nI, {
  $$tabLineColor: "unset",
  fontFamily: "$base",
  cursor: "pointer",
  pt: "$base",
  px: "$16",
  pb: `calc($base + ${Kc})`,
  textAlign: "center",
  fontSize: "$bodyText",
  fontWeight: "$bold",
  border: "none",
  background: "none",
  color: "$textPrimary50",
  position: "relative",
  outline: "none",
  flex: "1 1 auto",
  minWidth: 0,
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
  "&::after": {
    content: "",
    display: "block",
    height: Kc,
    position: "absolute",
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "$xs",
    backgroundColor: "$$tabLineColor"
  },
  "&:hover, &:focus": {
    $$tabLineColor: "$colors$uiPrimary16A"
  },
  '&[data-state="active"]': {
    color: "$uiPrimaryMain",
    $$tabLineColor: "$colors$uiPrimaryMain"
  },
  "&[data-disabled]": {
    color: "$uiDisabled50",
    $$tabLineColor: "unset",
    '&[data-state="active"]': {
      $$tabLineColor: "$colors$uiDisabled50"
    }
  }
}), u8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Content: rI,
  List: oI,
  Root: eI,
  Trigger: aI
}, Symbol.toStringTag, { value: "Module" })), Lo = "ToggleGroup", [v1, d8] = _e(Lo, [
  Gt
]), $1 = Gt(), iI = /* @__PURE__ */ A.forwardRef((e, t) => {
  const { type: n, ...r } = e;
  if (n === "single") {
    const o = r;
    return /* @__PURE__ */ A.createElement(sI, S({}, o, {
      ref: t
    }));
  }
  if (n === "multiple") {
    const o = r;
    return /* @__PURE__ */ A.createElement(cI, S({}, o, {
      ref: t
    }));
  }
  throw new Error(`Missing prop \`type\` expected on \`${Lo}\``);
}), [x1, y1] = v1(Lo), sI = /* @__PURE__ */ A.forwardRef((e, t) => {
  const { value: n, defaultValue: r, onValueChange: o = () => {
  }, ...a } = e, [i, s] = Te({
    prop: n,
    defaultProp: r,
    onChange: o
  });
  return /* @__PURE__ */ A.createElement(x1, {
    scope: e.__scopeToggleGroup,
    type: "single",
    value: i ? [
      i
    ] : [],
    onItemActivate: s,
    onItemDeactivate: A.useCallback(
      () => s(""),
      [
        s
      ]
    )
  }, /* @__PURE__ */ A.createElement(C1, S({}, a, {
    ref: t
  })));
}), cI = /* @__PURE__ */ A.forwardRef((e, t) => {
  const { value: n, defaultValue: r, onValueChange: o = () => {
  }, ...a } = e, [i = [], s] = Te({
    prop: n,
    defaultProp: r,
    onChange: o
  }), c = A.useCallback(
    (d) => s(
      (u = []) => [
        ...u,
        d
      ]
    ),
    [
      s
    ]
  ), l = A.useCallback(
    (d) => s(
      (u = []) => u.filter(
        (f) => f !== d
      )
    ),
    [
      s
    ]
  );
  return /* @__PURE__ */ A.createElement(x1, {
    scope: e.__scopeToggleGroup,
    type: "multiple",
    value: i,
    onItemActivate: c,
    onItemDeactivate: l
  }, /* @__PURE__ */ A.createElement(C1, S({}, a, {
    ref: t
  })));
}), [lI, uI] = v1(Lo), C1 = /* @__PURE__ */ A.forwardRef((e, t) => {
  const { __scopeToggleGroup: n, disabled: r = !1, rovingFocus: o = !0, orientation: a, dir: i, loop: s = !0, ...c } = e, l = $1(n), d = Bt(i), u = {
    role: "group",
    dir: d,
    ...c
  };
  return /* @__PURE__ */ A.createElement(lI, {
    scope: n,
    rovingFocus: o,
    disabled: r
  }, o ? /* @__PURE__ */ A.createElement(Eo, S({
    asChild: !0
  }, l, {
    orientation: a,
    dir: d,
    loop: s
  }), /* @__PURE__ */ A.createElement(te.div, S({}, u, {
    ref: t
  }))) : /* @__PURE__ */ A.createElement(te.div, S({}, u, {
    ref: t
  })));
}), Ua = "ToggleGroupItem", dI = /* @__PURE__ */ A.forwardRef((e, t) => {
  const n = y1(Ua, e.__scopeToggleGroup), r = uI(Ua, e.__scopeToggleGroup), o = $1(e.__scopeToggleGroup), a = n.value.includes(e.value), i = r.disabled || e.disabled, s = {
    ...e,
    pressed: a,
    disabled: i
  }, c = A.useRef(null);
  return r.rovingFocus ? /* @__PURE__ */ A.createElement(Po, S({
    asChild: !0
  }, o, {
    focusable: !i,
    active: a,
    ref: c
  }), /* @__PURE__ */ A.createElement(qc, S({}, s, {
    ref: t
  }))) : /* @__PURE__ */ A.createElement(qc, S({}, s, {
    ref: t
  }));
}), qc = /* @__PURE__ */ A.forwardRef((e, t) => {
  const { __scopeToggleGroup: n, value: r, ...o } = e, a = y1(Ua, n), i = {
    role: "radio",
    "aria-checked": e.pressed,
    "aria-pressed": void 0
  }, s = a.type === "single" ? i : void 0;
  return /* @__PURE__ */ A.createElement(Fd, S({}, s, o, {
    ref: t,
    onPressedChange: (c) => {
      c ? a.onItemActivate(r) : a.onItemDeactivate(r);
    }
  }));
}), fI = iI, pI = dI, bI = k(fI, {
  display: "grid",
  gridAutoFlow: "column",
  gridAutoColumns: "max-content",
  gap: "$8"
}), gI = k(pI, {
  ...kd
}), f8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Item: gI,
  Root: bI
}, Symbol.toStringTag, { value: "Module" }));
export {
  SI as Accordion,
  EI as Avatar,
  Vp as Badge,
  nn as Box,
  rn as Button,
  a8 as Card,
  eb as Checkbox,
  TI as Chip,
  RI as CircularProgress,
  c8 as DatePicker,
  MI as Divider,
  qI as Dropdown,
  o8 as Footer,
  DI as FormControlLabel,
  UI as Icon,
  hg as Input,
  OI as Label,
  FI as Layout,
  yg as List,
  Cg as ListItem,
  kI as Loader,
  s8 as Modal,
  r8 as Popover,
  jI as Portal,
  ZI as Radio,
  wI as Root,
  La as ScrollArea,
  La as ScrollAreaComposed,
  QI as ScrollAreaComposition,
  zd as ScrollAreaRoot,
  _a as ScrollAreaScrollbar,
  Hd as ScrollAreaViewport,
  _I as Select,
  BI as Slider,
  je as Slot,
  cl as Slottable,
  GI as Switch,
  u8 as Tabs,
  Sg as Tag,
  NI as Text,
  WI as TextField,
  t8 as Toast,
  YI as Toggle,
  f8 as ToggleGroup,
  kd as ToggleStyles,
  HI as Tooltip,
  x0 as colors,
  al as createTheme,
  tn as css,
  il as darkThemeClass,
  Fl as dividerStyles,
  yI as getCssText,
  xI as globalCss,
  Lt as keyframes,
  CI as media,
  k as styled,
  $I as theme,
  sl as transitionalDarkThemeClass
};
